export const translations = {
  en: {
    // Phase 728 — Record Bill Payment dialog labels
    recordBillPayment: "Record Bill Payment",
    paymentDate: "Payment Date",
    paymentDateRequired: "Payment date is required",
    referenceReceipt: "Reference / Receipt / Transaction Number",
    savePayment: "Save Payment",
    bankAccount: "Bank Account",
    bankAccountRequired: "Please choose a bank account",
    selectBankAccount: "Select bank account",
    noBankAccounts: "No bank accounts configured",
    cashSource: "Internal Cash",
    cashSourcePlaceholder: "e.g. Office petty cash",
    // Phase 727 — PDF preview reliability
    openInNewTab: "Open in new tab",
    pdfEmbedBlocked: "The browser blocked the embedded PDF preview.",
    // Phase 726 — PDF Export column picker
    pdfExportOptions: "PDF Export Options",
    pdfExportOptionsHint: "Select the columns you want to include in the PDF.",
    pdfExportAtLeastOne: "Please select at least one column.",
    clientVendor: "Client / Vendor",
    // Phase 420 — Bills v2 (asset-centric) translation keys
    billsTitle: "Bills",
    billsV2Desc: "Operational tracking of recurring & one-off bills, per asset. Independent of Finance accounting.",
    assetsItems: "Assets / Items",
    assetsTree: "Items",
    subcategories: "Subcategories",
    billCategoriesDesc: "Top-level groups (Cars, Buildings, Equipment, Other, …) that host your items.",
    billSubcategoriesDesc: "Bill types within a category (e.g. Cars → MOT, Insurance, Road Tax).",
    legacyBills: "Legacy Bills (read-only) →",
    addAsset: "Add item",
    editAsset: "Edit item",
    deleteAsset: "Delete item",
    confirmDeleteAsset: "Delete",
    addSubcategory: "Add subcategory",
    editSubcategory: "Edit subcategory",
    deleteSubcategory: "Delete subcategory",
    renameSubcategory: "Rename subcategory",
    subcategoryNamePlaceholder: "e.g. Electricity",
    noSubcategoriesInCategory: "No subcategories in this category yet.",
    vendorPickerPlaceholder: "Type or pick a vendor…",
    vendorIndependentHint: "Pick from existing vendors or type a new one. Vendors are not tied to a category — the same vendor can appear across any Category + Subcategory.",
    addBill: "Add bill / invoice",
    editBill: "Edit bill / invoice",
    deleteBill: "Delete bill / invoice",
    confirmDeleteBill: "Delete",
    confirmDeleteSub: "Delete",
    confirmDeleteCategory: "Delete",
    paymentsCascaded: "Linked payments will also be deleted.",
    noBills: "No invoices for this asset yet.",
    noPayments: "No payments recorded yet.",
    draftAutoSaved: "Draft auto-saved · picks up where you left off",
    discardDraft: "Discard Draft",
    draftDiscarded: "Draft discarded",
    noInvoicesHint: "No bills have been recorded in this subcategory yet.",
    noPaymentsHint: "No payments have been recorded for invoices in this subcategory yet.",
    noTimeline: "No history yet for this asset.",
    noAssetsInCategory: "No assets yet",
    noSubcategories: "No subcategories",
    noAlerts: "No active reminders. You're all caught up.",
    selectAssetHint: "Select an asset from the tree to view its invoices, payments, and statement.",
    dueSoon15Days: "Due Soon (15 days)",
    paidThisMonth: "Paid This Month",
    upcomingRenewals: "Upcoming Renewals",
    next30Days: "next 30 days",
    expiringInDays: "Expires in",
    expires: "Expires",
    due: "Due",
    reminders: "Reminders",
    alerts: "alerts",
    viewAllAssets: "View all assets",
    overdue: "Overdue",
    identifier: "Identifier / Plate / Code",
    forRenewalsReminders: "for renewals/reminders",
    subcategoryRequired: "Subcategory is required",
    nameRequired: "Name is required",
    nameAndCategoryRequired: "Name and category are required",
    amountRequired: "Amount must be greater than 0",
    paymentSaved: "Payment saved",
    created: "Created",
    updated: "Updated",
    builtin: "built-in",
    custom: "custom",
    moveUp: "Move up",
    moveDown: "Move down",
    totalInvoiced: "Invoiced",
    totalPaid: "Paid",
    outstanding: "Outstanding",
    paid: "Paid",
    balance: "Balance",
    expiryDate: "Expiry date",
    startDate: "Start date",
    invoiceNumber: "Invoice #",
    paymentLabel: "Payment",
    invoice: "Invoice",
    finalBalance: "Final balance",
    debit: "Debit",
    credit: "Credit",
    card: "Card",
    rows: "rows",
    source: "Source",
    breakdown: "Breakdown",
    breakdownHelp: "Every row contributing to Total Expenses. Source: db.expenses (records added via Purchases → Expenses). Reference Categories and bank labels are NOT included.",
    viewBreakdown: "View breakdown →",
    select: "Select…",
    optional: "Optional",
    bills: "bills",
    title: "Title",
    type: "Type",
    name: "Name",
    actions: "Actions",
    categories: "Categories",
    addCategory: "Add category",
    editCategory: "Edit category",
    deleteCategory: "Delete category",
    subcategory: "Subcategory",
    supplier: "Supplier",
    dueDate: "Due date",
    // Phase 423 — Bills v2 (managed items, global add)
    managedItems: "Managed Items",
    item: "Item",
    items: "Items",
    selectItem: "Select item",
    selectItemRequired: "Select an item",
    selectCategoryFirst: "Select a category first",
    itemNameRequired: "Item name is required",
    itemCreated: "Item created",
    createItem: "Create item",
    newItemName: "New item name",
    noItemsCreateBelow: "No items yet — create one below",
    noItemsYet: "No items yet",
    addItem: "Add Item",
    classify: "Classify",
    amountWithoutVat: "Amount Without VAT",
    attachments: "Attachments",
    upload: "Upload",
    noAttachmentsYet: "No attachments yet.",
    saveFirstToAttach: "Save the certification first to attach files.",
    certAttachmentsHint: "PDF inspection reports, photos, certificates, invoices. Max 5 MB per file, 25 MB total per certification.",
    deleteAttachmentConfirm: "Delete this attachment?",
    uploadedSuccess: "Uploaded",
    uploadFailed: "Upload failed",
    deleteFailed: "Delete failed",
    fileTooLarge: "File too large",
    elevatorCertificationAttachments: "Elevator Certification Attachments",
    elevCertAttachmentsHint: "Pick individual files to include. Nothing is attached automatically.",
    addAttachment: "Add attachment",
    noAttachments: "No attachments yet.",
    recordPaymentOptional: "Record payment (optional)",
    billCreated: "Bill created",
    billSavedPaymentFailed: "Bill saved but payment failed:",
    purchases: "Purchases",
    purchasesDesc: "Manage suppliers, supplier invoices, payments and statements.",
    suppliers: "Suppliers",
    supplierInvoices: "Supplier Invoices",
    searchSuppliers: "Search suppliers...",
    selectSupplier: "Select a supplier",
    selectSupplierToShowStatement: "Select a supplier to view their statement.",
    // Phase 422 — Zoho-style Sales Invoice detail
    selectInvoiceHint: "Select an invoice from the list to view it here.",
    invoiceNo: "Invoice No",
    billTo: "Bill To",
    amountDue: "Amount Due",
    subtotal: "Subtotal",
    quantity: "Qty",
    rate: "Rate",
    pdfPrint: "PDF / Print",
    recordPayment: "Record Payment",
    markAsSent: "Mark as Sent",
    downloadPdf: "Download PDF",
    clone: "Clone",
    more: "More",
    share: "Share",
    reminders: "Reminders",
    sendEmail: "Send Email",
    linkCopied: "PDF link copied to clipboard",
    clonedInvoice: "Invoice cloned — review and save.",
    newInvoiceCloneTitle: "New Invoice (Clone Draft)",
    draftNotSaved: "Draft — Not Saved",
    clonedFromBanner: "Cloned from {n} — review the fields and click Save to create a new invoice.",
    clonedFromBannerHint: "Nothing has been saved yet. Close to discard — no invoice will be created until you click Save.",
    markInactive: "Mark Inactive",
    reactivate: "Reactivate",
    cleanerArchived: "Cleaner archived",
    cleanerReactivated: "Cleaner reactivated",
    cleanerMarkedInactive: "Cleaner marked inactive",
    cleanerInactiveWarning: "This cleaner is inactive. Reactivate first.",
    cleanerInactiveBlocksAdd: "Cleaner is inactive — reactivate to add jobs / payments.",
    confirmDeactivateCleaner: "Mark this cleaner as inactive? Their full history is preserved and they will disappear from the Active list.",
    confirmReactivateCleaner: "Reactivate this cleaner? They will reappear in the Active list.",
    markAsSentHint: "Open the Send by Email dialog to send this invoice.",

    // Navigation
    dashboard: "Dashboard",
    buildingManagement: "Building Management",
    buildingDashboardDesc: "Overview of all buildings, apartment debts, and alerts",
    activeAlerts: "Active Alerts",
    apartmentDebts: "Apartment Debts",
    noApartmentDebts: "No apartment debts — all payments are up to date",
    noUnpaidItems: "No unpaid items in this category",
    outstandingByBuilding: "Outstanding by Building",
    alertsAndExpirations: "Alerts & Expirations",
    elevatorContract: "Elevator Contract",
    critical: "Critical",
    net: "Net",
    buildings: "Buildings",
    building: "Building",
    tasks: "Tasks",
    payments: "Payments",
    notifications: "Notifications",
    settings: "Settings",
    users: "Users",
    logout: "Logout",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    loginWithGoogle: "Continue with Google",
    orContinueWith: "Or continue with",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign Up",
    signIn: "Sign In",
    
    // Dashboard
    overview: "Overview",
    totalBuildings: "Total Buildings",
    totalUnits: "Total Units",
    completedTasks: "Completed Tasks",
    activeTasks: "Active Tasks",
    noCompletedTasks: "No completed tasks yet",
    viewAllTasks: "View All Tasks",
    pendingTasks: "Pending Tasks",
    upcomingTasks: "Upcoming Tasks",
    overduePayments: "Overdue Payments",
    financialAlerts: "Financial Alerts",
    noFinancialAlerts: "No financial alerts — everything is in order",
    unpaidBill: "Unpaid Bill",
    unpaidExpense: "Unpaid Expense",
    pendingPayment: "Pending Payment",
    pendingPayments: "Pending Payments",
    daysOverdue: "days overdue",
    due: "Due",
    recentActivity: "Recent Activity",
    
    // Status
    completed: "Completed",
    pending: "Pending",
    upcoming: "Upcoming",
    expiring: "Expiring",
    overdue: "Overdue",
    paid: "Paid",
    unpaid: "Unpaid",
    partial: "Partial",
    paidCredit: "Paid • Credit",
    ok: "OK",
    issue: "Issue",
    attention: "Needs Attention",
    
    // Buildings
    addBuilding: "Add Building",
    editBuilding: "Edit Building",
    deleteBuilding: "Delete Building",
    buildingArchived: "Building archived (has historical data)",
    buildingRestored: "Building restored successfully",
    deleteArchiveWarning: "If this building has historical data (cleaning, payments, expenses), it will be archived instead of permanently deleted. Archived buildings can be restored later.",
    managers: "Managers",
    addManager: "Add Manager",
    noManagers: "No managers added",
    managerName: "Manager Name",
    managerPhone: "Phone",
    buildingName: "Building Name",
    buildingCode: "Building Code",
    takeoverDate: "Takeover Date",
    releaseDate: "Release Date",
    manager: "Manager",
    units: "Units",
    address: "Address",
    streetAddress: "Street Address",
    zipCode: "ZIP Code",
    city: "City",
    countryRegion: "Country / Region",
    totalWithVat: "Total (incl. VAT)",
    withoutVat: "Without VAT",
    location: "Location",
    notes: "Notes",
    bankDetails: "Bank Details",
    bankAccountName: "Account Name",
    bankAccountNumber: "Account Number",
    bankIban: "IBAN",
    bankSwift: "SWIFT / BIC",
    bankName: "Bank Name",
    bankPhone: "Phone Number",
    companySettings: "Company Settings",
    companySettingsDesc: "Global settings applied to all buildings and PDFs",
    bankDetailsGlobalHint: "These bank details will be used in all generated PDFs (invoices, statements, receipts) unless overridden at building level.",
    bankDetailsBuildingHint: "Bank details for this building. These will be used in PDFs generated for this building.",
    companyDetails: "Company Details",
    paymentDetails: "Payment Details",
    noBuildings: "No buildings yet",
    noData: "No data available",
    
    // Tasks / Reminders
    addTask: "Add Task",
    allTasksComplete: "All tasks complete",
    inProgress: "In Progress",
    statusPending: "Pending",
    statusInProgress: "In Progress",
    statusWaiting: "Waiting",
    statusCompleted: "Completed",
    followUpDate: "Follow-up date",
    editTask: "Edit Task",
    deleteTask: "Delete Task",
    addReminder: "Add Reminder",
    editReminder: "Edit Reminder",
    deleteReminder: "Delete Reminder",
    reminders: "Reminders",
    noReminders: "No reminders yet",
    markComplete: "Mark Complete",
    date: "Date",
    taskType: "Task Type",
    companyName: "Company Name",
    startDate: "Start Date",
    endDate: "End Date",
    lastPayment: "Last Payment",
    lastPaymentDate: "Last Payment Date",
    noPaymentYet: "No payment yet",
    nextCheck: "Next Check",
    status: "Status",
    paymentStatus: "Payment Status",
    categories: "Categories",
    categoriesManageHelp: "Manage expense categories used across all buildings. The same list appears in Add Expense and filter dropdowns.",
    addCategory: "Add Category",
    newCategoryNamePrompt: "Enter category name:",
    newCategoryGroupPrompt: "Enter type (monthly or capital):",
    editCategoryNamePrompt: "Edit category name:",
    editCategoryGroupPrompt: "Edit type (monthly or capital). Leave unchanged if category is in use:",
    cannotDeleteInUse: "Cannot delete — category is in use by existing expenses.",
    cannotChangeTypeInUse: "Type cannot be changed while the category is in use.",
    codeAutoGenerateHint: "Leave blank to auto-generate (200 series for monthly, 300 for capital).",
    rfAdjustmentColLabel: "Adjustment",
    rfAdjustmentColTitle: "Per-apartment share of the annual rounding adjustment, distributed by Share %.",
    rfFinalMonthlyColLabel: "Final Monthly",
    rfFinalMonthlyColTitle: "Original Reserve Fund Monthly + Adjustment / 12.",
    changeOwner: "Change Owner",
    changeOwnerHint: "The previous owner is preserved in Owner History with an automatic End Date. The new owner is created as Active.",
    currentOwner: "Current Owner",
    newActiveOwner: "New Active Owner",
    saveActivateNewOwner: "Save & Activate New Owner",
    viewOwnerHistory: "View Owner History",
    useChangeOwnerHint: "use Change Owner to update",
    ownerLabel: "Owner",
    ownershipPeriod: "Ownership Period",
    selectOwner: "Select Owner",
    allOwners: "All Owners",
    invoiceOwner: "Invoice Owner",
    invoiceOwnerHint: "Auto-selected from the invoice period. Change if this invoice belongs to a different historical owner. The selection is permanently linked to this invoice.",
    allocateEquallyLabel: "Split amount equally across months",
    manualAllocationLabel: "Enter each month manually",
    openingBalanceForNewOwner: "Opening Balance for New Owner",
    openingBalanceForNewOwnerHint: "Defaults to €0.00. Set only when the new owner explicitly agreed to take over part or all of the previous owner's balance. Positive = owed by owner; negative = credit in their favor.",
    openingBalanceNotes: "Opening Balance Notes",
    openingBalanceNotesPlaceholder: "e.g. Took over €200 from previous owner",
    searchByBuilding: "Search by building name…",
    allBuildings: "All Buildings",
    noTasks: "No pending tasks",
    noNotes: "No notes yet",
    statementTracking: "Statement Tracking",
    bankReceiptsPage: "Bank Receipts",
    statementHistory: "Statement History",
    statementSent: "Statement Sent",
    lastStatementSent: "Last Statement Sent",
    neverSent: "Never Sent",
    noStatementTrackingRows: "No apartments match the current filter",
    clearFilter: "Clear",
    history: "History",
    selectOwnerHint: "Filters unpaid invoices to the selected owner. The payment will stay permanently linked to this owner.",
    fullShort: "Full",
    payThisInvoiceInFull: "Pay this invoice in full (remaining amount)",
    noUnpaidInvoicesForOwner: "No unpaid invoices for the selected owner.",
    contactPerson: "Contact Person",
    contactPersonName: "Name",
    contactPersonHint: "For cases where communication goes through secretary, accountant, family member, office, etc.",
    contactPersonEmail: "Contact Person Email",
    emailRecipients: "Email Recipients",
    emailRecipientsHint: "Choose which addresses receive invoices, statements, reminders and payment notifications.",
    ownerEmail: "Owner Email",
    additionalEmail: "Additional Email",
    extraEmailsCc: "Additional Emails (CC List)",
    addEmail: "Add email",
    tenantOptional: "Tenant (optional)",
    tenantName: "Tenant Name",
    tenantPhone: "Tenant Phone",
    tenantEmail: "Tenant Email",
    paysCommonExpenses: "Pays Common Expenses",
    noCategories: "No categories defined.",
    usage: "Usage",
    code: "Code",
    type: "Type",
    monthly: "Monthly",
    capital: "Capital",
    missingBillingPeriod: "Missing billing period",
    draftsHiddenTitle: "{n} expense(s) hidden — missing billing period",
    draftsHiddenHelp: "Incomplete expenses are kept out of the list and totals until you fill their From/To dates.",
    showDrafts: "Show",
    hideDrafts: "Hide",
    reserveFundUsage: "Reserve Fund Usage",
    totalBeforeRepairs: "Contributions this period",
    totalSpentFromReserveFund: "Reserve Fund expenses this period",
    remainingBalance: "Remaining Balance",
    // Phase 814 — Bank-statement style balance carry-forward labels.
    openingReserveFundBalance: "Opening Reserve Fund Balance",
    closingReserveFundBalance: "Closing Reserve Fund Balance",
    carriedForwardFromPriorPeriod: "Carried forward from prior period",
    carriedForwardToNextPeriod: "Carried forward to next period",
    before: "before",
    asOf: "as of",
    // Phase 815 — Per-year sub-sections in multi-year reports.
    contributions: "Contributions",
    reserveFundExpensesThisYear: "Reserve Fund expenses this year",
    grandTotalClosingBalance: "Grand Total Closing Reserve Fund Balance",
    // Phase 817 — Manual Reserve Fund Opening Balance seed.
    managementTakeoverSeed: "management takeover seed",
    rfSeedNotesPlaceholder: "e.g. Balance at management takeover",
    rfSeedHelp: "Only used as the initial balance when this building is first added. After that, every new period automatically carries forward the previous period's closing balance.",
    noRepairsPaidFromReserve: "No repairs have been paid from the Reserve Fund yet.",
    detailBreakdown: "Detailed Breakdown",
    paidInCash: "Paid in cash by the committee",
    paidFromBank: "Paid from the committee bank",
    useReserveFundToggle: "Use Reserve Fund (optional)",
    fundingBreakdown: "Funding Breakdown (optional)",
    reserveFundPortion: "From Reserve Fund",
    sharedPortion: "Distributed to Apartments",
    splitFundingHelp: "Paid upfront from the Reserve Fund. The remainder is split across apartments by share percentage.",
    splitFundingInvalid: "Reserve Fund portion must be between €0 and the total amount.",
    noTasks: "No tasks yet",
    quickUpdate: "Quick Update",
    cleanedToday: "Cleaned Today",
    
    // Task Types
    cleaning: "Cleaning",
    cleanings: "Cleanings",
    elevator: "Elevator Inspection",
    electricity: "Electricity Check",
    insurance: "Insurance",
    maintenance: "General Maintenance",
    
    // Payments
    addPayment: "Add Payment",
    amount: "Amount",
    dueDate: "Due Date",
    paidDate: "Paid Date",
    markAsPaid: "Mark as Paid",
    noPayments: "No payments yet",
    
    // Actions
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    export: "Export",
    search: "Search",
    filter: "Filter",
    all: "All",
    allVendors: "All Vendors",
    searchExpensesPlaceholder: "Description, notes, vendor…",
    unpaidCleaners: "Unpaid cleaners",
    paidCleaners: "Paid cleaners",
    allCleanersPaid: "All cleaners are paid up.",
    searchCleaner: "Search cleaners…",
    
    // Export
    exportExcel: "Export to Excel",
    exportPDF: "Export to PDF",
    exportCSV: "Export to CSV",
    
    // Messages
    confirmDelete: "Are you sure you want to delete this?",
    savedSuccess: "Saved successfully",
    deletedSuccess: "Deleted successfully",
    errorOccurred: "An error occurred",
    invalidAmount: "Invalid amount",
    
    // User Roles
    admin: "Admin",
    staff: "Staff",
    role: "Role",
    
    // Notifications
    noNotifications: "No notifications",
    markAllRead: "Mark all as read",
    contractExpiry: "Contract Expiry",
    inspectionDue: "Inspection Due",
    paymentDue: "Payment Due",
    
    // Misc
    welcome: "Welcome",
    loading: "Loading...",
    language: "Language",
    english: "English",
    greek: "Ελληνικά",
    
    // Building Types
    buildingType: "Building Type",
    managed: "Managed",
    cleaning_only: "Cleaning Only",
    
    // Building Cleaning (formerly "Cleaning History")
    cleaningHistory: "Building Cleaning",
    buildingsCleaning: "Building Cleaning",
    addBuildingCleaning: "Add Building Cleaning",
    details: "Details",
    
    // Cleaning Management
    cleaningManagement: "Cleaning Management",
    cleaners: "Cleaners",
    clients: "Clients",
    jobHistory: "Job History",
    jobs: "Jobs",
    addCleaner: "Add Cleaner",
    editCleaner: "Edit Cleaner",
    addClient: "Add Client",
    editClient: "Edit Client",
    addJob: "Add Job",
    editJob: "Edit Job",
    paymentType: "Payment Type",
    perHour: "Per Hour",
    perMonth: "Per Month",
    overall: "Overall",
    selectDate: "Select Date",
    fromDate: "From Date",
    toDate: "To Date",
    applyFilter: "Apply Filter",
    // Phase 517 — Supplier Refund & Discount/Credit
    supplierRefundCredit: "Supplier Refund / Credit",
    discountCreditAmount: "Discount / Credit Amount",
    refundAmount: "Refund Amount",
    refundReference: "Refund Reference",
    refundDate: "Refund Date",
    refundNotes: "Refund Notes",
    originalExpense: "Original Expense",
    supplierCredit: "Supplier Credit",
    supplierRefund: "Supplier Refund",
    finalExpense: "Final Expense",
    totalSupplierRefunds: "Supplier Refunds",
    totalSupplierCredits: "Supplier Credits",
    optional: "optional",
    // Phase 518 — Finance separation (Official vs Internal Invoices)
    // Phase 524 — Renamed "Internal Cash" → "Internal Invoices" + dedicated tab.
    invoiceType: "Type",
    invoiceTypeOfficial: "Official",
    invoiceTypeInternalCash: "Internal Invoices",
    invoiceTypeInternalInvoices: "Internal Invoices",
    badgeInternalCash: "Internal",
    badgeOfficial: "Official",
    internalCashHint: "Will NOT appear in Finance / VAT / official exports.",
    internalCashTrackingTitle: "Internal Invoices",
    internalCashCardHint: "Excluded from Finance / VAT / official exports",
    // Phase 524 — dedicated Internal Invoices tab labels.
    internal_invoices: "Internal Invoices",
    internalInvoicesLabel: "Internal Invoices",
    newInternalInvoice: "New Internal Invoice",
    internalInvoicesHint: "Internal bookkeeping only — excluded from official Finance/VAT and bank account totals.",
    officialInvoicesHint: "Official customer invoices — included in Finance/VAT and bank account totals.",
    // Phase 526 — dedicated Internal Cash Payments tab labels.
    internal_payments: "Internal Cash Payments",
    internalPaymentsLabel: "Internal Cash Payments",
    newInternalPayment: "New Internal Cash Payment",
    internalPaymentsHint: "Internal Cash Payments — auto-routed to the Internal Cash wallet; excluded from official Finance/VAT and bank account totals.",
    officialPaymentsHint: "Official customer payments — affect treasury/bank balances and official Finance/VAT reports.",
    paymentTypeOfficial: "Official",
    paymentTypeInternalCash: "Internal Cash",
    // Phase 539 — Internal Cash columns / status labels.
    reference: "Reference",
    unusedAmount: "Unused",
    allocatedAmount: "Allocated",
    paymentNumberOrRef: "Payment # / Ref",
    autoAllocateFifo: "Auto-allocate (oldest first)",
    failedToCreateClient: "Failed to create client",
    referenceNo: "Reference #",
    clientVendorBuilding: "Client / Vendor / Building",
    clients: "Clients",
    buildings: "Buildings",
    invoice: "INVOICE",
    vat: "VAT",
    regNo: "Reg.",
    editIncomeAllocOnly: "Editing a Finance Income entry — only Reference, Notes, Date and invoice allocations are saved. Amount and method are managed in Finance → Income.",
    confirmDeleteInternalCashRow: "Delete this Internal Cash entry? Any allocations on linked Internal Invoices will be reversed.",
    bank: "Bank",
    cash: "Cash",
    badgePaid: "PAID",
    badgePartial: "PARTIAL",
    badgeUnpaid: "UNPAID",
    // Phase 528 — Internal Cash is now a per-customer ledger under
    // Finance → Customers, NOT a bank account.
    internal_cash: "Internal Cash",
    internalCashLabel: "Internal Cash",
    newInternalCashPayment: "New Internal Cash Payment",
    internalCashSectionHint: "Internal customer/invoice tracking — separate from official treasury and bank accounts.",
    internalCashInvoicedLabel: "Internal Invoiced",
    totalPaid: "Total Paid",
    totalRemaining: "Total Remaining",
    remainingBalance: "Remaining",
    paymentHistory: "History",
    invoice: "Invoice",
    method: "Method",
    actions: "Actions",
    from: "From",
    to: "To",
    clearFilters: "Clear",
    // Phase 527 — Simplified Internal Cash wallet view.
    internalCashWalletHint: "Auto-managed wallet — Excluded from official treasury & VAT",
    totalBalance: "Total Balance",
    noInternalCashPayments: "No Internal Cash payments yet. New entries are auto-routed here when you flag them as Internal Cash on Finance → Income or Sales → Internal Cash Payments.",
    customerPayment: "Customer Payment",
    finance: "Finance",
    invoiced: "Invoiced",
    collected: "Collected",
    cashOnHand: "Cash on Hand",
    outstanding: "Outstanding",
    clientPayments: "Client Payments",
    cleanerPayments: "Cleaner Payments",
    hourlyRate: "Hourly Rate",
    monthlyRate: "Monthly Rate",
    hoursWorked: "Hours Worked",
    clientAmount: "Client Paid",
    cleanerEarned: "Cleaner Earned",
    totalEarned: "Total Earned",
    totalPaid: "Total Paid",
    remainingBalance: "Remaining Balance",
    totalJobs: "Total Jobs",
    totalEntries: "Total Entries",
    totalHours: "Total Hours",
    totalRevenue: "Total Revenue",
    cleanerStatement: "Cleaner Statement",
    viewAllCombined: "All (Combined)",
    viewBuildingsOnly: "Building Cleaning",
    viewJobsOnly: "Job History",
    dateMode: "Period",
    modeDate: "Date",
    modeMonth: "Month",
    modeRange: "Range",
    oldestFirst: "Oldest first",
    newestFirst: "Newest first",
    recordPayment: "Record Payment",
    partialPayment: "Partial Payment",
    cleanerHistory: "Cleaner History",
    clientHistory: "Client History",
    viewStatement: "View Statement",
    downloadPdf: "Download PDF",
    viewPrint: "View / Print",
    download: "Download",
    showBuildingNames: "Show building names",
    clientType: "Client Type",
    customClient: "Custom (House/Office)",
    linkedBuilding: "Linked Building",
    selectBuilding: "Select Building",
    paymentAmount: "Payment Amount",
    selectCleaner: "Select Cleaner",
    selectClient: "Select Client",
    autoCalculated: "Auto-calculated",
    office: "Office",
    house: "House",
    profit: "Profit",
    totalCost: "Total Cost",
    profitGenerated: "Profit Generated",
    onboardDate: "Date Added",
    exportPdf: "Export PDF",
    paid: "Paid",
    paidSoFar: "Paid So Far",
    clientPaid: "Client Paid",
    cleanerCost: "Cleaner Cost",
    performance: "Performance",
    offices: "Offices",
    generalCleaning: "General Cleaning",
    totalCleanerCost: "Total Cleaner Cost",
    totalClientPaid: "Total Client Paid",
    totalProfit: "Total Profit",
    client: "Client",
    overallCleaning: "Overall Cleaning",
    allCategories: "All categories",
    byMonth: "By Month",
    byYear: "By Year",
    year: "Year",
    serviceLog: "Service Log",
    addCleaningEntry: "Add Entry",
    employeeName: "Employee / Cleaner",
    workTypes: "Work Done",
    general_cleaning: "General Cleaning",
    windows: "Windows",
    storage_doors: "Storage Doors",
    roof_terrace: "Roof / Terrace",
    entrance: "Entrance",
    other: "Other",
    otherNotes: "Other Details",
    lastCleaning: "Last Cleaning",
    daysSinceCleaning: "Days Since Cleaning",
    noCleaning: "No cleaning history",
    notCleanedRecently: "Not Cleaned Recently",
    cleaningOnlyBuildings: "Cleaning Only",
    logCleaning: "Log Cleaning",
    quickLog: "Quick Log",
    viewHistory: "View History",
    daysAgo: "days ago",
    today: "Today",
    cleaningType: "Cleaning Type",
    allTypes: "All Types",
    dateFrom: "Date From",
    dateTo: "Date To",
    cleaningAlerts: "Cleaning Alerts",
    overdueCleaningAlert: "not cleaned for",
    neverCleaned: "Never cleaned",
    editCleaningEntry: "Edit Entry",
    deleteCleaningEntry: "Delete Entry",
    confirmDeleteCleaning: "Are you sure you want to delete this cleaning record?",
    lastCleaningByType: "Last Cleaning by Type",
    cleaners: "Cleaners",
    addCleaner: "Add Cleaner",
    editCleaner: "Edit Cleaner",
    deleteCleaner: "Delete Cleaner",
    confirmDeleteCleaner: "Are you sure you want to delete this cleaner?",
    manageCleaner: "Manage Cleaners",
    allCleaners: "All Cleaners",
    addNewCleaner: "Add New Cleaner",
    cleanerName: "Cleaner Name",
    selectCleaner: "Select Cleaner",
    filterByCleaner: "Filter by Cleaner",
    
    // Insurance
    insuranceSection: "Insurance",
    insuranceCompany: "Insurance Company",
    policyStartDate: "Policy Start",
    policyEndDate: "Policy End",
    coveragePeriod: "Coverage Period",
    months: "months",
    addInsurance: "Add Insurance",
    totalPremium: "Total Premium",
    numInstallments: "Number of Installments",
    installmentAmount: "Installment Amount",
    insuredAmounts: "Insured Amounts",
    insuredBuilding: "Building",
    insuredCommonAreas: "Common Areas",
    insuredOutdoor: "Outdoor Items",
    insuredCivilLiability: "Civil Liability",
    insuredExcess: "Excess",
    generateInsuranceInvoices: "Generate Installment Invoices",
    insuranceInvoicesGenerated: "Insurance installment invoices generated",
    insuranceLabel: "Insurance",
    perMonth: "/month",
    editInsurance: "Edit Insurance",
    renewInsurance: "Renew Insurance",
    deleteInsurance: "Delete Insurance",
    cancelInsurance: "Cancel Insurance",
    confirmCancelInsurance: "Are you sure you want to cancel this insurance policy? The policy will be marked as cancelled.",
    confirmDeleteInsurance: "Are you sure you want to delete this insurance? This cannot be undone.",
    reactivate: "Reactivate",
    renewal: "Renewal",
    cancelled: "Cancelled",
    insuranceStatus: "Insurance Status",
    active: "Active",
    expiring_soon: "Expiring Soon",
    expired: "Expired",
    noInsurance: "No insurance",
    daysUntilExpiry: "days until expiry",
    expiresIn: "Expires in",
    expiredDaysAgo: "Expired",
    viewInsurance: "View Insurance",
    insuranceFrom: "From",
    insuranceTo: "To",
    days: "days",
    day: "day",
    payFullAmount: "Pay Full Amount",
    selectInstallment: "Select Installment",
    installmentTracking: "Installment Tracking",
    paidInstallments: "Paid",
    remainingInstallments: "Remaining",
    installment: "Installment",
    
    // Financial
    financials: "Financials",
    managementFee: "Management Fee",
    unpaidManagement: "Management Unpaid",
    unpaidCleaning: "Cleaning Unpaid",
    unpaidElevator: "Elevator Unpaid",
    unpaidInsurance: "Insurance Unpaid",
    unpaidMonthly: "Monthly Unpaid",
    unpaidCapital: "Capital Unpaid",
    amountOwed: "Amount Owed",
    buildingStatement: "Building Statement",
    cleaningCharges: "Cleaning Charges",
    allPeriods: "All Periods",
    statementActivity: "Statement Activity",
    fixedMonthly: "Fixed Monthly",
    perCleaning: "Per Cleaning",
    cleaningChargeMode: "Cleaning Charge Mode",
    fixedMonthlyDesc: "Only the monthly cleaning fee is charged. Cleaning history does not affect charges.",
    perCleaningDesc: "Charges come from cleaning history entries (per visit). No monthly fee applied.",
    billingPricing: "Billing / Pricing",
    chargeMode: "Charge Mode",
    monthlyCharge: "Monthly Charge (ex VAT)",
    vatPercent: "VAT %",
    totalIncVat: "Total (incl. VAT)",
    recurring: "Recurring",
    recurringDesc: "Auto monthly from building pricing",
    manual: "Manual",
    manualDesc: "One-time custom invoice",
    recurringEnabled: "Recurring monthly invoicing enabled.",
    recurringAlreadyOn: "Recurring is already enabled. Re-saving keeps the current pricing.",
    recurringWillEnable: "Saving will switch this building to monthly auto-invoicing.",
    setPricingFirst: "Set monthly cleaning charge in Edit Building first.",
    view: "View",
    statementsTab: "Statements",
    exVat: "ex VAT",
    billVendors: "Bills",
    billVendorsDesc: "Manage your bills (utility & service invoices). Independent from Building Management vendors.",
    addBillEntry: "Add Bill",
    editBillEntry: "Edit Bill",
    billEntryName: "Bill Name",
    deleteBillEntryWarning: "This will archive the bill record. Linked invoices remain.",
    billCategoryRequired: "Category is required",
    billNoCategoriesYet: "No categories yet. Add some via Manage Categories.",
    manageVendors: "Manage Vendors",
    manageBills: "Manage Bills",
    confirmDeleteBillMessage: "Are you sure you want to delete this bill? This action cannot be undone.",
    syncedWithFinance: "Synced with Finance",
    syncedWithBuilding: "Synced with Building Management",
    syncedToBills: "Synced to Bills",
    payTo: "Pay To",
    remaining: "Remaining",
    available: "Available",
    availableBeforePayment: "Available before payment",
    payment: "Payment",
    insufficientAvailableBalance: "Insufficient available balance.",
    linkedBill: "Linked Bill",
    selectBill: "Select a bill",
    noPayableBills: "No unpaid bills available.",
    noPayableVendors: "No vendor accounts with outstanding balance.",
    noBillVendors: "No bill vendors configured.",
    noInvoices: "No invoices",
    billsCount: "bills",
    outstanding: "Outstanding",
    fifoAllocation: "oldest invoice first",
    currentBalanceLabel: "Current Balance",
    currentBalanceTopTooltip: "Sum of per-account current balances for accounts where Include in Financial Summary is ON.",
    includeInFinancialSummary: "Include in Financial Summary",
    includeInFinancialSummaryDesc: "When ON, this account's balance contributes to the global Current Balance, Final Balance and Add Payment calculations.",
    accountsExcluded: "account(s) excluded from summary",
    excludedFromSummary: "Excluded from summary",
    // Phase 239 — Payment Reminder System
    reminderSettings: "Payment Reminder Settings",
    enableReminders: "Enable reminders",
    firstReminderDays: "First (days)",
    secondReminderDays: "Second (days)",
    finalReminderDays: "Final (days)",
    reminderHint: "Apartments with unpaid balances are flagged at each stage based on how many days the oldest unpaid invoice has been overdue.",
    paymentReminders: "Payment Reminders",
    debtors: "debtors",
    daysOverdue: "Days Overdue",
    stage: "Stage",
    lastReminder: "Last Reminder",
    firstReminder: "First",
    secondReminder: "Second",
    finalReminder: "Final",
    sendEmail: "Send Email",
    logManualReminder: "Log manual reminder",
    manual: "Manual",
    reminderSent: "Reminder Sent",
    reminderQueued: "Reminder queued",
    reminderLogged: "Reminder logged",
    reminderFailed: "Reminder failed",
    deficit: "Deficit",
    negativeBalance: "Negative Balance",
    negativeBalanceAllowed: "Final Balance will go negative. Payment is still allowed — future income will cover the deficit.",
    negativeBalanceTooltip: "Negative balance — future income will close the gap.",
    optional: "optional",
    none: "None",
    synced: "Synced",
    transactionDetails: "Transaction Details",
    actions: "Actions",
    close: "Close",
    noClient: "No client",
    pdf: "PDF",
    syncToFinance: "Sync to Finance",
    syncToBuilding: "Sync to Building Management",
    syncToFinanceHint: "Auto-create a matching Finance income; updates and deletes cascade.",
    syncToBuildingHint: "Auto-create a matching Building Management payment; updates and deletes cascade.",
    paymentMethodCash: "Cash",
    paymentMethodBank: "Bank",
    incomeType: "Income Type",
    incomeType_client_payment: "Client Payment",
    incomeType_bank_refund: "Bank Refund",
    incomeType_bank_adjustment: "Bank Adjustment",
    incomeType_interest: "Interest",
    incomeType_transfer_in: "Transfer In",
    incomeType_owner_contribution: "Owner Contribution",
    incomeType_other: "Other",
    incomeTypeBadgeClient: "CLIENT",
    incomeTypeBadgeRefund: "REFUND",
    incomeTypeBadgeAdjustment: "ADJUSTMENT",
    incomeTypeBadgeInterest: "INTEREST",
    incomeTypeBadgeTransfer: "TRANSFER",
    incomeTypeBadgeOwnerContrib: "OWNER",
    incomeTypeBadgeOther: "OTHER",
    filterByIncomeType: "Filter by Income Type",
    addVendor: "Add Vendor",
    contactPerson: "Contact Person",
    accountNumber: "Account Number",
    invoiceNumber: "Invoice Number",
    issueDate: "Issue Date",
    dueDate: "Due Date",
    period: "Period",
    amountExVat: "Amount ex VAT",
    vatPercent: "VAT %",
    totalIncVat: "Total inc VAT",
    attachment: "Attachment (PDF/Image)",
    currentAttachment: "Current",
    invoices: "Invoices",
    invoice: "Invoice",
    totalInvoiced: "Total Invoiced",
    totalUnpaid: "Total Unpaid",
    totalPaid: "Total Paid",
    overdueInvoices: "Overdue Invoices",
    partiallyPaid: "Partial",
    printPdf: "Print PDF",
    downloadPdf: "Download PDF",
    vendorRequired: "Vendor required",
    selectVendor: "Select vendor…",
    vendorArchived: "Vendor archived",
    manageVendorsHint: "Add a new vendor from Manage Vendors → Add Vendor.",
    noInvoices: "No invoices for this vendor yet.",
    searchBills: "Search bills...",
    searchVendors: "Search vendors...",
    activeItems: "Active",
    archivedItems: "Archived",
    noVendors: "No bill vendors found.",
    sortOrder: "Sort Order",
    newestFirst: "Newest → Oldest",
    oldestFirst: "Oldest → Newest",
    newestFirstHint: "Newest first (click to flip)",
    oldestFirstHint: "Oldest first (click to flip)",
    byVendor: "By Vendor",
    allBills: "All Bills",
    paymentMethod: "Method",
    debits: "Debit",
    credits: "Credit",
    closingBalance: "Closing Balance",
    all: "All",
    permanentlyDelete: "Permanently Delete",
    permanentlyDeleteBuilding: "Permanently Delete Building",
    permanentDeleteWarning: "This action is irreversible. The building and ALL related data will be permanently removed from the database. This cannot be undone.",
    willBeArchivedWarning: "This building has data attached and will be moved to Archive. All data is preserved and the building can be restored at any time. Permanent deletion (admin-only) is available from the Archive view.",
    emptyBuildingDeleteWarning: "This building has no data attached. It will be permanently removed.",
    adminAuthRequired: "Admin authorization is required for this action.",
    buildingPermanentlyDeleted: "Building permanently deleted",
    invoice: "Invoice",
    type: "Type",
    source: "Source",
    cleaningFee: "Cleaning Fee",
    vatRate: "VAT Rate",
    managementVat: "Management VAT",
    cleaningVat: "Cleaning VAT",
    totalVat: "Total VAT",
    vat: "VAT",
    subtotal: "Subtotal",
    total: "Total",
    totalAmount: "Total Amount",
    monthlyTotal: "Monthly Total",
    feeBreakdown: "Fee Breakdown",
    discount: "Discount",
    discountAmount: "Discount Amount",
    discountedSubtotal: "Subtotal after Discount",
    finalTotal: "Final Total",
    netPerUnit: "Unit Price (Net)",
    lineNet: "Net",
    lineTotal: "Total (incl. VAT)",
    invoiceItems: "Invoice Items",
    
    // Statements
    statements: "Statements",
    banking: "Banking",
    supplierPayments: "Supplier Payments",
    supplierStatements: "Supplier Statements",
    generateStatement: "Generate Statement",
    statementPeriod: "Period",
    month: "Month",
    year: "Year",
    draft: "Draft",
    sent: "Sent",
    markAsSent: "Mark as Sent",
    viewStatement: "View Statement",
    noStatements: "No statements",
    statementBreakdown: "Statement Breakdown",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    
    // Invoices
    invoices: "Invoices",
    apartmentCharges: "Apartment Charges",
    invoice: "Invoice",
    invoiceNumber: "Invoice No.",
    managementInvoice: "Management Invoice",
    cleaningInvoice: "Cleaning Invoice",
    generateInvoice: "Generate Invoice",
    generateBothInvoices: "Generate Both Invoices",
    invoiceType: "Invoice Type",
    management: "Management",
    paymentsByCategory: "Payments by Category",
    lastPaid: "Last Paid",
    paidUntil: "Paid Until",
    oldestFirst: "Oldest first",
    unpaidFirst: "Unpaid first",
    buildingTechnical: "Building / Technical",
    financial: "Financial",
    system: "System",
    viewAll: "View all",
    showLess: "Show less",
    cleaning: "Cleaning",
    noInvoices: "No invoices",
    viewInvoice: "View Invoice",
    invoiceDetails: "Invoice Details",
    bothInvoices: "Both Invoices",
    addInvoice: "Add Invoice",
    editInvoice: "Edit Invoice",
    deleteInvoice: "Delete Invoice",
    manualInvoice: "Manual",
    autoInvoice: "Auto",
    expenseInvoice: "Expense",
    extraWork: "Extra Work",
    other: "Other",
    confirmDeleteManualInvoice: "Are you sure you want to delete this manual invoice?",
    confirmDeleteAutoInvoice: "WARNING: This is an auto-generated monthly invoice. Deleting it will affect the building's financial records. Are you sure you want to proceed?",
    invoiceDescription: "Description",
    updatedSuccess: "Updated successfully",

    // Expenses
    expenses: "Expenses",
    addExpense: "Add Expense",
    editExpense: "Edit Expense",
    deleteExpense: "Delete Expense",
    renameCategory: "Rename Category",
    deleteCategory: "Delete Category",
    deleteCategoryWarning: "This category has expenses. You can move them to another category or delete them too.",
    moveExpensesTo: "Move expenses to",
    deleteAnyway: "Delete anyway (soft delete expenses)",
    expenseType: "Expense Type",
    expenseElectricity: "Electricity",
    expenseBankFees: "Bank Fees",
    expenseElectricalWork: "Electrical Work",
    expenseOther: "Other",
    billingPeriod: "Billing Period",
    insurancePeriod: "Insurance Period",
    servicePeriod: "Service Period",
    addBillingPeriod: "Add Billing Period",
    remove: "Remove",
    paidDates: "Paid Dates",
    addPaidDate: "Add Paid Date",
    totalExpenses: "Total Expenses",
    paidExpenses: "Paid",
    unpaidExpenses: "Unpaid",
    noExpenses: "No expenses",
    markExpensePaid: "Mark as Paid",
    expenseAmount: "Amount",
    expenseDate: "Date",
    billingPeriod: "Billing Period",
    billingPeriodFrom: "Billing Period From",
    billingPeriodTo: "Billing Period To",
    periodFrom: "From",
    periodTo: "To",
    financialYear: "Financial Year",
    allYears: "All Years",
    balanceBroughtForward: "Balance Brought Forward",
    from: "from",
    expenseSummary: "Expense Summary",
    viewExpenses: "View Expenses",
    viewPayments: "View Payments",
    partiallyPaid: "Partially Paid",
    paidAmount: "Paid",
    expenseRemainingBalance: "Remaining",
    paymentNotes: "Notes",
    confirmDeletePayment: "Are you sure you want to delete this payment? The expense status will be recalculated.",
    expensePayments: "Expense Payments",

    // Expense Categories
    expenseCategory: "Category",
    expenseCategoryHelp: "Creates an expense entry under this category (appears in Expenses module and Annual Statement).",
    allocatePerCategoryHelp: "Allocate the payment per invoice category (203 Monthly / 301 Capital). Amounts are recorded separately in Expenses.",
    categoryGroup: "Group",
    monthlyExpenses: "Monthly Expenses",
    capitalExpenses: "Capital Expenses",
    allCategories: "All Categories",
    allBuildings: "All Buildings",
    noExpirations: "No upcoming expirations",
    noOverduePayments: "No overdue payments",
    showAll: "Show All",
    items: "items",
    item: "item",
    allGroups: "All Groups",
    listView: "List View",
    flatView: "Flat View",
    groupByCategory: "Group by Category",
    allMonths: "All Months",
    category: "Category",
    cat_201: "201 Management",
    cat_202: "202 Cleaning",
    cat_203: "203 Elevator",
    cat_204: "204 Electricity",
    cat_205: "205 Water",
    cat_206: "206 Bank Fees",
    cat_301: "301 Elevator Works",
    cat_302: "302 Building Works",
    cat_303: "303 Plumbing Works",
    cat_304: "304 Electrical Works",
    cat_305: "305 Mechanical Works",
    cat_306: "306 Building Insurance",
    cat_307: "307 Garden Works",
    cat_308: "308 Small Expenses",
    cat_309: "309 Bank Fees",
    cat_310: "310 Elevator Certification",
    cat_custom: "Custom",
    cat_elevator: "Elevator",
    cat_other: "Other",
    uncategorized: "Uncategorized",
    categoryBreakdown: "Category Breakdown",

    // Building Details
    buildingDetails: "Building Details",
    overview: "Overview",
    income: "Income",
    totalIncome: "Total Income",
    totalBalance: "Balance",
    profitLoss: "Profit / Loss",
    quickStats: "Quick Stats",
    backToBuildings: "Back to Buildings",
    date: "Date",
    description: "Description",
    expense: "Expense",
    balance: "Balance",

    // Expiry Alerts & Notes
    expiringSoon: "Expiring Soon",
    noAlerts: "No expiring items",
    expiringInsurance: "Insurance",
    expiringElevator: "Elevator Contract",
    daysLeft: "days left",
    expired: "Expired",
    recentNotes: "Recent Notes",
    buildingNotes: "Notes",
    addNote: "Add Note",
    addNotePlaceholder: "Type a comment, update, or log entry...",
    noHistoryYet: "No history yet. Add a note to start the timeline.",
    markAsCompleted: "Mark as Completed",
    taskCompletedReadOnly: "Task completed — history is read-only.",
    noteTextPlaceholder: "Write your note here...",
    noteSaved: "Note saved",
    editNote: "Edit Note",
    deleteNote: "Delete Note",
    noteText: "Note",
    noNotes: "No notes",
    noteCreated: "Created",

    // Elevator
    elevator: "Elevator",
    elevatorMaintenance: "Elevator Maintenance",
    maintenanceCompany: "Maintenance Company",
    contractStartDate: "Contract Start",
    contractEndDate: "Contract End",
    contractFile: "Contract File",
    uploadContract: "Upload Contract",
    downloadContract: "Download Contract",
    addContract: "Add Contract",
    editContract: "Edit Contract",
    noContracts: "No contracts",
    elevatorExpenses: "Elevator Expenses",
    addElevatorExpense: "Add Elevator Invoice",
    addElevatorInvoice: "Add Elevator Invoice",
    invoiceAmount: "Invoice Amount",
    noElevatorExpenses: "No elevator expenses",
    totalElevatorCost: "Total Elevator Cost",
    elevatorBalance: "Elevator Balance",
    elevatorInvoices: "Elevator Invoices",
    elevatorPayments: "Elevator Payments",
    elevatorStatement: "Elevator Statement",
    contractStatus: "Contract Status",
    daysRemaining: "days remaining",
    contracts: "Contracts",
    contactPhone: "Phone",
    contactEmail: "Email",
    invoiceNumber: "Invoice Number",
    uploadInvoice: "Upload Invoice",
    downloadInvoice: "Download Invoice",
    downloadReceipt: "Download Receipt",
    exportFullStatement: "Export Full Statement",
    viewPdf: "View PDF",
    invoiceFile: "Invoice File",
    editElevatorExpense: "Edit Invoice",
    deleteElevatorExpense: "Delete Invoice",
    confirmDeleteElevatorExpense: "Are you sure you want to delete this elevator invoice? All associated payments will also be deleted.",
    elevatorCompany: "Company",
    elevatorCompanies: "Elevator Companies",
    vendors: "Vendors",
    companiesOverview: "Companies",
    tasksAndNotes: "Tasks & Notes",
    noTasksOrNotes: "No tasks or notes",
    certificationCompanies: "Certification",
    addVendor: "Add Vendor",
    createNewVendor: "Create New Vendor",
    vendorCreated: "Vendor created successfully",
    noSelection: "None",
    editVendor: "Edit Vendor",
    vendorName: "Vendor Name",
    searchVendors: "Search vendors...",
    noVendors: "No vendors found",
    deleteVendorWarning: "This will archive the vendor. Linked expenses will remain",
    owners: "Owners",
    addOwner: "Add Owner",
    editOwner: "Edit Owner",
    searchOwners: "Search owners...",
    noOwners: "No owners found",
    deleteOwnerWarning: "This will delete or archive the owner",
    ownerProfile: "Owner Profile",
    viewProfile: "View Profile",
    unlinkOwner: "Unlink Owner",
    linkExistingOwner: "Link Existing Owner",
    linkedApartments: "Linked Apartments",
    fullName: "Full Name",
    ownerDetails: "Owner Details",
    ownerAndUnitInfo: "Owner & Unit Info",
    selectOwner: "Select Owner",
    createAndLink: "Create & Link",
    ownerArchived: "Owner archived (has financial records)",
    changeOwnerWarning: "This apartment already has an owner. Changing will unlink the previous owner.",
    preferredVendor: "Preferred Vendor",
    expensesByBuilding: "Expenses by Building",
    selectVendor: "Select Vendor",
    selectInvoice: "Select Invoice",
    manualPayment: "Manual payment (no invoice)",
    vendor: "Vendor",
    deleteExpenseWarning: "This expense will be archived. It can be restored later",
    confirmArchive: "Archive",
    archived: "Archived",
    archive: "Archive",
    activeItems: "Active",
    archivedItems: "Archived",
    allItems: "All",
    restore: "Restore",
    permanentDelete: "Delete Permanently",
    confirmRestore: "Are you sure you want to restore this item?",
    confirmPermanentDelete: "This will permanently delete this item and all related records. This action cannot be undone.",
    itemRestored: "Item restored successfully",
    itemPermanentlyDeleted: "Item permanently deleted",
    addElevatorCompany: "Add Company",
    editElevatorCompany: "Edit Company",
    deleteElevatorCompany: "Delete Company",
    confirmDeleteElevatorCompany: "Are you sure you want to delete this company?",
    elevatorPaid: "Paid",
    elevatorUnpaid: "Unpaid",
    manageCompanies: "Manage Companies",
    maintenanceNotes: "Monthly Maintenance",
    maintenanceMonth: "Maintenance Month",
    netAmount: "Net Amount",
    grandTotal: "Grand Total",
    invoiceTotal: "Invoice Total",
    vatAmount: "VAT Amount",
    totalInclVat: "Total (incl. VAT)",
    elevatorCertificationCompanies: "Elevator Certification Companies",
    addCertificationCompany: "Add Company",
    editCertificationCompany: "Edit Company",
    deleteCertificationCompany: "Delete Company",
    confirmDeleteCertificationCompany: "Are you sure you want to delete this certification company?",
    noCertificationCompanies: "No elevator certification companies yet",
    selectMonth: "Select Month",
    selectYear: "Select Year",
    allMonths: "All Months",
    allYears: "All Years",
    extraCharges: "Extra Charges",
    addExtraCharge: "Add Extra Charge",
    chargeDescription: "Description",
    chargeAmount: "Amount",
    monthlyCharges: "Monthly Charges",
    totalExtraCharges: "Total Extra Charges",
    totalMonthlyCharges: "Total Monthly Charges",
    statementGrandTotal: "Grand Total",
    sourceInvoice: "Source Invoice",
    totalIncVat: "Total incl. VAT",
    recurringMonthly: "Recurring (Monthly)",
    oneTimeExtra: "One-time (Extra)",
    chargesSection: "Charges",
    paymentsSection: "Payments",
    extrasSection: "Extras",
    noExtraCharges: "No extra charges",
    elevatorDescPlaceholder: "e.g. Elevator maintenance, Repair, Inspection",
    extraChargesTotal: "Extra Charges Total",
    addNewCompany: "Add New Company",
    apartments: "Units / Apartments",
    apartmentNumber: "Apartment",
    ownerName: "Owner Name",
    monthlyFee: "Monthly Fee",
    addApartment: "Add Apartment",
    editApartment: "Edit Apartment",
    deleteApartment: "Delete Apartment",
    deleteApartmentWarning: "If this apartment has invoices or payments, it will be archived instead of deleted.",
    deleteSuccess: "Deleted successfully",
    noApartments: "No apartments",
    totalDue: "Total Due",
    totalPaid: "Total Paid",
    remainingBalance: "Balance",
    overdue: "Overdue",
    pending: "Pending",
    totalExpectedIncome: "Total Expected",
    totalCollected: "Total Collected",
    cashReceipts: "Cash Receipts",
    bankReceipts: "Bank Receipts",
    amountIn: "Amount In",
    amountOut: "Amount Out",
    runningBalance: "Running Balance",
    noCashTransactions: "No cash transactions recorded yet.",
    noBankTransactions: "No bank transactions recorded yet.",
    distributedAmount: "Distributed",
    repairs: "Repairs",
    repair: "Repair",
    reserveFundTab: "Reserve Fund",
    totalOutstanding: "Total Outstanding",
    totalCreditBalance: "Total Credit Balance",
    apartmentsOwing: "Apartments owing",
    apartmentsWithCredit: "Apartments with credit",
    netPosition: "Net Position",
    netPositionDesc: "Outstanding minus credits — what you actually need to collect.",
    of: "of",
    filterByPeriod: "Filter by Period",
    allTime: "All Time",
    customRange: "Custom Range",
    month: "Month",
    year: "Year",
    alertsNotifications: "Alerts & Notifications",
    topOutstanding: "Top Outstanding Balances",
    outstandingByCategory: "Outstanding by Category",
    recentPayments: "Recent Payments",
    recentExpenses: "Recent Expenses",
    noRecentPayments: "No recent payments",
    noRecentExpenses: "No recent expenses",
    buildingStatus: "Building Status",
    addPayment: "Add Payment",
    paymentHistory: "Payment History",
    deletePayment: "Delete Payment",
    noPayments: "No payments",
    recordPayment: "Record Payment",
    editReceipt: "Edit Receipt",
    invoiceAllocation: "Invoice Allocation",
    paymentAmount: "Amount Paid",
    viewApartments: "Apartments",

    // Annual Financial Statement
    annualFinancialStatement: "Annual Financial Statement",
    annualStatementDesc: "Generate and view the annual financial report for this building.",
    reserveFundStatement: "Reserve Fund Statement",
    reserveStatementDesc: "View savings per apartment, repairs from reserve, and net balance.",
    reserveStatementHint: "Enter the years and click Generate to create the reserve fund statement.",
    savingsBalancePerApartment: "Total Savings Balance per apartment",
    monthlySavingsSummary: "Monthly Expenses",
    savingsTotal: "Savings Total",
    totalSavingsBeforeRepairs: "Total Amount of Savings Before Repairs",
    repairsThroughReserve: "Repairs Through the Saving Account (Unexpected Expenses)",
    totalRepairs: "Total Repairs",
    totalSavingsNet: "Total Amount of Savings",
    years: "Years",
    yearsHint: "Comma-separated years, e.g. 2025,2026",
    month_short_1: "JAN", month_short_2: "FEB", month_short_3: "MAR", month_short_4: "APR",
    month_short_5: "MAY", month_short_6: "JUN", month_short_7: "JUL", month_short_8: "AUG",
    month_short_9: "SEP", month_short_10: "OCT", month_short_11: "NOV", month_short_12: "DEC",
    generateReport: "Generate Report",
    generate: "Generate",
    sendViaEmail: "Send via Email",
    exportPDF: "Export PDF",
    exportExcel: "Export Excel",
    exportSuccess: "Export completed successfully",
    year: "Year",
    period: "Period",
    openingBalance: "Opening Balance",
    setOpeningBalance: "Set Opening Balance",
    noOpeningBalance: "No opening balance set",
    openingBalanceHint: "Positive = surplus, Negative = deficit at the given date",
    elevatorOpeningBalance: "Elevator Opening Balance",
    elevatorBalance: "Elevator Balance",
    currentBalance: "Current Balance",
    changeHistory: "Change History",
    cleared: "Cleared",
    clear: "Clear",
    buildingTotal: "Building Total",
    averagePerJob: "Avg / Job",
    dailyTotal: "Daily Total",
    officeJob: "Office Job",
    buildingJob: "Building Job",
    officeCleaning: "Office Cleaning",
    buildingCleaning: "Building Cleaning",
    collapseAll: "Collapse All",
    expandAll: "Expand All",
    groupByDate: "Group by Date",
    groupByBuilding: "Group by Building",
    entries: "entries",
    jobsCount: "jobs",
    finalBalance: "Final Balance",
    closingCashBalance: "Closing Cash Balance",
    closingBankBalance: "Closing Bank Balance",
    totalClosingBalance: "Total Closing Balance",
    summary: "Summary",
    expenseBreakdown: "Expense Breakdown",
    signatures: "Signatures",
    president: "President",
    chairman: "Chairman",
    secretary: "Secretary",
    treasurer: "Treasurer",
    committee: "Committee",
    editCommittee: "Edit Committee",
    assignCommittee: "Assign Committee",
    noCommitteeAssigned: "No committee members assigned",
    notAssigned: "Not assigned",
    byAuthorization: "by authorization",
    electedWithAuthorization: "Elected with authorization (proxy)",
    authorizedBy: "Authorized by",
    selectApartment: "Link to apartment",
    manualEntryCommittee: "Manual entry",
    noTransactions: "No transactions for this period",
    selectYearAndGenerate: "Select a year and click Generate Report to create the annual financial statement",
    emailFeatureComingSoon: "Email feature coming soon",
    address: "Address",
    apartmentStatement: "Apartment Statement",
    closingBalance: "Closing Balance",
    totalCharges: "Total Charges",
    totalPayments: "Total Payments",
    included: "Included",
    dateFrom: "From",
    dateTo: "To",
    generateStatement: "Generate Statement",
    charge: "Charge",
    payment: "Payment",
    selectApartment: "Select Apartment",
    downloadPdf: "Download PDF",
    printPdf: "Print PDF",
    printAllPayments: "Print ALL Payments",
    allPayments: "All Payments",

    // Insurance Companies
    insuranceCompanies: "Insurance Companies",
    addInsuranceCompany: "Add Insurance Company",
    editInsuranceCompany: "Edit Insurance Company",
    deleteInsuranceCompany: "Delete Insurance Company",
    confirmDeleteCompany: "Are you sure you want to delete this insurance company? This cannot be undone.",
    noInsuranceCompanies: "No insurance companies added yet",
    selectCompany: "Select Company",
    typeManually: "Type Manually",
    contactInfo: "Contact Information",
    contactPerson: "Contact Person",
    contactName: "Contact Name",
    contactPhone: "Contact Phone",
    phoneNumber: "Phone Number",
    totalContracts: "Total Contracts",
    expiringSoonPolicies: "Expiring Soon",
    insuredBuildings: "Insured Buildings",
    companyProfile: "Company Profile",
    vatRegistrationNumber: "VAT Registration Number",
    companyProfileHint: "Manage your company information used across all documents and reports",
    companyNameLine2: "Company Name (Line 2)",

    // Task improvements
    apartment: "Apartment",
    wholeBuilding: "Whole Building",
    customTaskType: "Custom Task Type",
    customTaskPlaceholder: "e.g. Owner request, Leak issue...",
    reminderDate: "Reminder Date",
    important: "Important",
    overdue: "Overdue",
    custom: "Custom",
    taskReminders: "Task Reminders",
    today: "Today",
    noTasks: "No tasks found",

    // Insurance updates
    policyNumber: "Policy Number",
    insuranceDetails: "Insurance Details",
    insuranceHistory: "Insurance History",
    latest: "Latest",

    // Dashboard Alerts
    upcomingExpirations: "Upcoming Expirations",
    insuranceExpiring: "Insurance Expiring",
    elevatorCertification: "Elevator Certification",
    addCertification: "Add Certification",
    addFollowUp: "Follow-up",
    followUpInspection: "Follow-up Inspection",
    followUpOf: "Follow-up of",
    repaired: "Repaired",
    repairCompletedDate: "Repair Completed Date",
    resolvedByFollowup: "Resolved by follow-up",
    editCertification: "Edit Certification",
    deleteCertification: "Delete Certification",
    confirmDeleteCertification: "Are you sure you want to delete this certification record?",
    noCertifications: "No elevator certification records yet",
    nextInspectionDate: "Next Inspection Date",
    failureReason: "Failure Reason",
    failureReasons: "Failure Reasons",
    addNewFailureReason: "Type new reason and press Enter or click +",
    selectReason: "Select reason",
    safetyIssue: "Safety issue",
    electricalIssue: "Electrical issue",
    mechanicalIssue: "Mechanical issue",
    documentationMissing: "Documentation missing",
    other: "Other",
    selectCompany: "Select company",
    inspectionOverdue: "Inspection overdue by",
    inspectionDueIn: "Inspection due in",
    failureReasons: "Failure Reasons",
    addFailureReason: "Add Reason",
    editFailureReason: "Edit Reason",
    deleteFailureReason: "Delete Reason",
    confirmDeleteFailureReason: "Are you sure you want to delete this failure reason? It will not be removed from past records.",
    noFailureReasons: "No failure reasons defined yet",
    reasonName: "Reason Name",
    taskTypes: "Task Types",
    addTaskType: "Add Task Type",
    editTaskType: "Edit Task Type",
    deleteTaskType: "Delete Task Type",
    confirmDeleteTaskType: "Are you sure you want to delete this task type? Types in use cannot be deleted.",
    noTaskTypes: "No task types defined yet",
    selectTaskType: "Select task type",
    certificationFailed: "Certification FAILED",
    inspectionDate: "Inspection Date",
    expiryDate: "Expiry Date",
    certificateNumber: "Certificate Number",
    inspector: "Inspector",
    result: "Result",
    passed: "Passed",
    failed: "Failed",
    conditional: "Conditional",
    cost: "Cost",
    urgent: "Urgent",
    ok: "OK",
    insuranceExpiresIn: "Insurance expires in",
    insuranceExpiredAgo: "Insurance expired",
    elevatorDueIn: "Elevator inspection due in",
    elevatorExpiredAgo: "Elevator inspection overdue by",
    lastInspection: "Last Inspection",
    nextInspection: "Next Inspection",
    latestCertification: "Latest Certification",
    noCertificationYet: "No certification recorded yet",
    certificationDate: "Date of Certification",
    inspectionInProgressMsg: "Inspection is pending / in progress",
    certificationHistory: "Certification History",
    updateStatus: "Update Status",
    totalRecords: "Total records",
    createdAt: "Created At",
    selectFailureReasons: "Select failure reasons",
    searchReasons: "Search reasons…",
    noReasonFound: "No reason found",
    reasonsSelected: "selected",
    expand: "Expand",
    hide: "Hide",
    viewBreakdown: "View breakdown",
    locked: "Locked",
    passedFinalMsg: "This certification is final. Add a new one to start a new cycle.",
    editCycleTitle: "Edit Certification",
    incl: "incl.",
    allCertifications: "All Certifications",
    allCertificationsDescription: "Each certification is an independent record with its own lifecycle.",
    certificationCycle: "Certification",
    current: "Current",
    historyOfThisCert: "Edits to this certification",
    shared: "Shared",
    sharedDesc: "Split across apartments",
    buildingFund: "Building Fund",
    buildingFundDesc: "Paid from building fund",
    noPaymentsYet: "No payments recorded yet",
    optionalNotes: "Optional notes",
    enterValidAmount: "Please enter a valid amount",
    unpaidRepairs: "Unpaid Repairs",
    bankAccount: "Bank Account",
    deductFromReserveFund: "Deduct from Reserve Fund",
    viewStatement: "View Statement",
    outstandingDesc: "All apartments with their invoiced / paid / remaining balance. Negative values indicate credit balances (overpaid).",
    viewOutstandingDetails: "Click to view all apartment outstanding balances",
    invoiced: "Invoiced",
    ownerName: "Owner Name",
    markAsActiveCommittee: "Mark as Active Management Committee meeting",
    activeCommitteeMeetingHint: "This meeting defines the active Management Committee — click to unset",
    activeCommitteeSet: "Marked as Active Management Committee",
    activeCommitteeUnset: "Unmarked as Active Management Committee",
    reserveFundAvailable: "Reserve Fund available",
    paymentExceedsRemaining: "Payment exceeds remaining balance",
    selectBankAccount: "Select bank account",
    noBankAccountsConfigured: "No bank accounts configured. Add one in Finance → Bank Accounts.",
    yes: "Yes",

    // Inline Edit & Apartment fields
    changesSaved: "Changes saved",
    commonExpenses: "Common Expenses",
    reserveFund: "Reserve Fund",
    reserveFundHistory: "Reserve Fund History",
    reserveFundTransactions: "Reserve Fund Transactions",
    reserveFundManagedFromAnnual: "Reserve Fund base amount is managed from Annual Expenses",
    share: "Share",
    previousAmount: "Previous Amount",
    newAmount: "New Amount",
    changedAt: "Changed At",
    changedBy: "Changed By",
    noChanges: "No changes recorded",
    sharePercentage: "Share (%)",
    shareUnder100: "Total share is under 100%",
    shareOver100: "Total share exceeds 100%",
    totalDue: "Total Due",
    pay: "Pay",
    recordPayment: "Record Payment",
    noApartments: "No apartments found",
    apartments: "Apartments",
    total: "Total",
    // Receipt & Payment System
    receiptHistory: "Receipt History",
    receiptNumber: "Receipt No.",
    receiptNumberPlaceholder: "Leave empty to auto-generate (e.g. RCP-0017)",
    receiptNumberAlreadyExists: "Receipt number already exists.",
    receiptAutoHint: "Leave empty to auto-generate (REC-YYYY-NNNN)",
    optional: "optional",
    reference: "Reference",
    referenceNumber: "Receipt / Reference No.",
    referenceNumberHint: "Receipt, invoice or bank reference",
    receiptGenerated: "Receipt Generated",
    paymentRecorded: "Payment Recorded",
    buildingExpenses: "Building Expenses",
    commonExpensesDesc: "Payment from apartment owner (rent, common charges)",
    buildingExpensesDesc: "Payment to supplier or for building expenses",
    paymentMethod: "Payment Method",
    cash: "Cash",
    bankTransfer: "Bank Transfer",
    other: "Other",
    issuedTo: "Issued To",
    manualEntry: "— Manual entry (no linked expense) —",
    supplier: "Supplier",
    supplierPlaceholder: "Company or supplier name",
    selectExpense: "Select Expense",
    selectAtLeastOneInvoice: "Select at least one invoice to pay",
    totalToPay: "Total to Pay",
    // Customer Card
    customerProfile: "Customer Profile",
    overview: "Overview",
    invoices: "Invoices",
    payments: "Payments",
    statement: "Statement",
    totalDue: "Total Due",
    totalPaid: "Total Paid",
    remainingBalance: "Remaining Balance",
    totalCharges: "Total Charges",
    totalPayments: "Total Payments",
    charges: "Charges",
    description: "Description",
    balance: "Balance",
    noOwner: "No Owner",
    cleanerPayment: "Cleaner Payment",
    totalCleanerPayments: "Total Cleaner Payments",
    addAnotherCleaner: "Add Another Cleaner",
    addCleaningType: "Add Cleaning Type",
    finance: "Finance",
    bills: "Bills",
    addBill: "Add Bill",
    editBill: "Edit Bill",
    billsDescription: "Recurring expenses and obligations",
    billStatement: "Bill Statement",
    unpaidBillsSection: "Unpaid Bills",
    billTimeline: "Timeline",
    addInvoiceToBill: "Add Invoice",
    recordPaymentToBill: "Record Payment",
    totalInvoiced: "Total Invoiced",
    totalPaidAmount: "Total Paid",
    billBalance: "Balance",
    viewStatement: "View Statement",
    backToBills: "Back to Bills",
    invoiceCreated: "Invoice Created",
    paymentMade: "Payment Made",
    noBillActivity: "No activity yet. Add an invoice to start tracking.",
    dueDate: "Due Date",
    sortedByDueDate: "Sorted by nearest due date",
    totalBills: "Total Bills",
    unpaidBills: "Unpaid",
    noBills: "No bills yet",
    nextPayment: "Next Payment",
    dueSoon: "Due Soon",
    scheduled: "Scheduled",
    markPaid: "Mark Paid",
    reminderDays: "Reminder (days before)",
    yearlyTotal: "Yearly Total",
    nameRequired: "Name is required",
    amountRequired: "Amount is required",
    bankAccounts: "Bank Accounts",
    addBankAccount: "Add Bank Account",
    editBankAccount: "Edit Bank Account",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    openingBalance: "Opening Balance",
    currentBalance: "Current Balance",
    companyIncome: "Income",
    companyExpenses: "Expenses",
    addIncome: "Add Income",
    addExpense: "Add Expense",
    editIncome: "Edit Income",
    editExpense: "Edit Expense",
    incomeDescription: "Description",
    expenseCategory: "Category",
    paymentSource: "Payment Source",
    totalIncome: "Total Income",
    totalSupplierExpenses: "Total Supplier Expenses",
    netBalance: "Net Balance",
    expenseCategories: "Reference Categories",
    referenceCategories: "Reference Categories",
    expenseCategoriesDesc: "Helper / reference labels for bank movements and manual categorization. These DO NOT contribute to Total Expenses — only actual expense records (Purchases → Expenses) do.",
    expensesByCategory: "Expenses by Category",
    default: "Default",
    addCategory: "Add Category",
    categoryName: "Category Name",
    selectClient: "Select Client",
    clientRequired: "Client is required",
    selectCategory: "Select Category",
    selectBank: "Select Bank Account",
    selectSource: "Select Source",
    cashSource: "Cash",
    bankSource: "Bank",
    bankIncome: "Bank Income",
    cashIncome: "Cash Income",
    addCashIncome: "Add Cash Income",
    noCashIncome: "No cash income entries",
    cashNoVatNotice: "Cash income: No VAT or 12.5% applied. Simple tracking only.",
    noVatNoAllocation: "No VAT / No 12.5%",
    noIncome: "No income entries",
    noExpenses: "No expense entries",
    financialOverview: "Financial Overview",
    netIncome: "Net Income",
    vatTotal: "VAT (19%)",
    grossIncome: "Gross Income",
    netAmount: "Net",
    vatAmount: "VAT",
    allocation125: "12.5% Allocation",
    allocation125Tab: "12.5% Allocation",
    totalNet: "Total Net",
    totalAllocation: "Total 12.5%",
    vatIncluded: "Amount includes VAT",
    vatNotIncluded: "Amount is NET (VAT will be added)",
    incomeSource: "Income Source",
    transactions: "Transactions",
    balanceAfter: "Balance After",
    noTransactions: "No transactions found",
    viewDetails: "View Details",
    allCategories: "All Categories",
    allSources: "All Sources",
    allClients: "All Clients",
    syncToCleaning: "Sync with Cleaning Management",
    // Phase 523 — Finance treasury classification (Internal Cash isolation).
    affectsTreasury: "Affects Company Treasury?",
    treasuryYes: "Yes — Official Company Cash",
    treasuryNo: "No — Internal Cash",
    treasuryYesHint: "Adds to bank account balance and appears in the bank statement.",
    treasuryNoHint: "Tracked only for internal bookkeeping. Auto-routed to the Internal Cash wallet — excluded from bank account totals and bank statements.",
    badgeInternalCash: "Internal",
    referenceNumber: "Reference #",
    bankAccountRequired: "Please select a bank account when the source is \"bank\".",
    autoAllocateOldestFirst: "Auto Allocate Oldest First",
    allocateFull: "Full",
    allocateRemaining: "Remaining",
    allocateFullTooltip: "Fill with full remaining balance of this invoice",
    allocateRemainingTooltip: "Apply whatever payment amount is still free to this invoice",
    quickAllocate: "Quick",
    // Phase 488 — Company Branding
    branding: "Branding",
    noLogoUploaded: "No logo uploaded",
    logoHelperText: "Appears on all invoices, statements, PDFs, and emails. PNG, JPG, SVG, WEBP — max 500KB.",
    uploadLogo: "Upload Logo",
    replaceLogo: "Replace Logo",
    removeLogo: "Remove",
    uploading: "Uploading...",
    logoUpdated: "Logo updated",
    logoRemoved: "Logo removed",
    logoFormatError: "Logo must be PNG, JPG, JPEG or SVG",
    logoSizeError: "Logo file is too large.",
    logoCompressed: "Logo auto-compressed",
    website: "Website",
    registrationNumber: "Registration Number",
    // Phase 483 — Automatic Customer Payment Allocation
    allocatePaymentTitle: "Allocate payment to invoices",
    allocatePaymentSubtitle: "Apply €{amount} from {client} to one or more open invoices",
    allocSingle: "Single invoice",
    allocMulti: "Multiple invoices",
    allocAuto: "Auto FIFO (oldest first)",
    invoiceNo: "Invoice #",
    total: "Total",
    remaining: "Remaining",
    applyAmount: "Apply €",
    paymentAmount: "Payment amount",
    totalAllocated: "Total allocated",
    remainingUnallocated: "Remaining unallocated",
    allocateLater: "Skip / Allocate later",
    applyAllocation: "Apply allocation",
    applying: "Applying...",
    allocationApplied: "Allocation applied",
    allocationExceedsPayment: "Allocation exceeds payment amount",
    enterAllocationAmounts: "Enter at least one allocation amount",
    selectInvoice: "Select an invoice",
    linkedInvoices: "Linked invoices",
    unallocatedCredit: "Unallocated credit",
    syncedFromFinance: "From Finance",
    autoFromBuilding: "Auto from Building",
    autoFromHistory: "Auto from Cleaning History",
    finalNet: "Final Net",
    finalNetBalance: "Final Net Balance",
    deductedFrom: "Deducted From",
    bucketVat: "VAT",
    bucketAllocation: "12.5%",
    bucketReserve: "Reserve 10%",
    bucketNet: "Net",
    reserve10: "Reserve 10%",
    socialInsurance10: "Social Insurance (10%)",
    columns: "Columns",
    bucketSocialInsurance: "Social Ins. 10%",
    bucketFinalBalance: "Final Balance",
    vatDisplayOnlyTooltip: "Informational only — NOT included in Deductions or Final Balance calculations.",
    vatInfoOnlyNote: "VAT is informational only and NOT included in deductions.",
    deductionsRemaining: "Deductions Remaining",
    accrued: "Accrued",
    totalIncomeWithVat: "Total Income (with VAT)",
    netIncomeWithoutVat: "Net Income (without VAT)",
    gross: "Gross",
    paymentsTotal: "Payments",
    bucketBalance: "Bucket Balance",
    ledgerLegend: "Rows with + are VAT / contributions collected from income. Rows with − are payments made from each bucket.",
    paidFrom: "Paid From",
    paidFromRequired: "Paid From is required",
    paidFromDesc: "Select which fund the money is deducted from",
    paidFromVat: "VAT",
    paidFromSocialInsurance: "Social Insurance",
    paidFrom125: "12.5% Tax",
    paidFromReserve: "Reserve",
    paidFromFinalBalance: "Final Balance",
    freeBalance: "Final Balance",
    bankBalance: "Bank Balance",
    managePurchaseCategories: "Manage Purchase Categories",
    vatFromGross: "19% from Gross",
    fromNet: "from Net",
    availableBalance: "Available Balance",
    netAfterDeductions: "Net after all deductions",
    netIncomeBeforeDeductions: "Net Income (Before Deductions)",
    deductionsBreakdown: "Deductions",
    deductions: "Deductions",
    deductionsTooltip: "12.5% + Reserve 10% + Social Insurance 10%",
    totalGrossIncome: "Total Income (Gross)",
    finalBalance: "Final Balance",
    totalCashIncome: "Total Cash Income",
    bankIncomeOnly: "Bank income only",
    backToFinance: "Back to Finance",
    runningBalance: "Running Balance",
    autoImported: "Auto-imported",
    removeCleaner: "Remove Cleaner",
    totalPayment: "Total Payment",
    multipleCleaners: "Multiple Cleaners",
    selectedPeriod: "Selected Period",
    monthlyBreakdown: "Monthly Breakdown",
    noPayments: "No payments found",
    editApartment: "Edit Apartment",
    payNow: "Pay Now",
    noInvoices: "No unpaid invoices found",
    remaining: "Remaining",
    back: "Back",
    close: "Close",
    type: "Type",
    period: "Period",
    apartment: "Apartment",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    thisYear: "This Year",
    custom: "Custom",
    showingDataFor: "Showing data for",
    collectedThisPeriod: "Collected this period",
    outstandingThisPeriod: "Outstanding this period",
    previousPeriod: "Previous Period",
    currentPeriod: "Current Period",
    difference: "Difference",
    periodComparison: "Period Comparison",
    expensesPaidInPeriod: "Expenses Paid",
    expensesUnpaidInPeriod: "Expenses Unpaid",
    elevatorExpensesInPeriod: "Elevator Expenses",
    active: "Active",
    inactive: "Inactive",
    closed: "Closed",
    closeBuilding: "Close Building",
    reopenBuilding: "Reopen Building",
    closeDate: "Close Date",
    closeReason: "Reason",
    closedOn: "Closed on",
    confirmCloseBuilding: "Are you sure you want to close this building? All history will be preserved. No new entries or payments can be added.",
    buildingClosed: "Building closed",
    buildingReopened: "Building reopened",
    closedBuildingBanner: "This building is closed. No new entries can be added.",
    reasonClientStopped: "Client stopped cooperation",
    reasonPaymentIssues: "Payment issues",
    reasonWeStoppedService: "We stopped service",
    reasonBuildingSold: "Building sold",
    reasonOther: "Other",
    manageTypes: "Manage Types",
    addType: "Add Type",
    typeName: "Type Name",
    typeNameEn: "Name (English)",
    typeNameEl: "Name (Greek)",
    typeKey: "Key",
    typeUsedInRecords: "Type is used in records and cannot be deleted",
    editType: "Edit Type",
    deleteType: "Delete Type",
    confirmDeleteType: "Are you sure you want to delete this cleaning type?",
    typeAdded: "Type added",
    typeUpdated: "Type updated",
    typeDeleted: "Type deleted",
    thresholdDays: "Alert Threshold (days)",
    actions: "Actions",
    totalReserveFund: "Total Reserve Fund",
    annualReserveFund: "Annual Reserve Fund",
    monthlyReserveFund: "Monthly Reserve Fund",
    reserveFundCollected: "Reserve Fund Collected",
    reserveFundFromPayments: "Calculated from payments",
    collectedReserveFund: "Collected Reserve Fund",
    basedOnPaidInvoicesOnly: "Based on paid invoices only",
    of: "of",
    annualTarget: "Annual Target",
    reserveFundDeductions: "Reserve fund deductions",
    pendingCollection: "Pending Collection",
    unpaidReservePortion: "Reserve portion of unpaid invoices",
    collectionProgress: "Collection Progress",
    monthlyShare: "Monthly Share",
    extraReserveFund: "Extra Monthly Reserve",
    extraReserveMode: "Distribution Mode",
    bySharePercentage: "By Share (%)",
    fixedPerApartment: "Fixed Per Apartment",
    extraReserveMonthly: "Monthly Total",
    extraReserveFixed: "Fixed Amount Per Apartment",
    extraReserveColumn: "Extra Reserve",
    combinedMonthlyTotal: "Combined Monthly Total (Reserve + Extra)",
    stopExtraReserve: "Stop",
    confirmStopExtraReserve: "Stop Extra Monthly Reserve? Historical data remains intact.",
    extraReserveStopped: "Extra Reserve stopped",
    activeVersion: "Active Version",
    ongoing: "ongoing",
    generateExtraReserveInvoices: "Generate Monthly Invoices",
    extraReserveInvoicesGenerated: "Monthly invoices generated (includes extra reserve)",
    extraReserveIncluded: "Extra reserve is included in common expenses invoice",
    selectPeriod: "Select Period",
    historyUsedInInvoices: "This record is used in invoices",
    confirmDeleteUsedHistory: "This record is used in {count} invoice(s). Deleting it may affect financial reports. Delete anyway?",
    reserveAmountLabel: "Reserve",
    extraReserve: "Extra Reserve",
    totalAdded: "Total",
    buildingFundsOnlyHint: "Repair payments use this building's Cash Receipts / Bank Receipts — never company finance accounts.",
    cashReceiptsBuilding: "Cash Receipts (Building)",
    bankReceiptsBuilding: "Bank Receipts (Building)",
    categoryRequired: "Category is required",
    vendorRequired: "Vendor is required",
    selectRepair: "Select Repair",
    selectRepairToPay: "Select the repair this payment applies to",
    repairPaymentPickerHint: "Only active repairs with a remaining balance are shown. Continue to enter payment details.",
    rcpNo: "RCP No",
    charge: "Charge",
    balance: "Balance",
    reserveFund: "Reserve Fund",
    reserveFundManual: "Manual",
    reserveFundAuto: "Auto",
    recalculate: "Recalculate",
    resetToAuto: "Reset to Auto",
    reserveFundUpdated: "Reserve fund updated",
    reserveFundRecalculated: "Reserve fund recalculated",
    reserveFundDistributed: "Reserve fund saved and distributed",
    repairsFundDistributed: "Repairs fund saved and distributed",
    saveAndDistribute: "Save & Distribute",
    saveAsNewVersion: "Save as New Version",
    confirmDeleteHistoryEntry: "Delete this history entry? This does not re-issue invoices.",
    history: "History",
    saveDistributesAuto: "Saving automatically distributes to auto-mode apartments",
    annualExpenses: "Annual Expenses",
    annualAmount: "Annual Amount",
    actual: "Actual",
    distributionPerApartment: "Distribution per Apartment",
    repairAmount: "Repair Amount",
    allocatedAmount: "Allocated Amount",
    recalculateByPercentages: "Recalculate by %",
    recalculatedByPercentages: "Amounts recalculated from shares",
    zeroAmountNotAllowed: "Amount must be greater than 0 for",
    allocationSumMustEqualTotal: "Allocations must sum to the repair total",
    editExpenses: "Edit Expenses",
    mode: "Mode",
    operationalExpenses: "Operational Expenses",
    operationalTotal: "Operational Total",
    oneTime: "One-time",
    monthly: "Monthly",
    onlyOperationalDistributed: "Only operational (monthly) expenses are distributed to apartments. Capital expenses (repairs, one-time) are tracked separately.",
    autoFilledFrom: "Amounts auto-filled from year",
    type: "Type",
    monthlyTotal: "Monthly Total",
    monthlyTotalDesc: "Monthly common expenses per apartment (Annual Operational / 12)",
    includeInCalc: "Include",
    alwaysIncluded: "always included",
    onlyIncluded: "only included categories",
    distributionSource: "Distribution Source",
    distributionSourceDesc: "Choose which data source drives Operational Total, Monthly Total, and per-apartment distribution.",
    actualExpenses: "Actual Expenses",
    annualBudget: "Annual Budget",
    source: "Source",
    includedCategories: "Included Categories",
    includedCategoriesDesc: "Choose which categories participate in Operational Total, Monthly Total, and per-apartment distribution.",
    categoriesSelected: "categories",
    selectCategories: "Select categories",
    selectAll: "Select all",
    selectNone: "Clear all",
    budget: "Budget",
    monthlyActual: "Monthly (Actual)",
    monthlyBudget: "Monthly (Budget)",
    totalActual: "Total (Actual)",
    actualTotalDivided: "Actual / 12",
    monthlyTotalDescActual: "Average monthly spend = Actual / 12",
    monthlyBase: "Monthly Base",
    totalRounded: "Total (Rounded)",
    roundedDivided: "Rounded / 12",
    monthlyTotalDescRounded: "Average monthly spend = Rounded Actual / 12",
    original: "Original",
    autoCalculated: "Auto-calculated",
    finalMonthly: "Final Monthly",
    monthlyPerApartment: "Monthly fee per apartment (based on share %)",
    monthlyAmount: "Monthly Amount",
    loadFromExpenses: "Load from Expenses",
    loadedFromExpenses: "Loaded from building expenses",
    entries: "entries",
    automatic: "Auto",
    reserveFundHistory: "Reserve Fund History",
    totalDistributed: "Total Distributed",
    reserveFundWarning: "Reserve fund distribution mismatch",
    notCleanedThisMonth: "Not cleaned this month",
    paymentSource: "Payment Source",
    cashBalance: "Cash Balance",
    bankBalance: "Bank Balance",
    reserveFundBalance: "Reserve Fund Balance",
    cash: "Cash",
    bank: "Bank",
    credit: "Credit",
    fundBalances: "Fund Balances",
    insufficientBalance: "Insufficient balance",
    fundTransactions: "Fund Transactions",
    setBalances: "Set Balances",
    balanceSaved: "Balance saved",
    outstandingExpenses: "Outstanding",
    unpaidLeaveOpen: "Unpaid (leave open)",
    paymentSourceHint: "Select a source to pay immediately, or leave as Unpaid",
    recurringMonthlyExpense: "Recurring Monthly Expense",
    recurringExpenses: "Recurring Expenses",
    addRecurringExpense: "Add Recurring Expense",
    editRecurringExpense: "Edit Recurring Expense",
    noRecurringExpenses: "No recurring expenses configured",
    recurringExpenseHint: "Auto-generated every month on the specified day",
    generatedOnDay: "Generated on day",
    recurringDay: "Day of month",
    recurringDayHint: "Charge will be auto-created on this day each month",
    expenseCreatedUnpaid: "Expense will be created as unpaid. Use 'Add Payment' to record payments.",
    paidFromReserveFund: "Paid from Reserve Fund",
    deductFromReserveFund: "Deduct from Reserve Fund",
    // Phase 708 — Reserve Fund Deduction structured fields (EN)
    reserveFundDeduction: "Reserve Fund Deduction",
    amountDeducted: "Amount Deducted",
    coveredByAnnualBudget: "Covered by Annual Budget",
    deductFromReserveFund: "Deduct from Reserve Fund",
    reason: "Reason",
    selectReason: "Select reason…",
    referenceOptional: "Reference (optional)",
    rfDescriptionPlaceholder: "e.g. Electricity bill exceeded annual budget by €200",
    rfReferencePlaceholder: "e.g. EAC Invoice 24/06/2025",
    rfReason_UnexpectedExpense: "Unexpected Expense",
    rfReason_AnnualBudgetAdjustment: "Annual Budget Adjustment",
    rfReason_EmergencyRepair: "Emergency Repair",
    rfReason_MajorRepair: "Major Repair",
    rfReason_CapitalImprovement: "Capital Improvement",
    rfReason_InsuranceExcess: "Insurance Excess",
    rfReason_UtilityCostDifference: "Utility Cost Difference",
    rfReason_Legacyentry: "Legacy entry",
    rfReason_Other: "Other",
    available: "available",
    requested: "requested",
    englishName: "English Name",
    greekName: "Greek Name",
    optionalFallbackToEnglish: "Optional — falls back to English",
    incomeOnly: "from income only",
    percent: "%",
    totalDeductions: "Total Deductions",
    clickForBreakdown: "Click for breakdown",
    mustMatchTopMetric: "must match top metric",
    addNotesOptional: "Add notes (optional)",
    selectCategoryToSeeHistory: "Select a category to see its expense history.",
    expenseHistory: "Expense History",
    entry: "entry",
    // Phase 86 — Suppliers / Purchases
    purchases: "Purchases",
    suppliers: "Suppliers",
    suppliersDesc: "Track one-time purchases and running supplier ledgers.",
    addSupplier: "Add Supplier",
    editSupplier: "Edit Supplier",
    supplierType: "Type",
    oneTimeType: "One-time",
    statementType: "Ledger",
    oneTimeTypeLabel: "One-time Purchase (simple expense)",
    statementTypeLabel: "Statement-based (running balance)",
    oneTimeSupplierDesc: "Quick-entry purchases without a running balance.",
    statementSupplierDesc: "Tracks invoices and payments with a running supplier balance.",
    noSuppliers: "No suppliers yet",
    selectSupplier: "Select a supplier to view details.",
    outstandingBalance: "Outstanding Balance",
    totalPurchases: "Total Purchases",
    invoicesLabel: "Invoices",
    paymentsLabel: "Payments",
    addPurchase: "Add Purchase",
    editPurchase: "Edit Purchase",
    noPurchases: "No purchases recorded",
    addInvoice: "Add Invoice",
    editInvoice: "Edit Invoice",
    noInvoices: "No invoices recorded",
    invoiceNumber: "Invoice #",
    invoice: "Invoice",
    addPayment: "Add Payment",
    editPayment: "Edit Payment",
    noPayments: "No payments recorded",
    noTransactions: "No transactions yet",
    paymentMethod: "Payment Method",
    bankAccount: "Bank Account",
    autoCalc: "auto",
    legacyOneTimeSupplierNotice: "This supplier was created with the legacy \"one-time\" type. Record new purchases in Expenses under a category; this entry is read-only.",
    categoryRequired: "Please select a category for this expense.",
    optionalShort: "Optional",
    expensesListDesc: "Standalone one-time purchases with categories, VAT and payment source.",
    bankExpenseReflectionNote: "Note: expense entries are reflections from Purchases → Expenses. Edit or delete them only from the Expenses page.",
    openingBalanceTopTooltip: "Sum of bank account opening balances ONLY (excludes cash, VAT, and deductions).",
    totalIncomeTopTooltip: "Bank income only. Cash income is tracked separately in the Bank Accounts → Cash block.",
    banksOnly: "banks only",
    finalBalanceTopTooltip: "Opening Balance + Income − Expenses. Matches the running balance at the bottom of each bank / cash statement.",
    purchaseCategories: "Purchase Categories",
    purchaseCategoriesDesc: "Independent categories for Purchases → Expenses. Not shared with Finance expense categories.",
    noPurchaseCategories: "No purchase categories yet. Add one to start logging expenses.",
    noPurchaseCategoriesHint: "Add a purchase category first (Purchases → Purchase Categories).",
    usage: "Usage",
    payments: "Payments",
    addPayment: "Add Payment",
    editPayment: "Edit Payment",
    noPayments: "No payments recorded.",
    categoryOrSupplier: "Category or Supplier",
    selectCategoryOrSupplier: "Select category or supplier",
    categoryOrSupplierRequired: "Category or Supplier is required",
    asOf: "as of",
    noExpenseCategoriesHint: "Add an expense category first (Finance → Expense Categories).",
    viewInFinance: "View in Finance",
    cascadeDeleteTitle: "Related records found",
    cascadeDeleteConfirm: "Delete All",
    bucket: "Bucket",
    bucketHelp: "Optional — link this category to an allocation bucket (VAT, 12.5%, Reserve, Social). Payments against it will reduce that bucket's available balance.",
    none: "None",
    availableBalance: "Available Balance",
    afterPayment: "After payment",
    exceedsBalance: "Exceeds available balance",
    exceedsBalanceTitle: "Payment exceeds available balance",
    paymentAmount: "Payment Amount",
    overdraftBy: "Overdraft by",
    proceedAnyway: "Proceed Anyway",
    amountMustBePositive: "Amount must be positive",
    allocation: "Allocation",
    official: "Official",
    internal: "Internal",
    totalAllocated: "Allocated",
    totalPaid: "Paid",
    noEntries: "No entries yet.",
    type: "Type",
    reference: "Reference",
    vatPaid: "VAT Paid",
    vatPaidDesc: "Input VAT — total VAT you have paid via Supplier Invoices and standalone Expenses. Income VAT is excluded.",
    vatFromSuppliers: "VAT from Suppliers",
    vatFromExpenses: "VAT from Expenses",
    totalVatPaid: "Total VAT Paid",
    suppliersVat: "Suppliers VAT",
    expensesVat: "Expenses VAT",
    invoices: "invoices",
    invoice: "Invoice",
    noVatEntries: "No VAT entries in this period.",

    suppliersOutstandingBalances: "Suppliers Outstanding Balances",
    suppliersOutstandingDesc: "Suppliers you still owe money to, sorted by highest balance first. Click a row to open the supplier statement.",
    supplierName: "Supplier Name",
    totalInvoices: "Total Invoices",
    totalPaid: "Total Paid",
    totalOwed: "Total Owed",
    allSuppliersPaid: "All suppliers are paid up",
    allSuppliersPaidDesc: "Every supplier ledger has a zero or negative balance — nothing outstanding.",
    received: "Received",
    viewDetails: "View Details",
    pdfStatement: "PDF Statement",
    exportPdf: "Export PDF",
    exportExcel: "Export Excel",
    exportExpenses: "Export Expenses",
    exportFormat: "Format",
    expExportDateFrom: "Date From",
    expExportDateTo: "Date To",
    expExportType: "Expense Type",
    allTypes: "All Types",
    pdfExported: "PDF exported successfully",
    leaveDatesEmpty: "Leave dates empty to include all invoices",
    selectBuilding: "Select Building",
    manageBuildings: "Manage Buildings",
    managedBuildings: "Buildings (Management)",
    cleaningClients: "Cleaning Clients",
    menu: "Menu",
    manageCategories: "Manage Categories",
    addCategory: "Add New Category",
    categoryName: "Category Name",
    statementsComingSoon: "Statement generation will be available soon",
    totalApartments: "Total Apartments",
    assignedCompany: "Assigned Company",
    noCompanyAssigned: "No company assigned",
    noCompany: "No company",
    editCompany: "Edit Company",
    deleteCompany: "Delete Company",
    noCompanies: "No companies yet",
    accountStatement: "Account Statement",
    saveStatement: "Save Statement",
    savedStatements: "Saved Statements",
    statementNotes: "Statement Notes",
    statementNotesPlaceholder: "Internal notes for this apartment (not visible to customer)...",
    statementNotesHint: "These notes are for internal use only and will not appear on customer statements.",
    statementSaved: "Statement saved",
    totalRepairsFund: "Repairs",
    addRepair: "Add Repair",
    editRepair: "Edit Repair",
    deleteRepair: "Delete Repair",
    deleteRepairConfirm: "Are you sure you want to delete this repair entry?",
    repairsHistoryDesc: "Each repair is tracked individually with payment period",
    activeRepairsTotal: "Active Repairs Total",
    noRepairs: "No repair entries yet",
    generateInvoices: "Generate Invoices",
    generateInvoicesAndCreate: "Create & Generate Invoices",
    invoicesGenerated: "Invoices Generated",
    invoicesNotGenerated: "Not Invoiced",
    repairInvoicesCreated: "Repair invoices created successfully",
    invoicesAlreadyGenerated: "Invoices already generated for this repair",
    repairLabel: "Repair",
    markClosed: "Close",
    markActive: "Reopen",
    closeRepair: "Close this repair",
    reopenRepair: "Reopen this repair",
    close: "Close",
    reopen: "Reopen",
    repairDescPlaceholder: "e.g. Roof waterproofing, Pipe replacement",
    repairsCost: "Repairs",
    allPeriods: "All Periods",
    // Meetings
    documents: "Documents",
    meetings: "Meetings",
    meetingMinutes: "Meeting Minutes",
    newMeeting: "New Meeting",
    editMeeting: "Edit Meeting",
    meetingType: "Meeting Type",
    agm: "Annual General Meeting",
    extraordinary: "Extraordinary Meeting",
    committeeMeeting: "Committee Meeting",
    meetingDate: "Date",
    meetingTime: "Time",
    meetingLocation: "Location",
    nextMeetingDate: "Next Meeting Date",
    nextMeetingTime: "Next Meeting Time",
    nextMeetingHint: "Auto-used when quorum is not reached. Also appears on the Calendar.",
    sendForApproval: "Send for Approval",
    optional: "optional",
    attendance: "Attendance",
    presentAbsent: "Present / Absent / Represented",
    present: "Present",
    represented: "Represented",
    representedByPlaceholder: "Represented by...",
    absent: "Absent",
    quorum: "Quorum",
    quorumReached: "Quorum Reached",
    quorumNotReached: "Quorum Not Reached",
    endTime: "End Time",
    duration: "Duration",
    totalParticipants: "Total Participants",
    totalPresent: "Total Present",
    totalAbsent: "Total Absent",
    attendanceRate: "Attendance Rate",
    autoGeneratedTexts: "Auto-Generated Texts",
    generateTexts: "Generate Texts",
    quorumDurationText: "Quorum & Duration Paragraph",
    legalQuorumText: "Legal Quorum Text",
    committeeDecisionText: "Committee Decision Text",
    topicsDecisions: "Topics & Decisions",
    addTopic: "Add Topic",
    topicTitle: "Topic Title",
    topicDecision: "Decision / Notes",
    financialSnapshot: "Financial Snapshot",
    refreshSnapshot: "Refresh Snapshot",
    snapshotCapturedAt: "Snapshot captured at",
    generateMinutes: "Generate Meeting Minutes",
    exportPdf: "Export PDF",
    attachments: "Attachments",
    attachFiles: "Attach Files",
    attachmentUploadFailed: "Some files failed to upload",
    uploadFile: "Upload File",
    noMeetings: "No meetings recorded yet",
    meetingCreated: "Meeting created successfully",
    meetingUpdated: "Meeting updated successfully",
    includeFinancialSummary: "Include Financial Summary in document",
    includeFinancialSummaryHint: "Off by default; turn on only when you want the section to appear in the PDF.",
    meetingDeleted: "Meeting deleted successfully",
    deleteMeeting: "Delete Meeting",
    deleteMeetingConfirm: "Are you sure you want to delete this meeting?",
    draft: "Draft",
    finalized: "Finalized",
    finalizeMeeting: "Finalize",
    viewMeeting: "View Meeting",
    backToList: "Back to List",
    generalInfo: "General Information",
    totalExpectedIncome: "Total Expected",
    totalCollected: "Total Collected",
    totalOutstanding: "Outstanding",
    cashBalance: "Cash Balance",
    bankBalance: "Bank Balance",
    repairsTotal: "Repairs Total",
    noTopics: "No topics added",
    topicPlaceholder: "e.g. Election of Committee, Building Insurance...",
    selectTopic: "-- Select Topic --",
    customTopic: "Custom topic (type manually)",
    decisionPlaceholder: "Decision or notes for this topic...",
    selectPredefinedTopic: "-- Select common topic --",
    topicFireExtinguishers: "Fire Extinguishers",
    topicElectionCommittee: "Election of Management Committee",
    topicFinancialStatus: "Building Financial Status",
    topicIncreaseExpenses: "Increase of Common Expenses",
    topicBuildingRepairs: "Building Repairs",
    topicBuildingSafety: "Building Safety",
    topicElectricalIssues: "Electrical Issues",
    topicBankSignatureChanges: "Bank Signature Changes",
    signatures: "Signatures",
    president: "President",
    secretary: "Secretary",
    treasurer: "Treasurer",
    meetingOf: "Meeting of",
    // Topic Categories & Agenda Templates
    topicCategories: "Topic Categories",
    agendaTemplates: "Agenda Templates",
    addTopicCategory: "Add Category",
    editCategory: "Edit Category",
    deleteTopicCategory: "Delete Category",
    confirmDeleteCategory: "Are you sure you want to delete this topic category?",
    noTopicCategories: "No topic categories yet",
    nameEn: "Name (English)",
    nameEl: "Name (Greek)",
    addTemplate: "Add Template",
    templates: "Templates",
    editTemplate: "Edit Template",
    deleteTemplate: "Delete Template",
    confirmDeleteTemplate: "Are you sure you want to delete this agenda template?",
    noTemplates: "No agenda templates yet",
    templateName: "Template Name",
    topicCount: "Topics",
    topicTitleEn: "Topic Title (EN)",
    topicTitleEl: "Topic Title (EL)",
    selectCategory: "Select Category",
    loadFromTemplate: "Load from Template",
    applyTemplate: "Apply Template",
    templateApplied: "Template applied",
    confirmReplaceTopics: "Apply this template? This will REPLACE the current topics.",
    pickTemplatePrompt: "Pick a template on the left to preview its topics.",
    selectTemplate: "-- Select agenda template --",
    // Credit Notes & Auto Invoicing
    createCreditNote: "Create Credit Note",
    creditNoteCreated: "Credit note created successfully",
    creditNotePlaceholder: "e.g. Overcharge adjustment, Discount...",
    creditNotes: "Credit Notes",
    creditNote: "Credit Note",
    creditNoteNumber: "Credit Note #",
    creditNotesApplied: "Credit Notes Applied",
    editCreditNote: "Edit Credit Note",
    creditNoteUpdated: "Credit note updated successfully",
    creditNoteDeleted: "Credit note deleted",
    noCreditNotes: "No credit notes found",
    // Phase 659 — Supplier Credit Notes (Sales Returns)
    addCreditNote: "Add Credit Note",
    recordCreditNote: "Record Supplier Credit Note",
    creditNotesTab: "Credit Notes",
    deleteCreditNote: "Delete Credit Note",
    deleteCreditNoteConfirm: "Are you sure you want to delete this credit note? The amount will be added back to the supplier balance.",
    creditNoteNumberRequired: "Credit Note number is required",
    supplierRequired: "Supplier is required",
    supplierCnPlaceholder: "Supplier's CN number",
    relatedInvoice: "Related Invoice",
    relatedInvoiceOptional: "Related Invoice (optional)",
    noneCreatesOpenCredit: "— None (creates open credit) —",
    amountExclVat: "Amount (excl. VAT)",
    record: "Record",
    // Phase 661 — Search placeholders + dropdown helper text
    searchPlaceholderCn: "Search number, invoice, notes, date...",
    searchPlaceholderInvoices: "Search number, description, date...",
    searchPlaceholderPayments: "Search payment #, invoice, reference, source...",
    noMatchesForSearch: "No matches found",
    onlyUnpaidShown: "Only unpaid / partially-paid invoices are shown.",
    // Phase 662 — Multi-allocation + Auto VAT
    autoCalculateVat: "Auto calculate VAT",
    vatRate: "VAT Rate",
    totalAmount: "Total Amount",
    netAmount: "Net",
    manual: "manual",
    allocateToInvoices: "Allocate to Invoices (optional)",
    addAllocation: "Add Allocation",
    selectInvoice: "— Select invoice —",
    allocated: "Allocated",
    allocationsExceedTotal: "Allocations exceed credit note amount",
    creditNoteAmountRequired: "Amount must be greater than zero",
    remove: "Remove",
    // Phase 663 — Statement labels for the new Credit-Note row
    creditNoteSalesReturn: "Credit Note / Sales Return",
    // Phase 665 — Split Maintenance vs Other in Elevator Extra Charges
    otherExtraCharges: "Other Extra Charges",
    noMaintenanceCharges: "No monthly maintenance charges for selected period.",
    noOtherExtraCharges: "No other extra charges for selected period.",
    linkedInvoice: "Linked Invoice",
    autoInvoicing: "Automatic Invoicing",
    autoInvoicingDesc: "Generate invoices automatically on the 1st of each month for all apartments",
    recurringInvoices: "Recurring Invoices",
    recurringInvoicesDesc: "Set up automatic monthly invoice generation",
    createInvoice: "Create Invoice",
    editInvoice: "Edit Invoice",
    deleteInvoiceWarning: "This invoice will be deleted. If it has payments, it will be archived instead",
    invoiceHasPayments: "This invoice has payments",
    addRule: "Add Rule",
    editRule: "Edit Rule",
    dayOfMonth: "Day of Month",
    autoGenerated: "Auto-generated",
    paymentNumber: "Payment No.",
    balanceBroughtForward: "Balance Brought Forward",
    broughtForward: "B/F",
    activeFilters: "Active filters",
    clearAllFilters: "Clear all",
    removeFilter: "Remove filter",
    noFiltersApplied: "No filters applied",
    savedViews: "Saved Views",
    mySavedViews: "My Saved Views",
    noSavedViewsYet: "No saved views yet",
    saveCurrentView: "Save Current View",
    updateWithCurrentFilters: "Update with Current Filters",
    renameView: "Rename",
    deleteView: "Delete",
    confirmDeleteView: "Delete this saved view?",
    viewName: "View Name",
    viewNamePlaceholder: "e.g. Monthly Cleaning, Q1 Expenses",
    setAsDefault: "Set as default",
    removeDefault: "Remove default",
    setAsDefaultView: "Set as default (loads automatically when opening Expenses)",
    savedFiltersSummary: "The current Building, Category, Date range and Search filters will be saved with this view.",
    transferFunds: "Transfer Funds",
    transferFundsHint: "Internal transfer between Internal Cash and the Bank Account. Updates both balances but creates NO income or expense in accounting.",
    fromAccount: "From Account",
    toAccount: "To Account",
    internalCash: "Internal Cash",
    bankAccount: "Bank Account",
    transferReferencePlaceholder: "e.g. Cash deposit slip #1234",
    transferCreated: "Funds transferred",
    transferSameSourceError: "From and To accounts must differ",
    transferAmountError: "Amount must be greater than zero",
    dateRequired: "Date is required",
    // Phase 820.3 — Management Company Advances / Repayments
    mcaAdvance: "New Advance",
    mcaRepayment: "Repayment",
    mcaOutstandingBank: "Management Company Outstanding (Bank)",
    mcaOutstandingCash: "Management Company Outstanding (Cash)",
    // Phase 820.4 — Apartment Owner Credits / Reimbursements
    aocCredit: "Owner Credit",
    aocReimbursement: "Reimbursement",
    aocOutstandingBank: "Apartment Owner Credit Outstanding (Bank)",
    aocOutstandingCash: "Apartment Owner Credit Outstanding (Cash)",
    // Phase 850 — Recurring Invoice Email Delivery
    sendAgain: "Send Again",
    emailKillSwitch: "Kill-switch active — no email dispatched",
    // Phase 855 — Cyprus bilingual Company-Profile labels. These are stored
    // as a single bilingual string in BOTH language dictionaries so PDFs +
    // Settings form + downstream documents render identically regardless of
    // the user's UI language. Do NOT split into per-language variants.
    companyAddress: "Διεύθυνση / Address",
    companyPhone: "Τηλ./Tel.",
    companyVatRegNo: "V.A.T Reg. No / Αρ. Μητρώου Φ.Π.Α",
    companyTicNo: "T.I.C / Α.Φ.Τ",
    // Phase 900 — Collections module
    collections: "Collections",
    // Phase 910 — Communications module
    communications: "Communications",
    // Phase 920.3 — Owner Advances module
    ownerAdvances: "Owner Advances",
    ownerFeedback: "Owner Suggestions & Requests",
    ownerAdvanceReimbursement: "Owner Advance Reimbursement",
    default: "Default",
    modified: "Modified",
    viewSaved: "View saved",
    viewUpdated: "View updated",
    viewRenamed: "View renamed",
    viewDeleted: "View deleted",
    defaultRemoved: "Default removed",
    viewNameRequired: "Please enter a view name",
    openingBalance: "Opening Balance",
    openingBankBalance: "Opening Bank Balance",
    openingCashBalance: "Opening Cash Balance",
    totalOpeningBalance: "Total Opening Balance",
    openingBalanceHint: "Carry-over from your previous bookkeeping system. Appears as the first row in the supplier statement.",
    debitOwed: "Debit (we owe)",
    creditHeld: "Credit (held)",
    linkToBillOptional: "Link this payment to a bill (optional)",
    possibleDuplicatePayment: "Possible duplicate payment detected",
    saveAnyway: "Save anyway?",
    savedTo: "Saved to",
    suspectedDuplicate: "Suspected Duplicate",
    currentlyViewing: "Currently viewing",
    debug: "Debug",
    debugOn: "Debug ON",
    debugInspector: "Debug Inspector — show raw record IDs",
    rowsHiddenByFilters: "rows hidden by filters",
    hiddenByDateRange: "by date range",
    hiddenByTypeFilter: "by income type filter",
    clearFilters: "Clear filters",
    linkedBank: "Linked Bank",
    linkedFinanceDeleted: "Finance Deleted",
    linkedFinanceMissing: "Finance Missing",
    imported: "Imported",
    importedFromBankReport: "Imported from Bank Report",
    manageImportedPayment: "Manage Imported Payment",
    manageAllocations: "Manage Allocations",
    importedPaymentLockedFields: "Synced from the Bank Statement. Amount, date, bank account and reference are locked. You can update the supplier link, notes and invoice allocations.",
    totals: "Totals",
    statementPdf: "Statement PDF",
    downloadStatementPdf: "Download Statement PDF",
    downloadInvoicePdf: "Download Invoice PDF",
    downloadReceiptPdf: "Download Receipt PDF",
    downloadMonthlyChargesPdf: "Download Monthly Charges PDF",
    downloadExtraChargesPdf: "Download Extra Charges PDF",
    exportInvoicesPdf: "Export Invoices PDF",
    exportInvoices: "Export Invoices",
    exportPayments: "Export Payments",
    maintenanceMonth: "Maintenance Month",
    monthlyMaintenance: "Monthly Maintenance",
    extra: "Extra",
    summaryTotalsPdf: "Summary Totals PDF",
    invoiceNumberSettings: "Invoice Number Settings",
    prefix: "Prefix",
    separator: "Separator",
    digits: "Digits",
    nextNumber: "Next Number",
    preview: "Preview",
    settingsSaved: "Settings saved",
    invoiceNumberExists: "This invoice number already exists",
    noRecurringRules: "No recurring rules configured",
    generateNow: "Generate Now",
    sendEmailOnGeneration: "Send email notification when invoice is generated",
    sendByEmail: "Send by Email",
    recipientEmail: "Recipient Email",
    recipientEmailPlaceholder: "name@example.com (comma-separated for multiple)",
    to: "To",
    subject: "Subject",
    ccPlaceholder: "CC recipients (comma-separated)",
    bccPlaceholder: "BCC recipients (comma-separated)",
    emailSubject: "Subject",
    emailMessage: "Message (optional)",
    emailSentSuccess: "Email sent successfully",
    emailHistory: "Email History",
    viewMessage: "View Message",
    resend: "Resend",
    sentBy: "Sent by",
    sent: "Sent",
    failed: "Failed",
    sending: "Sending...",
    emailNotConfigured: "Email service not configured. Please add Brevo API key.",
    attachment: "Attachment",
    organizationSettings: "Organization Settings",
    manageSubscription: "Manage Subscription",
    manageSubscriptionHint: "View and manage your current subscription plan",
    emailSettings: "Email Settings",
    emailSettingsHint: "Configure email delivery, sender details, and integration keys",
    senderEmail: "Sender Email",
    senderName: "Sender Name",
    apiKey: "API Key",
    emailProvider: "Email Provider",
    emailConfigSaved: "Email settings saved",
    comingSoon: "Coming Soon",
    invoiceNotifications: "Invoice Notifications",
    customerStatement: "Customer Statement",
    generalMeetings: "General Meetings",
    paymentNotification: "Payment Notification",
    emailTemplates: "Email Templates",
    defaultSubjectTemplate: "Default Subject",
    defaultBodyTemplate: "Default Body",
    templateHint: "Available variables: {apartment_number}, {owner_name}, {invoice_number}, {company_name}, {building_name}, {start_date}, {end_date}, {month}, {meeting_date}, {meeting_type}",
    useMonthlyFee: "Use monthly fee",
    noEndDate: "No end date",
    nextInvoice: "Next",
    thisApartment: "This Apartment",
    allApartments: "All Apartments",
    emailEnabled: "Email",
    scope: "Scope",
    optional: "optional",
    // Phase 1013 — Recurring invoice auto-email
    autoEmailInvoices: "Automatically email generated invoices",
    autoEmailInvoicesHint: "Runs server-side. Sends the invoice on the scheduled date even if nobody is logged in.",
    dayOfMonthShortMonthHint: "For 29/30/31: shorter months (e.g. Feb) auto-run on the last calendar day.",
    // Phase 1014 — Bills simple tabs (TimelyBills-style)
    upcoming: "Upcoming",
    overdue: "Overdue",
    recurring: "Recurring",
    paid: "Paid",
    advanced: "Advanced",
    bills: "bills",
    outstanding: "outstanding",
    totalPaid: "total paid",
    markAsPaid: "Mark as Paid",
    searchBillsPlaceholder: "Search vendor, property, invoice #…",
    noUpcomingBills: "No upcoming bills. Everything is on track.",
    noOverdueBills: "No overdue bills.",
    noPaidBills: "No paid bills yet.",
    noBills: "No bills.",
    dueDate: "Due Date",
    building: "Building",
    partial: "Partial",
    sendInvoiceTo: "Send invoice to",
    noEmailsConfigured: "No email addresses configured for this apartment",
    noEmailsConfiguredHint: "Add owner / tenant / contact email in the Apartment settings first.",
    autoUsePrimary: "Auto (uses primary email)",
    lastInvoiceGenerated: "Last invoice generated",
    lastEmailSent: "Last email sent",
    emailStatus: "Email status",
    emailStatusSent: "Sent",
    emailStatusFailed: "Failed",
    emailStatusPending: "Pending",
    emailStatusNoRecipient: "Email not sent – no recipient email configured",
    emailStatusSkippedTesting: "Skipped (test mode)",
    emailStatusMocked: "Logged (no provider)",
    recipientEmail: "Recipient",
    nextScheduled: "Next scheduled",
    never: "Never",
    startDate: "Start Date",
    endDate: "End Date",
    from: "From",
    monthly: "Monthly",
    enabled: "Enabled",
    disabled: "Disabled",
    noUnpaidInvoices: "No unpaid invoices",
    payNow: "Pay Now",
    totalPayment: "Total Payment",
    autoDistribute: "Auto-distribute (oldest first)",
    allocate: "Allocate",
    allocated: "Allocated",
    unallocated: "Unallocated",
    allocateToInvoices: "Allocate to Invoices",
    allInvoicesPaid: "All invoices are fully paid",
    afterPayment: "after payment",
    used: "Used",
    allocationMismatch: "Allocated total cannot exceed payment amount",
    overpayment: "Overpayment",
    overpaymentRecorded: "Overpayment recorded as credit",
    availableCredit: "Available Credit",
    creditBalance: "Credit Balance",
    creditApplied: "Credit applied successfully",
    noCreditToApply: "No credit available to apply",
    applyToInvoices: "Apply to unpaid invoices",
    clickToApplyCredit: "Click to apply to invoices",
    applyCreditToInvoices: "Apply Credit to Invoices",
    totalToApply: "Total to Apply",
    exceedsCredit: "Amount exceeds available credit",
    applyCredit: "Apply Credit",
    unpaidInvoices: "Unpaid Invoices",
    invoiceAmount: "Invoice",
    openingBalance: "Opening Balance",
    overpaymentCredit: "Overpayment → Credit balance",
    noUnpaidInvoicesCreditOnly: "No unpaid invoices — full amount will be saved as credit.",
    applies: "Will Apply",
    dateFrom: "Date From",
    dateTo: "Date To",
    clearFilter: "Clear",
    managementCommittee: "Management Committee",
    role: "Role",
    addMember: "Add Member",
    selectOwnerOrCustom: "Select Person",
    selectFromApartments: "-- Select apartment owner --",
    enterNameManually: "Or enter name manually",
    or: "or",
    apartmentShort: "Apt.",
    member: "Member",
    month_1: "January", month_2: "February", month_3: "March", month_4: "April",
    month_5: "May", month_6: "June", month_7: "July", month_8: "August",
    month_9: "September", month_10: "October", month_11: "November", month_12: "December",

    // Invoices Tab
    createInvoice: "Create Invoice",
    selectInvoiceType: "How would you like to generate the invoice?",
    singleApartment: "Single Apartment",
    singleApartmentDesc: "Create an invoice for a specific apartment with a custom amount",
    allApartments: "All Apartments (Monthly Charges)",
    allApartmentsDesc: "Split a total amount across all apartments based on their share percentage",
    totalAmount: "Total Amount",
    totalCharged: "Total Charged",
    totalRemaining: "Total Remaining",
    owner: "Owner",
    sharePreview: "Distribution Preview",
    optionalDescription: "Optional description...",
    generating: "Generating...",
    previewPdf: "Preview PDF",
    previewFailed: "Preview failed",
    invoiceDeleted: "Invoice deleted",
    invoiceUpdated: "Invoice updated",
    deleteInvoice: "Delete Invoice",
    confirmDeleteInvoice: "Are you sure you want to delete this invoice?",
    invoiceHasPaymentsWarning: "This invoice has payments. It will be archived instead of permanently deleted.",
    catManagement: "Management",
    catCleaning: "Cleaning",
    catElectricity: "Electricity",
    catInsurance: "Insurance",
    catElevator: "Elevator",
    catOther: "Other",
    expTypeMonthly: "Monthly",
    expTypeCapital: "Capital",
    expenseTypeLabel: "Expense Type",
    capital: "Capital",
    allStatuses: "All Statuses",
    allCategories: "All Categories",
    allPeriods: "All Periods",
    selectApartment: "Select apartment",
    change: "change",
    commonExpenses: "Common Expenses",
    invoiceDate: "Invoice Date",
    lineItems: "Line Items",
    addLine: "Add Line",
    autoGenerated: "Auto-generated",
    invoiceNumberPlaceholder: "Leave empty to auto-generate (e.g. ODY-0016)",
    periodAutoHint: "Auto-filled from Invoice Date — edit if you need a different reporting period.",

    // Payments Tab
    recordPayment: "Record Payment",
    paymentDeleted: "Payment deleted",
    paymentUpdated: "Payment updated",
    editPayment: "Edit Payment",
    paymentReceipt: "Payment Receipt",
    paymentDetails: "Payment Details",
    deletePayment: "Delete Payment",
    view: "View",
    pdf: "PDF",
    bill: "Bill",
    totalPayments: "Total Payments",
    cashPayments: "Cash Payments",
    bankPayments: "Bank Payments",
    allSources: "All Sources",
    source: "Source",
    outstandingInvoices: "Outstanding Invoices",
    noOutstandingInvoices: "No outstanding invoices",
    month: "Month",
    year: "Year",

    // Phase 134 — Internal Transfers between bank accounts.
    transfers: "Transfers",
    transfer: "Transfer",
    internalTransfer: "Internal Transfer",
    internalTransfers: "Internal Transfers",
    internalTransfersDesc: "Move money between bank accounts without affecting income, VAT, deductions, or Final Balance.",
    newTransfer: "New Transfer",
    addTransfer: "Add Transfer",
    editTransfer: "Edit Transfer",
    deleteTransfer: "Delete Transfer",
    confirmDeleteTransfer: "Delete this internal transfer? The running balance of both accounts will be recalculated.",
    noTransfers: "No internal transfers recorded yet.",
    fromAccount: "From Account",
    toAccount: "To Account",
    fromToRequired: "From and To accounts are required",
    fromToMustDiffer: "From and To accounts must be different",
    transferCreated: "Transfer created",
    transferUpdated: "Transfer updated",
    transferDeleted: "Transfer deleted",
    selectAccount: "Select account",
    deleted: "Deleted",
    entry: "entry",

    // Phase 137 — Opening Balance as a first-class dated transaction row.
    openingBalanceDate: "Opening Balance Date",
    openingBalanceDateRequired: "Opening balance date is required",
    openingBalanceDateHint: "The date from which this account's running balance begins.",
    openingBalanceNotes: "Opening Balance Notes",
    openingBalanceNotesPlaceholder: "e.g. Outstanding balance until 28/02/2025 (Jan + Feb 2025)",
    boundToApartmentId: "Bound to apartment_id",
    usePeriod: "Use Period",
    receiptNotFound: "Receipt not found",
    openingNotes: "Opening Notes",
    openingNotesPlaceholder: "e.g. Outstanding Jan + Feb 2025",

    // Phase 139 — Annual Expenses versioning / audit history.
    viewHistory: "View history",
    editHistory: "Edit History",
    editHistoryDesc: "Every amount change is logged and never overwritten.",
    noHistoryYet: "No edits recorded yet for this category.",
    changedAt: "Changed at",
    previousAmount: "Previous",
    newAmount: "New",
    delta: "Δ",
    changedBy: "Changed by",
    close: "Close",

    // Phase 140 — Rounded column in apartment distribution.
    rounded: "Rounded",
    readOnlyCalculated: "Calculated automatically (read-only)",

    // Phase 144 — Clearer column labels + Rounded UX (Enter auto-saves, manual override persists).
    annualTotal: "Annual Total",
    pressEnterToSave: "Press Enter to save",
    manualOverride: "Manual override — persists across budget changes",

    // Phase 141 — Per-expense breakdown at the bottom of Annual Expenses.
    breakdownPerExpense: "Breakdown per Expense",
    breakdownPerExpenseDesc: "Detailed allocation of each expense across all apartments. Rounding is applied per row, so the sum of rounded amounts may differ from the original expense total by a few cents — the difference is shown for full transparency.",
    originalAmount: "Original Amount",
    roundedAmount: "Rounded Amount",
    expenseTotalOriginal: "Expense Total (Original)",
    expenseTotalRounded: "Expense Total (Rounded)",
    difference: "Difference",

    // Phase 143 — Monthly rounding with Reserve Fund adjustment.
    breakdownMonthlyDesc: "Monthly amount per apartment, before and after rounding. Rounding residuals do NOT flow back to apartments — they are consolidated into the Reserve Fund adjustment below so the totals always reconcile.",
    monthlyBeforeRounding: "Monthly (Before Round)",
    monthlyAfterRounding: "Monthly (After Round)",
    totalBeforeRound: "Total (Before Round)",
    totalAfterRound: "Total (After Round)",
    diffFlowsToRF: "Flows to Reserve Fund ↓",
    adjusted: "Adjusted",
    reserveFundOriginalMonthly: "Reserve Fund — Monthly (Original)",
    reserveFundAdjustedMonthly: "Reserve Fund — Monthly (Adjusted)",
    roundingAdjustment: "Rounding Adjustment",
    roundingAdjustmentDesc: "Sum of all per-expense rounding differences across the building.",
    // Phase 147 — Reserve Fund reconciliation against Rounded overrides.
    monthlyTotalBeforeRounding: "Monthly Total (Before Rounding)",
    sumOfRoundedApartmentAmounts: "Sum of Rounded Apartment Amounts",
    roundingAdjustmentFormula: "= Sum of Rounded − Monthly Total (Before Rounding)",
    // Phase 153 — auto-save for category value edits.
    saved: "Saved",
    saving: "Saving…",
    unsavedChanges: "Unsaved changes",
    saveError: "Save Failed",
    saveNow: "Save now",
    planYear: "Year",
    reserveFundDistributionTitle: "Reserve Fund Distribution",
    annualTotal: "Annual Total",
    reserveFundManagedInAnnualExpenses: "Reserve Fund distribution is managed in Annual Expenses.",
    openAnnualExpenses: "Open Annual Expenses",
    noReserveFundPlan: "No active Annual Expenses plan with a Reserve Fund yet. Set the Reserve Fund inside Annual Expenses to see the distribution here.",
    paymentSource: "Payment Source",
    buildingFund: "Building Fund",
    buildingFundHint: "Paid directly from Cash or Bank now.",
    distributeToApartments: "Distribute to Apartments",
    distributeHint: "Split across apartments — becomes invoices, not paid yet.",
    distributionNotPaidYet: "Note: this is not paid yet — it will be charged to each apartment based on their share.",
    available: "Available",
    insufficientFundsWarning: "Insufficient funds: only €{available} available, €{needed} needed.",
    invoicePdf: "Invoice PDF",
    statementPdf: "Statement PDF",
    paymentReceiptPdf: "Payment Receipt PDF",
    // Phase 168 — Repair attachments.
    repairAttachments: "Attachments",
    repairAttachmentsHint: "Drag & drop invoices, receipts or photos here, or click Upload. Max 10 MB per file.",
    noAttachments: "No attachments yet",
    repairAttachmentTooLarge: "File exceeds 10 MB limit",
    repairAttachmentUploaded: "Attachment uploaded",
    repairAttachmentDeleted: "Attachment deleted",
    // Phase 152 — Reserve Fund adjustment matrix (Original / Adjustment / Adjusted × Monthly / Annual).
    reserveFundAdjustmentTitle: "Reserve Fund — Rounding Reconciliation",
    reserveFundAdjustmentHint: "Adjustment = Sum of Rounded − Monthly Total. Positive increases the Reserve Fund; negative decreases it.",
    colMonthly: "Monthly",
    colAnnual: "Annual (×12)",
    rowOriginal: "Reserve Fund (Original)",
    rowAdjustment: "Rounding Adjustment (+/−)",
    rowAdjusted: "Reserve Fund (Adjusted)",
    rfIncreases: "Reserve Fund increases",
    rfDecreases: "Reserve Fund decreases",
    rfUnchanged: "Reserve Fund unchanged",

    // Phase 148 — Plan management (named plans + Active/Inactive).
    plan: "Plan",
    plans: "Plans",
    active: "Active",
    inactive: "Inactive",
    newPlan: "New Plan",
    newPlanDesc: "Create a blank plan for this building and year.",
    duplicatePlan: "Duplicate Plan",
    duplicatePlanDesc: "Create a copy of the current plan as a new scenario.",
    renamePlan: "Rename Plan",
    renamePlanDesc: "Change the display name of this plan.",
    deletePlan: "Delete Plan",
    activatePlan: "Set as Active",
    activate: "Activate",
    planName: "Plan Name",
    planNamePlaceholder: "e.g. Basic Plan, Premium Plan, Scenario A, Budget 2025",
    planNameRequired: "Plan name is required",
    planCreated: "Plan created",
    planRenamed: "Plan renamed",
    planDeleted: "Plan deleted",
    planActivated: "Plan activated",
    apartmentsSynced: "apartments synced to monthly fee",
    // Phase 169 — Plan Start/End Date Versioning
    activatePlanDesc: "Pick the start date for this plan. The previous active plan will be automatically closed the day before.",
    previousPlanWillClose: "Previous plan \"{name}\" will be closed on {date}.",
    startDateRequired: "Start date is required",
    editPlanDates: "Edit Plan Dates",
    editPlanDatesDesc: "Manually adjust start / end dates. Overlaps with other plans are not allowed.",
    planDatesUpdated: "Plan dates updated",
    activeFrom: "Active from",
    leaveEmptyForOngoing: "Leave empty to keep this plan ongoing (end date = none).",
    open: "open",
    optional: "optional",
    cannotDeleteActivePlan: "Activate another plan first before deleting this one.",
    cannotDeleteActivePlanHint: "Cannot delete the Active plan. Switch to \"{name}\" and activate it first.",
    cannotDeleteOnlyPlan: "Cannot delete the only plan. Create another plan first.",
    confirmDeletePlan: "Permanently delete plan",
    noPlans: "No plans yet",
    sales: "Sales",
    salesSubtitle: "Customers, Invoices, Payments and Statements — connected to Cleaning Management & Finance.",
    fromFinance: "From Finance",
    transactionType: "Type",
    allocatedTo: "Allocated to",
    details: "Details",
    totalVat: "Total VAT",
    totalAmount: "Total Amount",
    totalPaid: "Total Paid",
    totalUnpaid: "Total Unpaid",
    totalsFor: "Totals for",
    unpaid: "Unpaid",
    exportPdf: "Export PDF",
    report: "Report",
    clientVendorBuilding: "Client / Vendor / Building",
    selectClientOrBuilding: "Select customer or building",
    clientsAndVendors: "Clients & Vendors",
    snoozed: "Snoozed",
    snoozedUntil: "Snoozed until",
    snoozeBill: "Snooze bill",
    changeSnooze: "Change snooze",
    snoozeBillHelp: "Hide this bill from urgent/due-soon dashboard sections until the chosen date. The bill stays accessible from the Bills list with the \"Snoozed\" filter.",
    snoozeUntil: "Snooze until",
    reminderDate: "Reminder date",
    optional: "optional",
    currentlySnoozedUntil: "Currently snoozed until",
    clearSnooze: "Clear snooze",
    upcoming: "Upcoming (≤15 days)",
    urgentAndUpcoming: "Urgent & Upcoming",
    snoozeFromOverviewHint: "Snooze any bill to remove it from this list until its reminder date.",
    noUrgentBills: "No urgent bills right now — Overview is clear.",
    remindersTitle: "Reminders",
    remindersHint: "Active obligations. Snoozed and paid items are hidden automatically.",
    noActiveObligations: "No active obligations right now.",
    openBill: "Open",
    snooze: "Snooze",
    billTitle: "Title",
    autoCreateInvoice: "Auto Create Invoice",
    intervalMonthly: "Monthly",
    intervalBimonthly: "Every 2 Months",
    intervalQuarterly: "Every 3 Months",
    intervalSemiannual: "Every 6 Months",
    intervalYearly: "Yearly",
    intervalCustom: "Custom interval",
    everyXMonths: "Every X months",
    createAs: "Auto-create as",
    draft: "Draft",
    officialInvoice: "Official Invoice",
    nextGenerationDate: "Next Generation Date",
    billTo: "Bill to",
    saveRecurrence: "Save recurrence",
    recurrenceStatus: "Recurrence Status",
    lastGenerated: "Last generated",
    nextInvoiceDate: "Next invoice date",
    nextCycleSkipped: "Next cycle will be skipped",
    state: "State",
    paused: "Paused",
    active: "Active",
    pauseRecurrence: "Pause",
    resumeRecurrence: "Resume",
    skipNextCycle: "Skip next cycle",
    clearSkip: "Clear skip",
    generateNow: "Generate Now",
    generationHistory: "Generation history",
    noHistoryYet: "No invoices generated yet.",
    generated: "Generated",
    skippedStatus: "Skipped",
    triggeredBy: "Triggered by",
    invoice: "Invoice",
    invoiceGenerated: "Invoice generated",
    recurrenceSaved: "Recurrence saved",
    recurrencePaused: "Recurrence paused",
    recurrenceResumed: "Recurrence resumed",
    recurrenceCycleSkipped: "Cycle skipped",
    skipNextOn: "Next cycle will be skipped",
    skipNextOff: "Skip cleared",
    descriptionPlaceholder: "e.g. Elevator Maintenance — bi-monthly",
    recurrenceSaveFirstHint: "Save the renewal bill first, then re-open it to configure automatic invoice generation.",
    enabled: "Enabled",
    activeFilter: "Active",
    allFilter: "All",
    billsFilter: "Bills",
    renewalsFilter: "Renewals",
    snoozedFilter: "Snoozed",
    invoiceNumber: "Invoice No.",
    outstanding: "Outstanding",
    partial: "partial",
    from: "From",
    to: "To",
    clear: "Clear",
    allCategories: "All categories",
    viewSubcategoryLedger: "Open subcategory ledger",
    recurringDate: "Recurring Date",
    recurrenceStartDate: "Recurrence start",
    nextRenewalDate: "Next renewal date",
    pickInterval: "Pick interval…",
    noneInterval: "— No fixed interval —",
    viewPDF: "View PDF",
    exportPDF: "Export PDF",
    identifier: "Identifier",
    identifierPlaceholder: "e.g. KXH 542 Toyota Yaris · Apartment 203 · Michalis",
    billDescription: "Description",
    billDescriptionPlaceholder: "e.g. Toyota Yaris KXH542 · Office Electricity · Michalis Life Insurance · Apt 203 Water",
    recurringFrequency: "Recurring Frequency",
    referenceNo: "Reference #",
    charge: "Charge",
    allocatePayment: "Allocate Payment",
    allocate: "Allocate",
    moveTo: "Move to invoice",
    selectInvoice: "Select invoice…",
    paymentReallocated: "Payment reallocated",
    paymentUnallocated: "Payment unallocated",
    reallocate: "Reallocate",
    unallocate: "Unallocate",
    policyNumber: "Policy Number",
    policyNumbers: "Policy Numbers",
    policyNumberPlaceholder: "e.g. ABC-29384",
    policyPeriodFrom: "Policy Period From",
    policyPeriodTo: "Policy Period To",
    policyPeriod: "Coverage Period",
    insuranceDetails: "Insurance Details",
    quickViewAllUnpaid: "All Unpaid",
    quickViewAllPaid: "All Paid",
    quickViewAllSnoozed: "All Snoozed",
    viewAllUnpaidBills: "View All Unpaid Bills",
    viewAllPaidBills: "View All Paid Bills",
    viewAllSnoozedBills: "View All Snoozed Bills",
    globalView: "Global view",
    inThisContext: "In this context",
    allocateAmount: "Allocate €",
    applyAllocations: "Apply Allocations",
    toAllocate: "To allocate",
    fill: "Max",
    useFullAmount: "Use remaining",
    allocateOverWarning: "Total allocations exceed the payment amount.",
    paymentAllocated: "Payment allocated",
    noAllocationCandidates: "No other unpaid invoices in this subcategory.",
    unallocatedCredit: "Unallocated credit",
    paymentAmount: "Payment",
    alreadyAllocated: "Already allocated",
    remainingCredit: "Remaining credit",
    payment: "Payment",
    activeRenewal: "Active",
    snoozedReappearHint: "Snoozed items disappear from the active list and return automatically on their reminder date.",
    alreadyPaid: "Already paid",
    markedAsPaid: "Marked as paid",
    dueSoon: "Due soon",
    activeBills: "Active bills",
    vendorBill: "Vendor / Bill",
    vendorClientBuilding: "Vendor / Client / Building",
    activeObligations: "Active obligations",
    vatSettlement: "VAT Settlement",
    vatSettlementHint: "Income VAT − Supplier VAT − Expenses VAT",
    totalIncomeVat: "Total Income VAT",
    supplierVat: "Supplier VAT",
    expensesVat: "Expenses VAT",
    vatToPay: "VAT To Pay",
    vatCreditRefund: "VAT Credit / Refund",
    fromCustomerInvoices: "from customer invoices",
    fromSupplierInvoices: "from supplier invoices",
    fromVendorExpenses: "from Vendors → Expenses",
    payableToAuthority: "payable to tax authority",
    owedByAuthority: "owed by tax authority",
    readOnlyEditInFinance: "Read-only. Edit in Finance.",
    bankTransactionProtected: "Bank transaction protected — manage in Finance",
    // Phase 621 — Accounting-style payment row labels.
    bankPayment: "Bank Payment",
    cashPayment: "Cash Payment",
    financeSync: "Finance Sync",
    syncedFrom: "synced from",
    viewInvoice: "View invoice",
    paymentsReadOnlyHint: "Payments are managed exclusively from Finance / Sales. They appear here automatically once recorded.",
    cleanupOrphans: "Cleanup orphans",
    cleanupOrphansHint: "Soft-delete every payment / job / history row that no longer maps to an active client or cleaner.",
    cleanupOrphansConfirm: "This will soft-delete every payment / job / history row that no longer maps to an active client or cleaner. Continue?",
    cleanupDone: "Cleanup complete",
    activePlan: "Active Plan",
    markActive: "Mark Active",
    markAsActivePlan: "Mark as Active Plan",
    customers: "Customers",
    invoices: "Invoices",
    payments: "Payments",
    statement: "Statement",
    newInvoice: "New Invoice",
    editInvoice: "Edit Invoice",
    newPayment: "New Payment",
    addPayment: "Add Payment",
    addJob: "Add Job",
    splitView: "Split",
    listView: "List",
    // Phase 735.43 — Cleaner payment status badges + dropdown filter tabs.
    cleanerStatus_paid: "Paid",
    cleanerStatus_partial: "Partial",
    cleanerStatus_unpaid: "Unpaid",
    // Phase 735.44 — Cleaner Invoices tab.
    invoices: "Invoices",
    invoiceNumber: "Invoice #",
    invoiceDate: "Invoice Date",
    createInvoice: "Create Invoice",
    invoiceCreated: "Invoice created",
    invoiceVoided: "Invoice voided",
    invoiceReactivated: "Invoice reactivated",
    invoiceExists: "An invoice already exists for this month",
    invoiceExistsWarning: "An active invoice already exists for this month. Voiding it first will preserve the invoice number.",
    confirmVoidInvoice: "Void this invoice?",
    noInvoicesYet: "No invoices yet. Click \"Create Invoice\" to generate one for a month.",
    showVoided: "Show voided",
    void: "Void",
    reactivate: "Reactivate",
    autoAssigned: "Auto-assigned on Save",
    totalInvoiced: "Total Invoiced",
    outstandingBalance: "Outstanding Balance",
    noWorkThisMonth: "No work found for this month.",
    cleanerInvoiceStatus_paid: "PAID",
    cleanerInvoiceStatus_partial: "PARTIAL",
    cleanerInvoiceStatus_unpaid: "UNPAID",
    cleanerInvoiceStatus_voided: "VOIDED",
    cleanerInvoiceStatus_draft: "DRAFT",
    cleanerInvoiceStatus_finalized: "FINALIZED",
    // Phase 735.45 — Edit / Rebuild / Lifecycle.
    editInvoice: "Edit Invoice",
    // Phase 735.46 — Statement ledger tab.
    statement: "Statement",
    reference: "Reference",
    debit: "Debit",
    credit: "Credit",
    runningBalance: "Running Balance",
    invoice: "Invoice",
    payment: "Payment",
    unallocated: "Unallocated",
    noStatementEntries: "No entries in this period.",
    invoiceUpdated: "Invoice updated",
    invoiceFinalized: "Invoice finalized",
    invoiceRebuilt: "Invoice rebuilt from Jobs",
    confirmFinalize: "Finalize this invoice? Automatic sync from Jobs will be disabled.",
    lockedByPayments: "LOCKED BY PAYMENTS",
    editInvoiceLockedWarn: "This invoice has allocated payments. Line-item edits will be marked as a forced override in the audit trail.",
    descriptionPlaceholder: "e.g. MAY 6+13+20+27",
    addLine: "Add Line",
    finalize: "Finalize",
    rebuildFromJobs: "Rebuild from Jobs",
    rebuildInvoice: "Rebuild Invoice from Jobs",
    confirmRebuild: "Confirm Rebuild",
    rebuilding: "Rebuilding…",
    rebuildWarning: "This invoice is not a draft. Rebuilding may affect allocations and balances.",
    currentTotal: "Current Total",
    proposedTotal: "Proposed Total",
    addedLines: "lines to add",
    removedLines: "lines to remove",
    changedLines: "lines changed",
    manualLinesKept: "manual line(s) kept as-is",
    auditTrail: "Audit Trail",
    notes: "Notes",
    save: "Save",
    quantity: "Qty",
    rate: "Rate",
    amount: "Amount",
    saving: "Saving…",
    selectAClient: "Select a client from the list",
    selectAClientHint: "Pick a client on the left to view jobs, invoices, payments and statement.",
    noJobsYet: "No jobs found",
    noInvoicesYet: "No invoices yet",
    noPaymentsRecorded: "No payments recorded",
    noEntriesYet: "No entries yet",
    noClientsFound: "No clients found",
    outstanding: "Outstanding",
    lastJob: "Last Job",
    // Phase 472 — Reminders redesign.
    dueToday: "Due Today",
    dueThisWeek: "Due This Week",
    next7Days: "Next 7 Days",
    upcoming: "Upcoming",
    searchBillsPlaceholder: "Search description, invoice #, category...",
    // Phase 732 — Recurring Bills
    recurringBills: "Recurring Bills",
    addRecurringBill: "Add Recurring Bill",
    editRecurringBill: "Edit Recurring Bill",
    createRecurringBill: "Create Recurring Bill",
    deleteRecurringBill: "Delete Recurring Bill",
    confirmDeleteRecurring: "Delete this recurring bill template? Already generated bills will remain intact.",
    noRecurringBills: "No recurring bill templates yet. Click \"Add Recurring Bill\" to create one.",
    recurringUpdated: "Recurring bill updated",
    recurringCreated: "Recurring bill created",
    recurringHistory: "Recurring History",
    noGeneratedBills: "No bills have been generated from this template yet.",
    generatedBill: "Generated Bill",
    generationDate: "Generation Date",
    upcomingRecurring: "Upcoming Recurring",
    generateNow: "Generate Now",
    viewHistory: "View History",
    pause: "Pause",
    resume: "Resume",
    duplicate: "Duplicate",
    active: "Active",
    paused: "Paused",
    expired: "Expired",
    daily: "Daily",
    weekly: "Weekly",
    quarterly: "Quarterly",
    semiannual: "Every 6 Months",
    yearly: "Yearly",
    custom: "Custom",
    everyNDays: "Every N days",
    frequency: "Frequency",
    recurrence: "Recurrence",
    dates: "Dates",
    options: "Options",
    optional: "optional",
    autoGenerateBills: "Automatically generate bills",
    autoGenerateHint: "Bills will be created automatically on their scheduled date.",
    autoMarkOverdue: "Automatically mark overdue",
    autoMarkOverdueHint: "Past-due unpaid bills will be flagged as overdue.",
    reminderBeforeDue: "Reminder before due date (days)",
    defaultAmount: "Default Amount",
    policyNumber: "Policy / Contract Number",
    selectSubcategory: "Select subcategory",
    subcategoryRequired: "Subcategory is required",
    startDateRequired: "Start date is required",
    done: "Done",
    saveChanges: "Save Changes",
    upcoming: "Upcoming",
    thisWeek: "This Week",
    searchReminders: "Search reminders…",
    allCaughtUp: "You’re all caught up.",
    noAlertsForFilter: "No reminders match this filter.",
    comfortable: "Comfortable",
    compact: "Compact",
    sortByDueDate: "Closest due",
    sortByAmount: "Highest amount",
    sortByCategory: "Category",
    sortByRecent: "Recently added",
    expiringSoonShort: "Expiring",
    dueSoonShort: "Due soon",
    agoShort: "ago",
    inShort: "in",
    showingCount: "Showing",
    // Phase 473 — Cleaners split-view.
    selectACleaner: "Select a cleaner from the list",
    selectACleanerHint: "Pick a cleaner on the left to view jobs, buildings, payments and statement.",
    viewStatement: "View Statement",
    openStatement: "Open Statement",
    fullStatement: "Full statement",
    fullStatementHint: "Opens the detailed statement dialog with all dates, filters and PDF export.",
    avgHourlyRate: "Avg / hour",
    pendingPayments: "Pending",
    dataMismatchDetected: "Data mismatch detected",
    expectedCount: "Expected",
    shownCount: "shown",
    refresh: "Refresh",
    noBuildingsCleaning: "No building cleaning records",
    entries: "Entries",
    // Phase 474 — Sync Audit.
    syncAudit: "Sync Audit",
    syncAuditHint: "Compare Finance Bank Accounts with Cleaning & Building payments. Detect orphans, broken links and pending syncs — then repair safely.",
    runRepair: "Run Repair",
    repairing: "Repairing…",
    generated: "Generated",
    allInSync: "Everything is in sync.",
    issuesFound: "issue(s) found across modules",
    reconciliationStatus: "Reconciliation",
    reconciliationTotals: "Reconciliation Totals",
    financeTotal: "Finance income (active)",
    syncedToCleaning: "Synced ↔ Cleaning",
    syncedToBuilding: "Synced ↔ Building",
    manualIncomes: "Manual (no link)",
    financeAnomalies: "Finance anomalies",
    orphanCleaningLink: "Finance row points to missing cleaning payment",
    orphanBuildingLink: "Finance row points to missing building payment",
    missingBankAccount: "Bank/Card income with no bank account",
    softDeletedStillLinked: "Soft-deleted finance row still has active payment link",
    cleaningAnomalies: "Cleaning payments",
    synced: "Synced",
    reverseSyncFromFinance: "From Finance",
    pendingNoLink: "Pending (no link)",
    brokenLinks: "Broken links",
    cleaningPendingNoLink: "Cleaning payments not synced to Finance",
    cleaningBrokenLink: "Cleaning payment links to deleted Finance row",
    cleaningMissingClient: "Cleaning payment has missing/unknown client_id",
    buildingAnomalies: "Building payments",
    buildingPendingNoLink: "Building payments not synced to Finance",
    buildingBrokenLink: "Building payment links to deleted Finance row",
    buildingMissingBuilding: "Building payment has missing/unknown building_id",
    backToFinance: "Back to Finance",
    rows: "rows",
    clientOrBuilding: "Client / Building",
    hoursShort: "Hours",
    category: "Category",
    manageCategories: "Manage",
    // Phase 478 — Full professional invoice editor.
    billTo: "Bill To",
    vatNumber: "VAT No",
    contact: "Contact",
    noContactOnFile: "No contact on file",
    invoiceNumber: "Invoice No",
    autoGenerated: "Auto-generated",
    paymentTerms: "Payment Terms",
    paymentTermsExample: "e.g. Net 30",
    items: "Items",
    addItem: "Add Item",
    itemDescription: "Description",
    itemExamplePlaceholder: "Office Cleaning – May 2026",
    qty: "Qty",
    unitPrice: "Unit price",
    tax: "Tax %",
    customerNotes: "Customer Notes",
    visibleOnPdf: "visible on PDF",
    customerNotesPlaceholder: "Thank you for your business.",
    internalNotes: "Internal Notes",
    notOnPdf: "not on PDF",
    internalNotesPlaceholder: "Private notes — only visible to your team.",
    subtotal: "Subtotal",
    discount: "Discount",
    adjustment: "Adjustment",
    grandTotal: "Grand Total",
    amountPaid: "Paid",
    remainingBalance: "Balance",
    invoiceAtLeastOneItem: "Add at least one item with description, quantity and unit price",
    totalMustBePositive: "Grand total must be > 0",
    invoicesReadOnlyHint: "Invoices are managed exclusively from Finance. They appear here automatically once issued — both Internal (IC-*) and Official (SI-*) types are shown, grouped below.",
    autoSynced: "Auto Synced",
    autoSyncedHint: "Payment auto-synced from Finance",
    autoSyncedFromFinanceHint: "Synced from Finance — manage in /sales",
    openInFinance: "Open in Finance",
    filtered: "filtered",
    invoicedMinusCost: "invoiced − cost",
    internalInvoices: "Internal Invoices (IC-*)",
    officialInvoices: "Official Invoices (SI-*)",
    // Phase 609 — Cleaner payment allocations.
    paymentAmount: "Payment",
    allocated: "Allocated",
    unallocated: "Unallocated",
    autoAllocateFifo: "Auto-allocate FIFO over oldest unpaid jobs (recommended)",
    unpaidJobs: "Unpaid / Partial Jobs",
    noUnpaidJobs: "No unpaid jobs — the payment will be recorded as fully unallocated credit.",
    allocate: "Allocate",
    overAllocatedWarn: "Allocations exceed the payment amount. Reduce some rows.",
    unallocatedRemainderWarn: "Some of this payment will stay as unallocated credit.",
    cannotOverAllocate: "Allocated total cannot exceed payment amount.",
    runningBalance: "Running balance",
    debit: "Debit",
    credit: "Credit",
    legacy: "Legacy",
    // Phase 611 — Unified allocation modal.
    outstandingDebits: "Outstanding Debits",
    noOpenDebits: "No outstanding debits — the payment will be recorded as fully unallocated credit.",
    editAllocation: "Edit Allocation",
    unallocatedHint: "Not yet linked to a debit",
    jobs: "Jobs",
    buildings: "Buildings",
    building: "Building",
    client: "Client",
    job: "Job",
    clickToAllocateFull: "Click to allocate the full outstanding amount. Click again to reset.",
    noDebitsInRange: "No outstanding debits in the selected period. Adjust or clear the filter.",
    outOfRangeAllocsWarn: "{count} pre-existing allocation(s) totalling €{total} fall outside the active period and are hidden but will still be saved. Clear the filter to view or edit them.",
    mergedDuplicateRowsTip: "Merged from duplicate cleaning_history entries for the same building and date.",
    statusPaid: "PAID",
    statusPartial: "PARTIAL",
    statusUnpaid: "UNPAID",
    ledger: "Ledger",
    monthlyPayroll: "Monthly Payroll",
    monthlyPayrollSummary: "Monthly Payroll Summary",
    monthlyPayrollHint: "Months are based on the date the work was performed, not the payment date. For a payment-date timeline, open the Ledger tab.",
    workDateRange: "Work date",
    workDateFrom: "Work Date From",
    workDateTo: "Work Date To",
    jobsAndBuildings: "Jobs & Buildings",
    paymentsForMonthWork: "Payments for {month} Work",
    noJobsThisMonth: "No jobs recorded for this month.",
    noPaymentsThisMonthWork: "No payments have been linked to this month's work yet.",
    paymentDate: "Payment Date",
    paymentDateInfoOnly: "Payment date is informational only — the work month determines the payroll bucket.",
    unallocatedPayments: "Unallocated Payments",
    unallocatedPaymentsHint: "(payments not yet linked to a specific job or building)",
    earned: "Earned",
    paid: "Paid",
    payrollMonth: "Payroll Month",
    payrollMonthHelp: "Indicates which month's work this payment belongs to. A payment made in June can be for May's work.",
    payrollMonthRequired: "Payroll Month is required.",
    paymentDateHelp: "The actual date the cleaner was paid.",
    jumpToMonth: "Jump to month",
    selectMonth: "Select month",
    selectYear: "Select year",
    showAllMonths: "Show All",
    totalPaid: "Total Paid",
    editPayment: "Edit Payment",
    month: "Month",
    year: "Year",
    opening: "Opening",
    earnings: "earnings",
    contactDirectory: "Contact Directory",
    general: "General",
    contactsHint: "Find any owner or tenant across all buildings by phone, name, apartment, or building.",
    contactsSearchPlaceholder: "Phone, owner / tenant name, apartment number, or building name…",
    contactsHintMin2: "Type at least 2 characters to search.",
    contactsNoMatch: "No matching contacts found.",
    ownerPhone: "Owner Phone",
    tenantPhone: "Tenant Phone",
    searching: "Searching…",
    result: "result",
    results: "results",
    // Phase 481 — Duplicate clients & merge.
    duplicateClients: "Duplicate clients",
    noDuplicateClients: "No duplicate clients detected.",
    duplicateClientsHint: "Pairs of active clients that normalise to the same name (case-insensitive, ignoring common corporate suffixes like LTD / INC). Pick a survivor and click Merge — the source will be soft-deleted with a merged_into reference and all its jobs / invoices / payments / finance links will be re-pointed.",
    suggestedSurvivor: "Suggested survivor",
    buildingAuto: "Building Auto",
    mergeIntoSurvivor: "Merge into survivor",
    merging: "Merging…",
    matchPaymentToInvoice: "Match payment to invoice (optional)",
    billingAddress: "Billing address",
    amountNet: "Amount (net)",
    vatAmount: "VAT amount",
    dueDate: "Due date",
    bankAccount: "Bank account",
    bankTransfer: "Bank transfer",
    cheque: "Cheque",
    selectClient: "Select client",
    selectClientToShowStatement: "Select a client to view their statement.",
    totalInvoiced: "Total invoiced",
    allocated: "Allocated",
    optional: "Optional",
    none: "— None —",
    selected: "selected",
    clear: "Clear",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    exportOptions: "Export Options",
    selectColumnsHint: "Select the columns you want in the PDF.",
    selectAtLeastOneColumn: "Select at least one column",
    unallocatedCredit: "Unallocated Credit",
    allocatedStatus: "Allocated Status",
    fullyAllocated: "Fully Allocated",
    unallocated: "Unallocated",
    partial: "Partial",
    remaining: "remaining",
    deleteSelected: "Delete Selected",
    cannotDeleteLinked: "Cannot delete. Linked to existing jobs/history",
    linkedToJobs: "linked to jobs/history",
    partiallyDeleted: "Some records could not be deleted",
    distributionMethod: "Distribution method",
    byShare: "By share (%)",
    byShareHint: "Allocate proportionally to ownership %.",
    equally: "Equally",
    equallyHint: "Split the total equally per apartment.",
    noPlansAvailable: "No plans available",
    noPlansAvailableHint: "Create your first annual expense plan to get started.",
    createNewPlan: "Create New Plan",
    selectPlan: "Select Plan",
    duplicateChoice: "What do you want to keep in the duplicate?",
    duplicateKeepRounded: "Keep all Rounded (€) overrides",
    duplicateKeepRoundedDesc: "Best for minor variants — the exact payable amounts carry over.",
    duplicateResetRounded: "Reset Rounded — recompute from budget",
    duplicateResetRoundedDesc: "Best for fresh scenarios — start with auto-calculated values.",

    // Phase 150 — Apartment modal: Monthly Fee is auto-synced from Active plan.
    repairs: "Repairs",
    fromPlan: "From Plan",
    feeFromActivePlanHint: "Monthly fee is controlled by the Active Annual Expenses plan (Rounded value).",

    // Phase 282 — Owner History (ownership timeline)
    ownerHistory: "Owner History",
    ownerHistoryTitle: "Owner History",
    ownerHistoryDesc: "Timeline of every owner change. Historical invoices stay linked to the correct owner.",
    addOwnerHistory: "Add Owner Record",
    editOwnerHistory: "Edit Owner Record",
    deleteOwnerHistory: "Delete Owner Record",
    deleteOwnerHistoryConfirm: "Delete this owner record? This cannot be undone.",
    firstName: "First Name",
    lastName: "Last Name",
    ownershipPercentage: "Ownership %",
    startDate: "Start Date",
    endDate: "End Date",
    statusActive: "Active",
    statusPrevious: "Previous",
    reasonForChange: "Reason for Change",
    reasonSale: "Sale",
    reasonDonation: "Donation",
    reasonInheritance: "Inheritance",
    reasonOther: "Other",
    noOwnerHistory: "No owner records yet. Add the first one to start tracking.",
    markAsPrevious: "Mark as Previous",
    markAsActive: "Mark as Active",
    apartmentLabel: "Apartment",
    autoCloseHint: "Marking active will auto-close all other active records for this apartment.",
    cannotDeleteOwnerLinked: "Cannot delete: linked to existing invoices/payments.",
    buildingOwnerHistoryDesc: "All owner changes across every apartment in this building.",

    // Phase 336 — Repairs PDF preview & column selector
    repairsReport: "Repairs Report",
    pdfPreview: "PDF Preview",
    previewAndDownload: "Preview and download the repair statement PDF.",
    closePreview: "Close",
    repairPdfOptions: "Repair PDF Options",
    repairPdfOptionsHint: "Choose the columns to include in the PDF. Your selection is remembered for next time.",
    generatePreview: "Generate Preview",

    // Phase 337 — Email Templates per building
    emailTemplates: "Email Templates",
    generateEmail: "Generate Email",
    generateEmailHint: "Pick or edit a template, fill custom values, preview, then copy/send.",
    templates: "Templates",
    newTemplate: "New",
    noTemplatesYet: "No templates yet. Click \"New\" to create one.",
    templateName: "Template Name",
    templateNamePh: "e.g. Monthly Report",
    templateNameRequired: "Template name is required",
    setAsDefault: "Set as default",
    editor: "Editor",
    body: "Body",
    characters: "chars",
    availablePlaceholders: "Available Placeholders",
    customFields: "Custom Fields",
    customFieldNamePh: "e.g. Reminders",
    noCustomFields: "No custom fields. Add to expose {{custom:Name}} placeholders.",
    previewAndSend: "Preview & Send",
    balanceAsOf: "Balance As Of",
    balanceAsOfHint: "Empty = today. Affects cash & bank balance values.",
    customFieldValues: "Custom Field Values",
    customFieldValuePh: "Enter content…",
    preview: "Preview",
    copy: "Copy",
    copiedToClipboard: "Copied to clipboard",
    sendEmail: "Send Email",
    sendEmailHint: "The email is sent via Brevo using the previewed content.",
    to: "To",
    commaSeparated: "Comma-separated.",
    atLeastOneRecipient: "At least one recipient is required",
    emailSent: "Email sent",
    confirmDeleteTemplate: "Delete this template?",
    managerName: "Manager Name",
    managerNamePh: "e.g. John Smith",
    committeeName: "Committee Name",
    committeeNamePh: "e.g. Building Committee",
    emailContactLabels: "Email Contact Labels",
    emailContactLabelsHint: "Used by Email Templates to auto-fill {{manager_name}} and {{committee_name}}.",

    // Phase 339 — Email History (audit log)
    compose: "Compose",
    emailHistory: "Email History",
    searchHistoryPh: "Search subject, body, recipient, template…",
    allStatuses: "All statuses",
    sent: "Sent",
    failed: "Failed",
    sentAt: "Sent At",
    recipients: "Recipients",
    template: "Template",
    sentBy: "Sent By",
    actions: "Actions",
    resend: "Re-send",
    noEmailHistory: "No emails sent yet.",
    emailDetails: "Email Details",
    error: "Error",
    building: "Building",
    close: "Close",

    // Phase 340 — Expense category auto-fill picker
    expenseCategories: "Expense Categories",
    expenseCategoriesHint: "Click to insert the latest entry for each category. Categories without records are hidden.",
    insertAll: "Insert all",
    insertAllCategories: "Insert all categories",

    // Phase 345 — Hide / restore chips & inline editor send buttons
    restoreHiddenTags: "Restore hidden",
    confirmRestoreHiddenTags: "Restore all hidden placeholders and categories?",
    allPlaceholdersHidden: "All placeholders hidden.",
    allCategoriesHidden: "All categories hidden.",
    copyResolved: "Copy resolved content",

    // Phase 347 — Compact template picker + Send / Confirm / Attachments
    selectTemplate: "Select template…",
    liveBalancesNote: "Cash & Bank balance placeholders always pull the LIVE figures (same as the Dashboard).",
    addFiles: "Add files",
    replace: "Replace",
    noAttachmentsHint: "No files attached. PDF, Excel, Word, images and other common documents are supported.",
    attachments: "Attachments",
    reviewAndSend: "Review & Send",
    sendEmailHintConfirm: "Add recipients & attachments. A final preview will appear before the email is actually sent.",
    confirmSendTitle: "Final preview",
    confirmSendHint: "This is exactly what the recipients will receive. Click Confirm Send to dispatch.",
    confirmSend: "Confirm Send",

    // Phase 341 — Fire Extinguisher Certification
    fireCertification: "Fire Extinguisher Certification",
    fireCertHint: "Record the latest annual fire extinguisher inspection and maintenance contract details.",
    latestCertification: "Latest Certification",
    addCertification: "Add Certification",
    editCertification: "Edit Certification",
    confirmDeleteCertification: "Delete this certification?",
    noFireCertYet: "No fire extinguisher certification recorded yet. Click \"Add Certification\" to create the first one.",
    companyName: "Company Name",
    companyNamePh: "Or type a name…",
    companyNameRequired: "Company name is required",
    selectCompany: "Select company…",
    addCompany: "Add company",
    addCompanyHint: "Register a new fire extinguisher service provider.",
    certificationDate: "Certification Date",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    totalAmount: "Total",
    totalAutoHint: "Auto = qty × unit price. Editable.",
    contractNumber: "Contract Number",
    contractStartDate: "Contract Start",
    contractEndDate: "Contract Expiry",
    notesPh: "Multi-line notes…",
    history: "History",
    phone: "Phone",

    // Phase 342 — Global Fire Extinguisher Companies catalogue
    fireExtinguisherCompanies: "Fire Extinguisher Companies",
    assignedCompany: "Assigned Company",
    manageCompanies: "Manage companies",
    noFireCompaniesHint: "No companies yet. Click \"Manage companies\" to add one first.",
    companyRequired: "Please select a company",
    storedCompanyName: "Stored name",
    contactPerson: "Contact Person",

    // Phase 346 — Companies hub inside Manage Buildings → Settings
    companies: "Companies",
    companiesHint: "Manage all service-provider catalogues (insurance, elevator, certification, fire extinguisher)",
    companiesIntro: "Manage every service provider from one place. Each category opens its CRUD screen with search, edit and delete.",
    insuranceCompaniesHint: "Building insurance providers — contacts & policies.",
    elevatorCompaniesHint: "Elevator maintenance companies — contacts & contracts.",
    certific: "Building insurance providers — contacts & policies.",
    elevatorCompaniesHint: "Elevator maintenance companies — contacts & contracts.",
    certificationCompaniesHint: "Elevator certification inspectors — contacts & contracts.",
    fireExtinguisherCompaniesHint: "Fire extinguisher providers — annual certification & contracts.",

    // Phase 348 — Global Vendors / Expense Categories / Failure Reasons
    vendorsCentralHint: "Central vendor catalogue — add, edit, delete and search.",
    expenseCategoriesCentralHint: "Manage monthly + capital expense categories centrally; the catalogue is shared across all buildings.",
    failureReasonsCentralHint: "Central list of elevator failure reasons — shared across all buildings.",
    searchCategoryPh: "Search by code or name…",

    // Phase 349 — Global email templates + per-building send tab
    emailTemplatesCentralHint: "Manage email templates centrally — shared across every building.",
    emailTemplatesGlobalHint: "Templates are shared across every building. Select which one to use from each building's Emails tab.",
    emails: "Emails",
    emailCenter: "Email Center",
    // Phase 810 — Operations Dashboard widgets
    electricityWidget: "Electricity",
    nextMeetings: "Next Meetings",
    noElectricityData: "No electricity payments on file",
    managementWidget: "Management",
    noManagementData: "No management payments on file",
    noEmails: "No emails sent yet",
    noNextMeetings: "No upcoming meetings",
    emailCenterMailbox: "Mailbox",
    emailCenterInbox: "Inbox",
    emailCenterSent: "Sent",
    emailCenterDrafts: "Drafts",
    emailCenterArchive: "Archive",
    emailCenterTrash: "Trash",
    emailCenterCompose: "Compose",
    emailCenterReply: "Reply",
    emailCenterReplyAll: "Reply All",
    emailCenterForward: "Forward",
    emailCenterSearch: "Search",
    emailCenterCompanyMailbox: "Company mailbox",
    selectPeriodFirst: "Please select From and To dates",
    invalidPeriod: "From date must be on or before To date",
    setActive: "Set Active",
    setActiveTemplateForBuilding: "Pin as active for this building",
    templatePreview: "Template preview",
    attachElevatorStatement: "Attach elevator statement",
    attachElevatorStatementHint: "Statement PDF will be generated automatically for the selected period and attached.",
    autoGenerated: "auto",
    noAttachments: "No attachments.",
    from: "From",

    // Phase 351 — Per-building Email History + Statement period filter
    template: "Template",
    resend: "Resend",
    view: "View",
    emailDetails: "Email Details",
    readyToResend: "Recipients copied — review & send when ready.",
    searchHistoryPh: "Search recipient / subject / template…",
    noEmailsYet: "No emails sent yet from this building.",
    clear: "Clear",

    // Phase 352 — General Meetings hub (Agenda + Meeting Text Templates)
    generalMeetings: "General Meetings",
    generalMeetingsHint: "Agenda Templates + Meeting Text Templates — shared across every building.",
    generalMeetingsIntro: "Manage the templates used across every general meeting of every building from one place.",
    agendaTemplatesHint: "Agenda topics catalogue used when creating a new general meeting.",
    meetingTextTemplates: "Meeting Text Templates",
    meetingTextTemplatesHint: "Quorum & committee-decision legal text — auto-inserted into the minutes.",
    // Phase 733 — Agenda Templates per-topic template text
    greekTemplateText: "Greek Template Text",
    greekTemplatePlaceholder: "Text auto-inserted into the meeting when this topic is selected.",
    englishTranslation: "English Translation",
    englishTemplatePlaceholder: "Optional English version of the template text.",
    filled: "Filled",

    // Phase 343 — Fire Cert sub-tabs (Invoices / Payments / Statement)
    certifications: "Certifications",
    certificationExpiryDate: "Certification Expiry",
    invoices: "Invoices",
    payments: "Payments",
    statement: "Statement",
    addInvoice: "Add invoice",
    noFireInvoices: "No invoices linked yet.",
    noFirePayments: "No payments allocated yet.",
    paymentsAutoHint: "Payments auto-allocate from Cash/Bank Receipts when you set the source on the invoice.",
    description: "Description",
    reference: "Reference",
    source: "Source",
    openingBalance: "Opening Balance",
    invoicesTotal: "Invoices Total",
    paymentsTotal: "Payments Total",
    remainingBalance: "Remaining Balance",

    // Phase 344 — Statement ledger + inline edit
    invoiceNumber: "Invoice Number",
    invoiceAmount: "Invoice Amount",
    receiptNumber: "Receipt Number",
    receiptAmount: "Receipt Amount",
    runningBalance: "Running Balance",
    totals: "Totals",
    noLedgerEntries: "No entries yet.",
    editInvoice: "Edit Invoice",
    editInvoiceHint: "Edits update the linked expense in real time.",
    editPayment: "Edit Payment",
    editPaymentHint: "Edits adjust Cash / Bank balances automatically.",
    sendgridApiKey: "SendGrid API Key",
    brevoApiKey: "Brevo API Key",
    sendgridHint: "SendGrid uses Authorization: Bearer <key>. Make sure the sender email is verified (Single Sender or Domain Authentication).",
    brevoHint: "Brevo uses POST https://api.brevo.com/v3/smtp/email with an api-key header. Make sure the sender email is a verified sender in your Brevo account.",
    confirmDeleteInvoice: "Delete this invoice?",
    confirmDeletePayment: "Delete this payment?",
    attachedFile: "Attached File",
    attachedFiles: "files",
    attachments: "Attachments",
    attachmentsHelp: "Upload invoice scans, receipts, payment proofs (PDF / image, up to 15MB each).",
    uploadFiles: "Upload files",
    multipleFilesAllowed: "Multiple files allowed · PDF, PNG, JPG, WEBP",
    uploading: "Uploading…",
    addAttachment: "Add attachment",
    fileName: "File",
    size: "Size",
    uploadedAt: "Uploaded",
    // Phase 437 — Expense Vendors page + nested customer/supplier detail
    telephone: "Telephone",
    expenseVendors: "Expense Vendors",
    expenseVendorsDesc: "Payees used in Finance → Expenses. Independent of Suppliers, Bills and Building Management.",
    vendorSearchPlaceholder: "Search or type a new vendor (e.g. Petrolina, Superhome)",
    createVendor: "Create vendor",
    startTyping: "Start typing to search…",
    editVendor: "Edit Vendor",
    deleteVendor: "Delete Vendor",
    confirmDeleteVendor: "Are you sure you want to delete this vendor?",
    vendorInUseWarning: "This vendor is linked to one or more expenses. Reassign or delete those expenses first.",
    noVendors: "No vendors yet. Vendors are created automatically when added inline from the Expense form, or manually here.",
    noMatches: "No vendors match your search.",
    totalExpenses: "Total Expenses",
    attachment: "Attachment",
    fileTooLarge: "File is larger than 5 MB",
    remove: "remove",
    backToCustomers: "Back to Customers",
    backToSuppliers: "Back to Suppliers",
    customerNotFound: "Customer not found",
    supplierNotFound: "Supplier not found",
    billingDetails: "Billing Details",
    recentActivity: "Recent Activity",
    noActivity: "No activity yet.",
    noInvoicesYet: "No invoices yet.",
    noPaymentsYet: "No payments yet.",
    totalInvoices: "Total Invoices",
    totalPayments: "Total Payments",
    contact: "Contact",
    back: "Back",
    summary: "Summary",
    // Phase 438 — Global filter strip on Invoices / Payments index tabs.
    clearAll: "Clear",
    minAmount: "Min €",
    maxAmount: "Max €",
    invoicesLabel: "Invoices",
    paymentsLabel: "Payments",
    // Phase 439 — Bills nested categories tree
    billCategoriesNestedDesc: "Build a tree: Category → Subcategory → Sub-subcategory. Bills attach only to the deepest (leaf) subcategory.",
    addChild: "Add child",
    addSubcategory: "Add subcategory",
    editSubcategory: "Edit subcategory",
    deleteSubcategory: "Delete subcategory",
    under: "Under",
    noSubcategories: "No subcategories yet — click + to add one.",
    noCategoriesYet: "No categories yet. Click + Add category.",
    noLeafSubcategories: "No leaf subcategories — add one in Categories",
    deleteWithChildrenHint: "This node has nested children and/or bills. Choose how to proceed.",
    deleteCascadeHint: "Remove all descendant subcategories and their bills.",
    confirmDeleteSimple: "This will remove the item permanently.",
    selectTarget: "Select a target",
    // Phase 440 — Items inline in the categories tree
    editItem: "Edit item",
    deleteItem: "Delete item",
    confirmDeleteItem: "This will soft-delete the item. Existing bills attached to it remain but cannot be edited.",
    identifier: "Identifier",
    itemIdHint: "Plate, room #, model, etc.",
    optional: "optional",
    uncategorized: "uncategorized — assign to a leaf subcategory",
    // Phase 441 — Cascading dropdowns; items removed from bill flow
    subSubcategory: "Sub-subcategory",
    categoryRequired: "Category is required",
    subcategoryRequired: "Subcategory is required",
    pickDeepestSub: "Pick the deepest subcategory (current selection has further levels)",
    noSubsInCategory: "This category has no subcategories yet. Add one in Categories first.",
    none: "None",
    // Phase 442 — Renewal-based bills (Road Tax, Insurance, MOT, …)
    billType: "Bill type",
    billTypeInvoice: "Invoice bill",
    billTypeInvoiceDesc: "Tracks unpaid balance & due date (supplier invoices).",
    billTypeRenewal: "Renewal / coverage",
    billTypeRenewalDesc: "Road Tax, Insurance, MOT, License, Subscription. Status = active until expiry.",
    coverageStartDate: "Coverage start",
    coverageExpiryDate: "Coverage expires",
    renewalInvoicePlaceholder: "Receipt / confirmation # (optional)",
    renewalReminderHint: "Reminder fires 15 days before expiry. Status switches Active → Expiring soon → Expired automatically.",
    expiryRequiredForRenewal: "Expiry date is required for renewal bills",
    active: "Active",
    expiringSoon: "Expiring soon",
    expired: "Expired",
    pending: "Pending",
    left: "left",
    overdue: "overdue",
    balanceOrDays: "Balance / Days",
    deleteBill: "Delete bill",
    confirmDeleteBill: "This soft-deletes the bill and all linked payments. Reminders that reference it stop firing. Continue?",
    invoiceBills: "Invoice Bills",
    renewalBills: "Renewal Bills",
    invoiceBillsDesc: "Standard bills with invoice numbers, due dates, paid/unpaid balances and VAT.",
    renewalBillsDesc: "Road tax, insurance, licenses, subscriptions — coverage-based, tracks expiry/renewal dates instead of debt.",
    amountPaid: "Amount paid",
    amountPaidTotal: "Amount paid (total)",
    renewalsCount: "Renewals",
    activeRenewals: "Active",
    coverageOk: "coverage OK",
    within15Days: "within 15 days",
    expiredOverdue: "Expired / Overdue",
    actionRequired: "action required",
    partiallyPaid: "Partially Paid",
    invoiceBill: "Invoice Bill",
    initialPayment: "Initial payment",
    initialPaymentHint: "Records a payment immediately. Leave blank for fully unpaid.",
    initialPayExceedsTotal: "Payment exceeds the invoice total.",
    paymentAmount: "Amount paid",
    paymentAmountRequired: "Amount must be > 0",
    paymentAdded: "Payment added",
    paymentUpdated: "Payment updated",
    paymentDeleted: "Payment deleted",
    addPayment: "Add payment",
    editPayment: "Edit payment",
    deletePayment: "Delete payment",
    confirmDeletePayment: "Remove this payment? The bill balance will be recalculated.",
    summary: "Summary",
    invoiceCreated: "Invoice created",
    billTotal: "Bill total",
    alreadyPaid: "Already paid",
    outstanding: "Outstanding",
    viewDetails: "View details",
    close: "Close",
    bank: "Bank",
    cash: "Cash",
    card: "Card",
    cheque: "Cheque",
    other: "Other",
    openCustomerStatement: "Open customer statement",
    viewStatement: "View statement",
    fullStatement: "Full Statement",
    totalInvoiced: "Total invoiced",
    totalPaid: "Total paid",
    outstandingBalance: "Outstanding balance",
    settled: "Settled",
    runningBalance: "Running Balance",
    type: "Type",
    debit: "Debit",
    credit: "Credit",
    noBillsYetForCustomer: "No bills recorded yet under this customer.",
    invoicesLabel: "Invoices",
    totalPayments: "Total payments",
    noPaymentsThisMonth: "No payments recorded this month yet.",
    client: "Client / Vendor",
    selectBankAccount: "Select bank account…",
    searchBankAccount: "Search bank account…",
    noBankAccountsCreated: "No bank accounts created",
    createBankAccount: "Create bank account",
    noMatches: "No matches.",
    weOwe: "We owe",
    totalInvoiceAmount: "Total Invoice Amount",
    noEntriesInRange: "No entries in the selected date range.",
    totals: "Totals",
    openInvoices: "open",
    allocated: "Allocated",
    unallocated: "Unallocated",
    allocate: "Allocate",
    full: "Full",
    noOpenInvoices: "No open invoices to allocate.",
    allocateFull: "Allocate full outstanding",
    // Phase 960 — Bills → Vendors → Vendor Statement
    vendors: "Vendors",
    vendor: "Vendor",
    allInvoices: "All Invoices",
    vendorsCount: "Vendors",
    outstandingBalance: "Outstanding",
    invoicedTotal: "Invoiced",
    paidTotal: "Paid",
    creditedTotal: "Credited",
    creditNotes: "Credit notes",
    withBalance: "with balance",
    fullyPaid: "fully paid",
    invoices: "Invoices",
    withOutstanding: "With Balance",
    searchVendorsPlaceholder: "Search vendor name…",
    searchInvoicesPlaceholder: "Search invoice #, notes, description…",
    breakdown: "Breakdown",
    lastActivity: "Last activity",
    unpaidShort: "unpaid",
    partialShort: "partial",
    paidShort: "paid",
    noVendors: "No vendors yet",
    noVendorsHint: "Add a bill to see its vendor appear here.",
    backToVendors: "Back",
    invoiceDate: "Invoice Date",
    invoicesLabel: "Invoices",
    paymentsLabel: "Payments",
    statement: "Statement",
    noInvoicesForVendor: "No invoices match the current filters.",
    noPaymentsYet: "No payments recorded yet.",
    noEntries: "No entries in this period.",
    runningBalance: "Balance",
    invoice: "Invoice",
    payment: "Payment",
    creditNote: "Credit Note",
    type: "Type",
    renewals: "renewals",
    // Phase 961 — Inline expansion + Unpaid view + Category safe-delete
    paymentHistory: "Payment History",
    unpaidView: "Unpaid",
    totalOutstanding: "Total Outstanding",
    allOpen: "All Open",
    searchUnpaidPlaceholder: "Search vendor, invoice #, notes…",
    remaining: "Remaining",
    overdue: "Overdue",
    openVendorStatement: "Open vendor statement",
    allPaidUp: "You are all paid up",
    allPaidUpHint: "No unpaid or partially paid invoices match the current filters.",
    deleteCategoryOnly: "Delete category only",
    deleteDetachHint: "Keep all vendors, bills and payments. They will show as uncategorized.",
    moveToAnother: "Move vendors to another category",
    moveHint: "Everything inside moves to the category you pick, then this one is removed.",
    deleteCategoryDataSafeHint: "This category contains",
    vendorsAssociated: "vendor(s). Your bills and payments will NOT be deleted — the vendors will simply keep their history and lose the category label.",
    deleteCategoryEmptyHint: "This category has no vendors and can be deleted safely.",
    deleteSubcategoryHint: "This subcategory has nested children. Choose how to proceed.",
    // Phase 962 — Category-first navigation
    categoriesListHint: "Open a category to see the vendors inside it.",
    searchCategoryPlaceholder: "Search category…",
    noCategoriesHint: "Click \"Add category\" to create your first one.",
    noVendorsInCategory: "No vendors yet",
    uncategorized: "Uncategorized",
    renameCategory: "Rename category",
    categoryNamePlaceholder: "e.g. Household",
    // Phase 963 — Vendor & Payment edit / delete
    renameVendor: "Rename vendor",
    vendorName: "Vendor name",
    vendorNamePlaceholder: "e.g. CYTA",
    vendorRenameHint: "Renaming updates every asset row and bill that uses this vendor name. Financial history stays intact.",
    deleteVendor: "Delete vendor",
    deleteVendorHint: "The vendor will be removed from the list, but",
    deleteVendorHintSuffix: "invoice(s) and their payment history will be preserved. They will appear under (Uncategorized) or (Unspecified) until you reassign them.",
    deleteVendorEmpty: "This vendor has no invoices and can be removed safely.",
    deletePayment: "Delete payment",
    deletePaymentHint: "This removes the payment from the invoice ledger. The invoice status and remaining balance are recalculated automatically. Continue?",
    // Phase 965 — Invoice line items
    lineItems: "Line Items",
    lineItemsHint: "Optional. When you add items, the Total is computed automatically.",
    addLine: "Add line",
    noLineItemsYet: "No line items — click \"Add line\" to break the invoice down.",
    lineDescPlaceholder: "e.g. Cleaning products",
    quantity: "Qty",
    unitPrice: "Unit Price",
    lineItemsTotal: "Items total",
    item: "item",
    items: "items",
    remove: "Remove",
    noPaymentsForInvoice: "No payments recorded for this invoice.",
    // Phase 967 — Professional statement columns
    invoiceAmount: "Invoice Amount",
    paymentAmount: "Payment Amount",
    totalInvoiced: "Total Invoiced",
    totalPaid: "Total Paid",
    totalPayments: "Total Payments",
    // Phase 1004g/1005 — Management Company Advance History dialog
    viewMcaHistory: "View History",
    mcaViewPdf: "MCA PDF",
    mcaHistoryTitle: "Management Company Advance — History",
    mcaTotalAdvances: "Total Advances",
    mcaTotalRepayments: "Total Repayments",
    mcaOutstanding: "Outstanding",
    advance: "Advance",
    repayment: "Repayment",
    outstanding: "Outstanding",
  },
  
  el: {
    // Phase 728 — Record Bill Payment dialog labels
    recordBillPayment: "Καταχώρηση Πληρωμής Λογαριασμού",
    paymentDate: "Ημερομηνία Πληρωμής",
    paymentDateRequired: "Απαιτείται η ημερομηνία πληρωμής",
    referenceReceipt: "Αριθμός Αναφοράς / Απόδειξης / Συναλλαγής",
    savePayment: "Αποθήκευση Πληρωμής",
    bankAccount: "Τραπεζικός Λογαριασμός",
    bankAccountRequired: "Παρακαλώ επιλέξτε τραπεζικό λογαριασμό",
    selectBankAccount: "Επιλέξτε τραπεζικό λογαριασμό",
    noBankAccounts: "Δεν έχουν οριστεί τραπεζικοί λογαριασμοί",
    cashSource: "Εσωτερικό Ταμείο",
    cashSourcePlaceholder: "π.χ. Ταμείο γραφείου",
    // Phase 727 — PDF preview reliability
    openInNewTab: "Άνοιγμα σε νέα καρτέλα",
    pdfEmbedBlocked: "Το πρόγραμμα περιήγησης απέκλεισε την ενσωματωμένη προεπισκόπηση PDF.",
    // Phase 726 — PDF Export column picker
    pdfExportOptions: "Επιλογές Εξαγωγής PDF",
    pdfExportOptionsHint: "Επιλέξτε τις στήλες που θέλετε να συμπεριληφθούν στο PDF.",
    pdfExportAtLeastOne: "Παρακαλώ επιλέξτε τουλάχιστον μία στήλη.",
    clientVendor: "Πελάτης / Προμηθευτής",
    // Phase 420 — Bills v2 (Asset-centric)
    billsTitle: "Λογαριασμοί",
    billsV2Desc: "Λειτουργική παρακολούθηση λογαριασμών ανά περιουσιακό στοιχείο. Ανεξάρτητο από το λογιστικό μέρος.",
    assetsItems: "Περιουσιακά Στοιχεία",
    assetsTree: "Στοιχεία",
    subcategories: "Υποκατηγορίες",
    billCategoriesDesc: "Κεντρικές ομάδες (Οχήματα, Κτίρια, Εξοπλισμός, Άλλο, …) που φιλοξενούν τα στοιχεία σας.",
    billSubcategoriesDesc: "Τύποι λογαριασμών μέσα σε κατηγορία (π.χ. Οχήματα → MOT, Ασφάλεια, Τέλη).",
    legacyBills: "Παλαιοί Λογαριασμοί (μόνο ανάγνωση) →",
    addAsset: "Προσθήκη στοιχείου",
    editAsset: "Επεξεργασία στοιχείου",
    deleteAsset: "Διαγραφή στοιχείου",
    confirmDeleteAsset: "Διαγραφή",
    addSubcategory: "Προσθήκη υποκατηγορίας",
    editSubcategory: "Επεξεργασία υποκατηγορίας",
    deleteSubcategory: "Διαγραφή υποκατηγορίας",
    renameSubcategory: "Μετονομασία υποκατηγορίας",
    subcategoryNamePlaceholder: "π.χ. Ηλεκτρικό",
    noSubcategoriesInCategory: "Δεν υπάρχουν υποκατηγορίες σε αυτή την κατηγορία ακόμη.",
    vendorPickerPlaceholder: "Πληκτρολογήστε ή επιλέξτε προμηθευτή…",
    vendorIndependentHint: "Επιλέξτε από υπάρχοντες προμηθευτές ή πληκτρολογήστε νέο. Οι προμηθευτές δεν είναι δεμένοι σε κατηγορία — ο ίδιος προμηθευτής μπορεί να εμφανίζεται σε οποιοδήποτε συνδυασμό Κατηγορίας + Υποκατηγορίας.",
    addBill: "Προσθήκη λογαριασμού",
    editBill: "Επεξεργασία λογαριασμού",
    deleteBill: "Διαγραφή λογαριασμού",
    confirmDeleteBill: "Διαγραφή",
    confirmDeleteSub: "Διαγραφή",
    confirmDeleteCategory: "Διαγραφή",
    paymentsCascaded: "Οι συνδεδεμένες πληρωμές θα διαγραφούν επίσης.",
    noBills: "Δεν υπάρχουν λογαριασμοί για αυτό το στοιχείο.",
    noPayments: "Δεν έχουν καταχωρηθεί πληρωμές.",
    noInvoicesHint: "Δεν έχουν καταχωρηθεί λογαριασμοί σε αυτή την υποκατηγορία ακόμη.",
    noPaymentsHint: "Δεν έχουν καταχωρηθεί πληρωμές για τιμολόγια αυτής της υποκατηγορίας ακόμη.",
    draftAutoSaved: "Αυτόματη αποθήκευση προχείρου · συνεχίστε από το σημείο που σταματήσατε",
    discardDraft: "Απόρριψη προχείρου",
    draftDiscarded: "Το πρόχειρο διαγράφηκε",
    noTimeline: "Δεν υπάρχει ιστορικό για αυτό το στοιχείο.",
    noAssetsInCategory: "Δεν υπάρχουν στοιχεία",
    noSubcategories: "Δεν υπάρχουν υποκατηγορίες",
    noAlerts: "Δεν υπάρχουν ενεργές υπενθυμίσεις.",
    selectAssetHint: "Επιλέξτε στοιχείο για να δείτε λογαριασμούς, πληρωμές και ταμείο.",
    dueSoon15Days: "Λήξη Σύντομα (15 ημέρες)",
    paidThisMonth: "Πληρωμένα Αυτόν τον Μήνα",
    upcomingRenewals: "Επερχόμενες Ανανεώσεις",
    next30Days: "επόμενες 30 ημέρες",
    expiringInDays: "Λήγει σε",
    expires: "Λήγει",
    due: "Πληρωτέο",
    reminders: "Υπενθυμίσεις",
    alerts: "ειδοποιήσεις",
    viewAllAssets: "Όλα τα στοιχεία",
    overdue: "Εκπρόθεσμο",
    identifier: "Αναγνωριστικό / Πινακίδα",
    forRenewalsReminders: "για ανανεώσεις/υπενθυμίσεις",
    subcategoryRequired: "Απαιτείται υποκατηγορία",
    nameRequired: "Απαιτείται όνομα",
    nameAndCategoryRequired: "Απαιτούνται όνομα και κατηγορία",
    amountRequired: "Το ποσό πρέπει να είναι μεγαλύτερο από 0",
    paymentSaved: "Η πληρωμή αποθηκεύτηκε",
    created: "Δημιουργήθηκε",
    updated: "Ενημερώθηκε",
    builtin: "ενσωματωμένο",
    custom: "προσαρμοσμένο",
    moveUp: "Πάνω",
    moveDown: "Κάτω",
    totalInvoiced: "Τιμολόγια",
    totalPaid: "Πληρωμένα",
    outstanding: "Υπόλοιπο",
    paid: "Πληρωμένα",
    balance: "Υπόλοιπο",
    expiryDate: "Ημ/νία λήξης",
    startDate: "Ημ/νία έναρξης",
    invoiceNumber: "Αρ. Τιμολογίου",
    paymentLabel: "Πληρωμή",
    invoice: "Τιμολόγιο",
    finalBalance: "Τελικό υπόλοιπο",
    debit: "Χρέωση",
    credit: "Πίστωση",
    card: "Κάρτα",
    rows: "γραμμές",
    source: "Πηγή",
    breakdown: "Ανάλυση",
    breakdownHelp: "Όλες οι γραμμές που συνεισφέρουν στο Σύνολο Εξόδων. Πηγή: db.expenses (καταχωρήσεις από Αγορές → Έξοδα). Οι Κατηγορίες Αναφοράς ΔΕΝ περιλαμβάνονται.",
    viewBreakdown: "Προβολή ανάλυσης →",
    select: "Επιλέξτε…",
    optional: "Προαιρετικό",
    bills: "λογαριασμοί",
    title: "Τίτλος",
    type: "Τύπος",
    name: "Όνομα",
    actions: "Ενέργειες",
    categories: "Κατηγορίες",
    addCategory: "Προσθήκη κατηγορίας",
    editCategory: "Επεξεργασία κατηγορίας",
    deleteCategory: "Διαγραφή κατηγορίας",
    subcategory: "Υποκατηγορία",
    supplier: "Προμηθευτής",
    dueDate: "Ημ/νία πληρωμής",
    // Phase 423 — Bills v2 (managed items, global add)
    managedItems: "Στοιχεία",
    item: "Στοιχείο",
    items: "Στοιχεία",
    selectItem: "Επιλέξτε στοιχείο",
    selectItemRequired: "Επιλέξτε στοιχείο",
    selectCategoryFirst: "Επιλέξτε πρώτα κατηγορία",
    itemNameRequired: "Απαιτείται όνομα στοιχείου",
    itemCreated: "Το στοιχείο δημιουργήθηκε",
    createItem: "Δημιουργία στοιχείου",
    newItemName: "Όνομα νέου στοιχείου",
    noItemsCreateBelow: "Δεν υπάρχουν στοιχεία — δημιουργήστε ένα παρακάτω",
    noItemsYet: "Δεν υπάρχουν στοιχεία",
    addItem: "Προσθήκη στοιχείου",
    classify: "Ταξινόμηση",
    amountWithoutVat: "Ποσό χωρίς ΦΠΑ",
    attachments: "Συνημμένα",
    upload: "Μεταφόρτωση",
    noAttachmentsYet: "Δεν υπάρχουν συνημμένα ακόμα.",
    saveFirstToAttach: "Αποθηκεύστε πρώτα την πιστοποίηση για να επισυνάψετε αρχεία.",
    certAttachmentsHint: "Αναφορές PDF, φωτογραφίες, πιστοποιητικά, τιμολόγια. Έως 5 MB ανά αρχείο, 25 MB συνολικά ανά πιστοποίηση.",
    deleteAttachmentConfirm: "Διαγραφή αυτού του συνημμένου;",
    uploadedSuccess: "Μεταφορτώθηκε",
    uploadFailed: "Αποτυχία μεταφόρτωσης",
    deleteFailed: "Αποτυχία διαγραφής",
    fileTooLarge: "Πολύ μεγάλο αρχείο",
    elevatorCertificationAttachments: "Συνημμένα Πιστοποίησης Ανελκυστήρα",
    elevCertAttachmentsHint: "Επιλέξτε συγκεκριμένα αρχεία. Τίποτα δεν επισυνάπτεται αυτόματα.",
    addAttachment: "Προσθήκη συνημμένου",
    noAttachments: "Δεν υπάρχουν συνημμένα.",
    recordPaymentOptional: "Καταχώριση πληρωμής (προαιρετικό)",
    billCreated: "Ο λογαριασμός δημιουργήθηκε",
    billSavedPaymentFailed: "Ο λογαριασμός αποθηκεύτηκε αλλά η πληρωμή απέτυχε:",
    purchases: "Αγορές",
    purchasesDesc: "Διαχείριση προμηθευτών, τιμολογίων προμηθευτών, πληρωμών και ταμείου.",
    suppliers: "Προμηθευτές",
    supplierInvoices: "Τιμολόγια Προμηθευτών",
    searchSuppliers: "Αναζήτηση προμηθευτών...",
    selectSupplier: "Επιλέξτε προμηθευτή",
    selectSupplierToShowStatement: "Επιλέξτε προμηθευτή για το ταμείο.",
    // Phase 422 — Zoho-style Sales Invoice detail
    selectInvoiceHint: "Επιλέξτε τιμολόγιο από τη λίστα για προβολή.",
    invoiceNo: "Αρ. Τιμολογίου",
    billTo: "Πελάτης",
    amountDue: "Οφειλόμενο Ποσό",
    subtotal: "Υποσύνολο",
    quantity: "Ποσ.",
    rate: "Τιμή",
    pdfPrint: "PDF / Εκτύπωση",
    recordPayment: "Καταχώριση Πληρωμής",
    markAsSent: "Σήμανση ως Αποστολή",
    downloadPdf: "Λήψη PDF",
    clone: "Κλωνοποίηση",
    more: "Περισσότερα",
    share: "Κοινοποίηση",
    reminders: "Υπενθυμίσεις",
    sendEmail: "Αποστολή Email",
    linkCopied: "Ο σύνδεσμος PDF αντιγράφηκε στο πρόχειρο",
    clonedInvoice: "Τιμολόγιο κλωνοποιήθηκε — ελέγξτε και αποθηκεύστε.",
    newInvoiceCloneTitle: "Νέο Τιμολόγιο (Πρόχειρο)",
    draftNotSaved: "Πρόχειρο — Δεν Αποθηκεύτηκε",
    clonedFromBanner: "Αντίγραφο από {n} — ελέγξτε τα πεδία και πατήστε Αποθήκευση για να δημιουργηθεί νέο τιμολόγιο.",
    clonedFromBannerHint: "Τίποτα δεν έχει αποθηκευτεί ακόμα. Κλείστε για ακύρωση — κανένα τιμολόγιο δεν θα δημιουργηθεί μέχρι να πατήσετε Αποθήκευση.",
    markInactive: "Ανενεργός",
    reactivate: "Επανενεργοποίηση",
    cleanerArchived: "Ο καθαριστής αρχειοθετήθηκε",
    cleanerReactivated: "Ο καθαριστής επανενεργοποιήθηκε",
    cleanerMarkedInactive: "Ο καθαριστής σημάνθηκε ως ανενεργός",
    cleanerInactiveWarning: "Αυτός ο καθαριστής είναι ανενεργός. Επανενεργοποιήστε τον πρώτα.",
    cleanerInactiveBlocksAdd: "Ο καθαριστής είναι ανενεργός — επανενεργοποιήστε για να προσθέσετε εργασίες / πληρωμές.",
    confirmDeactivateCleaner: "Να σημανθεί αυτός ο καθαριστής ως ανενεργός; Το ιστορικό του διατηρείται και θα εξαφανιστεί από τη λίστα Ενεργών.",
    confirmReactivateCleaner: "Επανενεργοποίηση αυτού του καθαριστή; Θα επανεμφανιστεί στη λίστα Ενεργών.",
    markAsSentHint: "Ανοίξτε τον διάλογο Αποστολής Email για να σταλεί.",

    // Navigation
    dashboard: "Πίνακας Ελέγχου",
    buildingManagement: "Διαχείριση Κτιρίων",
    buildingDashboardDesc: "Επισκόπηση όλων των κτιρίων, χρεών διαμερισμάτων και ειδοποιήσεων",
    activeAlerts: "Ενεργές Ειδοποιήσεις",
    apartmentDebts: "Χρέη Διαμερισμάτων",
    noApartmentDebts: "Δεν υπάρχουν χρέη — όλες οι πληρωμές είναι ενημερωμένες",
    noUnpaidItems: "Δεν υπάρχουν απλήρωτα σε αυτή την κατηγορία",
    outstandingByBuilding: "Υπόλοιπα ανά Κτίριο",
    alertsAndExpirations: "Ειδοποιήσεις & Λήξεις",
    elevatorContract: "Συμβόλαιο Ανελκυστήρα",
    critical: "Κρίσιμο",
    net: "Καθαρό",
    buildings: "Κτίρια",
    building: "Κτίριο",
    tasks: "Εργασίες",
    payments: "Πληρωμές",
    notifications: "Ειδοποιήσεις",
    settings: "Ρυθμίσεις",
    users: "Χρήστες",
    logout: "Αποσύνδεση",
    
    // Auth
    login: "Σύνδεση",
    register: "Εγγραφή",
    email: "Email",
    password: "Κωδικός",
    name: "Όνομα",
    phone: "Τηλέφωνο",
    loginWithGoogle: "Συνέχεια με Google",
    orContinueWith: "Ή συνεχίστε με",
    dontHaveAccount: "Δεν έχετε λογαριασμό;",
    alreadyHaveAccount: "Έχετε ήδη λογαριασμό;",
    signUp: "Εγγραφή",
    signIn: "Σύνδεση",
    
    // Dashboard
    overview: "Επισκόπηση",
    totalBuildings: "Σύνολο Κτιρίων",
    totalUnits: "Σύνολο Μονάδων",
    completedTasks: "Ολοκληρωμένες Εργασίες",
    activeTasks: "Ενεργές Εργασίες",
    noCompletedTasks: "Δεν υπάρχουν ολοκληρωμένες εργασίες",
    viewAllTasks: "Προβολή Όλων των Εργασιών",
    pendingTasks: "Εκκρεμείς Εργασίες",
    upcomingTasks: "Προσεχείς Εργασίες",
    overduePayments: "Ληξιπρόθεσμες Πληρωμές",
    financialAlerts: "Οικονομικές Ειδοποιήσεις",
    noFinancialAlerts: "Δεν υπάρχουν οικονομικές ειδοποιήσεις — όλα είναι εντάξει",
    unpaidBill: "Απλήρωτος Λογαριασμός",
    unpaidExpense: "Απλήρωτο Έξοδο",
    pendingPayment: "Εκκρεμής Πληρωμή",
    pendingPayments: "Εκκρεμείς Πληρωμές",
    daysOverdue: "ημέρες καθυστέρηση",
    due: "Λήξη",
    recentActivity: "Πρόσφατη Δραστηριότητα",
    
    // Status
    completed: "Ολοκληρώθηκε",
    pending: "Εκκρεμεί",
    upcoming: "Προσεχώς",
    expiring: "Λήγει",
    overdue: "Ληξιπρόθεσμο",
    paid: "Πληρώθηκε",
    unpaid: "Απλήρωτο",
    partial: "Μερική",
    paidCredit: "Πληρ. • Πίστωση",
    ok: "OK",
    issue: "Πρόβλημα",
    attention: "Χρειάζεται Προσοχή",
    
    // Buildings
    addBuilding: "Προσθήκη Κτιρίου",
    editBuilding: "Επεξεργασία Κτιρίου",
    deleteBuilding: "Διαγραφή Κτιρίου",
    buildingArchived: "Το κτίριο αρχειοθετήθηκε (έχει ιστορικά δεδομένα)",
    buildingRestored: "Το κτίριο επαναφέρθηκε επιτυχώς",
    deleteArchiveWarning: "Εάν αυτό το κτίριο έχει ιστορικά δεδομένα (καθαρισμός, πληρωμές, έξοδα), θα αρχειοθετηθεί αντί να διαγραφεί οριστικά. Τα αρχειοθετημένα κτίρια μπορούν να επαναφερθούν αργότερα.",
    managers: "Διαχειριστές",
    addManager: "Προσθήκη Διαχειριστή",
    noManagers: "Δεν έχουν προστεθεί διαχειριστές",
    managerName: "Όνομα Διαχειριστή",
    managerPhone: "Τηλέφωνο",
    buildingName: "Όνομα Κτιρίου",
    buildingCode: "Κωδικός Κτιρίου",
    takeoverDate: "Ημ/νία Ανάληψης",
    releaseDate: "Ημ/νία Αποδέσμευσης",
    manager: "Διαχειριστής",
    units: "Μονάδες",
    address: "Διεύθυνση",
    streetAddress: "Οδός",
    zipCode: "Τ.Κ.",
    city: "Πόλη",
    countryRegion: "Χώρα / Περιοχή",
    totalWithVat: "Σύνολο (με ΦΠΑ)",
    withoutVat: "Χωρίς ΦΠΑ",
    location: "Τοποθεσία",
    notes: "Σημειώσεις",
    bankDetails: "Τραπεζικά Στοιχεία",
    bankAccountName: "Όνομα Λογαριασμού",
    bankAccountNumber: "Αριθμός Λογαριασμού",
    bankIban: "IBAN",
    bankSwift: "SWIFT / BIC",
    bankName: "Τράπεζα",
    bankPhone: "Τηλέφωνο",
    companySettings: "Ρυθμίσεις Εταιρείας",
    companySettingsDesc: "Γενικές ρυθμίσεις που εφαρμόζονται σε όλα τα κτίρια και τα PDF",
    bankDetailsGlobalHint: "Αυτά τα τραπεζικά στοιχεία θα χρησιμοποιούνται σε όλα τα PDF (τιμολόγια, καταστάσεις, αποδείξεις) εκτός αν αντικατασταθούν σε επίπεδο κτιρίου.",
    bankDetailsBuildingHint: "Τραπεζικά στοιχεία για αυτό το κτίριο. Θα χρησιμοποιούνται στα PDF που δημιουργούνται για αυτό το κτίριο.",
    companyDetails: "Στοιχεία Εταιρείας",
    paymentDetails: "Στοιχεία Πληρωμής",
    noBuildings: "Δεν υπάρχουν κτίρια",
    noData: "Δεν υπάρχουν δεδομένα",
    
    // Tasks / Reminders
    addTask: "Προσθήκη Εργασίας",
    allTasksComplete: "Όλες οι εργασίες ολοκληρώθηκαν",
    inProgress: "Σε Εξέλιξη",
    statusPending: "Σε εκκρεμότητα",
    statusInProgress: "Σε εξέλιξη",
    statusWaiting: "Σε αναμονή",
    statusCompleted: "Ολοκληρώθηκε",
    followUpDate: "Ημ. follow-up",
    editTask: "Επεξεργασία Εργασίας",
    deleteTask: "Διαγραφή Εργασίας",
    addReminder: "Προσθήκη Υπενθύμισης",
    editReminder: "Επεξεργασία Υπενθύμισης",
    deleteReminder: "Διαγραφή Υπενθύμισης",
    reminders: "Υπενθυμίσεις",
    noReminders: "Δεν υπάρχουν υπενθυμίσεις",
    markComplete: "Ολοκλήρωση",
    date: "Ημερομηνία",
    taskType: "Τύπος Εργασίας",
    companyName: "Εταιρεία",
    startDate: "Ημ. Έναρξης",
    endDate: "Ημ. Λήξης",
    lastPayment: "Τελευταία Πληρωμή",
    lastPaymentDate: "Ημ. Τελευταίας Πληρωμής",
    noPaymentYet: "Καμία πληρωμή",
    nextCheck: "Επόμενος Έλεγχος",
    status: "Κατάσταση",
    paymentStatus: "Κατάσταση Πληρωμής",
    categories: "Κατηγορίες",
    categoriesManageHelp: "Διαχείριση κατηγοριών εξόδων για όλα τα κτίρια. Η ίδια λίστα εμφανίζεται στην Προσθήκη Εξόδου και στα φίλτρα.",
    addCategory: "Προσθήκη Κατηγορίας",
    newCategoryNamePrompt: "Εισάγετε όνομα κατηγορίας:",
    newCategoryGroupPrompt: "Εισάγετε τύπο (monthly ή capital):",
    editCategoryNamePrompt: "Επεξεργασία ονόματος κατηγορίας:",
    editCategoryGroupPrompt: "Επεξεργασία τύπου (monthly ή capital). Αφήστε ως έχει αν η κατηγορία χρησιμοποιείται:",
    cannotDeleteInUse: "Δεν μπορεί να διαγραφεί — χρησιμοποιείται σε υπάρχοντα έξοδα.",
    cannotChangeTypeInUse: "Ο τύπος δεν μπορεί να αλλάξει όσο η κατηγορία χρησιμοποιείται.",
    codeAutoGenerateHint: "Αφήστε κενό για αυτόματη δημιουργία (σειρά 200 για Μηνιαία, 300 για Κεφαλαιουχικά).",
    rfAdjustmentColLabel: "Προσαρμογή",
    rfAdjustmentColTitle: "Μερίδιο κάθε διαμερίσματος στην ετήσια προσαρμογή στρογγυλοποίησης, με βάση το Ποσοστό %.",
    rfFinalMonthlyColLabel: "Τελικό Μηνιαίο",
    rfFinalMonthlyColTitle: "Αρχικό Μηνιαίο Αποθεματικό + Προσαρμογή / 12.",
    changeOwner: "Αλλαγή Ιδιοκτήτη",
    changeOwnerHint: "Ο προηγούμενος ιδιοκτήτης διατηρείται στο Ιστορικό Ιδιοκτητών με αυτόματη Ημ/νία Λήξης. Ο νέος ιδιοκτήτης δημιουργείται ως Ενεργός.",
    currentOwner: "Τρέχων Ιδιοκτήτης",
    newActiveOwner: "Νέος Ενεργός Ιδιοκτήτης",
    saveActivateNewOwner: "Αποθήκευση & Ενεργοποίηση Νέου Ιδιοκτήτη",
    viewOwnerHistory: "Προβολή Ιστορικού Ιδιοκτητών",
    useChangeOwnerHint: "χρησιμοποιήστε Αλλαγή Ιδιοκτήτη για ενημέρωση",
    ownerLabel: "Ιδιοκτήτης",
    ownershipPeriod: "Περίοδος Ιδιοκτησίας",
    selectOwner: "Επιλογή Ιδιοκτήτη",
    allOwners: "Όλοι οι Ιδιοκτήτες",
    invoiceOwner: "Ιδιοκτήτης Τιμολογίου",
    invoiceOwnerHint: "Επιλέγεται αυτόματα με βάση την περίοδο. Άλλαξέ το αν το τιμολόγιο ανήκει σε άλλον ιστορικό ιδιοκτήτη. Η επιλογή συνδέεται μόνιμα με αυτό το τιμολόγιο.",
    allocateEquallyLabel: "Ισόποσος επιμερισμός ανά μήνα",
    manualAllocationLabel: "Χειροκίνητη καταχώρηση ανά μήνα",
    openingBalanceForNewOwner: "Αρχικό Υπόλοιπο Νέου Ιδιοκτήτη",
    openingBalanceForNewOwnerHint: "Προεπιλογή €0.00. Καταχώρηση μόνο όταν ο νέος ιδιοκτήτης έχει συμφωνήσει ρητά να αναλάβει μέρος ή όλο το υπόλοιπο του προηγούμενου. Θετική τιμή = οφειλή· αρνητική = πίστωση υπέρ του ιδιοκτήτη.",
    openingBalanceNotes: "Σημειώσεις Αρχικού Υπολοίπου",
    openingBalanceNotesPlaceholder: "π.χ. Ανέλαβε €200 από τον προηγούμενο ιδιοκτήτη",
    searchByBuilding: "Αναζήτηση κτιρίου…",
    allBuildings: "Όλα τα Κτίρια",
    noTasks: "Δεν υπάρχουν εκκρεμείς εργασίες",
    noNotes: "Δεν υπάρχουν σημειώσεις",
    statementTracking: "Statement Tracking",
    bankReceiptsPage: "Bank Receipts",
    statementHistory: "Ιστορικό Εκκαθαρίσεων",
    statementSent: "Απεστάλη",
    lastStatementSent: "Τελευταία Αποστολή",
    neverSent: "Δεν έχει σταλεί",
    noStatementTrackingRows: "Δεν υπάρχουν διαμερίσματα που να ταιριάζουν στο φίλτρο",
    clearFilter: "Καθαρισμός",
    history: "Ιστορικό",
    selectOwnerHint: "Φιλτράρει τα ανεξόφλητα τιμολόγια στον επιλεγμένο ιδιοκτήτη. Η πληρωμή θα παραμείνει μόνιμα συνδεδεμένη με αυτόν.",
    fullShort: "Όλο",
    payThisInvoiceInFull: "Εξόφληση ολόκληρου του υπολοίπου αυτού του τιμολογίου",
    noUnpaidInvoicesForOwner: "Δεν υπάρχουν ανεξόφλητα τιμολόγια για τον επιλεγμένο ιδιοκτήτη.",
    contactPerson: "Πρόσωπο Επικοινωνίας",
    contactPersonName: "Όνομα",
    contactPersonHint: "Για περιπτώσεις όπου η επικοινωνία γίνεται μέσω γραμματέα, λογιστή, μέλους οικογένειας, γραφείου κ.λπ.",
    contactPersonEmail: "Email Προσώπου Επικοινωνίας",
    emailRecipients: "Παραλήπτες Email",
    emailRecipientsHint: "Επιλέξτε ποιες διευθύνσεις λαμβάνουν τιμολόγια, καταστάσεις, υπενθυμίσεις και ειδοποιήσεις πληρωμών.",
    ownerEmail: "Email Ιδιοκτήτη",
    additionalEmail: "Επιπλέον Email",
    extraEmailsCc: "Επιπλέον Emails (Λίστα CC)",
    addEmail: "Προσθήκη Email",
    tenantOptional: "Ενοικιαστής (Προαιρετικό)",
    tenantName: "Όνομα Ενοικιαστή",
    tenantPhone: "Τηλέφωνο Ενοικιαστή",
    tenantEmail: "Email Ενοικιαστή",
    paysCommonExpenses: "Πληρώνει Κοινόχρηστα",
    noCategories: "Δεν έχουν οριστεί κατηγορίες.",
    usage: "Χρήση",
    code: "Κωδικός",
    type: "Τύπος",
    monthly: "Μηνιαία",
    capital: "Κεφαλαιουχικά",
    missingBillingPeriod: "Λείπει η περίοδος χρέωσης",
    draftsHiddenTitle: "{n} έξοδο(α) κρυφό(ά) — λείπει η περίοδος χρέωσης",
    draftsHiddenHelp: "Τα ατελή έξοδα δεν εμφανίζονται στη λίστα και στα σύνολα μέχρι να συμπληρωθεί η περίοδος.",
    showDrafts: "Εμφάνιση",
    hideDrafts: "Απόκρυψη",
    reserveFundUsage: "Χρήση Αποθεματικού Ταμείου",
    totalBeforeRepairs: "Εισφορές αυτής της περιόδου",
    totalSpentFromReserveFund: "Δαπάνες Αποθεματικού αυτής της περιόδου",
    remainingBalance: "Υπόλοιπο",
    // Phase 814 (Greek) — Bank-statement style balance carry-forward labels.
    openingReserveFundBalance: "Άνοιγμα Υπολοίπου Αποθεματικού",
    closingReserveFundBalance: "Κλείσιμο Υπολοίπου Αποθεματικού",
    carriedForwardFromPriorPeriod: "Μεταφορά από προηγούμενη περίοδο",
    carriedForwardToNextPeriod: "Μεταφορά στην επόμενη περίοδο",
    before: "πριν",
    asOf: "στις",
    // Phase 815 (Greek) — Per-year sub-sections in multi-year reports.
    contributions: "Εισφορές",
    reserveFundExpensesThisYear: "Δαπάνες Αποθεματικού αυτού του έτους",
    grandTotalClosingBalance: "Γενικό Σύνολο Υπολοίπου Αποθεματικού",
    // Phase 817 (Greek) — Manual Reserve Fund Opening Balance seed.
    managementTakeoverSeed: "αρχική εγγραφή διαχείρισης",
    rfSeedNotesPlaceholder: "π.χ. Υπόλοιπο κατά την ανάληψη διαχείρισης",
    rfSeedHelp: "Χρησιμοποιείται μόνο ως αρχικό υπόλοιπο όταν προστίθεται για πρώτη φορά το κτίριο. Στη συνέχεια, κάθε νέα περίοδος μεταφέρει αυτόματα το κλείσιμο της προηγούμενης περιόδου.",
    noRepairsPaidFromReserve: "Δεν έχουν πληρωθεί επισκευές από το Αποθεματικό Ταμείο ακόμη.",
    detailBreakdown: "Αναλυτική Ανάλυση",
    paidInCash: "Πληρώθηκε σε μετρητά από την επιτροπή",
    paidFromBank: "Πληρώθηκε από την τράπεζα της επιτροπής",
    useReserveFundToggle: "Χρήση Αποθεματικού Ταμείου (προαιρετικό)",
    fundingBreakdown: "Κατανομή Χρηματοδότησης (προαιρετικό)",
    reserveFundPortion: "Από Αποθεματικό Ταμείο",
    sharedPortion: "Κατανομή στα Διαμερίσματα",
    splitFundingHelp: "Πληρώνεται άμεσα από το Αποθεματικό Ταμείο. Το υπόλοιπο κατανέμεται στα διαμερίσματα κατά ποσοστό.",
    splitFundingInvalid: "Το ποσό από το Αποθεματικό πρέπει να είναι μεταξύ €0 και του συνολικού ποσού.",
    noTasks: "Δεν υπάρχουν εργασίες",
    quickUpdate: "Γρήγορη Ενημέρωση",
    cleanedToday: "Καθαρίστηκε Σήμερα",
    
    // Task Types
    cleaning: "Καθαρισμός",
    cleanings: "Καθαρισμοί",
    elevator: "Έλεγχος Ανελκυστήρα",
    electricity: "Έλεγχος Ηλεκτρικών",
    insurance: "Ασφάλεια",
    maintenance: "Γενική Συντήρηση",
    
    // Payments
    addPayment: "Προσθήκη Πληρωμής",
    amount: "Ποσό",
    dueDate: "Ημ. Λήξης",
    paidDate: "Ημ. Πληρωμής",
    markAsPaid: "Επισήμανση ως Πληρωμένο",
    noPayments: "Δεν υπάρχουν πληρωμές",
    
    // Actions
    save: "Αποθήκευση",
    cancel: "Ακύρωση",
    delete: "Διαγραφή",
    edit: "Επεξεργασία",
    export: "Εξαγωγή",
    search: "Αναζήτηση",
    filter: "Φίλτρο",
    all: "Όλα",
    allVendors: "Όλοι οι Προμηθευτές",
    searchExpensesPlaceholder: "Περιγραφή, σημειώσεις, προμηθευτής…",
    unpaidCleaners: "Ανεξόφλητοι καθαριστές",
    paidCleaners: "Εξοφλημένοι καθαριστές",
    allCleanersPaid: "Όλοι οι καθαριστές είναι εξοφλημένοι.",
    searchCleaner: "Αναζήτηση καθαριστών…",
    
    // Export
    exportExcel: "Εξαγωγή σε Excel",
    exportPDF: "Εξαγωγή σε PDF",
    exportCSV: "Εξαγωγή σε CSV",
    
    // Messages
    confirmDelete: "Είστε σίγουροι ότι θέλετε να διαγράψετε;",
    savedSuccess: "Αποθηκεύτηκε επιτυχώς",
    deletedSuccess: "Διαγράφηκε επιτυχώς",
    errorOccurred: "Παρουσιάστηκε σφάλμα",
    invalidAmount: "Μη έγκυρο ποσό",
    
    // User Roles
    admin: "Διαχειριστής",
    staff: "Προσωπικό",
    role: "Ρόλος",
    
    // Notifications
    noNotifications: "Δεν υπάρχουν ειδοποιήσεις",
    markAllRead: "Σήμανση όλων ως αναγνωσμένα",
    contractExpiry: "Λήξη Συμβολαίου",
    inspectionDue: "Επερχόμενος Έλεγχος",
    paymentDue: "Οφειλόμενη Πληρωμή",
    
    // Misc
    welcome: "Καλώς ήρθατε",
    loading: "Φόρτωση...",
    language: "Γλώσσα",
    english: "English",
    greek: "Ελληνικά",
    
    // Building Types
    buildingType: "Τύπος Κτιρίου",
    managed: "Διαχείριση",
    cleaning_only: "Μόνο Καθαρισμός",
    
    // Building Cleaning (formerly "Cleaning History")
    cleaningHistory: "Καθαρισμός Κτιρίων",
    buildingsCleaning: "Καθαρισμός Κτιρίων",
    addBuildingCleaning: "Προσθήκη Καθαρισμού Κτιρίου",
    details: "Λεπτομέρειες",
    
    // Cleaning Management
    cleaningManagement: "Διαχείριση Καθαρισμού",
    cleaners: "Καθαριστές",
    clients: "Πελάτες",
    jobHistory: "Ιστορικό Εργασιών",
    jobs: "Εργασίες",
    addCleaner: "Προσθήκη Καθαριστή",
    editCleaner: "Επεξεργασία Καθαριστή",
    addClient: "Προσθήκη Πελάτη",
    editClient: "Επεξεργασία Πελάτη",
    addJob: "Προσθήκη Εργασίας",
    editJob: "Επεξεργασία Εργασίας",
    paymentType: "Τύπος Πληρωμής",
    perHour: "Ανά Ώρα",
    perMonth: "Ανά Μήνα",
    overall: "Συνολικά",
    selectDate: "Επιλέξτε Ημερομηνία",
    fromDate: "Από Ημ/νία",
    toDate: "Έως Ημ/νία",
    applyFilter: "Εφαρμογή Φίλτρου",
    // Phase 517 — Supplier Refund & Discount/Credit (EL)
    supplierRefundCredit: "Επιστροφή / Έκπτωση Προμηθευτή",
    discountCreditAmount: "Ποσό Έκπτωσης / Πίστωσης",
    refundAmount: "Ποσό Επιστροφής",
    refundReference: "Αναφορά Επιστροφής",
    refundDate: "Ημ/νία Επιστροφής",
    refundNotes: "Σημειώσεις Επιστροφής",
    originalExpense: "Αρχική Δαπάνη",
    supplierCredit: "Πίστωση Προμηθευτή",
    supplierRefund: "Επιστροφή Προμηθευτή",
    finalExpense: "Τελική Δαπάνη",
    totalSupplierRefunds: "Επιστροφές Προμηθευτών",
    totalSupplierCredits: "Πιστώσεις Προμηθευτών",
    optional: "προαιρετικό",
    // Phase 518 — Finance separation (Official vs Internal Invoices) (EL)
    // Phase 524 — Renamed "Internal Cash" → "Internal Invoices" + dedicated tab.
    invoiceType: "Τύπος",
    invoiceTypeOfficial: "Επίσημο",
    invoiceTypeInternalCash: "Εσωτερικά Τιμολόγια",
    invoiceTypeInternalInvoices: "Εσωτερικά Τιμολόγια",
    badgeInternalCash: "Εσωτερικό",
    badgeOfficial: "Επίσημο",
    internalCashHint: "ΔΕΝ θα εμφανιστεί σε Λογιστήριο / ΦΠΑ / επίσημες εξαγωγές.",
    internalCashTrackingTitle: "Εσωτερικά Τιμολόγια",
    internalCashCardHint: "Δεν περιλαμβάνεται σε Λογιστήριο / ΦΠΑ / επίσημες εξαγωγές",
    // Phase 524 — Ξεχωριστή καρτέλα Εσωτερικών Τιμολογίων.
    internal_invoices: "Εσωτερικά Τιμολόγια",
    internalInvoicesLabel: "Εσωτερικά Τιμολόγια",
    newInternalInvoice: "Νέο Εσωτερικό Τιμολόγιο",
    internalInvoicesHint: "Μόνο για εσωτερική λογιστική παρακολούθηση — εξαιρούνται από επίσημο Λογιστήριο/ΦΠΑ και σύνολα τραπεζικών λογαριασμών.",
    officialInvoicesHint: "Επίσημα τιμολόγια πελατών — περιλαμβάνονται σε Λογιστήριο/ΦΠΑ και σύνολα τραπεζικών λογαριασμών.",
    // Phase 526 — Ξεχωριστή καρτέλα Εσωτερικών Πληρωμών.
    internal_payments: "Εσωτερικές Πληρωμές",
    internalPaymentsLabel: "Εσωτερικές Πληρωμές",
    newInternalPayment: "Νέα Εσωτερική Πληρωμή",
    internalPaymentsHint: "Εσωτερικές πληρωμές — δρομολογούνται αυτόματα στο Πορτοφόλι Εσωτερικών Μετρητών· εξαιρούνται από επίσημο Λογιστήριο/ΦΠΑ και σύνολα τραπεζικών λογαριασμών.",
    officialPaymentsHint: "Επίσημες πληρωμές πελατών — επηρεάζουν τα υπόλοιπα ταμείου/τράπεζας και τις επίσημες αναφορές Λογιστηρίου/ΦΠΑ.",
    paymentTypeOfficial: "Επίσημη",
    paymentTypeInternalCash: "Εσωτερικά Μετρητά",
    // Phase 539 — Στήλες/καταστάσεις πίνακα Εσωτερικών Μετρητών.
    reference: "Αναφορά",
    unusedAmount: "Αχρησιμοποίητο",
    allocatedAmount: "Κατανεμημένο",
    paymentNumberOrRef: "Αρ. Πληρωμής / Αναφ.",
    autoAllocateFifo: "Αυτόματη κατανομή (παλαιότερα πρώτα)",
    lines: "γραμμές",
    failedToCreateClient: "Αποτυχία δημιουργίας πελάτη",
    referenceNo: "Αρ. Αναφοράς",
    clientVendorBuilding: "Πελάτης / Προμηθευτής / Κτίριο",
    clients: "Πελάτες",
    buildings: "Κτίρια",
    paymentNumberPlaceholder: "Δημιουργείται αυτόματα αν είναι κενό",
    invoice: "ΤΙΜΟΛΟΓΙΟ",
    vat: "ΦΠΑ",
    regNo: "Αρ. Μητρ.",
    editIncomeAllocOnly: "Επεξεργασία εγγραφής Εσόδου Finance — αποθηκεύονται μόνο Αναφορά, Σημειώσεις, Ημερομηνία και κατανομές τιμολογίων. Το ποσό και η μέθοδος ελέγχονται από το Finance → Έσοδα.",
    confirmDeleteInternalCashRow: "Διαγραφή αυτής της εγγραφής Εσωτερικών Μετρητών; Τυχόν κατανομές σε συνδεδεμένα Εσωτερικά Τιμολόγια θα ακυρωθούν.",
    badgeVoided: "ΑΚΥΡΩΘΗΚΕ",
    void: "Ακύρωση",
    voidPayment: "Ακύρωση Πληρωμής",
    voidPaymentHint: "Αυτή η πληρωμή είναι συνδεδεμένη με τραπεζικό λογαριασμό και δεν μπορεί να διαγραφεί. Η ακύρωση αντιστρέφει όλες τις κατανομές τιμολογίων και διατηρεί την εγγραφή στο ιστορικό ελέγχου.",
    voidReasonPlaceholder: "Για ποιο λόγο ακυρώνεται αυτή η πληρωμή;",
    paymentVoided: "Η πληρωμή ακυρώθηκε",
    voidedLockHint: "Κλειδωμένη",
    reason: "Αιτιολογία",
    bank: "Τράπεζα",
    cash: "Μετρητά",
    badgePaid: "ΠΛΗΡΩΘΗΚΕ",
    badgePartial: "ΜΕΡΙΚΩΣ",
    badgeUnpaid: "ΑΠΛΗΡΩΤΟ",
    // Phase 528 — Τα Εσωτερικά Μετρητά είναι πλέον καθολικός
    // πελατο-κεντρικός κατάλογος στο Finance → Πελάτες (όχι τραπεζικός λογ.).
    internal_cash: "Εσωτερικά Μετρητά",
    internalCashLabel: "Εσωτερικά Μετρητά",
    newInternalCashPayment: "Νέα Εσωτερική Πληρωμή",
    internalCashSectionHint: "Εσωτερική παρακολούθηση πελατών/τιμολογίων — ξεχωριστά από το επίσημο ταμείο και τους τραπεζικούς λογαριασμούς.",
    internalCashInvoicedLabel: "Εσωτερικά Τιμολογημένα",
    totalPaid: "Σύνολο Πληρωμών",
    totalRemaining: "Υπόλοιπο",
    remainingBalance: "Υπόλοιπο",
    paymentHistory: "Ιστορικό",
    invoice: "Τιμολόγιο",
    method: "Μέθοδος",
    actions: "Ενέργειες",
    from: "Από",
    to: "Έως",
    clearFilters: "Καθαρισμός",
    // Phase 527 — Απλοποιημένη προβολή Πορτοφολιού Εσωτερικών Μετρητών.
    internalCashWalletHint: "Αυτόματα διαχειριζόμενο πορτοφόλι — Εξαιρείται από επίσημο Ταμείο & ΦΠΑ",
    totalBalance: "Συνολικό Υπόλοιπο",
    noInternalCashPayments: "Δεν υπάρχουν Εσωτερικές Πληρωμές. Οι νέες καταχωρίσεις δρομολογούνται αυτόματα εδώ όταν τις χαρακτηρίζετε ως Εσωτερικά Μετρητά στα Χρηματοοικονομικά → Έσοδα ή Πωλήσεις → Εσωτερικές Πληρωμές.",
    customerPayment: "Πληρωμή Πελάτη",
    finance: "Χρηματοοικονομικά",
    invoiced: "Τιμολογήθηκαν",
    collected: "Εισπράχθηκαν",
    cashOnHand: "Ταμείο",
    outstanding: "Εκκρεμή",
    clientPayments: "Πληρωμές Πελατών",
    cleanerPayments: "Πληρωμές Καθαριστών",
    hourlyRate: "Ωριαία Αμοιβή",
    monthlyRate: "Μηνιαία Αμοιβή",
    hoursWorked: "Ώρες Εργασίας",
    clientAmount: "Πληρωμή Πελάτη",
    cleanerEarned: "Κέρδος Καθαριστή",
    totalEarned: "Σύνολο Κερδών",
    totalPaid: "Σύνολο Πληρωμών",
    remainingBalance: "Υπόλοιπο",
    totalJobs: "Σύνολο Εργασιών",
    totalEntries: "Σύνολο Εγγραφών",
    totalHours: "Σύνολο Ωρών",
    totalRevenue: "Σύνολο Εσόδων",
    cleanerStatement: "Κατάσταση Καθαριστή",
    viewAllCombined: "Όλα (Συνδυασμένα)",
    viewBuildingsOnly: "Καθαρισμός Κτιρίων",
    viewJobsOnly: "Ιστορικό Εργασιών",
    dateMode: "Περίοδος",
    modeDate: "Ημερομηνία",
    modeMonth: "Μήνας",
    modeRange: "Εύρος",
    oldestFirst: "Παλαιότερα πρώτα",
    newestFirst: "Νεότερα πρώτα",
    recordPayment: "Καταχώρηση Πληρωμής",
    partialPayment: "Μερική Πληρωμή",
    cleanerHistory: "Ιστορικό Καθαριστή",
    clientHistory: "Ιστορικό Πελάτη",
    viewStatement: "Προβολή Κατάστασης",
    downloadPdf: "Λήψη PDF",
    viewPrint: "Προβολή / Εκτύπωση",
    download: "Λήψη",
    showBuildingNames: "Εμφάνιση ονομάτων κτιρίων",
    clientType: "Τύπος Πελάτη",
    customClient: "Προσαρμοσμένο (Σπίτι/Γραφείο)",
    linkedBuilding: "Συνδεδεμένο Κτίριο",
    selectBuilding: "Επιλέξτε Κτίριο",
    paymentAmount: "Ποσό Πληρωμής",
    selectCleaner: "Επιλέξτε Καθαριστή",
    selectClient: "Επιλέξτε Πελάτη",
    autoCalculated: "Αυτόματος υπολογισμός",
    office: "Γραφείο",
    house: "Σπίτι",
    profit: "Κέρδος",
    totalCost: "Συνολικό Κόστος",
    profitGenerated: "Κέρδος που Δημιουργήθηκε",
    onboardDate: "Ημ/νία Εισαγωγής",
    exportPdf: "Εξαγωγή PDF",
    paid: "Πληρωμένα",
    paidSoFar: "Πληρωμένα μέχρι τώρα",
    clientPaid: "Πληρωμή Πελάτη",
    cleanerCost: "Κόστος Καθαριστή",
    performance: "Απόδοση",
    offices: "Γραφεία",
    generalCleaning: "Γενικός Καθαρισμός",
    totalCleanerCost: "Συνολικό Κόστος Καθαριστών",
    totalClientPaid: "Συνολικά Έσοδα από Πελάτες",
    totalProfit: "Συνολικό Κέρδος",
    client: "Πελάτης",
    overallCleaning: "Συνολική Εικόνα",
    allCategories: "Όλες οι κατηγορίες",
    byMonth: "Ανά Μήνα",
    byYear: "Ανά Έτος",
    year: "Έτος",
    serviceLog: "Αρχείο Υπηρεσιών",
    addCleaningEntry: "Προσθήκη Καταχώρησης",
    employeeName: "Υπάλληλος / Καθαριστής",
    workTypes: "Εργασίες",
    general_cleaning: "Γενικός Καθαρισμός",
    windows: "Παράθυρα",
    storage_doors: "Πόρτες Αποθήκης",
    roof_terrace: "Ταράτσα / Στέγη",
    entrance: "Είσοδος",
    other: "Άλλο",
    otherNotes: "Λεπτομέρειες Άλλο",
    lastCleaning: "Τελευταίος Καθαρισμός",
    daysSinceCleaning: "Μέρες από Καθαρισμό",
    noCleaning: "Χωρίς ιστορικό καθαρισμού",
    notCleanedRecently: "Δεν Καθαρίστηκε Πρόσφατα",
    cleaningOnlyBuildings: "Μόνο Καθαρισμός",
    logCleaning: "Καταχώρηση Καθαρισμού",
    quickLog: "Γρήγορη Καταχώρηση",
    viewHistory: "Προβολή Ιστορικού",
    daysAgo: "μέρες πριν",
    today: "Σήμερα",
    cleaningType: "Τύπος Καθαρισμού",
    allTypes: "Όλοι οι Τύποι",
    dateFrom: "Από Ημερομηνία",
    dateTo: "Έως Ημερομηνία",
    cleaningAlerts: "Ειδοποιήσεις Καθαρισμού",
    overdueCleaningAlert: "δεν καθαρίστηκε για",
    neverCleaned: "Δεν καθαρίστηκε ποτέ",
    editCleaningEntry: "Επεξεργασία Καταχώρησης",
    deleteCleaningEntry: "Διαγραφή Καταχώρησης",
    confirmDeleteCleaning: "Σίγουρα θέλετε να διαγράψετε αυτή την καταχώρηση καθαρισμού;",
    lastCleaningByType: "Τελευταίος Καθαρισμός ανά Τύπο",
    cleaners: "Καθαριστές",
    addCleaner: "Προσθήκη Καθαριστή",
    editCleaner: "Επεξεργασία Καθαριστή",
    deleteCleaner: "Διαγραφή Καθαριστή",
    confirmDeleteCleaner: "Σίγουρα θέλετε να διαγράψετε αυτόν τον καθαριστή;",
    manageCleaner: "Διαχείριση Καθαριστών",
    allCleaners: "Όλοι οι Καθαριστές",
    addNewCleaner: "Προσθήκη Νέου Καθαριστή",
    cleanerName: "Όνομα Καθαριστή",
    selectCleaner: "Επιλογή Καθαριστή",
    filterByCleaner: "Φίλτρο ανά Καθαριστή",
    
    // Insurance
    insuranceSection: "Ασφάλεια",
    insuranceCompany: "Ασφαλιστική Εταιρεία",
    policyStartDate: "Έναρξη Συμβολαίου",
    policyEndDate: "Λήξη Συμβολαίου",
    coveragePeriod: "Περίοδος Κάλυψης",
    months: "μήνες",
    addInsurance: "Προσθήκη Ασφάλειας",
    totalPremium: "Συνολικό Ασφάλιστρο",
    numInstallments: "Αριθμός Δόσεων",
    installmentAmount: "Ποσό Δόσης",
    insuredAmounts: "Ασφαλισμένα Ποσά",
    insuredBuilding: "Κτίριο",
    insuredCommonAreas: "Κοινόχρηστοι Χώροι",
    insuredOutdoor: "Εξωτερικά",
    insuredCivilLiability: "Αστική Ευθύνη",
    insuredExcess: "Απαλλαγή",
    generateInsuranceInvoices: "Δημιουργία Τιμολογίων Δόσεων",
    insuranceInvoicesGenerated: "Τα τιμολόγια δόσεων ασφάλειας δημιουργήθηκαν",
    insuranceLabel: "Ασφάλεια",
    perMonth: "/μήνα",
    editInsurance: "Επεξεργασία Ασφάλειας",
    renewInsurance: "Ανανέωση Ασφάλειας",
    deleteInsurance: "Διαγραφή Ασφάλειας",
    cancelInsurance: "Ακύρωση Ασφάλειας",
    confirmCancelInsurance: "Είστε σίγουροι ότι θέλετε να ακυρώσετε αυτό το ασφαλιστήριο; Θα σημανθεί ως ακυρωμένο.",
    confirmDeleteInsurance: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την ασφάλεια; Αυτό δεν μπορεί να αναιρεθεί.",
    reactivate: "Επανενεργοποίηση",
    renewal: "Ανανέωση",
    cancelled: "Ακυρωμένη",
    insuranceStatus: "Κατάσταση Ασφάλειας",
    active: "Ενεργή",
    expiring_soon: "Λήγει Σύντομα",
    expired: "Έληξε",
    noInsurance: "Χωρίς ασφάλεια",
    daysUntilExpiry: "μέρες μέχρι λήξη",
    expiresIn: "Λήγει σε",
    expiredDaysAgo: "Έληξε",
    viewInsurance: "Προβολή Ασφάλειας",
    insuranceFrom: "Από",
    insuranceTo: "Έως",
    days: "μέρες",
    day: "μέρα",
    payFullAmount: "Πληρωμή Ολόκληρου Ποσού",
    selectInstallment: "Επιλογή Δόσης",
    installmentTracking: "Παρακολούθηση Δόσεων",
    paidInstallments: "Πληρωμένες",
    remainingInstallments: "Εκκρεμείς",
    installment: "Δόση",
    
    // Financial
    financials: "Οικονομικά",
    managementFee: "Αμοιβή Διαχείρισης",
    unpaidManagement: "Απλ. Διαχείρισης",
    unpaidCleaning: "Απλ. Καθαρισμού",
    unpaidElevator: "Απλ. Ανελκυστήρα",
    unpaidInsurance: "Απλ. Ασφάλειας",
    unpaidMonthly: "Απλ. Μηνιαία",
    unpaidCapital: "Απλ. Κεφαλαίου",
    amountOwed: "Οφειλόμενο Ποσό",
    buildingStatement: "Κατάσταση Κτιρίου",
    cleaningCharges: "Χρεώσεις Καθαρισμού",
    allPeriods: "Όλες οι Περίοδοι",
    statementActivity: "Δραστηριότητα Κατάστασης",
    fixedMonthly: "Σταθερό Μηνιαίο",
    perCleaning: "Ανά Καθαρισμό",
    cleaningChargeMode: "Τρόπος Χρέωσης Καθαρισμού",
    fixedMonthlyDesc: "Χρεώνεται μόνο η μηνιαία αμοιβή καθαρισμού. Το ιστορικό καθαρισμού δεν επηρεάζει τις χρεώσεις.",
    perCleaningDesc: "Οι χρεώσεις προέρχονται από τις εγγραφές ιστορικού καθαρισμού (ανά επίσκεψη). Δεν εφαρμόζεται μηνιαία αμοιβή.",
    billingPricing: "Χρέωση / Τιμολόγηση",
    chargeMode: "Τρόπος Χρέωσης",
    monthlyCharge: "Μηνιαία Χρέωση (χωρίς ΦΠΑ)",
    vatPercent: "ΦΠΑ %",
    totalIncVat: "Σύνολο (με ΦΠΑ)",
    recurring: "Επαναλαμβανόμενο",
    recurringDesc: "Αυτόματα μηνιαία βάσει τιμολόγησης κτιρίου",
    manual: "Χειροκίνητο",
    manualDesc: "Μεμονωμένο τιμολόγιο",
    recurringEnabled: "Ενεργοποιήθηκε η μηνιαία αυτόματη τιμολόγηση.",
    recurringAlreadyOn: "Η επανάληψη είναι ήδη ενεργή. Η αποθήκευση διατηρεί την τρέχουσα τιμολόγηση.",
    recurringWillEnable: "Η αποθήκευση θα ενεργοποιήσει τη μηνιαία αυτόματη τιμολόγηση για το κτίριο.",
    setPricingFirst: "Ορίστε πρώτα τη μηνιαία χρέωση καθαρισμού στο Επεξεργασία Κτιρίου.",
    view: "Προβολή",
    statementsTab: "Καταστάσεις",
    exVat: "χωρίς ΦΠΑ",
    billVendors: "Λογαριασμοί",
    billVendorsDesc: "Διαχείριση των Λογαριασμών σας (τιμολόγια κοινής ωφέλειας & υπηρεσιών). Ανεξάρτητοι από τους Παρόχους Διαχείρισης Κτιρίων.",
    addBillEntry: "Προσθήκη Λογαριασμού",
    editBillEntry: "Επεξεργασία Λογαριασμού",
    billEntryName: "Όνομα Λογαριασμού",
    deleteBillEntryWarning: "Ο Λογαριασμός θα αρχειοθετηθεί. Τα συνδεδεμένα τιμολόγια παραμένουν.",
    billCategoryRequired: "Η κατηγορία είναι υποχρεωτική",
    billNoCategoriesYet: "Δεν υπάρχουν κατηγορίες. Προσθέστε από τη Διαχείριση Κατηγοριών.",
    manageVendors: "Διαχείριση Παρόχων",
    manageBills: "Διαχείριση Λογαριασμών",
    confirmDeleteBillMessage: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον λογαριασμό; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
    syncedWithFinance: "Συγχρονισμένο με Οικονομικά",
    syncedWithBuilding: "Συγχρονισμένο με Διαχείριση Κτιρίων",
    syncedToBills: "Συγχρονισμένο με Λογαριασμούς",
    payTo: "Πληρωμή Προς",
    remaining: "Υπόλοιπο",
    available: "Διαθέσιμο",
    availableBeforePayment: "Διαθέσιμο πριν την πληρωμή",
    payment: "Πληρωμή",
    insufficientAvailableBalance: "Ανεπαρκές διαθέσιμο υπόλοιπο.",
    linkedBill: "Συνδεδεμένος Λογαριασμός",
    selectBill: "Επιλέξτε Λογαριασμό",
    noPayableBills: "Δεν υπάρχουν ανεξόφλητοι λογαριασμοί.",
    noPayableVendors: "Δεν υπάρχουν πάροχοι με ανεξόφλητο υπόλοιπο.",
    noBillVendors: "Δεν έχουν καταχωρηθεί πάροχοι.",
    noInvoices: "Χωρίς τιμολόγια",
    billsCount: "λογαριασμοί",
    outstanding: "Ανεξόφλητο",
    fifoAllocation: "παλαιότερο τιμολόγιο πρώτο",
    currentBalanceLabel: "Τρέχον Υπόλοιπο",
    currentBalanceTopTooltip: "Άθροισμα των τρεχόντων υπολοίπων ανά λογαριασμό για όσους είναι ενεργοποιημένοι στο Συνοπτικό Οικονομικό Πίνακα.",
    includeInFinancialSummary: "Συμπερίληψη στον Οικονομικό Πίνακα",
    includeInFinancialSummaryDesc: "Όταν είναι ενεργό, το υπόλοιπο αυτού του λογαριασμού συμμετέχει στο γενικό Τρέχον Υπόλοιπο, Τελικό Υπόλοιπο και τους υπολογισμούς της Προσθήκης Πληρωμής.",
    accountsExcluded: "λογαριασμοί εξαιρούνται από τη σύνοψη",
    excludedFromSummary: "Εξαιρείται από τη σύνοψη",
    // Phase 239 — Payment Reminder System
    reminderSettings: "Ρυθμίσεις Υπενθυμίσεων Πληρωμής",
    enableReminders: "Ενεργοποίηση υπενθυμίσεων",
    firstReminderDays: "Πρώτη (μέρες)",
    secondReminderDays: "Δεύτερη (μέρες)",
    finalReminderDays: "Τελική (μέρες)",
    reminderHint: "Διαμερίσματα με ανεξόφλητο υπόλοιπο επισημαίνονται σε κάθε στάδιο βάσει πόσες μέρες είναι ληξιπρόθεσμο το παλαιότερο τιμολόγιο.",
    paymentReminders: "Υπενθυμίσεις Πληρωμής",
    debtors: "οφειλέτες",
    daysOverdue: "Μέρες Καθυστέρησης",
    stage: "Στάδιο",
    lastReminder: "Τελευταία Υπενθύμιση",
    firstReminder: "Πρώτη",
    secondReminder: "Δεύτερη",
    finalReminder: "Τελική",
    sendEmail: "Αποστολή Email",
    logManualReminder: "Καταγραφή χειροκίνητης υπενθύμισης",
    manual: "Χειροκίνητο",
    reminderSent: "Υπενθύμιση Εστάλη",
    reminderQueued: "Υπενθύμιση σε αναμονή",
    reminderLogged: "Υπενθύμιση καταγράφηκε",
    reminderFailed: "Αποτυχία υπενθύμισης",
    deficit: "Έλλειμμα",
    negativeBalance: "Αρνητικό Υπόλοιπο",
    negativeBalanceAllowed: "Το Τελικό Υπόλοιπο θα γίνει αρνητικό. Η πληρωμή επιτρέπεται κανονικά — μελλοντικά έσοδα θα καλύψουν το έλλειμμα.",
    negativeBalanceTooltip: "Αρνητικό υπόλοιπο — μελλοντικά έσοδα θα καλύψουν το έλλειμμα.",
    optional: "προαιρετικό",
    none: "Κανένα",
    synced: "Συγχρονισμένο",
    transactionDetails: "Λεπτομέρειες Συναλλαγής",
    actions: "Ενέργειες",
    close: "Κλείσιμο",
    noClient: "Χωρίς πελάτη",
    pdf: "PDF",
    syncToFinance: "Συγχρονισμός με Οικονομικά",
    syncToBuilding: "Συγχρονισμός με Διαχείριση Κτιρίων",
    syncToFinanceHint: "Αυτόματη δημιουργία αντίστοιχου εσόδου στα Οικονομικά. Ενημερώσεις και διαγραφές προωθούνται.",
    syncToBuildingHint: "Αυτόματη δημιουργία αντίστοιχης πληρωμής στη Διαχείριση Κτιρίων. Ενημερώσεις και διαγραφές προωθούνται.",
    paymentMethodCash: "Μετρητά",
    paymentMethodBank: "Τράπεζα",
    incomeType: "Τύπος Εσόδου",
    incomeType_client_payment: "Πληρωμή Πελάτη",
    incomeType_bank_refund: "Επιστροφή Τραπέζης",
    incomeType_bank_adjustment: "Διόρθωση Τραπέζης",
    incomeType_interest: "Τόκοι",
    incomeType_transfer_in: "Μεταφορά Εισερχόμενη",
    incomeType_owner_contribution: "Εισφορά Ιδιοκτήτη",
    incomeType_other: "Άλλο",
    incomeTypeBadgeClient: "ΠΕΛΑΤΗΣ",
    incomeTypeBadgeRefund: "ΕΠΙΣΤΡΟΦΗ",
    incomeTypeBadgeAdjustment: "ΔΙΟΡΘΩΣΗ",
    incomeTypeBadgeInterest: "ΤΟΚΟΙ",
    incomeTypeBadgeTransfer: "ΜΕΤΑΦΟΡΑ",
    incomeTypeBadgeOwnerContrib: "ΙΔΙΟΚΤΗΤΗΣ",
    incomeTypeBadgeOther: "ΑΛΛΟ",
    filterByIncomeType: "Φιλτράρισμα ανά Τύπο Εσόδου",
    addVendor: "Προσθήκη Παρόχου",
    contactPerson: "Υπεύθυνος Επικοινωνίας",
    accountNumber: "Αρ. Λογαριασμού",
    invoiceNumber: "Αρ. Τιμολογίου",
    issueDate: "Ημ/νία Έκδοσης",
    dueDate: "Ημ/νία Λήξης",
    period: "Περίοδος",
    amountExVat: "Ποσό χωρίς ΦΠΑ",
    vatPercent: "ΦΠΑ %",
    totalIncVat: "Σύνολο με ΦΠΑ",
    attachment: "Συνημμένο (PDF/Εικόνα)",
    currentAttachment: "Τρέχον",
    invoices: "Τιμολόγια",
    invoice: "Τιμολόγιο",
    totalInvoiced: "Σύνολο Τιμολογήσεων",
    totalUnpaid: "Σύνολο Ανεξόφλητων",
    totalPaid: "Σύνολο Πληρωμένων",
    overdueInvoices: "Ληξιπρόθεσμα Τιμολόγια",
    partiallyPaid: "Μερική",
    printPdf: "Εκτύπωση PDF",
    downloadPdf: "Λήψη PDF",
    vendorRequired: "Απαιτείται πάροχος",
    selectVendor: "Επιλέξτε πάροχο…",
    vendorArchived: "Ο πάροχος αρχειοθετήθηκε",
    manageVendorsHint: "Προσθέστε νέο πάροχο από Διαχείριση Παρόχων → Προσθήκη Παρόχου.",
    noInvoices: "Δεν υπάρχουν τιμολόγια για αυτόν τον πάροχο.",
    searchBills: "Αναζήτηση λογαριασμών...",
    searchVendors: "Αναζήτηση παρόχων...",
    activeItems: "Ενεργά",
    archivedItems: "Αρχειοθετημένα",
    noVendors: "Δεν βρέθηκαν πάροχοι λογαριασμών.",
    sortOrder: "Σειρά Ταξινόμησης",
    newestFirst: "Νεότερα → Παλαιότερα",
    oldestFirst: "Παλαιότερα → Νεότερα",
    newestFirstHint: "Νεότερα πρώτα (κλικ για αλλαγή)",
    oldestFirstHint: "Παλαιότερα πρώτα (κλικ για αλλαγή)",
    byVendor: "Ανά Πάροχο",
    allBills: "Όλα τα Τιμολόγια",
    paymentMethod: "Τρόπος",
    debits: "Χρέωση",
    credits: "Πίστωση",
    closingBalance: "Τελικό Υπόλοιπο",
    all: "Όλα",
    permanentlyDelete: "Οριστική Διαγραφή",
    permanentlyDeleteBuilding: "Οριστική Διαγραφή Κτιρίου",
    permanentDeleteWarning: "Η ενέργεια είναι μη αναστρέψιμη. Το κτίριο και ΟΛΑ τα σχετικά δεδομένα θα διαγραφούν οριστικά από τη βάση. Δεν μπορεί να αναιρεθεί.",
    willBeArchivedWarning: "Το κτίριο περιέχει δεδομένα και θα μεταφερθεί στο Αρχείο. Όλα τα δεδομένα διατηρούνται και το κτίριο μπορεί να επαναφερθεί ανά πάσα στιγμή. Η οριστική διαγραφή (μόνο διαχειριστής) είναι διαθέσιμη από το Αρχείο.",
    emptyBuildingDeleteWarning: "Το κτίριο δεν περιέχει δεδομένα. Θα διαγραφεί οριστικά.",
    adminAuthRequired: "Απαιτείται εξουσιοδότηση διαχειριστή για αυτή την ενέργεια.",
    buildingPermanentlyDeleted: "Το κτίριο διαγράφηκε οριστικά",
    invoice: "Τιμολόγιο",
    type: "Τύπος",
    source: "Πηγή",
    cleaningFee: "Αμοιβή Καθαρισμού",
    vatRate: "Συντελεστής ΦΠΑ",
    managementVat: "ΦΠΑ Διαχείρισης",
    cleaningVat: "ΦΠΑ Καθαρισμού",
    totalVat: "Σύνολο ΦΠΑ",
    vat: "ΦΠΑ",
    subtotal: "Μερικό Σύνολο",
    total: "Σύνολο",
    totalAmount: "Συνολικό Ποσό",
    monthlyTotal: "Μηνιαίο Σύνολο",
    feeBreakdown: "Ανάλυση Αμοιβών",
    discount: "Έκπτωση",
    discountAmount: "Ποσό Έκπτωσης",
    discountedSubtotal: "Σύνολο μετά Έκπτωση",
    finalTotal: "Τελικό Σύνολο",
    netPerUnit: "Τιμή Μονάδας (Καθαρή)",
    lineNet: "Καθαρή Αξία",
    lineTotal: "Σύνολο (με ΦΠΑ)",
    invoiceItems: "Είδη Τιμολογίου",
    
    // Statements
    statements: "Καταστάσεις",
    banking: "Τραπεζικά",
    supplierPayments: "Πληρωμές Προμηθευτών",
    supplierStatements: "Καταστάσεις Προμηθευτών",
    generateStatement: "Δημιουργία Κατάστασης",
    statementPeriod: "Περίοδος",
    month: "Μήνας",
    year: "Έτος",
    draft: "Πρόχειρο",
    sent: "Απεσταλμένο",
    markAsSent: "Σήμανση ως Απεσταλμένο",
    viewStatement: "Προβολή Κατάστασης",
    noStatements: "Δεν υπάρχουν καταστάσεις",
    statementBreakdown: "Ανάλυση Κατάστασης",
    january: "Ιανουάριος",
    february: "Φεβρουάριος",
    march: "Μάρτιος",
    april: "Απρίλιος",
    may: "Μάιος",
    june: "Ιούνιος",
    july: "Ιούλιος",
    august: "Αύγουστος",
    september: "Σεπτέμβριος",
    october: "Οκτώβριος",
    november: "Νοέμβριος",
    december: "Δεκέμβριος",
    
    // Invoices
    invoices: "Τιμολόγια",
    apartmentCharges: "Χρεώσεις Διαμερισμάτων",
    invoice: "Τιμολόγιο",
    invoiceNumber: "Αρ. Τιμολογίου",
    managementInvoice: "Τιμολόγιο Διαχείρισης",
    cleaningInvoice: "Τιμολόγιο Καθαρισμού",
    generateInvoice: "Δημιουργία Τιμολογίου",
    generateBothInvoices: "Δημιουργία Και Τα Δύο",
    invoiceType: "Τύπος Τιμολογίου",
    management: "Διαχείριση",
    paymentsByCategory: "Πληρωμές ανά Κατηγορία",
    lastPaid: "Τελευταία Πληρωμή",
    paidUntil: "Πληρωμένο μέχρι",
    oldestFirst: "Πιο παλιά πρώτα",
    unpaidFirst: "Απλήρωτα πρώτα",
    buildingTechnical: "Κτίριο / Τεχνικά",
    financial: "Οικονομικά",
    system: "Σύστημα",
    viewAll: "Προβολή όλων",
    showLess: "Εμφάνιση λιγότερων",
    cleaning: "Καθαρισμός",
    noInvoices: "Δεν υπάρχουν τιμολόγια",
    addInvoice: "Προσθήκη Τιμολογίου",
    editInvoice: "Επεξεργασία Τιμολογίου",
    deleteInvoice: "Διαγραφή Τιμολογίου",
    manualInvoice: "Χειροκίνητο",
    autoInvoice: "Αυτόματο",
    expenseInvoice: "Έξοδο",
    extraWork: "Επιπλέον Εργασία",
    other: "Άλλο",
    confirmDeleteManualInvoice: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το χειροκίνητο τιμολόγιο;",
    confirmDeleteAutoInvoice: "ΠΡΟΣΟΧΗ: Αυτό είναι αυτόματα δημιουργημένο μηνιαίο τιμολόγιο. Η διαγραφή του θα επηρεάσει τα οικονομικά αρχεία του κτιρίου. Είστε σίγουροι ότι θέλετε να συνεχίσετε;",
    invoiceDescription: "Περιγραφή",
    updatedSuccess: "Ενημερώθηκε επιτυχώς",
    viewInvoice: "Προβολή Τιμολογίου",
    invoiceDetails: "Λεπτομέρειες Τιμολογίου",
    bothInvoices: "Και Τα Δύο",

    // Expenses
    expenses: "Έξοδα",
    addExpense: "Προσθήκη Εξόδου",
    editExpense: "Επεξεργασία Εξόδου",
    deleteExpense: "Διαγραφή Εξόδου",
    renameCategory: "Μετονομασία Κατηγορίας",
    deleteCategory: "Διαγραφή Κατηγορίας",
    deleteCategoryWarning: "Αυτή η κατηγορία έχει έξοδα. Μπορείτε να τα μεταφέρετε σε άλλη κατηγορία ή να τα διαγράψετε.",
    moveExpensesTo: "Μετακίνηση εξόδων σε",
    deleteAnyway: "Διαγραφή ούτως ή άλλως",
    expenseType: "Τύπος Εξόδου",
    expenseElectricity: "Ηλεκτρικό Ρεύμα",
    expenseBankFees: "Τραπεζικά Έξοδα",
    expenseElectricalWork: "Ηλεκτρολογικές Εργασίες",
    expenseOther: "Άλλα",
    billingPeriod: "Περίοδος Χρέωσης",
    insurancePeriod: "Ασφαλιστική Περίοδος",
    servicePeriod: "Περίοδος Υπηρεσίας",
    addBillingPeriod: "Προσθήκη Περιόδου Χρέωσης",
    remove: "Αφαίρεση",
    paidDates: "Ημερομηνίες Πληρωμής",
    addPaidDate: "Προσθήκη Ημερομηνίας",
    totalExpenses: "Σύνολο Εξόδων",
    paidExpenses: "Πληρωμένα",
    unpaidExpenses: "Απλήρωτα",
    noExpenses: "Δεν υπάρχουν έξοδα",
    markExpensePaid: "Σήμανση ως Πληρωμένο",
    expenseAmount: "Ποσό",
    expenseDate: "Ημερομηνία",
    billingPeriod: "Περίοδος Χρέωσης",
    billingPeriodFrom: "Περίοδος Χρέωσης Από",
    billingPeriodTo: "Περίοδος Χρέωσης Έως",
    periodFrom: "Από",
    periodTo: "Έως",
    financialYear: "Οικονομικό Έτος",
    allYears: "Όλα τα Έτη",
    balanceBroughtForward: "Υπόλοιπο εκ Μεταφοράς",
    from: "από",
    expenseSummary: "Σύνοψη Εξόδων",
    viewExpenses: "Προβολή Εξόδων",
    viewPayments: "Προβολή Πληρωμών",
    partiallyPaid: "Μερικώς Πληρωμένο",
    paidAmount: "Πληρωμένο",
    expenseRemainingBalance: "Υπόλοιπο",
    paymentNotes: "Σημειώσεις",
    confirmDeletePayment: "Σίγουρα θέλετε να διαγράψετε αυτήν την πληρωμή; Η κατάσταση του εξόδου θα επανυπολογιστεί.",
    expensePayments: "Πληρωμές Εξόδων",

    // Expense Categories
    expenseCategory: "Κατηγορία",
    expenseCategoryHelp: "Δημιουργεί καταχώρηση εξόδου στην κατηγορία αυτή (εμφανίζεται στα Έξοδα και στον Ετήσιο Απολογισμό).",
    allocatePerCategoryHelp: "Κατανείμετε την πληρωμή ανά κατηγορία τιμολογίου (203 Μηνιαία / 301 Κεφαλαιουχικά). Τα ποσά καταγράφονται ξεχωριστά στα Έξοδα.",
    categoryGroup: "Ομάδα",
    monthlyExpenses: "Μηνιαία Έξοδα",
    capitalExpenses: "Κεφαλαιουχικά Έξοδα",
    allCategories: "Όλες οι Κατηγορίες",
    allBuildings: "Όλα τα Κτίρια",
    noExpirations: "Δεν υπάρχουν επερχόμενες λήξεις",
    noOverduePayments: "Δεν υπάρχουν εκπρόθεσμες πληρωμές",
    showAll: "Εμφάνιση Όλων",
    items: "στοιχεία",
    item: "στοιχείο",
    allGroups: "Όλες οι Ομάδες",
    listView: "Λίστα",
    flatView: "Επίπεδη Προβολή",
    groupByCategory: "Ανά Κατηγορία",
    allMonths: "Όλοι οι Μήνες",
    category: "Κατηγορία",
    cat_201: "201 ΔΙΑΧΕΙΡΙΣΗ",
    cat_202: "202 ΚΑΘΑΡΙΟΤΗΤΑ",
    cat_203: "203 ΑΝΕΛΚΥΣΤΗΡΑΣ",
    cat_204: "204 ΗΛΕΚΤΡΙΣΜΟΣ",
    cat_205: "205 ΝΕΡΟ",
    cat_206: "206 ΕΞΟΔΑ ΤΡΑΠΕΖΑΣ",
    cat_301: "301 ΕΡΓΑΣΙΕΣ ΑΝΕΛΚΥΣΤΗΡΑ",
    cat_302: "302 ΟΙΚΟΔΟΜΙΚΕΣ ΕΡΓΑΣΙΕΣ",
    cat_303: "303 ΥΔΡΑΥΛΙΚΕΣ ΕΡΓΑΣΙΕΣ",
    cat_304: "304 ΗΛΕΚΤΡΟΛΟΓΙΚΕΣ ΕΡΓΑΣΙΕΣ",
    cat_305: "305 ΜΗΧΑΝΟΛΟΓΙΚΕΣ ΕΡΓΑΣΙΕΣ",
    cat_306: "306 ΑΣΦΑΛΕΙΑ ΠΟΛΥΚΑΤΟΙΚΙΑΣ",
    cat_307: "307 ΕΡΓΑΣΙΕΣ ΚΗΠΟΥ",
    cat_308: "308 ΜΙΚΡΟΔΑΠΑΝΕΣ",
    cat_309: "309 ΤΡΑΠΕΖΙΚΑ ΕΞΟΔΑ",
    cat_310: "310 ΠΙΣΤΟΠΟΙΗΣΗ ΑΝΕΛΚΥΣΤΗΡΑ",
    cat_custom: "Προσαρμοσμένο",
    cat_elevator: "Ανελκυστήρας",
    cat_other: "Άλλα",
    uncategorized: "Χωρίς Κατηγορία",
    categoryBreakdown: "Ανάλυση Κατηγοριών",

    // Building Details
    buildingDetails: "Λεπτομέρειες Κτιρίου",
    overview: "Επισκόπηση",
    income: "Έσοδα",
    totalIncome: "Συνολικά Έσοδα",
    totalBalance: "Υπόλοιπο",
    profitLoss: "Κέρδος / Ζημιά",
    quickStats: "Γρήγορα Στατιστικά",
    backToBuildings: "Πίσω στα Κτίρια",
    date: "Ημ/νία",
    description: "Περιγραφή",
    expense: "Έξοδα",
    balance: "Υπόλοιπο",

    // Expiry Alerts & Notes
    expiringSoon: "Λήγουν Σύντομα",
    noAlerts: "Δεν υπάρχουν στοιχεία που λήγουν",
    expiringInsurance: "Ασφάλεια",
    expiringElevator: "Συμβόλαιο Ανελκυστήρα",
    daysLeft: "μέρες απομένουν",
    expired: "Έληξε",
    recentNotes: "Πρόσφατες Σημειώσεις",
    buildingNotes: "Σημειώσεις",
    addNote: "Προσθήκη Σημείωσης",
    addNotePlaceholder: "Γράψτε ένα σχόλιο, ενημέρωση ή καταχώρηση...",
    noHistoryYet: "Δεν υπάρχει ιστορικό ακόμα. Προσθέστε σημείωση για να ξεκινήσετε.",
    markAsCompleted: "Σήμανση ως Ολοκληρωμένη",
    taskCompletedReadOnly: "Η εργασία ολοκληρώθηκε — το ιστορικό είναι μόνο για ανάγνωση.",
    noteTextPlaceholder: "Γράψτε τη σημείωσή σας εδώ...",
    noteSaved: "Η σημείωση αποθηκεύτηκε",
    editNote: "Επεξεργασία Σημείωσης",
    deleteNote: "Διαγραφή Σημείωσης",
    noteText: "Σημείωση",
    noNotes: "Δεν υπάρχουν σημειώσεις",
    noteCreated: "Δημιουργήθηκε",

    // Elevator
    elevator: "Ανελκυστήρας",
    elevatorMaintenance: "Συντήρηση Ανελκυστήρα",
    maintenanceCompany: "Εταιρεία Συντήρησης",
    contractStartDate: "Έναρξη Συμβολαίου",
    contractEndDate: "Λήξη Συμβολαίου",
    contractFile: "Αρχείο Συμβολαίου",
    uploadContract: "Μεταφόρτωση Συμβολαίου",
    downloadContract: "Λήψη Συμβολαίου",
    addContract: "Προσθήκη Συμβολαίου",
    editContract: "Επεξεργασία Συμβολαίου",
    noContracts: "Δεν υπάρχουν συμβόλαια",
    elevatorExpenses: "Έξοδα Ανελκυστήρα",
    addElevatorExpense: "Προσθήκη Τιμολογίου Ανελκυστήρα",
    addElevatorInvoice: "Προσθήκη Τιμολογίου Ανελκυστήρα",
    invoiceAmount: "Ποσό Τιμολογίου",
    noElevatorExpenses: "Δεν υπάρχουν έξοδα ανελκυστήρα",
    totalElevatorCost: "Συνολικό Κόστος Ανελκυστήρα",
    elevatorBalance: "Υπόλοιπο Ανελκυστήρα",
    elevatorInvoices: "Τιμολόγια Ανελκυστήρα",
    elevatorPayments: "Πληρωμές Ανελκυστήρα",
    elevatorStatement: "Κατάσταση Ανελκυστήρα",
    contractStatus: "Κατάσταση Συμβολαίου",
    daysRemaining: "μέρες απομένουν",
    contracts: "Συμβόλαια",
    contactPhone: "Τηλέφωνο",
    contactEmail: "Email",
    invoiceNumber: "Αριθμός Τιμολογίου",
    uploadInvoice: "Μεταφόρτωση Τιμολογίου",
    downloadInvoice: "Λήψη Τιμολογίου",
    downloadReceipt: "Λήψη Απόδειξης",
    exportFullStatement: "Εξαγωγή Κατάστασης",
    viewPdf: "Προβολή PDF",
    invoiceFile: "Αρχείο Τιμολογίου",
    editElevatorExpense: "Επεξεργασία Τιμολογίου",
    deleteElevatorExpense: "Διαγραφή Τιμολογίου",
    confirmDeleteElevatorExpense: "Σίγουρα θέλετε να διαγράψετε αυτό το τιμολόγιο ανελκυστήρα; Όλες οι σχετικές πληρωμές θα διαγραφούν επίσης.",
    elevatorCompany: "Εταιρεία",
    elevatorCompanies: "Εταιρείες Ανελκυστήρων",
    vendors: "Προμηθευτές",
    companiesOverview: "Εταιρείες",
    tasksAndNotes: "Εργασίες & Σημειώσεις",
    noTasksOrNotes: "Δεν υπάρχουν εργασίες ή σημειώσεις",
    certificationCompanies: "Πιστοποίηση",
    addVendor: "Προσθήκη Προμηθευτή",
    createNewVendor: "Δημιουργία Νέου Προμηθευτή",
    vendorCreated: "Ο προμηθευτής δημιουργήθηκε επιτυχώς",
    noSelection: "Κανένα",
    editVendor: "Επεξεργασία Προμηθευτή",
    vendorName: "Όνομα Προμηθευτή",
    searchVendors: "Αναζήτηση προμηθευτών...",
    noVendors: "Δεν βρέθηκαν προμηθευτές",
    deleteVendorWarning: "Ο προμηθευτής θα αρχειοθετηθεί. Τα συνδεδεμένα έξοδα θα παραμείνουν",
    owners: "Ιδιοκτήτες",
    addOwner: "Προσθήκη Ιδιοκτήτη",
    editOwner: "Επεξεργασία Ιδιοκτήτη",
    searchOwners: "Αναζήτηση ιδιοκτητών...",
    noOwners: "Δεν βρέθηκαν ιδιοκτήτες",
    deleteOwnerWarning: "Ο ιδιοκτήτης θα διαγραφεί ή θα αρχειοθετηθεί",
    ownerProfile: "Προφίλ Ιδιοκτήτη",
    viewProfile: "Προβολή Προφίλ",
    unlinkOwner: "Αποσύνδεση Ιδιοκτήτη",
    linkExistingOwner: "Σύνδεση Υπάρχοντος Ιδιοκτήτη",
    linkedApartments: "Συνδεδεμένα Διαμερίσματα",
    fullName: "Πλήρες Όνομα",
    ownerDetails: "Στοιχεία Ιδιοκτήτη",
    ownerAndUnitInfo: "Στοιχεία Ιδιοκτήτη & Μονάδας",
    selectOwner: "Επιλογή Ιδιοκτήτη",
    createAndLink: "Δημιουργία & Σύνδεση",
    ownerArchived: "Ο ιδιοκτήτης αρχειοθετήθηκε (υπάρχουν οικονομικά αρχεία)",
    changeOwnerWarning: "Αυτό το διαμέρισμα έχει ήδη ιδιοκτήτη. Η αλλαγή θα αποσυνδέσει τον προηγούμενο ιδιοκτήτη.",
    preferredVendor: "Προτιμώμενος Προμηθευτής",
    expensesByBuilding: "Έξοδα ανά Κτίριο",
    selectVendor: "Επιλογή Προμηθευτή",
    selectInvoice: "Επιλογή Τιμολογίου",
    manualPayment: "Χειροκίνητη πληρωμή (χωρίς τιμολόγιο)",
    vendor: "Προμηθευτής",
    deleteExpenseWarning: "Αυτό το έξοδο θα αρχειοθετηθεί. Μπορεί να αποκατασταθεί αργότερα",
    confirmArchive: "Αρχειοθέτηση",
    archived: "Αρχειοθετημένο",
    archive: "Αρχειοθέτηση",
    activeItems: "Ενεργά",
    archivedItems: "Αρχειοθετημένα",
    allItems: "Όλα",
    restore: "Επαναφορά",
    permanentDelete: "Οριστική Διαγραφή",
    confirmRestore: "Σίγουρα θέλετε να επαναφέρετε αυτό το στοιχείο;",
    confirmPermanentDelete: "Αυτό θα διαγράψει οριστικά αυτό το στοιχείο και όλα τα σχετικά αρχεία. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
    itemRestored: "Το στοιχείο επαναφέρθηκε επιτυχώς",
    itemPermanentlyDeleted: "Το στοιχείο διαγράφηκε οριστικά",
    addElevatorCompany: "Προσθήκη Εταιρείας",
    editElevatorCompany: "Επεξεργασία Εταιρείας",
    deleteElevatorCompany: "Διαγραφή Εταιρείας",
    confirmDeleteElevatorCompany: "Σίγουρα θέλετε να διαγράψετε αυτήν την εταιρεία;",
    elevatorPaid: "Πληρωμένο",
    elevatorUnpaid: "Απλήρωτο",
    manageCompanies: "Διαχείριση Εταιρειών",
    maintenanceNotes: "Μηνιαία Συντήρηση",
    maintenanceMonth: "Μήνας Συντήρησης",
    netAmount: "Καθαρό Ποσό",
    grandTotal: "Γενικό Σύνολο",
    invoiceTotal: "Σύνολο Τιμολογίου",
    vatAmount: "Ποσό ΦΠΑ",
    totalInclVat: "Σύνολο (με ΦΠΑ)",
    elevatorCertificationCompanies: "Εταιρείες Πιστοποίησης Ανελκυστήρων",
    addCertificationCompany: "Προσθήκη Εταιρείας",
    editCertificationCompany: "Επεξεργασία Εταιρείας",
    deleteCertificationCompany: "Διαγραφή Εταιρείας",
    confirmDeleteCertificationCompany: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την εταιρεία πιστοποίησης;",
    noCertificationCompanies: "Δεν υπάρχουν εταιρείες πιστοποίησης ανελκυστήρων",
    selectMonth: "Επιλογή Μήνα",
    selectYear: "Επιλογή Έτους",
    allMonths: "Όλοι οι Μήνες",
    allYears: "Όλα τα Έτη",
    extraCharges: "Επιπλέον Χρεώσεις",
    addExtraCharge: "Προσθήκη Χρέωσης",
    chargeDescription: "Περιγραφή",
    chargeAmount: "Ποσό",
    monthlyCharges: "Μηνιαίες Χρεώσεις",
    totalExtraCharges: "Σύνολο Επιπλέον Χρεώσεων",
    totalMonthlyCharges: "Σύνολο Μηνιαίων Χρεώσεων",
    statementGrandTotal: "Γενικό Σύνολο",
    sourceInvoice: "Πηγή Τιμολογίου",
    totalIncVat: "Σύνολο με ΦΠΑ",
    recurringMonthly: "Επαναλαμβανόμενο (Μηνιαίο)",
    oneTimeExtra: "Εφάπαξ (Επιπλέον)",
    chargesSection: "Χρεώσεις",
    paymentsSection: "Πληρωμές",
    extrasSection: "Επιπλέον",
    noExtraCharges: "Δεν υπάρχουν επιπλέον χρεώσεις",
    elevatorDescPlaceholder: "π.χ. Συντήρηση ανελκυστήρα, Επισκευή, Επιθεώρηση",
    extraChargesTotal: "Σύνολο Επιπλέον Χρεώσεων",
    addNewCompany: "Προσθήκη Νέας Εταιρείας",
    apartments: "Μονάδες / Διαμερίσματα",
    apartmentNumber: "Διαμέρισμα",
    ownerName: "Όνομα Ιδιοκτήτη",
    monthlyFee: "Μηνιαίο Τέλος",
    addApartment: "Προσθήκη Διαμερίσματος",
    editApartment: "Επεξεργασία Διαμερίσματος",
    deleteApartment: "Διαγραφή Διαμερίσματος",
    deleteApartmentWarning: "Εάν το διαμέρισμα έχει τιμολόγια ή πληρωμές, θα αρχειοθετηθεί αντί να διαγραφεί.",
    deleteSuccess: "Διαγράφηκε επιτυχώς",
    noApartments: "Δεν υπάρχουν διαμερίσματα",
    totalDue: "Συνολική Οφειλή",
    totalPaid: "Συνολικά Πληρωμένα",
    remainingBalance: "Υπόλοιπο",
    overdue: "Ληξιπρόθεσμο",
    pending: "Εκκρεμεί",
    totalExpectedIncome: "Αναμενόμενο Εισόδημα",
    totalCollected: "Εισπράχθηκαν",
    cashReceipts: "Ταμειακές Αποδείξεις",
    bankReceipts: "Τραπεζικές Κινήσεις",
    amountIn: "Εισπράξεις",
    amountOut: "Πληρωμές",
    runningBalance: "Τρέχον Υπόλοιπο",
    noCashTransactions: "Δεν υπάρχουν ταμειακές συναλλαγές.",
    noBankTransactions: "Δεν υπάρχουν τραπεζικές συναλλαγές.",
    distributedAmount: "Κατανεμημένο",
    repairs: "Επισκευές",
    repair: "Επισκευή",
    reserveFundTab: "Αποθεματικό",
    totalOutstanding: "Εκκρεμή",
    totalCreditBalance: "Συνολικό Πιστωτικό Υπόλοιπο",
    apartmentsOwing: "Διαμερίσματα με Οφειλή",
    apartmentsWithCredit: "Διαμερίσματα με Πίστωση",
    netPosition: "Καθαρή Θέση",
    netPositionDesc: "Εκκρεμότητες μείον πιστώσεις — το πραγματικό ποσό προς είσπραξη.",
    of: "από",
    filterByPeriod: "Φιλτράρισμα ανά Περίοδο",
    allTime: "Όλες οι Περίοδοι",
    customRange: "Προσαρμοσμένη Περίοδος",
    month: "Μήνας",
    year: "Έτος",
    alertsNotifications: "Ειδοποιήσεις",
    topOutstanding: "Υψηλότερα Εκκρεμή Υπόλοιπα",
    outstandingByCategory: "Εκκρεμή ανά Κατηγορία",
    recentPayments: "Πρόσφατες Πληρωμές",
    recentExpenses: "Πρόσφατα Έξοδα",
    noRecentPayments: "Δεν υπάρχουν πρόσφατες πληρωμές",
    noRecentExpenses: "Δεν υπάρχουν πρόσφατα έξοδα",
    buildingStatus: "Κατάσταση Κτιρίου",
    addPayment: "Προσθήκη Πληρωμής",
    paymentHistory: "Ιστορικό Πληρωμών",
    deletePayment: "Διαγραφή Πληρωμής",
    noPayments: "Δεν υπάρχουν πληρωμές",
    recordPayment: "Καταγραφή Πληρωμής",
    editReceipt: "Επεξεργασία Απόδειξης",
    invoiceAllocation: "Κατανομή Τιμολογίων",
    paymentAmount: "Ποσό Πληρωμής",
    viewApartments: "Διαμερίσματα",

    // Annual Financial Statement
    annualFinancialStatement: "Ετήσια Οικονομική Κατάσταση",
    annualStatementDesc: "Δημιουργία και προβολή ετήσιας οικονομικής αναφοράς για αυτό το κτίριο.",
    reserveFundStatement: "Κατάσταση Αποθεματικού",
    reserveStatementDesc: "Προβολή αποταμιεύσεων ανά διαμέρισμα, επισκευών από αποθεματικό και καθαρού υπολοίπου.",
    reserveStatementHint: "Εισάγετε τα έτη και πατήστε Δημιουργία για τη δημιουργία κατάστασης αποθεματικού.",
    savingsBalancePerApartment: "Συνολικό Υπόλοιπο Αποθεματικού ανά Διαμέρισμα",
    monthlySavingsSummary: "Μηνιαία Έξοδα",
    savingsTotal: "Σύνολο Αποθεματικού",
    totalSavingsBeforeRepairs: "Συνολικό Ποσό Αποθεματικού Πριν Επισκευές",
    repairsThroughReserve: "Επισκευές Μέσω Αποθεματικού (Έκτακτα Έξοδα)",
    totalRepairs: "Σύνολο Επισκευών",
    totalSavingsNet: "Συνολικό Ποσό Αποθεματικού",
    years: "Έτη",
    yearsHint: "Διαχωρισμένα με κόμμα, π.χ. 2025,2026",
    month_short_1: "ΙΑΝ", month_short_2: "ΦΕΒ", month_short_3: "ΜΑΡ", month_short_4: "ΑΠΡ",
    month_short_5: "ΜΑΙ", month_short_6: "ΙΟΥΝ", month_short_7: "ΙΟΥΛ", month_short_8: "ΑΥΓ",
    month_short_9: "ΣΕΠ", month_short_10: "ΟΚΤ", month_short_11: "ΝΟΕ", month_short_12: "ΔΕΚ",
    generateReport: "Δημιουργία Αναφοράς",
    generate: "Δημιουργία",
    sendViaEmail: "Αποστολή μέσω Email",
    exportPDF: "Εξαγωγή PDF",
    exportExcel: "Εξαγωγή Excel",
    exportSuccess: "Η εξαγωγή ολοκληρώθηκε",
    year: "Έτος",
    period: "Περίοδος",
    openingBalance: "Αρχικό Υπόλοιπο",
    setOpeningBalance: "Ορισμός Αρχικού Υπολοίπου",
    noOpeningBalance: "Δεν έχει οριστεί αρχικό υπόλοιπο",
    openingBalanceHint: "Θετικό = πλεόνασμα, Αρνητικό = έλλειμμα στη δεδομένη ημερομηνία",
    elevatorOpeningBalance: "Αρχικό Υπόλοιπο Ανελκυστήρα",
    elevatorBalance: "Υπόλοιπο Ανελκυστήρα",
    currentBalance: "Τρέχον Υπόλοιπο",
    changeHistory: "Ιστορικό Αλλαγών",
    cleared: "Εκκαθαρίστηκε",
    clear: "Εκκαθάριση",
    buildingTotal: "Σύνολο Κτιρίου",
    averagePerJob: "Μ.Ο. / Εργασία",
    dailyTotal: "Ημερήσιο Σύνολο",
    officeJob: "Εργασία Γραφείου",
    buildingJob: "Εργασία Πολυκατοικίας",
    officeCleaning: "Καθαρισμός Γραφείου",
    buildingCleaning: "Καθαρισμός Πολυκατοικίας",
    collapseAll: "Σύμπτυξη Όλων",
    expandAll: "Ανάπτυξη Όλων",
    groupByDate: "Ομαδοποίηση ανά Ημ/νία",
    groupByBuilding: "Ομαδοποίηση ανά Κτίριο",
    entries: "εγγραφές",
    jobsCount: "εργασίες",
    finalBalance: "Τελικό Υπόλοιπο",
    closingCashBalance: "Τελικό Υπόλοιπο Μετρητών",
    closingBankBalance: "Τελικό Υπόλοιπο Τράπεζας",
    totalClosingBalance: "Συνολικό Τελικό Υπόλοιπο",
    summary: "Σύνοψη",
    expenseBreakdown: "Ανάλυση Εξόδων",
    signatures: "Υπογραφές",
    president: "Πρόεδρος",
    chairman: "Πρόεδρος",
    secretary: "Γραμματέας",
    treasurer: "Ταμίας",
    committee: "Επιτροπή",
    editCommittee: "Επεξεργασία Επιτροπής",
    assignCommittee: "Ορισμός Επιτροπής",
    noCommitteeAssigned: "Δεν έχουν οριστεί μέλη επιτροπής",
    notAssigned: "Δεν έχει οριστεί",
    byAuthorization: "δι' εξουσιοδοτήσεως",
    electedWithAuthorization: "Εκλεγμένος/η δι' εξουσιοδοτήσεως",
    authorizedBy: "Εξουσιοδοτημένο από",
    selectApartment: "Σύνδεση με διαμέρισμα",
    manualEntryCommittee: "Χειροκίνητη εισαγωγή",
    noTransactions: "Δεν υπάρχουν συναλλαγές για αυτήν την περίοδο",
    selectYearAndGenerate: "Επιλέξτε έτος και πατήστε Δημιουργία Αναφοράς",
    emailFeatureComingSoon: "Η λειτουργία email θα είναι σύντομα διαθέσιμη",
    address: "Διεύθυνση",
    apartmentStatement: "Κατάσταση Διαμερίσματος",
    closingBalance: "Τελικό Υπόλοιπο",
    totalCharges: "Σύνολο Χρεώσεων",
    totalPayments: "Σύνολο Πληρωμών",
    included: "Περιλαμβάνεται",
    dateFrom: "Από",
    dateTo: "Έως",
    generateStatement: "Δημιουργία Κατάστασης",
    charge: "Χρέωση",
    payment: "Πληρωμή",
    selectApartment: "Επιλέξτε Διαμέρισμα",
    downloadPdf: "Λήψη PDF",
    printPdf: "Εκτύπωση PDF",
    printAllPayments: "Εκτύπωση ΟΛΩΝ των Πληρωμών",
    allPayments: "Όλες οι Πληρωμές",

    // Insurance Companies
    insuranceCompanies: "Ασφαλιστικές Εταιρείες",
    addInsuranceCompany: "Προσθήκη Ασφ. Εταιρείας",
    editInsuranceCompany: "Επεξεργασία Ασφ. Εταιρείας",
    deleteInsuranceCompany: "Διαγραφή Ασφ. Εταιρείας",
    confirmDeleteCompany: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την ασφαλιστική εταιρεία;",
    noInsuranceCompanies: "Δεν υπάρχουν ασφαλιστικές εταιρείες",
    selectCompany: "Επιλέξτε Εταιρεία",
    typeManually: "Χειροκίνητη Εισαγωγή",
    contactInfo: "Στοιχεία Επικοινωνίας",
    contactPerson: "Υπεύθυνος Επικοινωνίας",
    contactName: "Όνομα Επαφής",
    contactPhone: "Τηλέφωνο Επαφής",
    phoneNumber: "Τηλέφωνο",
    totalContracts: "Σύνολο Συμβολαίων",
    expiringSoonPolicies: "Λήγουν Σύντομα",
    insuredBuildings: "Ασφαλισμένα Κτίρια",
    companyProfile: "Προφίλ Εταιρείας",
    vatRegistrationNumber: "ΑΦΜ",
    companyProfileHint: "Διαχείριση πληροφοριών εταιρείας που χρησιμοποιούνται σε έγγραφα και αναφορές",
    companyNameLine2: "Επωνυμία Εταιρείας (Γραμμή 2)",

    // Task improvements
    apartment: "Διαμέρισμα",
    wholeBuilding: "Όλο το Κτίριο",
    customTaskType: "Τύπος Εργασίας",
    customTaskPlaceholder: "π.χ. Αίτημα ιδιοκτήτη, Διαρροή...",
    reminderDate: "Υπενθύμιση",
    important: "Σημαντικό",
    overdue: "Εκπρόθεσμο",
    custom: "Προσαρμοσμένο",
    taskReminders: "Υπενθυμίσεις Εργασιών",
    today: "Σήμερα",
    noTasks: "Δεν βρέθηκαν εργασίες",

    // Insurance updates
    policyNumber: "Αριθμός Ασφαλιστηρίου",
    insuranceDetails: "Στοιχεία Ασφάλισης",
    allocateAmount: "Κατανομή €",
    applyAllocations: "Εφαρμογή Κατανομών",
    toAllocate: "Προς κατανομή",
    fill: "Μέγ.",
    useFullAmount: "Χρήση υπολοίπου",
    allocateOverWarning: "Οι κατανομές υπερβαίνουν το ποσό της πληρωμής.",
    paymentAllocated: "Η πληρωμή κατανεμήθηκε",
    insuranceHistory: "Ιστορικό Ασφάλισης",
    latest: "Τελευταίο",

    // Dashboard Alerts
    upcomingExpirations: "Επερχόμενες Λήξεις",
    insuranceExpiring: "Ασφάλεια - Λήξη",
    elevatorCertification: "Πιστοποίηση Ανελκυστήρα",
    addCertification: "Προσθήκη Πιστοποίησης",
    addFollowUp: "Επανέλεγχος",
    followUpInspection: "Επανέλεγχος Επιθεώρησης",
    followUpOf: "Επανέλεγχος της",
    repaired: "Επισκευάστηκε",
    repairCompletedDate: "Ημ/νία Ολοκλήρωσης Επισκευής",
    resolvedByFollowup: "Επιλύθηκε με επανέλεγχο",
    editCertification: "Επεξεργασία Πιστοποίησης",
    deleteCertification: "Διαγραφή Πιστοποίησης",
    confirmDeleteCertification: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο πιστοποίησης;",
    noCertifications: "Δεν υπάρχουν αρχεία πιστοποίησης ανελκυστήρα",
    nextInspectionDate: "Ημερομηνία Επόμενης Επιθεώρησης",
    failureReason: "Λόγος Αποτυχίας",
    failureReasons: "Λόγοι Αποτυχίας",
    addNewFailureReason: "Πληκτρολογήστε νέο λόγο και πατήστε Enter ή +",
    selectReason: "Επιλέξτε λόγο",
    safetyIssue: "Θέμα ασφαλείας",
    electricalIssue: "Ηλεκτρολογικό θέμα",
    mechanicalIssue: "Μηχανολογικό θέμα",
    documentationMissing: "Ελλιπής τεκμηρίωση",
    other: "Άλλο",
    selectCompany: "Επιλέξτε εταιρεία",
    inspectionOverdue: "Επιθεώρηση εκπρόθεσμη κατά",
    inspectionDueIn: "Επιθεώρηση σε",
    failureReasons: "Λόγοι Αποτυχίας",
    addFailureReason: "Προσθήκη Λόγου",
    editFailureReason: "Επεξεργασία Λόγου",
    deleteFailureReason: "Διαγραφή Λόγου",
    confirmDeleteFailureReason: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον λόγο αποτυχίας; Δεν θα αφαιρεθεί από παλαιότερα αρχεία.",
    noFailureReasons: "Δεν έχουν οριστεί λόγοι αποτυχίας",
    reasonName: "Όνομα Λόγου",
    taskTypes: "Τύποι Εργασιών",
    addTaskType: "Προσθήκη Τύπου",
    editTaskType: "Επεξεργασία Τύπου",
    deleteTaskType: "Διαγραφή Τύπου",
    confirmDeleteTaskType: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον τύπο εργασίας; Τύποι σε χρήση δεν μπορούν να διαγραφούν.",
    noTaskTypes: "Δεν έχουν οριστεί τύποι εργασιών",
    selectTaskType: "Επιλέξτε τύπο εργασίας",
    certificationFailed: "Πιστοποίηση ΑΠΟΤΥΧΙΑ",
    inspectionDate: "Ημερομηνία Επιθεώρησης",
    expiryDate: "Ημερομηνία Λήξης",
    certificateNumber: "Αριθμός Πιστοποιητικού",
    inspector: "Επιθεωρητής",
    result: "Αποτέλεσμα",
    passed: "Επιτυχής",
    failed: "Αποτυχία",
    conditional: "Υπό Όρους",
    cost: "Κόστος",
    urgent: "Επείγον",
    ok: "OK",
    insuranceExpiresIn: "Η ασφάλεια λήγει σε",
    insuranceExpiredAgo: "Η ασφάλεια έληξε πριν",
    elevatorDueIn: "Έλεγχος ανελκυστήρα σε",
    elevatorExpiredAgo: "Ο έλεγχος ανελκυστήρα εκπρόθεσμος κατά",
    lastInspection: "Τελευταίος Έλεγχος",
    nextInspection: "Επόμενος Έλεγχος",
    latestCertification: "Τελευταία Πιστοποίηση",
    noCertificationYet: "Δεν έχει καταχωρηθεί πιστοποίηση ακόμα",
    certificationDate: "Ημερομηνία Πιστοποίησης",
    inspectionInProgressMsg: "Ο έλεγχος εκκρεμεί / βρίσκεται σε εξέλιξη",
    certificationHistory: "Ιστορικό Πιστοποιήσεων",
    updateStatus: "Ενημέρωση Κατάστασης",
    totalRecords: "Σύνολο εγγραφών",
    createdAt: "Δημιουργήθηκε",
    selectFailureReasons: "Επιλέξτε λόγους αποτυχίας",
    searchReasons: "Αναζήτηση λόγων…",
    noReasonFound: "Δεν βρέθηκε λόγος",
    reasonsSelected: "επιλεγμένοι",
    expand: "Ανάπτυξη",
    hide: "Απόκρυψη",
    viewBreakdown: "Προβολή Ανάλυσης",
    locked: "Κλειδωμένο",
    passedFinalMsg: "Αυτή η πιστοποίηση είναι οριστική. Προσθέστε νέα για να ξεκινήσετε νέο κύκλο.",
    editCycleTitle: "Επεξεργασία Πιστοποίησης",
    incl: "με",
    allCertifications: "Όλες οι Πιστοποιήσεις",
    allCertificationsDescription: "Κάθε πιστοποίηση είναι ανεξάρτητη εγγραφή με τον δικό της κύκλο ζωής.",
    certificationCycle: "Πιστοποίηση",
    current: "Τρέχουσα",
    historyOfThisCert: "Αλλαγές αυτής της πιστοποίησης",
    shared: "Κοινόχρηστη",
    sharedDesc: "Κατανομή στα διαμερίσματα",
    buildingFund: "Ταμείο Κτιρίου",
    buildingFundDesc: "Πληρωμή από το ταμείο",
    noPaymentsYet: "Δεν έχουν καταχωρηθεί πληρωμές",
    optionalNotes: "Προαιρετικές σημειώσεις",
    enterValidAmount: "Εισάγετε έγκυρο ποσό",
    unpaidRepairs: "Απλήρωτες Επισκευές",
    bankAccount: "Τραπεζικός Λογαριασμός",
    deductFromReserveFund: "Αφαίρεση από Αποθεματικό",
    viewStatement: "Προβολή Καρτέλας",
    outstandingDesc: "Όλα τα διαμερίσματα με τα ποσά που έχουν χρεωθεί / πληρωθεί / υπολείπονται. Αρνητικές τιμές δηλώνουν πιστωτικά υπόλοιπα (υπερπληρωμή).",
    viewOutstandingDetails: "Κλικ για προβολή όλων των οφειλών ανά διαμέρισμα",
    invoiced: "Χρεωμένα",
    ownerName: "Ονοματεπώνυμο Ιδιοκτήτη",
    markAsActiveCommittee: "Ορισμός ως συνέλευση Ενεργής Επιτροπής Διαχείρισης",
    activeCommitteeMeetingHint: "Αυτή η συνέλευση ορίζει την ενεργή Επιτροπή Διαχείρισης — κλικ για κατάργηση",
    activeCommitteeSet: "Ορίστηκε ως συνέλευση Ενεργής Επιτροπής Διαχείρισης",
    activeCommitteeUnset: "Καταργήθηκε ως συνέλευση Ενεργής Επιτροπής Διαχείρισης",
    reserveFundAvailable: "Διαθέσιμο Αποθεματικό",
    paymentExceedsRemaining: "Η πληρωμή υπερβαίνει το υπόλοιπο",
    selectBankAccount: "Επιλέξτε τραπεζικό λογαριασμό",
    noBankAccountsConfigured: "Δεν υπάρχουν τραπεζικοί λογαριασμοί. Προσθέστε στο Οικονομικά → Λογαριασμοί.",
    yes: "Ναι",

    // Inline Edit & Apartment fields
    changesSaved: "Αποθηκεύτηκε",
    commonExpenses: "Κοινόχρηστα",
    reserveFund: "Αποθεματικό",
    reserveFundHistory: "Ιστορικό Αποθεματικού",
    reserveFundTransactions: "Κινήσεις Αποθεματικού",
    reserveFundManagedFromAnnual: "Το βασικό ποσό Αποθεματικού διαχειρίζεται από τα Ετήσια Έξοδα",
    share: "Μερίδιο",
    previousAmount: "Προηγούμενο Ποσό",
    newAmount: "Νέο Ποσό",
    changedAt: "Ημ. Αλλαγής",
    changedBy: "Αλλαγή Από",
    noChanges: "Δεν υπάρχουν καταγραφές",
    sharePercentage: "Ποσοστό (%)",
    shareUnder100: "Το σύνολο είναι κάτω από 100%",
    shareOver100: "Το σύνολο υπερβαίνει το 100%",
    totalDue: "Σύνολο Οφειλής",
    pay: "Πληρωμή",
    recordPayment: "Καταχώρηση Πληρωμής",
    noApartments: "Δεν βρέθηκαν διαμερίσματα",
    apartments: "Διαμερίσματα",
    total: "Σύνολο",
    // Receipt & Payment System
    receiptHistory: "Ιστορικό Αποδείξεων",
    receiptNumber: "Αρ. Απόδειξης",
    receiptNumberPlaceholder: "Αφήστε κενό για αυτόματη δημιουργία (π.χ. RCP-0017)",
    receiptNumberAlreadyExists: "Ο αριθμός απόδειξης υπάρχει ήδη.",
    receiptAutoHint: "Αφήστε κενό για αυτόματη δημιουργία (REC-YYYY-NNNN)",
    optional: "προαιρετικό",
    reference: "Αναφορά",
    referenceNumber: "Αρ. Απόδειξης / Αναφοράς",
    referenceNumberHint: "Απόδειξη, τιμολόγιο ή τραπεζική αναφορά",
    receiptGenerated: "Η Απόδειξη Δημιουργήθηκε",
    paymentRecorded: "Η Πληρωμή Καταγράφηκε",
    buildingExpenses: "Έξοδα Κτιρίου",
    commonExpensesDesc: "Πληρωμή από ιδιοκτήτη διαμερίσματος (ενοίκιο, κοινόχρηστα)",
    buildingExpensesDesc: "Πληρωμή σε προμηθευτή ή για έξοδα κτιρίου",
    paymentMethod: "Τρόπος Πληρωμής",
    cash: "Μετρητά",
    bankTransfer: "Τραπεζική Μεταφορά",
    other: "Άλλο",
    issuedTo: "Προς",
    manualEntry: "— Χειροκίνητη εισαγωγή (χωρίς σύνδεση εξόδου) —",
    supplier: "Προμηθευτής",
    supplierPlaceholder: "Εταιρεία ή προμηθευτής",
    selectExpense: "Επιλέξτε Έξοδο",
    selectAtLeastOneInvoice: "Επιλέξτε τουλάχιστον ένα τιμολόγιο",
    totalToPay: "Σύνολο Πληρωμής",
    // Customer Card
    customerProfile: "Προφίλ Πελάτη",
    overview: "Επισκόπηση",
    invoices: "Τιμολόγια",
    payments: "Πληρωμές",
    statement: "Κατάσταση Λογαριασμού",
    totalDue: "Σύνολο Οφειλής",
    totalPaid: "Σύνολο Πληρωμών",
    remainingBalance: "Υπόλοιπο",
    totalCharges: "Σύνολο Χρεώσεων",
    totalPayments: "Σύνολο Πληρωμών",
    charges: "Χρεώσεις",
    description: "Περιγραφή",
    balance: "Υπόλοιπο",
    noOwner: "Χωρίς Ιδιοκτήτη",
    cleanerPayment: "Πληρωμή Καθαριστή",
    totalCleanerPayments: "Σύνολο Πληρωμών Καθαριστή",
    addAnotherCleaner: "Προσθήκη Καθαριστή",
    addCleaningType: "Προσθήκη Τύπου Καθαρισμού",
    finance: "Οικονομικά",
    bills: "Λογαριασμοί",
    addBill: "Προσθήκη Λογαριασμού",
    editBill: "Επεξεργασία Λογαριασμού",
    billsDescription: "Επαναλαμβανόμενα έξοδα και υποχρεώσεις",
    billStatement: "Κατάσταση Λογαριασμού",
    unpaidBillsSection: "Απλήρωτοι Λογαριασμοί",
    billTimeline: "Χρονολόγιο",
    addInvoiceToBill: "Προσθήκη Τιμολογίου",
    recordPaymentToBill: "Καταγραφή Πληρωμής",
    totalInvoiced: "Σύνολο Τιμολογηθέντων",
    totalPaidAmount: "Σύνολο Πληρωθέντων",
    billBalance: "Υπόλοιπο",
    viewStatement: "Προβολή Κατάστασης",
    backToBills: "Πίσω στους Λογαριασμούς",
    invoiceCreated: "Δημιουργία Τιμολογίου",
    paymentMade: "Πληρωμή",
    noBillActivity: "Δεν υπάρχει δραστηριότητα. Προσθέστε τιμολόγιο για να ξεκινήσετε.",
    dueDate: "Ημ/νία Πληρωμής",
    sortedByDueDate: "Ταξινόμηση κατά πλησιέστερη ημ/νία",
    totalBills: "Σύνολο Λογαριασμών",
    unpaidBills: "Απλήρωτοι",
    noBills: "Δεν υπάρχουν λογαριασμοί",
    nextPayment: "Επόμενη Πληρωμή",
    dueSoon: "Σύντομα",
    scheduled: "Προγραμματισμένο",
    markPaid: "Πληρωμένο",
    reminderDays: "Υπενθύμιση (ημέρες πριν)",
    yearlyTotal: "Ετήσιο Σύνολο",
    nameRequired: "Το όνομα είναι υποχρεωτικό",
    amountRequired: "Το ποσό είναι υποχρεωτικό",
    bankAccounts: "Τραπεζικοί Λογαριασμοί",
    addBankAccount: "Προσθήκη Λογαριασμού",
    editBankAccount: "Επεξεργασία Λογαριασμού",
    bankName: "Όνομα Τράπεζας",
    accountNumber: "Αριθμός Λογαριασμού",
    openingBalance: "Αρχικό Υπόλοιπο",
    currentBalance: "Τρέχον Υπόλοιπο",
    companyIncome: "Έσοδα",
    companyExpenses: "Έξοδα",
    addIncome: "Προσθήκη Εσόδου",
    addExpense: "Προσθήκη Εξόδου",
    editIncome: "Επεξεργασία Εσόδου",
    editExpense: "Επεξεργασία Εξόδου",
    incomeDescription: "Περιγραφή",
    expenseCategory: "Κατηγορία",
    paymentSource: "Πηγή Πληρωμής",
    totalIncome: "Σύνολο Εσόδων",
    totalSupplierExpenses: "Σύνολο Εξόδων Προμηθευτών",
    netBalance: "Καθαρό Υπόλοιπο",
    expenseCategories: "Κατηγορίες Αναφοράς",
    referenceCategories: "Κατηγορίες Αναφοράς",
    expenseCategoriesDesc: "Ετικέτες αναφοράς για τραπεζικές κινήσεις και χειροκίνητη ταξινόμηση. Αυτές ΔΕΝ συνεισφέρουν στο Σύνολο Εξόδων — μόνο τα πραγματικά έξοδα (Αγορές → Έξοδα) το κάνουν.",
    expensesByCategory: "Έξοδα ανά Κατηγορία",
    default: "Προεπιλογή",
    addCategory: "Προσθήκη Κατηγορίας",
    categoryName: "Όνομα Κατηγορίας",
    selectClient: "Επιλογή Πελάτη",
    clientRequired: "Ο πελάτης είναι υποχρεωτικός",
    selectCategory: "Επιλογή Κατηγορίας",
    selectBank: "Επιλογή Λογαριασμού",
    selectSource: "Επιλογή Πηγής",
    cashSource: "Μετρητά",
    bankSource: "Τράπεζα",
    bankIncome: "Τραπεζικά Έσοδα",
    cashIncome: "Έσοδα Μετρητών",
    addCashIncome: "Προσθήκη Εσόδου Μετρητών",
    noCashIncome: "Δεν υπάρχουν έσοδα μετρητών",
    cashNoVatNotice: "Έσοδα μετρητών: Χωρίς ΦΠΑ ή 12,5%. Απλή καταγραφή.",
    noVatNoAllocation: "Χωρίς ΦΠΑ / Χωρίς 12,5%",
    noIncome: "Δεν υπάρχουν έσοδα",
    noExpenses: "Δεν υπάρχουν έξοδα",
    financialOverview: "Οικονομική Επισκόπηση",
    netIncome: "Καθαρά Έσοδα",
    vatTotal: "ΦΠΑ (19%)",
    grossIncome: "Ακαθάριστα Έσοδα",
    netAmount: "Καθαρό",
    vatAmount: "ΦΠΑ",
    allocation125: "Κατανομή 12,5%",
    allocation125Tab: "Κατανομή 12,5%",
    totalNet: "Σύνολο Καθαρών",
    totalAllocation: "Σύνολο 12,5%",
    vatIncluded: "Το ποσό περιλαμβάνει ΦΠΑ",
    vatNotIncluded: "Το ποσό είναι Καθαρό (θα προστεθεί ΦΠΑ)",
    incomeSource: "Πηγή Εσόδου",
    transactions: "Συναλλαγές",
    balanceAfter: "Υπόλοιπο Μετά",
    noTransactions: "Δεν βρέθηκαν συναλλαγές",
    viewDetails: "Προβολή Λεπτομερειών",
    allCategories: "Όλες οι Κατηγορίες",
    allSources: "Όλες οι Πηγές",
    allClients: "Όλοι οι Πελάτες",
    syncToCleaning: "Συγχρονισμός με Διαχείριση Καθαρισμού",
    // Phase 523 — Ταμείο εταιρείας (απομόνωση εσωτερικών μετρητών).
    affectsTreasury: "Επηρεάζει το Ταμείο της Εταιρείας;",
    treasuryYes: "Ναι — Επίσημα Μετρητά Εταιρείας",
    treasuryNo: "Όχι — Εσωτερικά Μετρητά",
    treasuryYesHint: "Προστίθεται στο υπόλοιπο του τραπεζικού λογαριασμού και εμφανίζεται στην τραπεζική κατάσταση.",
    treasuryNoHint: "Μόνο για εσωτερική λογιστική παρακολούθηση. Δρομολογείται αυτόματα στο Πορτοφόλι Εσωτερικών Μετρητών — εξαιρείται από σύνολα και καταστάσεις τραπεζικών λογαριασμών.",
    badgeInternalCash: "Εσωτερικό",
    referenceNumber: "Αρ. Αναφοράς",
    bankAccountRequired: "Παρακαλώ επιλέξτε τραπεζικό λογαριασμό όταν η πηγή είναι «τράπεζα».",
    // Phase 488 — Εταιρική Επωνυμία
    branding: "Επωνυμία",
    noLogoUploaded: "Δεν έχει φορτωθεί λογότυπο",
    logoHelperText: "Εμφανίζεται σε όλα τα τιμολόγια, καταστάσεις, PDF και emails. PNG, JPG, SVG, WEBP — μέγιστο 500KB.",
    uploadLogo: "Μεταφόρτωση Λογότυπου",
    replaceLogo: "Αντικατάσταση Λογότυπου",
    removeLogo: "Αφαίρεση",
    uploading: "Μεταφόρτωση...",
    logoUpdated: "Το λογότυπο ενημερώθηκε",
    logoRemoved: "Το λογότυπο αφαιρέθηκε",
    logoFormatError: "Το λογότυπο πρέπει να είναι PNG, JPG, JPEG ή SVG",
    logoSizeError: "Το αρχείο λογότυπου είναι πολύ μεγάλο.",
    logoCompressed: "Αυτόματη συμπίεση λογότυπου",
    website: "Ιστοσελίδα",
    registrationNumber: "Αριθμός Εγγραφής",
    customerNotes: "Σημειώσεις Πελάτη",
    internalNotes: "Εσωτερικές Σημειώσεις",
    visibleOnPdf: "ορατό στο PDF",
    teamOnlyNotOnPdf: "μόνο ομάδα, ΟΧΙ στο PDF",
    termsAndConditions: "Όροι & Προϋποθέσεις",
    termsPlaceholder: "Πληρωμή εντός 30 ημερών. Καθυστερημένες πληρωμές μπορεί να επιφέρουν τόκο.",
    taxSummary: "Σύνοψη Φόρου",
    rate: "Συντελεστής",
    taxableAmount: "Φορολογητέο Ποσό",
    taxAmount: "Ποσό Φόρου",
    balanceDue: "Υπόλοιπο Πληρωμής",
    paymentInformation: "Στοιχεία Πληρωμής",
    issuedBy: "Έκδοση Από",
    receivedBy: "Παραλαβή Από",
    // Phase 483 — Αυτόματη Καταχώρηση Πληρωμής Πελάτη
    allocatePaymentTitle: "Καταχώρηση πληρωμής σε τιμολόγια",
    allocatePaymentSubtitle: "Εφαρμογή €{amount} από {client} σε ένα ή περισσότερα ανοιχτά τιμολόγια",
    allocSingle: "Ένα τιμολόγιο",
    allocMulti: "Πολλαπλά τιμολόγια",
    allocAuto: "Αυτόματα FIFO (παλαιότερα πρώτα)",
    invoiceNo: "Αρ. Τιμολογίου",
    total: "Σύνολο",
    remaining: "Υπόλοιπο",
    applyAmount: "Ποσό €",
    paymentAmount: "Ποσό πληρωμής",
    totalAllocated: "Συνολικά κατανεμημένο",
    remainingUnallocated: "Μη κατανεμημένο υπόλοιπο",
    allocateLater: "Παράλειψη / Αργότερα",
    applyAllocation: "Εφαρμογή κατανομής",
    applying: "Εφαρμογή...",
    allocationApplied: "Η κατανομή εφαρμόστηκε",
    allocationExceedsPayment: "Η κατανομή υπερβαίνει το ποσό της πληρωμής",
    enterAllocationAmounts: "Εισάγετε τουλάχιστον ένα ποσό κατανομής",
    selectInvoice: "Επιλέξτε τιμολόγιο",
    linkedInvoices: "Συνδεδεμένα τιμολόγια",
    unallocatedCredit: "Μη κατανεμημένο πίστωση",
    syncedFromFinance: "Από Οικονομικά",
    autoFromBuilding: "Αυτόματο από Κτίριο",
    autoFromHistory: "Αυτόματο από Ιστορικό",
    finalNet: "Τελικό Καθαρό",
    finalNetBalance: "Τελικό Καθαρό Υπόλοιπο",
    deductedFrom: "Αφαιρέθηκε Από",
    bucketVat: "ΦΠΑ",
    bucketAllocation: "12,5%",
    bucketReserve: "Αποθεματικό 10%",
    bucketNet: "Καθαρό",
    reserve10: "Αποθεματικό 10%",
    socialInsurance10: "Κοινωνικές Ασφαλίσεις (10%)",
    columns: "Στήλες",
    bucketSocialInsurance: "Κοιν. Ασφ. 10%",
    bucketFinalBalance: "Τελικό Υπόλοιπο",
    vatDisplayOnlyTooltip: "Μόνο πληροφοριακό — ΔΕΝ περιλαμβάνεται στις Κρατήσεις ή στο Τελικό Υπόλοιπο.",
    vatInfoOnlyNote: "Ο ΦΠΑ είναι μόνο πληροφοριακός και ΔΕΝ περιλαμβάνεται στις κρατήσεις.",
    deductionsRemaining: "Υπόλοιπες Κρατήσεις",
    accrued: "Συσσωρευμένες",
    totalIncomeWithVat: "Συνολικά Έσοδα (με ΦΠΑ)",
    netIncomeWithoutVat: "Καθαρά Έσοδα (χωρίς ΦΠΑ)",
    gross: "Μεικτά",
    paymentsTotal: "Πληρωμές",
    bucketBalance: "Υπόλοιπο Κατηγορίας",
    ledgerLegend: "Γραμμές με + είναι ΦΠΑ/κρατήσεις από εισοδήματα. Γραμμές με − είναι πληρωμές από κάθε κατηγορία.",
    paidFrom: "Πληρωμή Από",
    paidFromRequired: "Η «Πληρωμή Από» είναι υποχρεωτική",
    paidFromDesc: "Επιλέξτε από ποιο ταμείο αφαιρείται το ποσό",
    paidFromVat: "ΦΠΑ",
    paidFromSocialInsurance: "Κοινωνικές Ασφαλίσεις",
    paidFrom125: "Φόρος 12,5%",
    paidFromReserve: "Αποθεματικό",
    paidFromFinalBalance: "Τελικό Υπόλοιπο",
    freeBalance: "Τελικό Υπόλοιπο",
    bankBalance: "Τραπεζικό Υπόλοιπο",
    managePurchaseCategories: "Διαχείριση Κατηγοριών Αγορών",
    vatFromGross: "19% από Μεικτό",
    fromNet: "από Καθαρό",
    availableBalance: "Διαθέσιμο Υπόλοιπο",
    netAfterDeductions: "Καθαρό μετά από όλες τις κρατήσεις",
    netIncomeBeforeDeductions: "Καθαρό Εισόδημα (Πριν τις Κρατήσεις)",
    deductionsBreakdown: "Κρατήσεις",
    deductions: "Κρατήσεις",
    deductionsTooltip: "12,5% + Αποθεματικό 10% + Κοιν. Ασφάλιση 10%",
    totalGrossIncome: "Συνολικά Έσοδα (Ακαθάριστα)",
    finalBalance: "Τελικό Υπόλοιπο",
    totalCashIncome: "Σύνολο Εσόδων Μετρητών",
    bankIncomeOnly: "Μόνο τραπεζικά έσοδα",
    backToFinance: "Πίσω στα Οικονομικά",
    runningBalance: "Τρέχον Υπόλοιπο",
    autoImported: "Αυτόματη εισαγωγή",
    removeCleaner: "Αφαίρεση Καθαριστή",
    totalPayment: "Συνολική Πληρωμή",
    multipleCleaners: "Πολλαπλοί Καθαριστές",
    selectedPeriod: "Επιλεγμένη Περίοδος",
    monthlyBreakdown: "Μηνιαία Ανάλυση",
    noPayments: "Δεν βρέθηκαν πληρωμές",
    editApartment: "Επεξεργασία Διαμερίσματος",
    payNow: "Πληρωμή",
    noInvoices: "Δεν βρέθηκαν απλήρωτα τιμολόγια",
    remaining: "Υπόλοιπο",
    back: "Πίσω",
    close: "Κλείσιμο",
    type: "Τύπος",
    period: "Περίοδος",
    apartment: "Διαμέρισμα",
    thisMonth: "Τρέχων Μήνας",
    lastMonth: "Προηγούμενος Μήνας",
    thisYear: "Τρέχον Έτος",
    custom: "Προσαρμοσμένο",
    showingDataFor: "Εμφάνιση δεδομένων για",
    collectedThisPeriod: "Εισπράχθηκαν αυτήν την περίοδο",
    outstandingThisPeriod: "Εκκρεμούν αυτήν την περίοδο",
    previousPeriod: "Προηγούμενη Περίοδος",
    currentPeriod: "Τρέχουσα Περίοδος",
    difference: "Διαφορά",
    periodComparison: "Σύγκριση Περιόδων",
    expensesPaidInPeriod: "Πληρωμένα Έξοδα",
    expensesUnpaidInPeriod: "Απλήρωτα Έξοδα",
    elevatorExpensesInPeriod: "Έξοδα Ανελκυστήρα",
    active: "Ενεργό",
    inactive: "Ανενεργό",
    closed: "Κλειστό",
    closeBuilding: "Κλείσιμο Κτιρίου",
    reopenBuilding: "Επαναλειτουργία Κτιρίου",
    closeDate: "Ημερομηνία Κλεισίματος",
    closeReason: "Λόγος",
    closedOn: "Έκλεισε στις",
    confirmCloseBuilding: "Είστε σίγουροι ότι θέλετε να κλείσετε αυτό το κτίριο; Όλο το ιστορικό θα διατηρηθεί. Δεν θα μπορούν να προστεθούν νέες καταχωρήσεις ή πληρωμές.",
    buildingClosed: "Το κτίριο έκλεισε",
    buildingReopened: "Το κτίριο επαναλειτούργησε",
    closedBuildingBanner: "Αυτό το κτίριο είναι κλειστό. Δεν μπορούν να προστεθούν νέες καταχωρήσεις.",
    reasonClientStopped: "Ο πελάτης σταμάτησε τη συνεργασία",
    reasonPaymentIssues: "Προβλήματα πληρωμής",
    reasonWeStoppedService: "Σταματήσαμε την υπηρεσία",
    reasonBuildingSold: "Πωλήθηκε το κτίριο",
    reasonOther: "Άλλο",
    manageTypes: "Διαχείριση Τύπων",
    addType: "Προσθήκη Τύπου",
    typeName: "Όνομα Τύπου",
    typeNameEn: "Όνομα (Αγγλικά)",
    typeNameEl: "Όνομα (Ελληνικά)",
    typeKey: "Κλειδί",
    typeUsedInRecords: "Ο τύπος χρησιμοποιείται σε εγγραφές και δεν μπορεί να διαγραφεί",
    editType: "Επεξεργασία Τύπου",
    deleteType: "Διαγραφή Τύπου",
    confirmDeleteType: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον τύπο καθαρισμού;",
    typeAdded: "Ο τύπος προστέθηκε",
    typeUpdated: "Ο τύπος ενημερώθηκε",
    typeDeleted: "Ο τύπος διαγράφηκε",
    thresholdDays: "Όριο Ειδοποίησης (ημέρες)",
    actions: "Ενέργειες",
    totalReserveFund: "Συνολικό Αποθεματικό",
    annualReserveFund: "Ετήσιο Αποθεματικό",
    monthlyReserveFund: "Μηνιαίο Αποθεματικό",
    reserveFundCollected: "Αποθεματικό που Εισπράχθηκε",
    reserveFundFromPayments: "Υπολογισμός από πληρωμές",
    collectedReserveFund: "Εισπραγμένο Αποθεματικό",
    basedOnPaidInvoicesOnly: "Βάσει εξοφλημένων τιμολογίων",
    of: "από",
    annualTarget: "Ετήσιος Στόχος",
    reserveFundDeductions: "Αφαιρέσεις αποθεματικού",
    pendingCollection: "Προς Είσπραξη",
    unpaidReservePortion: "Αποθεματικό σε ανεξόφλητα τιμολόγια",
    collectionProgress: "Πρόοδος Είσπραξης",
    monthlyShare: "Μηνιαίο Μερίδιο",
    extraReserveFund: "Έκτακτο Μηνιαίο Αποθεματικό",
    extraReserveMode: "Τρόπος Κατανομής",
    bySharePercentage: "Κατά Ποσοστό (%)",
    fixedPerApartment: "Σταθερό ανά Διαμέρισμα",
    extraReserveMonthly: "Μηνιαίο Σύνολο",
    extraReserveFixed: "Σταθερό Ποσό ανά Διαμέρισμα",
    extraReserveColumn: "Έκτακτο Αποθεματικό",
    combinedMonthlyTotal: "Συνολικό Μηνιαίο (Αποθεματικό + Έκτακτο)",
    stopExtraReserve: "Διακοπή",
    confirmStopExtraReserve: "Διακοπή Έκτακτου Μηνιαίου Αποθεματικού; Τα ιστορικά δεδομένα διατηρούνται.",
    extraReserveStopped: "Το Έκτακτο Αποθεματικό διακόπηκε",
    activeVersion: "Ενεργή Έκδοση",
    ongoing: "ενεργό",
    generateExtraReserveInvoices: "Δημιουργία Μηνιαίων Τιμολογίων",
    extraReserveInvoicesGenerated: "Τα μηνιαία τιμολόγια δημιουργήθηκαν (περιλαμβάνουν έκτακτο αποθεματικό)",
    extraReserveIncluded: "Το έκτακτο αποθεματικό περιλαμβάνεται στο τιμολόγιο κοινοχρήστων",
    selectPeriod: "Επιλογή Περιόδου",
    historyUsedInInvoices: "Αυτή η εγγραφή χρησιμοποιείται σε τιμολόγια",
    confirmDeleteUsedHistory: "Αυτή η εγγραφή χρησιμοποιείται σε {count} τιμολόγιο/-α. Η διαγραφή μπορεί να επηρεάσει τις οικονομικές αναφορές. Διαγραφή ούτως ή άλλως;",
    reserveAmountLabel: "Αποθεματικό",
    extraReserve: "Έκτακτο Αποθεματικό",
    totalAdded: "Σύνολο",
    buildingFundsOnlyHint: "Οι πληρωμές επισκευών χρησιμοποιούν τα Ταμειακά/Τραπεζικά Έσοδα της πολυκατοικίας — ποτέ εταιρικούς λογαριασμούς.",
    cashReceiptsBuilding: "Ταμειακά Έσοδα (Πολυκατοικία)",
    bankReceiptsBuilding: "Τραπεζικά Έσοδα (Πολυκατοικία)",
    categoryRequired: "Απαιτείται κατηγορία",
    vendorRequired: "Απαιτείται προμηθευτής",
    selectRepair: "Επιλογή Επισκευής",
    selectRepairToPay: "Επιλέξτε την επισκευή στην οποία αντιστοιχεί η πληρωμή",
    repairPaymentPickerHint: "Εμφανίζονται μόνο ενεργές επισκευές με υπόλοιπο. Συνεχίστε για να καταχωρήσετε την πληρωμή.",
    rcpNo: "Αρ. Απόδειξης",
    charge: "Χρέωση",
    balance: "Υπόλοιπο",
    reserveFund: "Αποθεματικό",
    reserveFundManual: "Χειροκίνητο",
    reserveFundAuto: "Αυτόματο",
    recalculate: "Επανυπολογισμός",
    resetToAuto: "Επαναφορά σε Αυτόματο",
    reserveFundUpdated: "Το αποθεματικό ενημερώθηκε",
    reserveFundRecalculated: "Το αποθεματικό επανυπολογίστηκε",
    reserveFundDistributed: "Το αποθεματικό αποθηκεύτηκε και κατανεμήθηκε",
    repairsFundDistributed: "Το ταμείο επισκευών αποθηκεύτηκε και κατανεμήθηκε",
    saveAndDistribute: "Αποθήκευση & Κατανομή",
    saveAsNewVersion: "Αποθήκευση ως Νέα Έκδοση",
    confirmDeleteHistoryEntry: "Διαγραφή αυτής της καταχώρησης ιστορικού;",
    history: "Ιστορικό",
    saveDistributesAuto: "Η αποθήκευση κατανέμει αυτόματα στα αυτόματα διαμερίσματα",
    annualExpenses: "Ετήσια Έξοδα",
    annualAmount: "Ετήσιο Ποσό",
    actual: "Πραγματικά",
    distributionPerApartment: "Κατανομή ανά Διαμέρισμα",
    repairAmount: "Ποσό Επισκευής",
    allocatedAmount: "Κατανεμημένο Ποσό",
    recalculateByPercentages: "Επανυπολογισμός με %",
    recalculatedByPercentages: "Τα ποσά επανυπολογίστηκαν από τα ποσοστά",
    zeroAmountNotAllowed: "Το ποσό πρέπει να είναι μεγαλύτερο από 0 για το",
    allocationSumMustEqualTotal: "Το σύνολο των κατανομών πρέπει να ισούται με το ποσό της επισκευής",
    editExpenses: "Επεξεργασία Εξόδων",
    mode: "Λειτουργία",
    operationalExpenses: "Λειτουργικά Έξοδα",
    operationalTotal: "Λειτουργικό Σύνολο",
    oneTime: "Εφάπαξ",
    monthly: "Μηνιαίο",
    onlyOperationalDistributed: "Μόνο τα λειτουργικά (μηνιαία) έξοδα κατανέμονται στα διαμερίσματα. Τα κεφαλαιουχικά έξοδα (επισκευές, εφάπαξ) παρακολουθούνται ξεχωριστά.",
    autoFilledFrom: "Τα ποσά συμπληρώθηκαν αυτόματα από το έτος",
    type: "Τύπος",
    monthlyTotal: "Μηνιαίο Σύνολο",
    monthlyTotalDesc: "Μηνιαία κοινόχρηστα ανά διαμέρισμα (Ετήσια Λειτουργικά / 12)",
    includeInCalc: "Περιλαμβάνεται",
    alwaysIncluded: "πάντα",
    onlyIncluded: "μόνο επιλεγμένες κατηγορίες",
    distributionSource: "Πηγή Κατανομής",
    distributionSourceDesc: "Επιλέξτε ποια πηγή δεδομένων καθορίζει το Λειτουργικό Σύνολο, το Μηνιαίο Σύνολο και την κατανομή ανά διαμέρισμα.",
    actualExpenses: "Πραγματικά Έξοδα",
    annualBudget: "Ετήσιος Προϋπολογισμός",
    source: "Πηγή",
    includedCategories: "Επιλεγμένες Κατηγορίες",
    includedCategoriesDesc: "Επιλέξτε ποιες κατηγορίες συμμετέχουν στο Λειτουργικό Σύνολο, Μηνιαίο Σύνολο και κατανομή ανά διαμέρισμα.",
    categoriesSelected: "κατηγορίες",
    selectCategories: "Επιλογή κατηγοριών",
    selectAll: "Επιλογή όλων",
    selectNone: "Καθαρισμός",
    budget: "Προϋπολογισμός",
    monthlyActual: "Μηνιαίο (Πραγματικό)",
    monthlyBudget: "Μηνιαίο (Προϋπ.)",
    totalActual: "Σύνολο (Πραγματικό)",
    actualTotalDivided: "Πραγματικό / 12",
    monthlyTotalDescActual: "Μέσο μηνιαίο έξοδο = Πραγματικό / 12",
    monthlyBase: "Μηνιαία Βάση",
    totalRounded: "Σύνολο (Στρογγυλό)",
    roundedDivided: "Στρογγυλό / 12",
    monthlyTotalDescRounded: "Μέσο μηνιαίο έξοδο = Στρογγυλοποιημένο Πραγματικό / 12",
    original: "Αρχικό",
    autoCalculated: "Αυτόματος Υπολογισμός",
    finalMonthly: "Τελικό Μηνιαίο",
    monthlyPerApartment: "Μηνιαίο τέλος ανά διαμέρισμα (βάσει ποσοστού %)",
    monthlyAmount: "Μηνιαίο Ποσό",
    loadFromExpenses: "Φόρτωση από Έξοδα",
    loadedFromExpenses: "Φορτώθηκαν από τα έξοδα του κτιρίου",
    entries: "εγγραφές",
    automatic: "Αυτόμ.",
    reserveFundHistory: "Ιστορικό Αποθεματικού",
    reserveFundTransactions: "Κινήσεις Αποθεματικού",
    share: "Μερίδιο",
    totalDistributed: "Σύνολο Κατανομής",
    reserveFundWarning: "Αναντιστοιχία κατανομής αποθεματικού",
    notCleanedThisMonth: "Δεν καθαρίστηκε αυτόν τον μήνα",
    paymentSource: "Πηγή Πληρωμής",
    cashBalance: "Υπόλοιπο Μετρητών",
    bankBalance: "Υπόλοιπο Τράπεζας",
    reserveFundBalance: "Υπόλοιπο Αποθεματικού",
    cash: "Μετρητά",
    bank: "Τράπεζα",
    credit: "Πίστωση",
    fundBalances: "Υπόλοιπα Ταμείων",
    insufficientBalance: "Ανεπαρκές υπόλοιπο",
    fundTransactions: "Συναλλαγές Ταμείων",
    setBalances: "Ορισμός Υπολοίπων",
    balanceSaved: "Το υπόλοιπο αποθηκεύτηκε",
    outstandingExpenses: "Οφειλόμενα",
    unpaidLeaveOpen: "Απλήρωτο (ανοιχτό)",
    paymentSourceHint: "Επιλέξτε πηγή για άμεση πληρωμή ή αφήστε ως Απλήρωτο",
    recurringMonthlyExpense: "Επαναλαμβανόμενο Μηνιαίο Έξοδο",
    recurringExpenses: "Επαναλαμβανόμενα Έξοδα",
    addRecurringExpense: "Προσθήκη Επαναλαμβανόμενου",
    editRecurringExpense: "Επεξεργασία Επαναλαμβανόμενου",
    noRecurringExpenses: "Δεν υπάρχουν επαναλαμβανόμενα έξοδα",
    recurringExpenseHint: "Δημιουργείται αυτόματα κάθε μήνα την καθορισμένη ημέρα",
    generatedOnDay: "Δημιουργία την ημέρα",
    recurringDay: "Ημέρα μήνα",
    recurringDayHint: "Η χρέωση θα δημιουργείται αυτόματα αυτή την ημέρα κάθε μήνα",
    expenseCreatedUnpaid: "Το έξοδο θα δημιουργηθεί ως απλήρωτο. Χρησιμοποιήστε 'Προσθήκη Πληρωμής' για καταγραφή πληρωμών.",
    paidFromReserveFund: "Πληρωμή από Αποθεματικό Κεφάλαιο",
    deductFromReserveFund: "Αφαίρεση από Αποθεματικό Κεφάλαιο",
    // Phase 708 — Reserve Fund Deduction structured fields (EL)
    reserveFundDeduction: "Αφαίρεση από Αποθεματικό",
    amountDeducted: "Ποσό Αφαίρεσης",
    coveredByAnnualBudget: "Καλύφθηκε από Ετήσιο Προϋπολογισμό",
    deductFromReserveFund: "Αφαίρεση από Αποθεματικό",
    reason: "Αιτία",
    selectReason: "Επιλέξτε αιτία…",
    referenceOptional: "Αναφορά (προαιρετικό)",
    rfDescriptionPlaceholder: "π.χ. Ο λογαριασμός ρεύματος υπερέβη τον ετήσιο προϋπολογισμό κατά €200",
    rfReferencePlaceholder: "π.χ. ΑΗΚ Τιμολόγιο 24/06/2025",
    rfReason_UnexpectedExpense: "Απρόβλεπτο Έξοδο",
    rfReason_AnnualBudgetAdjustment: "Προσαρμογή Ετήσιου Προϋπολογισμού",
    rfReason_EmergencyRepair: "Επείγουσα Επιδιόρθωση",
    rfReason_MajorRepair: "Μεγάλη Επιδιόρθωση",
    rfReason_CapitalImprovement: "Κεφαλαιακή Βελτίωση",
    rfReason_InsuranceExcess: "Υπέρβαση Ασφάλισης",
    rfReason_UtilityCostDifference: "Διαφορά Κοινόχρηστων",
    rfReason_Legacyentry: "Παλαιά εγγραφή",
    rfReason_Other: "Άλλο",
    available: "διαθέσιμο",
    requested: "ζητήθηκε",
    englishName: "Αγγλικό Όνομα",
    greekName: "Ελληνικό Όνομα",
    optionalFallbackToEnglish: "Προαιρετικό — χρησιμοποιεί Αγγλικά αν λείπει",
    incomeOnly: "μόνο από έσοδα",
    percent: "%",
    totalDeductions: "Σύνολο Κρατήσεων",
    clickForBreakdown: "Κάντε κλικ για ανάλυση",
    mustMatchTopMetric: "πρέπει να ταιριάζει με την κορυφαία μετρική",
    addNotesOptional: "Προσθέστε σημειώσεις (προαιρετικό)",
    selectCategoryToSeeHistory: "Επιλέξτε μια κατηγορία για να δείτε το ιστορικό εξόδων.",
    expenseHistory: "Ιστορικό Εξόδων",
    entry: "εγγραφή",
    // Phase 86 — Suppliers / Purchases
    purchases: "Αγορές",
    suppliers: "Εταιρείες",
    suppliersDesc: "Παρακολουθήστε εφάπαξ αγορές και τρέχοντα υπόλοιπα προμηθευτών.",
    addSupplier: "Νέα Εταιρεία",
    editSupplier: "Επεξεργασία Εταιρείας",
    supplierType: "Τύπος",
    oneTimeType: "Εφάπαξ",
    statementType: "Καθολικό",
    oneTimeTypeLabel: "Εφάπαξ Αγορά (απλό έξοδο)",
    statementTypeLabel: "Καθολικό (τρέχον υπόλοιπο)",
    oneTimeSupplierDesc: "Γρήγορες αγορές χωρίς τρέχον υπόλοιπο.",
    statementSupplierDesc: "Παρακολουθεί τιμολόγια και πληρωμές με τρέχον υπόλοιπο προμηθευτή.",
    noSuppliers: "Δεν υπάρχουν εταιρείες",
    selectSupplier: "Επιλέξτε μια εταιρεία για λεπτομέρειες.",
    outstandingBalance: "Εκκρεμές Υπόλοιπο",
    totalPurchases: "Σύνολο Αγορών",
    invoicesLabel: "Τιμολόγια",
    paymentsLabel: "Πληρωμές",
    addPurchase: "Νέα Αγορά",
    editPurchase: "Επεξεργασία Αγοράς",
    noPurchases: "Δεν υπάρχουν αγορές",
    addInvoice: "Νέο Τιμολόγιο",
    editInvoice: "Επεξεργασία Τιμολογίου",
    noInvoices: "Δεν υπάρχουν τιμολόγια",
    invoiceNumber: "Αρ. Τιμολογίου",
    invoice: "Τιμολόγιο",
    addPayment: "Νέα Πληρωμή",
    editPayment: "Επεξεργασία Πληρωμής",
    noPayments: "Δεν υπάρχουν πληρωμές",
    noTransactions: "Δεν υπάρχουν συναλλαγές",
    paymentMethod: "Τρόπος Πληρωμής",
    bankAccount: "Τραπεζικός Λογαριασμός",
    autoCalc: "αυτόματα",
    legacyOneTimeSupplierNotice: "Αυτός ο προμηθευτής δημιουργήθηκε με τον παλιό τύπο \"Εφάπαξ\". Καταγράψτε νέες αγορές στα Έξοδα με κατηγορία· αυτή η εγγραφή είναι μόνο για ανάγνωση.",
    categoryRequired: "Παρακαλώ επιλέξτε κατηγορία για αυτό το έξοδο.",
    optionalShort: "Προαιρετικό",
    expensesListDesc: "Αυτόνομες εφάπαξ αγορές με κατηγορίες, ΦΠΑ και τρόπο πληρωμής.",
    bankExpenseReflectionNote: "Σημείωση: οι εγγραφές εξόδων είναι αντανακλάσεις από Αγορές → Έξοδα. Επεξεργαστείτε ή διαγράψτε τις μόνο από τη σελίδα Έξοδα.",
    openingBalanceTopTooltip: "Άθροισμα μόνο των αρχικών υπολοίπων τραπεζικών λογαριασμών (χωρίς μετρητά, ΦΠΑ, κρατήσεις).",
    totalIncomeTopTooltip: "Μόνο τραπεζικά έσοδα. Τα μετρητά παρακολουθούνται ξεχωριστά στο Bank Accounts → Cash.",
    banksOnly: "μόνο τράπεζες",
    finalBalanceTopTooltip: "Αρχικό Υπόλοιπο + Έσοδα − Έξοδα. Ταιριάζει με το τρέχον υπόλοιπο στο κάτω μέρος κάθε κατάστασης τράπεζας/μετρητών.",
    purchaseCategories: "Κατηγορίες Αγορών",
    purchaseCategoriesDesc: "Ανεξάρτητες κατηγορίες για Αγορές → Έξοδα. Δεν μοιράζονται με τις κατηγορίες εξόδων του Finance.",
    noPurchaseCategories: "Δεν υπάρχουν κατηγορίες αγορών. Προσθέστε μία για να ξεκινήσετε.",
    noPurchaseCategoriesHint: "Προσθέστε πρώτα μια κατηγορία αγορών (Αγορές → Κατηγορίες Αγορών).",
    usage: "Χρήση",
    payments: "Πληρωμές",
    addPayment: "Προσθήκη Πληρωμής",
    editPayment: "Επεξεργασία Πληρωμής",
    noPayments: "Δεν έχουν καταχωρηθεί πληρωμές.",
    categoryOrSupplier: "Κατηγορία ή Προμηθευτής",
    selectCategoryOrSupplier: "Επιλέξτε κατηγορία ή προμηθευτή",
    categoryOrSupplierRequired: "Απαιτείται Κατηγορία ή Προμηθευτής",
    asOf: "έως",
    noExpenseCategoriesHint: "Προσθέστε πρώτα μια κατηγορία εξόδων (Finance → Κατηγορίες Εξόδων).",
    viewInFinance: "Προβολή στο Finance",
    cascadeDeleteTitle: "Βρέθηκαν συσχετισμένα αρχεία",
    cascadeDeleteConfirm: "Διαγραφή Όλων",
    bucket: "Κάδος",
    bucketHelp: "Προαιρετικά — συνδέστε αυτή την κατηγορία με έναν κάδο κατανομής (ΦΠΑ, 12,5%, Αποθεματικό, Κοιν. Ασφάλιση). Οι πληρωμές θα μειώνουν το διαθέσιμο υπόλοιπο του κάδου.",
    none: "Κανένα",
    availableBalance: "Διαθέσιμο Υπόλοιπο",
    afterPayment: "Μετά την πληρωμή",
    exceedsBalance: "Υπερβαίνει το διαθέσιμο υπόλοιπο",
    exceedsBalanceTitle: "Η πληρωμή υπερβαίνει το διαθέσιμο υπόλοιπο",
    paymentAmount: "Ποσό Πληρωμής",
    overdraftBy: "Υπέρβαση κατά",
    proceedAnyway: "Συνέχεια παρ' όλα αυτά",
    amountMustBePositive: "Το ποσό πρέπει να είναι θετικό",
    allocation: "Κατανομή",
    official: "Επίσημο",
    internal: "Εσωτερικό",
    totalAllocated: "Κατανεμημένα",
    totalPaid: "Πληρωμένα",
    noEntries: "Δεν υπάρχουν ακόμα εγγραφές.",
    type: "Τύπος",
    reference: "Αναφορά",
    vatPaid: "Πληρωμένο ΦΠΑ",
    vatPaidDesc: "Εισερχόμενος ΦΠΑ — συνολικός ΦΠΑ που έχετε πληρώσει μέσω Τιμολογίων Προμηθευτών και αυτόνομων Εξόδων. Ο ΦΠΑ εσόδων εξαιρείται.",
    vatFromSuppliers: "ΦΠΑ από Προμηθευτές",
    vatFromExpenses: "ΦΠΑ από Έξοδα",
    totalVatPaid: "Σύνολο Πληρωμένου ΦΠΑ",
    suppliersVat: "ΦΠΑ Προμηθευτών",
    expensesVat: "ΦΠΑ Εξόδων",
    invoices: "τιμολόγια",
    invoice: "Τιμολόγιο",
    noVatEntries: "Δεν υπάρχουν εγγραφές ΦΠΑ σε αυτή την περίοδο.",

    suppliersOutstandingBalances: "Ανοιχτά Υπόλοιπα Προμηθευτών",
    suppliersOutstandingDesc: "Προμηθευτές στους οποίους οφείλετε χρήματα, ταξινομημένοι από το μεγαλύτερο υπόλοιπο. Κάντε κλικ σε μια γραμμή για να ανοίξετε το καθολικό.",
    supplierName: "Όνομα Εταιρείας",
    totalInvoices: "Σύνολο Τιμολογίων",
    totalPaid: "Σύνολο Πληρωμών",
    totalOwed: "Σύνολο Οφειλών",
    allSuppliersPaid: "Όλοι οι προμηθευτές εξοφλημένοι",
    allSuppliersPaidDesc: "Κάθε καθολικό προμηθευτή έχει μηδενικό ή αρνητικό υπόλοιπο — δεν υπάρχει εκκρεμότητα.",
    received: "Εισπράχθηκαν",
    viewDetails: "Λεπτομέρειες",
    pdfStatement: "Κατάσταση PDF",
    exportPdf: "Εξαγωγή PDF",
    exportExcel: "Εξαγωγή Excel",
    exportExpenses: "Εξαγωγή Εξόδων",
    exportFormat: "Μορφή",
    expExportDateFrom: "Από Ημερομηνία",
    expExportDateTo: "Έως Ημερομηνία",
    expExportType: "Τύπος Εξόδου",
    allTypes: "Όλοι οι Τύποι",
    pdfExported: "Το PDF εξήχθη επιτυχώς",
    leaveDatesEmpty: "Αφήστε τις ημερομηνίες κενές για να συμπεριληφθούν όλα τα τιμολόγια",
    selectBuilding: "Επιλέξτε Κτίριο",
    manageBuildings: "Διαχείριση Κτιρίων",
    managedBuildings: "Κτίρια (Διαχείριση)",
    cleaningClients: "Πελάτες Καθαρισμού",
    menu: "Μενού",
    manageCategories: "Διαχείριση Κατηγοριών",
    addCategory: "Προσθήκη Νέας Κατηγορίας",
    categoryName: "Όνομα Κατηγορίας",
    statementsComingSoon: "Η δημιουργία καταστάσεων θα είναι σύντομα διαθέσιμη",
    totalApartments: "Σύνολο Διαμερισμάτων",
    assignedCompany: "Εκχωρημένη Εταιρεία",
    noCompanyAssigned: "Δεν έχει εκχωρηθεί εταιρεία",
    noCompany: "Καμία εταιρεία",
    editCompany: "Επεξεργασία Εταιρείας",
    deleteCompany: "Διαγραφή Εταιρείας",
    noCompanies: "Δεν υπάρχουν εταιρείες",
    accountStatement: "Κατάσταση Λογαριασμού",
    saveStatement: "Αποθήκευση Κατάστασης",
    savedStatements: "Αποθηκευμένες Καταστάσεις",
    statementNotes: "Σημειώσεις Κατάστασης",
    statementNotesPlaceholder: "Εσωτερικές σημειώσεις για αυτό το διαμέρισμα (δεν είναι ορατές στον πελάτη)...",
    statementNotesHint: "Αυτές οι σημειώσεις είναι μόνο για εσωτερική χρήση και δεν εμφανίζονται στις καταστάσεις πελατών.",
    statementSaved: "Η κατάσταση αποθηκεύτηκε",
    totalRepairsFund: "Επισκευές",
    addRepair: "Προσθήκη Επισκευής",
    editRepair: "Επεξεργασία Επισκευής",
    deleteRepair: "Διαγραφή Επισκευής",
    deleteRepairConfirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την εγγραφή επισκευής;",
    repairsHistoryDesc: "Κάθε επισκευή παρακολουθείται ξεχωριστά με περίοδο πληρωμής",
    activeRepairsTotal: "Σύνολο Ενεργών Επισκευών",
    noRepairs: "Δεν υπάρχουν εγγραφές επισκευών",
    generateInvoices: "Δημιουργία Τιμολογίων",
    generateInvoicesAndCreate: "Δημιουργία & Τιμολόγηση",
    invoicesGenerated: "Τιμολογημένο",
    invoicesNotGenerated: "Χωρίς Τιμολόγια",
    repairInvoicesCreated: "Τα τιμολόγια επισκευής δημιουργήθηκαν επιτυχώς",
    invoicesAlreadyGenerated: "Τα τιμολόγια έχουν ήδη δημιουργηθεί για αυτή την επισκευή",
    repairLabel: "Επισκευή",
    markClosed: "Κλείσιμο",
    markActive: "Επαναφορά",
    closeRepair: "Κλείσιμο επισκευής",
    reopenRepair: "Επαναφορά επισκευής",
    close: "Κλείσιμο",
    reopen: "Επαναφορά",
    repairDescPlaceholder: "π.χ. Στεγανοποίηση οροφής, Αντικατάσταση σωλήνα",
    repairsCost: "Επισκευές",
    allPeriods: "Όλες οι Περίοδοι",
    // Meetings
    documents: "Έγγραφα",
    meetings: "Συνελεύσεις",
    meetingMinutes: "Πρακτικά Συνέλευσης",
    newMeeting: "Νέα Συνέλευση",
    editMeeting: "Επεξεργασία Συνέλευσης",
    meetingType: "Τύπος Συνέλευσης",
    agm: "Ετήσια Γενική Συνέλευση",
    extraordinary: "Έκτακτη Συνέλευση",
    committeeMeeting: "Συνεδρίαση Επιτροπής",
    meetingDate: "Ημερομηνία",
    meetingTime: "Ώρα",
    meetingLocation: "Τόπος",
    nextMeetingDate: "Επόμενη Ημ/νία Συνέλευσης",
    nextMeetingTime: "Επόμενη Ώρα Συνέλευσης",
    nextMeetingHint: "Χρησιμοποιείται αυτόματα όταν δεν υπάρχει απαρτία. Εμφανίζεται και στο Ημερολόγιο.",
    sendForApproval: "Αποστολή για Έγκριση",
    optional: "προαιρετικό",
    attendance: "Παρουσίες",
    presentAbsent: "Παρών / Απών / Εκπροσωπείται",
    present: "Παρών",
    represented: "Εκπροσωπείται",
    representedByPlaceholder: "Εκπροσωπείται από...",
    absent: "Απών",
    quorum: "Απαρτία",
    quorumReached: "Επιτεύχθηκε Απαρτία",
    quorumNotReached: "Δεν Επιτεύχθηκε Απαρτία",
    endTime: "Ώρα Λήξης",
    duration: "Διάρκεια",
    totalParticipants: "Σύνολο Συμμετεχόντων",
    totalPresent: "Σύνολο Παρόντων",
    totalAbsent: "Σύνολο Απόντων",
    attendanceRate: "Ποσοστό Παρουσίας",
    autoGeneratedTexts: "Αυτόματα Κείμενα",
    generateTexts: "Δημιουργία Κειμένων",
    quorumDurationText: "Παράγραφος Απαρτίας & Διάρκειας",
    legalQuorumText: "Νομικό Κείμενο Απαρτίας",
    committeeDecisionText: "Κείμενο Απόφασης Επιτροπής",
    topicsDecisions: "Θέματα & Αποφάσεις",
    addTopic: "Προσθήκη Θέματος",
    topicTitle: "Τίτλος Θέματος",
    topicDecision: "Απόφαση / Σημειώσεις",
    financialSnapshot: "Οικονομική Κατάσταση",
    refreshSnapshot: "Ανανέωση Στιγμιοτύπου",
    snapshotCapturedAt: "Στιγμιότυπο ελήφθη στις",
    generateMinutes: "Δημιουργία Πρακτικών",
    exportPdf: "Εξαγωγή PDF",
    attachments: "Συνημμένα",
    attachFiles: "Επισύναψη Αρχείων",
    attachmentUploadFailed: "Κάποια αρχεία δεν μεταφορτώθηκαν",
    uploadFile: "Μεταφόρτωση Αρχείου",
    noMeetings: "Δεν υπάρχουν καταγεγραμμένες συνελεύσεις",
    meetingCreated: "Η συνέλευση δημιουργήθηκε επιτυχώς",
    meetingUpdated: "Η συνέλευση ενημερώθηκε επιτυχώς",
    includeFinancialSummary: "Συμπερίληψη Οικονομικής Κατάστασης στο έγγραφο",
    includeFinancialSummaryHint: "Απενεργοποιημένο προεπιλεγμένα· ενεργοποιήστε μόνο όταν θέλετε να εμφανίζεται στο PDF.",
    meetingDeleted: "Η συνέλευση διαγράφηκε επιτυχώς",
    deleteMeeting: "Διαγραφή Συνέλευσης",
    deleteMeetingConfirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συνέλευση;",
    draft: "Πρόχειρο",
    finalized: "Οριστικοποιημένο",
    finalizeMeeting: "Οριστικοποίηση",
    viewMeeting: "Προβολή Συνέλευσης",
    backToList: "Πίσω στη Λίστα",
    generalInfo: "Γενικές Πληροφορίες",
    totalExpectedIncome: "Αναμενόμενα Έσοδα",
    totalCollected: "Εισπραχθέντα",
    totalOutstanding: "Υπόλοιπο",
    cashBalance: "Υπόλοιπο Μετρητών",
    bankBalance: "Υπόλοιπο Τράπεζας",
    repairsTotal: "Σύνολο Επισκευών",
    noTopics: "Δεν υπάρχουν θέματα",
    topicPlaceholder: "π.χ. Εκλογή Επιτροπής, Ασφάλεια Κτιρίου...",
    selectTopic: "-- Επιλογή Θέματος --",
    customTopic: "Προσαρμοσμένο θέμα (πληκτρολόγηση)",
    decisionPlaceholder: "Απόφαση ή σημειώσεις για αυτό το θέμα...",
    selectPredefinedTopic: "-- Επιλογή θέματος --",
    topicFireExtinguishers: "Πυροσβεστήρες",
    topicElectionCommittee: "Εκλογή Διαχειριστικής Επιτροπής",
    topicFinancialStatus: "Οικονομική Κατάσταση Κτιρίου",
    topicIncreaseExpenses: "Αύξηση Κοινοχρήστων",
    topicBuildingRepairs: "Επισκευές Κτιρίου",
    topicBuildingSafety: "Ασφάλεια Κτιρίου",
    topicElectricalIssues: "Ηλεκτρολογικά Θέματα",
    topicBankSignatureChanges: "Αλλαγή Τραπεζικών Υπογραφών",
    signatures: "Υπογραφές",
    president: "Πρόεδρος",
    secretary: "Γραμματέας",
    treasurer: "Ταμίας",
    meetingOf: "Συνέλευση της",
    // Topic Categories & Agenda Templates
    topicCategories: "Κατηγορίες Θεμάτων",
    agendaTemplates: "Πρότυπα Ημερήσιας Διάταξης",
    addTopicCategory: "Προσθήκη Κατηγορίας",
    editCategory: "Επεξεργασία Κατηγορίας",
    deleteTopicCategory: "Διαγραφή Κατηγορίας",
    confirmDeleteCategory: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την κατηγορία θέματος;",
    noTopicCategories: "Δεν υπάρχουν κατηγορίες θεμάτων",
    nameEn: "Όνομα (Αγγλικά)",
    nameEl: "Όνομα (Ελληνικά)",
    addTemplate: "Προσθήκη Προτύπου",
    templates: "Πρότυπα",
    editTemplate: "Επεξεργασία Προτύπου",
    deleteTemplate: "Διαγραφή Προτύπου",
    confirmDeleteTemplate: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το πρότυπο;",
    noTemplates: "Δεν υπάρχουν πρότυπα ημερήσιας διάταξης",
    templateName: "Όνομα Προτύπου",
    topicCount: "Θέματα",
    topicTitleEn: "Τίτλος Θέματος (EN)",
    topicTitleEl: "Τίτλος Θέματος (EL)",
    selectCategory: "Επιλογή Κατηγορίας",
    loadFromTemplate: "Φόρτωση από Πρότυπο",
    applyTemplate: "Εφαρμογή Προτύπου",
    templateApplied: "Το πρότυπο εφαρμόστηκε",
    confirmReplaceTopics: "Εφαρμογή αυτού του προτύπου; Τα τρέχοντα θέματα θα ΑΝΤΙΚΑΤΑΣΤΑΘΟΥΝ.",
    pickTemplatePrompt: "Επιλέξτε ένα πρότυπο αριστερά για προεπισκόπηση των θεμάτων του.",
    selectTemplate: "-- Επιλογή προτύπου ημερήσιας διάταξης --",
    // Credit Notes & Auto Invoicing
    createCreditNote: "Δημιουργία Πιστωτικού",
    creditNoteCreated: "Το πιστωτικό δημιουργήθηκε επιτυχώς",
    creditNotePlaceholder: "π.χ. Διόρθωση υπερχρέωσης, Έκπτωση...",
    creditNotes: "Πιστωτικά",
    creditNote: "Πιστωτικό Σημείωμα",
    creditNoteNumber: "Πιστωτικό #",
    creditNotesApplied: "Εφαρμόστηκαν Πιστωτικά",
    editCreditNote: "Επεξεργασία Πιστωτικού",
    creditNoteUpdated: "Το πιστωτικό ενημερώθηκε επιτυχώς",
    creditNoteDeleted: "Το πιστωτικό διαγράφηκε",
    noCreditNotes: "Δεν βρέθηκαν πιστωτικά",
    // Phase 659 — Πιστωτικά Σημειώματα Προμηθευτή
    addCreditNote: "Καταχώρηση Πιστωτικού",
    recordCreditNote: "Καταχώρηση Πιστωτικού Προμηθευτή",
    creditNotesTab: "Πιστωτικά",
    deleteCreditNote: "Διαγραφή Πιστωτικού",
    deleteCreditNoteConfirm: "Είστε σίγουρος ότι θέλετε να διαγράψετε αυτό το πιστωτικό; Το ποσό θα προστεθεί ξανά στο υπόλοιπο του προμηθευτή.",
    creditNoteNumberRequired: "Ο αριθμός Πιστωτικού είναι υποχρεωτικός",
    supplierRequired: "Ο προμηθευτής είναι υποχρεωτικός",
    supplierCnPlaceholder: "Αρ. Πιστωτικού προμηθευτή",
    relatedInvoice: "Σχετικό Τιμολόγιο",
    relatedInvoiceOptional: "Σχετικό Τιμολόγιο (προαιρετικό)",
    noneCreatesOpenCredit: "— Κανένα (ανοιχτή πίστωση) —",
    amountExclVat: "Ποσό (χωρίς ΦΠΑ)",
    record: "Καταχώρηση",
    // Phase 661 — Πεδία αναζήτησης
    searchPlaceholderCn: "Αναζήτηση: αριθμός, τιμολόγιο, σημειώσεις, ημ/νία...",
    searchPlaceholderInvoices: "Αναζήτηση: αριθμός, περιγραφή, ημ/νία...",
    searchPlaceholderPayments: "Αναζήτηση: αρ. πληρωμής, τιμολόγιο, αναφορά, πηγή...",
    noMatchesForSearch: "Δεν βρέθηκαν αποτελέσματα",
    onlyUnpaidShown: "Εμφανίζονται μόνο ανεξόφλητα / μερικώς εξοφλημένα τιμολόγια.",
    // Phase 662 — Πολλαπλή κατανομή + Αυτόματος ΦΠΑ
    autoCalculateVat: "Αυτόματος υπολογισμός ΦΠΑ",
    vatRate: "Συντελεστής ΦΠΑ",
    totalAmount: "Συνολικό Ποσό",
    netAmount: "Καθαρό",
    manual: "χειροκίνητα",
    allocateToInvoices: "Κατανομή σε Τιμολόγια (προαιρετικό)",
    addAllocation: "Προσθήκη Κατανομής",
    selectInvoice: "— Επιλογή τιμολογίου —",
    allocated: "Κατανεμημένο",
    allocationsExceedTotal: "Οι κατανομές υπερβαίνουν το ποσό του πιστωτικού",
    creditNoteAmountRequired: "Το ποσό πρέπει να είναι μεγαλύτερο από μηδέν",
    remove: "Αφαίρεση",
    // Phase 663 — Ετικέτα Statement για τη νέα γραμμή Πιστωτικού
    creditNoteSalesReturn: "Πιστωτικό / Επιστροφή Πωλήσεων",
    // Phase 665 — Διαχωρισμός Μηνιαίας Συντήρησης από άλλες χρεώσεις
    otherExtraCharges: "Λοιπές Επιπρόσθετες Χρεώσεις",
    noMaintenanceCharges: "Δεν υπάρχουν μηνιαίες χρεώσεις συντήρησης στην επιλεγμένη περίοδο.",
    noOtherExtraCharges: "Δεν υπάρχουν λοιπές επιπρόσθετες χρεώσεις στην επιλεγμένη περίοδο.",
    linkedInvoice: "Συνδεδεμένο Τιμολόγιο",
    autoInvoicing: "Αυτόματη Τιμολόγηση",
    autoInvoicingDesc: "Αυτόματη δημιουργία τιμολογίων την 1η κάθε μήνα για όλα τα διαμερίσματα",
    recurringInvoices: "Επαναλαμβανόμενα Τιμολόγια",
    recurringInvoicesDesc: "Ρύθμιση αυτόματης μηνιαίας δημιουργίας τιμολογίων",
    createInvoice: "Δημιουργία Τιμολογίου",
    editInvoice: "Επεξεργασία Τιμολογίου",
    deleteInvoiceWarning: "Αυτό το τιμολόγιο θα διαγραφεί. Αν έχει πληρωμές, θα αρχειοθετηθεί",
    invoiceHasPayments: "Αυτό το τιμολόγιο έχει πληρωμές",
    addRule: "Προσθήκη Κανόνα",
    editRule: "Επεξεργασία Κανόνα",
    dayOfMonth: "Ημέρα Μήνα",
    autoGenerated: "Αυτόματη δημιουργία",
    paymentNumber: "Αρ. Πληρωμής",
    balanceBroughtForward: "Υπόλοιπο Μεταφοράς",
    broughtForward: "Μετ.",
    openingBalance: "Αρχικό Υπόλοιπο",
    openingBankBalance: "Αρχικό Υπόλοιπο Τράπεζας",
    openingCashBalance: "Αρχικό Υπόλοιπο Ταμείου",
    totalOpeningBalance: "Συνολικό Αρχικό Υπόλοιπο",
    openingBalanceHint: "Μεταφορά από το προηγούμενο λογιστικό σύστημα. Εμφανίζεται ως πρώτη γραμμή στην κατάσταση του προμηθευτή.",
    debitOwed: "Χρεωστικό (οφείλουμε)",
    creditHeld: "Πιστωτικό (κρατούμε)",
    linkToBillOptional: "Σύνδεση με λογαριασμό (προαιρετικό)",
    possibleDuplicatePayment: "Πιθανή διπλότυπη πληρωμή",
    saveAnyway: "Αποθήκευση ούτως ή άλλως;",
    savedTo: "Αποθηκεύτηκε σε",
    suspectedDuplicate: "Πιθανό Διπλότυπο",
    currentlyViewing: "Προβολή",
    debug: "Debug",
    debugOn: "Debug ΟΝ",
    debugInspector: "Debug Inspector — εμφάνιση raw IDs",
    rowsHiddenByFilters: "γραμμές κρυμμένες από φίλτρα",
    hiddenByDateRange: "από φίλτρο ημερομηνίας",
    hiddenByTypeFilter: "από φίλτρο τύπου εσόδου",
    clearFilters: "Καθαρισμός φίλτρων",
    linkedBank: "Συνδεδεμένη Τράπεζα",
    linkedFinanceDeleted: "Finance Διεγραμμένο",
    linkedFinanceMissing: "Finance Λείπει",
    imported: "Εισήχθη",
    importedFromBankReport: "Εισήχθη από Τραπεζική Κατάσταση",
    manageImportedPayment: "Διαχείριση Εισηγμένης Πληρωμής",
    manageAllocations: "Διαχείριση Κατανομών",
    importedPaymentLockedFields: "Συγχρονισμένο από την Τραπεζική Κατάσταση. Ποσό, ημερομηνία, τραπεζικός λογαριασμός και αναφορά είναι κλειδωμένα. Μπορείτε να αλλάξετε προμηθευτή, σημειώσεις και κατανομές τιμολογίων.",
    totals: "Σύνολα",
    statementPdf: "PDF Κατάστασης",
    downloadStatementPdf: "Λήψη PDF Κατάστασης",
    downloadInvoicePdf: "Λήψη PDF Τιμολογίου",
    downloadReceiptPdf: "Λήψη PDF Απόδειξης",
    downloadMonthlyChargesPdf: "Λήψη PDF Μηνιαίων Χρεώσεων",
    downloadExtraChargesPdf: "Λήψη PDF Πρόσθετων Χρεώσεων",
    exportInvoicesPdf: "Εξαγωγή PDF Τιμολογίων",
    exportInvoices: "Εξαγωγή Τιμολογίων",
    exportPayments: "Εξαγωγή Πληρωμών",
    maintenanceMonth: "Μήνας Συντήρησης",
    monthlyMaintenance: "Μηνιαία Συντήρηση",
    extra: "Πρόσθετη",
    summaryTotalsPdf: "PDF Σύνοψης Συνόλων",
    invoiceNumberSettings: "Ρυθμίσεις Αρίθμησης Τιμολογίου",
    prefix: "Πρόθεμα",
    separator: "Διαχωριστικό",
    digits: "Ψηφία",
    nextNumber: "Επόμενος Αριθμός",
    preview: "Προεπισκόπηση",
    settingsSaved: "Οι ρυθμίσεις αποθηκεύτηκαν",
    invoiceNumberExists: "Αυτός ο αριθμός τιμολογίου υπάρχει ήδη",
    noRecurringRules: "Δεν υπάρχουν επαναλαμβανόμενοι κανόνες",
    generateNow: "Δημιουργία Τώρα",
    sendEmailOnGeneration: "Αποστολή email ειδοποίησης κατά τη δημιουργία τιμολογίου",
    sendByEmail: "Αποστολή μέσω Email",
    recipientEmail: "Email Παραλήπτη",
    recipientEmailPlaceholder: "name@example.com (χωρισμένα με κόμμα για πολλαπλούς)",
    to: "Προς",
    subject: "Θέμα",
    ccPlaceholder: "Παραλήπτες CC (χωρισμένα με κόμμα)",
    bccPlaceholder: "Παραλήπτες BCC (χωρισμένα με κόμμα)",
    emailSubject: "Θέμα",
    emailMessage: "Μήνυμα (προαιρετικό)",
    emailSentSuccess: "Το email στάλθηκε με επιτυχία",
    emailHistory: "Ιστορικό Email",
    viewMessage: "Προβολή Μηνύματος",
    resend: "Επαναποστολή",
    sentBy: "Στάλθηκε από",
    sent: "Στάλθηκε",
    failed: "Απέτυχε",
    sending: "Αποστολή...",
    emailNotConfigured: "Η υπηρεσία email δεν έχει ρυθμιστεί. Προσθέστε κλειδί Brevo.",
    attachment: "Συνημμένο",
    activeFilters: "Ενεργά φίλτρα",
    clearAllFilters: "Καθαρισμός όλων",
    removeFilter: "Αφαίρεση φίλτρου",
    noFiltersApplied: "Χωρίς φίλτρα",
    savedViews: "Αποθηκευμένες Προβολές",
    mySavedViews: "Οι Προβολές μου",
    noSavedViewsYet: "Δεν έχετε ακόμα αποθηκευμένες προβολές",
    saveCurrentView: "Αποθήκευση Τρέχουσας Προβολής",
    updateWithCurrentFilters: "Ενημέρωση με τα Τρέχοντα Φίλτρα",
    renameView: "Μετονομασία",
    deleteView: "Διαγραφή",
    confirmDeleteView: "Διαγραφή αυτής της προβολής;",
    viewName: "Όνομα Προβολής",
    viewNamePlaceholder: "π.χ. Μηνιαία Καθαριότητα, Q1 Έξοδα",
    setAsDefault: "Ορισμός ως προεπιλογή",
    removeDefault: "Αφαίρεση προεπιλογής",
    setAsDefaultView: "Ορισμός ως προεπιλογή (φορτώνεται αυτόματα όταν ανοίγει η σελίδα Έξοδα)",
    savedFiltersSummary: "Τα τρέχοντα φίλτρα Κτιρίου, Κατηγορίας, Εύρους Ημερομηνιών και Αναζήτησης θα αποθηκευτούν με αυτή την προβολή.",
    transferFunds: "Μεταφορά Κεφαλαίων",
    transferFundsHint: "Εσωτερική μεταφορά μεταξύ Εσωτερικού Ταμείου και Τραπεζικού Λογαριασμού. Ενημερώνει και τα δύο υπόλοιπα αλλά ΔΕΝ δημιουργεί έσοδο ή έξοδο στη λογιστική.",
    fromAccount: "Από Λογαριασμό",
    toAccount: "Προς Λογαριασμό",
    internalCash: "Εσωτερικό Ταμείο",
    bankAccount: "Τραπεζικός Λογαριασμός",
    transferReferencePlaceholder: "π.χ. Απόδειξη κατάθεσης #1234",
    transferCreated: "Η μεταφορά ολοκληρώθηκε",
    transferSameSourceError: "Ο λογαριασμός Από και Προς πρέπει να διαφέρουν",
    transferAmountError: "Το ποσό πρέπει να είναι μεγαλύτερο από μηδέν",
    dateRequired: "Η ημερομηνία είναι υποχρεωτική",
    // Phase 820.3 — Management Company Advances / Repayments
    mcaAdvance: "Νέα Προκαταβολή",
    mcaRepayment: "Επιστροφή",
    mcaOutstandingBank: "Εκκρεμές Προς Εταιρεία Διαχείρισης (Τράπεζα)",
    mcaOutstandingCash: "Εκκρεμές Προς Εταιρεία Διαχείρισης (Μετρητά)",
    // Phase 820.4 — Apartment Owner Credits / Reimbursements
    aocCredit: "Πίστωση Ιδιοκτήτη",
    aocReimbursement: "Αποζημίωση",
    aocOutstandingBank: "Εκκρεμές Πίστωσης Ιδιοκτητών (Τράπεζα)",
    aocOutstandingCash: "Εκκρεμές Πίστωσης Ιδιοκτητών (Μετρητά)",
    // Phase 850 — Recurring Invoice Email Delivery
    sendAgain: "Επαναποστολή",
    emailKillSwitch: "Ενεργός kill-switch — δεν στάλθηκε email",
    // Phase 855 — Cyprus bilingual Company-Profile labels (identical to EN).
    companyAddress: "Διεύθυνση / Address",
    companyPhone: "Τηλ./Tel.",
    companyVatRegNo: "V.A.T Reg. No / Αρ. Μητρώου Φ.Π.Α",
    companyTicNo: "T.I.C / Α.Φ.Τ",
    // Phase 900 — Collections module
    collections: "Εισπράξεις",
    // Phase 910 — Communications module
    communications: "Επικοινωνίες",
    // Phase 920.3 — Owner Advances module
    ownerAdvances: "Χρηματοδοτήσεις Ιδιοκτητών",
    ownerFeedback: "Owner Suggestions & Requests",
    ownerAdvanceReimbursement: "Αποπληρωμή Χρηματοδότησης Ιδιοκτήτη",
    default: "Προεπιλογή",
    modified: "Τροποποιημένη",
    viewSaved: "Η προβολή αποθηκεύτηκε",
    viewUpdated: "Η προβολή ενημερώθηκε",
    viewRenamed: "Η προβολή μετονομάστηκε",
    viewDeleted: "Η προβολή διαγράφηκε",
    defaultRemoved: "Η προεπιλογή αφαιρέθηκε",
    viewNameRequired: "Παρακαλώ εισάγετε όνομα προβολής",
    organizationSettings: "Ρυθμίσεις Οργανισμού",
    manageSubscription: "Διαχείριση Συνδρομής",
    manageSubscriptionHint: "Προβολή και διαχείριση του τρέχοντος πλάνου συνδρομής",
    emailSettings: "Ρυθμίσεις Email",
    emailSettingsHint: "Ρύθμιση αποστολής email, στοιχεία αποστολέα και κλειδιά ενσωμάτωσης",
    senderEmail: "Email Αποστολέα",
    senderName: "Όνομα Αποστολέα",
    apiKey: "Κλειδί API",
    emailProvider: "Πάροχος Email",
    emailConfigSaved: "Οι ρυθμίσεις email αποθηκεύτηκαν",
    comingSoon: "Σύντομα Διαθέσιμο",
    invoiceNotifications: "Ειδοποιήσεις Τιμολογίων",
    customerStatement: "Κατάσταση Πελάτη",
    generalMeetings: "Γενικές Συνελεύσεις",
    paymentNotification: "Ειδοποίηση Πληρωμής",
    emailTemplates: "Πρότυπα Email",
    defaultSubjectTemplate: "Προεπιλεγμένο Θέμα",
    defaultBodyTemplate: "Προεπιλεγμένο Σώμα",
    templateHint: "Διαθέσιμες μεταβλητές: {apartment_number}, {owner_name}, {invoice_number}, {company_name}, {building_name}, {start_date}, {end_date}, {month}",
    useMonthlyFee: "Χρήση μηνιαίου τέλους",
    noEndDate: "Χωρίς ημερομηνία λήξης",
    nextInvoice: "Επόμενο",
    thisApartment: "Αυτό το Διαμέρισμα",
    allApartments: "Όλα τα Διαμερίσματα",
    emailEnabled: "Email",
    scope: "Εύρος",
    optional: "προαιρετικό",
    // Phase 1013 — Recurring invoice auto-email
    autoEmailInvoices: "Αυτόματη αποστολή τιμολογίων με email",
    autoEmailInvoicesHint: "Εκτελείται στον server. Στέλνει το τιμολόγιο την προγραμματισμένη ημερομηνία, ακόμα και αν κανείς δεν είναι συνδεδεμένος.",
    dayOfMonthShortMonthHint: "Για 29/30/31: σε πιο σύντομους μήνες (π.χ. Φεβ) εκτελείται στην τελευταία ημέρα του μήνα.",
    // Phase 1014 — Bills simple tabs (TimelyBills-style)
    upcoming: "Επερχόμενα",
    overdue: "Εκπρόθεσμα",
    recurring: "Επαναλαμβανόμενα",
    paid: "Πληρωμένα",
    advanced: "Προχωρημένα",
    bills: "λογαριασμοί",
    outstanding: "υπόλοιπο",
    totalPaid: "σύνολο πληρωμών",
    markAsPaid: "Επισήμανση ως Πληρωμένο",
    searchBillsPlaceholder: "Αναζήτηση προμηθευτή, ακινήτου, αρ. τιμολογίου…",
    noUpcomingBills: "Δεν υπάρχουν επερχόμενοι λογαριασμοί. Όλα στην ώρα τους.",
    noOverdueBills: "Δεν υπάρχουν εκπρόθεσμοι λογαριασμοί.",
    noPaidBills: "Δεν υπάρχουν πληρωμένοι λογαριασμοί ακόμη.",
    noBills: "Δεν υπάρχουν λογαριασμοί.",
    dueDate: "Ημερομηνία Λήξης",
    building: "Κτίριο",
    partial: "Μερική",
    sendInvoiceTo: "Αποστολή τιμολογίου προς",
    noEmailsConfigured: "Δεν έχουν οριστεί διευθύνσεις email για αυτό το διαμέρισμα",
    noEmailsConfiguredHint: "Προσθέστε email ιδιοκτήτη / ενοικιαστή / επαφής στις ρυθμίσεις του διαμερίσματος πρώτα.",
    autoUsePrimary: "Αυτόματα (κύριο email)",
    lastInvoiceGenerated: "Τελευταίο τιμολόγιο",
    lastEmailSent: "Τελευταίο email",
    emailStatus: "Κατάσταση email",
    emailStatusSent: "Απεστάλη",
    emailStatusFailed: "Απέτυχε",
    emailStatusPending: "Εκκρεμεί",
    emailStatusNoRecipient: "Email δεν στάλθηκε – δεν έχει οριστεί παραλήπτης",
    emailStatusSkippedTesting: "Παραλείφθηκε (test mode)",
    emailStatusMocked: "Καταγράφηκε (χωρίς provider)",
    recipientEmail: "Παραλήπτης",
    nextScheduled: "Επόμενη προγραμματισμένη",
    never: "Ποτέ",
    startDate: "Ημερομηνία Έναρξης",
    endDate: "Ημερομηνία Λήξης",
    from: "Από",
    monthly: "Μηνιαίο",
    enabled: "Ενεργό",
    disabled: "Ανενεργό",
    noUnpaidInvoices: "Δεν υπάρχουν απλήρωτα τιμολόγια",
    payNow: "Πληρωμή",
    totalPayment: "Συνολική Πληρωμή",
    autoDistribute: "Αυτόματη κατανομή (παλαιότερα πρώτα)",
    allocate: "Κατανομή",
    allocated: "Κατανεμημένο",
    unallocated: "Μη κατανεμημένο",
    allocateToInvoices: "Κατανομή σε Τιμολόγια",
    allInvoicesPaid: "Όλα τα τιμολόγια είναι εξοφλημένα",
    afterPayment: "μετά την πληρωμή",
    used: "Χρησιμοποιήθηκαν",
    allocationMismatch: "Η κατανομή δεν μπορεί να υπερβαίνει το ποσό πληρωμής",
    overpayment: "Υπερπληρωμή",
    overpaymentRecorded: "Υπερπληρωμή καταχωρήθηκε ως πίστωση",
    availableCredit: "Διαθέσιμη Πίστωση",
    creditBalance: "Υπόλοιπο Πίστωσης",
    creditApplied: "Η πίστωση εφαρμόστηκε επιτυχώς",
    noCreditToApply: "Δεν υπάρχει διαθέσιμη πίστωση",
    applyToInvoices: "Εφαρμογή σε απλήρωτα τιμολόγια",
    clickToApplyCredit: "Κάντε κλικ για εφαρμογή σε τιμολόγια",
    applyCreditToInvoices: "Εφαρμογή Πίστωσης σε Τιμολόγια",
    totalToApply: "Σύνολο Εφαρμογής",
    exceedsCredit: "Το ποσό υπερβαίνει τη διαθέσιμη πίστωση",
    applyCredit: "Εφαρμογή Πίστωσης",
    unpaidInvoices: "Απλήρωτα Τιμολόγια",
    invoiceAmount: "Τιμολόγιο",
    openingBalance: "Αρχικό Υπόλοιπο",
    overpaymentCredit: "Υπερπληρωμή → Πίστωση",
    noUnpaidInvoicesCreditOnly: "Δεν υπάρχουν απλήρωτα τιμολόγια — όλο το ποσό θα αποθηκευτεί ως πίστωση.",
    applies: "Θα Εφαρμοστεί",
    dateFrom: "Από",
    dateTo: "Έως",
    clearFilter: "Καθαρισμός",
    managementCommittee: "Διαχειριστική Επιτροπή",
    role: "Ρόλος",
    addMember: "Προσθήκη Μέλους",
    selectOwnerOrCustom: "Επιλογή Ατόμου",
    selectFromApartments: "-- Επιλογή ιδιοκτήτη --",
    enterNameManually: "Ή πληκτρολογήστε όνομα",
    or: "ή",
    apartmentShort: "Διαμ.",
    member: "Μέλος",
    month_1: "Ιανουάριος", month_2: "Φεβρουάριος", month_3: "Μάρτιος", month_4: "Απρίλιος",
    month_5: "Μάιος", month_6: "Ιούνιος", month_7: "Ιούλιος", month_8: "Αύγουστος",
    month_9: "Σεπτέμβριος", month_10: "Οκτώβριος", month_11: "Νοέμβριος", month_12: "Δεκέμβριος",

    // Invoices Tab
    createInvoice: "Δημιουργία Χρέωσης",
    selectInvoiceType: "Πώς θέλετε να δημιουργήσετε τη χρέωση;",
    singleApartment: "Μεμονωμένο Διαμέρισμα",
    singleApartmentDesc: "Δημιουργία χρέωσης για συγκεκριμένο διαμέρισμα με προσαρμοσμένο ποσό",
    allApartments: "Όλα τα Διαμερίσματα (Μηνιαίες Χρεώσεις)",
    allApartmentsDesc: "Κατανομή συνολικού ποσού σε όλα τα διαμερίσματα βάσει ποσοστού συμμετοχής (%)",
    totalAmount: "Συνολικό Ποσό",
    totalCharged: "Σύνολο Χρεώσεων",
    totalRemaining: "Σύνολο Υπολοίπου",
    owner: "Ιδιοκτήτης",
    sharePreview: "Προεπισκόπηση Κατανομής",
    optionalDescription: "Προαιρετική περιγραφή...",
    generating: "Δημιουργία...",
    previewPdf: "Προεπισκόπηση PDF",
    previewFailed: "Αποτυχία προεπισκόπησης",
    invoiceDeleted: "Η χρέωση διαγράφηκε",
    invoiceUpdated: "Η χρέωση ενημερώθηκε",
    deleteInvoice: "Διαγραφή Χρέωσης",
    confirmDeleteInvoice: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη χρέωση;",
    invoiceHasPaymentsWarning: "Αυτή η χρέωση έχει πληρωμές. Θα αρχειοθετηθεί αντί να διαγραφεί οριστικά.",
    catManagement: "Διαχείριση",
    catCleaning: "Καθαρισμός",
    catElectricity: "Ηλεκτρικό",
    catInsurance: "Ασφάλεια",
    catElevator: "Ανελκυστήρας",
    catOther: "Άλλο",
    expTypeMonthly: "Μηνιαίο",
    expTypeCapital: "Κεφαλαιακό",
    expenseTypeLabel: "Τύπος Δαπάνης",
    capital: "Κεφαλαιακό",
    allStatuses: "Όλες οι Καταστάσεις",
    allCategories: "Όλες οι Κατηγορίες",
    allPeriods: "Όλες οι Περίοδοι",
    selectApartment: "Επιλέξτε διαμέρισμα",
    change: "αλλαγή",
    commonExpenses: "Κοινόχρηστα",
    invoiceDate: "Ημ/νία Τιμολογίου",
    invoiceNumberPlaceholder: "Άφησέ το κενό για αυτόματη παραγωγή (π.χ. ODY-0016)",
    periodAutoHint: "Συμπληρώθηκε αυτόματα από την Ημ/νία Τιμολογίου — άλλαξέ το αν χρειάζεσαι διαφορετική περίοδο αναφοράς.",
    lineItems: "Γραμμές Χρέωσης",
    addLine: "Προσθήκη Γραμμής",
    autoGenerated: "Αυτόματη δημιουργία",

    // Payments Tab
    recordPayment: "Καταχώρηση Πληρωμής",
    paymentDeleted: "Η πληρωμή διαγράφηκε",
    paymentUpdated: "Η πληρωμή ενημερώθηκε",
    editPayment: "Επεξεργασία Πληρωμής",
    paymentReceipt: "Απόδειξη Πληρωμής",
    paymentDetails: "Λεπτομέρειες Πληρωμής",
    deletePayment: "Διαγραφή Πληρωμής",
    view: "Προβολή",
    pdf: "PDF",
    bill: "Λογαριασμός",
    totalPayments: "Σύνολο Πληρωμών",
    cashPayments: "Πληρωμές Μετρητών",
    bankPayments: "Τραπεζικές Πληρωμές",
    allSources: "Όλες οι Πηγές",
    source: "Πηγή",
    outstandingInvoices: "Εκκρεμείς Χρεώσεις",
    noOutstandingInvoices: "Δεν υπάρχουν εκκρεμείς χρεώσεις",
    month: "Μήνας",
    year: "Έτος",

    // Phase 134 — Internal Transfers (Μεταφορές μεταξύ τραπεζικών λογαριασμών).
    transfers: "Μεταφορές",
    transfer: "Μεταφορά",
    internalTransfer: "Εσωτερική Μεταφορά",
    internalTransfers: "Εσωτερικές Μεταφορές",
    internalTransfersDesc: "Μεταφορά χρημάτων μεταξύ τραπεζικών λογαριασμών χωρίς επίπτωση σε Έσοδα, ΦΠΑ, Κρατήσεις ή Τελικό Υπόλοιπο.",
    newTransfer: "Νέα Μεταφορά",
    addTransfer: "Προσθήκη Μεταφοράς",
    editTransfer: "Επεξεργασία Μεταφοράς",
    deleteTransfer: "Διαγραφή Μεταφοράς",
    confirmDeleteTransfer: "Να διαγραφεί η εσωτερική μεταφορά; Το υπόλοιπο και των δύο λογαριασμών θα επανυπολογιστεί.",
    noTransfers: "Δεν έχουν καταχωρηθεί εσωτερικές μεταφορές.",
    fromAccount: "Από Λογαριασμό",
    toAccount: "Προς Λογαριασμό",
    fromToRequired: "Απαιτούνται Από και Προς λογαριασμοί",
    fromToMustDiffer: "Οι λογαριασμοί Από και Προς πρέπει να διαφέρουν",
    transferCreated: "Η μεταφορά δημιουργήθηκε",
    transferUpdated: "Η μεταφορά ενημερώθηκε",
    transferDeleted: "Η μεταφορά διαγράφηκε",
    selectAccount: "Επιλέξτε λογαριασμό",
    deleted: "Διαγράφηκε",
    entry: "εγγραφή",

    // Phase 137 — Opening Balance as a first-class dated transaction row.
    openingBalanceDate: "Ημερομηνία Αρχικού Υπολοίπου",
    openingBalanceDateRequired: "Η ημερομηνία αρχικού υπολοίπου είναι υποχρεωτική",
    openingBalanceDateHint: "Η ημερομηνία από την οποία ξεκινά το τρέχον υπόλοιπο του λογαριασμού.",
    openingBalanceNotes: "Σημειώσεις Αρχικού Υπολοίπου",
    openingBalanceNotesPlaceholder: "π.χ. Οφειλόμενο υπόλοιπο έως 28/02/2025 (Ιαν + Φεβ 2025)",
    boundToApartmentId: "Συνδεδεμένο με apartment_id",
    usePeriod: "Χρήση Περιόδου",
    receiptNotFound: "Η απόδειξη δεν βρέθηκε",
    openingNotes: "Σημειώσεις Αρχικού Υπολοίπου",
    openingNotesPlaceholder: "π.χ. Οφειλόμενο Ιαν + Φεβ 2025",

    // Phase 139 — Annual Expenses versioning / audit history.
    viewHistory: "Προβολή Ιστορικού",
    editHistory: "Ιστορικό Επεξεργασιών",
    editHistoryDesc: "Κάθε αλλαγή ποσού καταγράφεται και δεν επικαλύπτεται ποτέ.",
    noHistoryYet: "Δεν έχουν καταγραφεί επεξεργασίες για αυτή την κατηγορία.",
    changedAt: "Ώρα αλλαγής",
    previousAmount: "Προηγούμενο",
    newAmount: "Νέο",
    delta: "Δ",
    changedBy: "Αλλαγή από",
    close: "Κλείσιμο",

    // Phase 140 — Στρογγυλοποιημένη στήλη στην κατανομή διαμερισμάτων.
    rounded: "Στρογγυλοποιημένο",
    readOnlyCalculated: "Υπολογισμένο αυτόματα (μόνο ανάγνωση)",

    // Phase 144 — Καθαρότερες ετικέτες στηλών + UX στρογγυλοποίησης.
    annualTotal: "Ετήσιο Σύνολο",
    pressEnterToSave: "Enter για αποθήκευση",
    manualOverride: "Χειροκίνητη τιμή — διατηρείται σε αλλαγές προϋπολογισμού",

    // Phase 141 — Ανάλυση ανά έξοδο στο κάτω μέρος των Ετήσιων Εξόδων.
    breakdownPerExpense: "Ανάλυση ανά Έξοδο",
    breakdownPerExpenseDesc: "Λεπτομερής κατανομή κάθε εξόδου σε όλα τα διαμερίσματα. Η στρογγυλοποίηση εφαρμόζεται ανά γραμμή, οπότε το σύνολο των στρογγυλοποιημένων ποσών μπορεί να διαφέρει ελαφρώς από το αρχικό σύνολο — η διαφορά εμφανίζεται για πλήρη διαφάνεια.",
    originalAmount: "Αρχικό Ποσό",
    roundedAmount: "Στρογγυλοποιημένο Ποσό",
    expenseTotalOriginal: "Σύνολο Εξόδου (Αρχικό)",
    expenseTotalRounded: "Σύνολο Εξόδου (Στρογγυλοποιημένο)",
    difference: "Διαφορά",

    // Phase 143 — Μηνιαία στρογγυλοποίηση με προσαρμογή Αποθεματικού.
    breakdownMonthlyDesc: "Μηνιαίο ποσό ανά διαμέρισμα, πριν και μετά τη στρογγυλοποίηση. Τα υπόλοιπα στρογγυλοποίησης ΔΕΝ επανακατανέμονται στα διαμερίσματα — συγκεντρώνονται στην προσαρμογή Αποθεματικού παρακάτω ώστε τα σύνολα πάντα να συμφωνούν.",
    monthlyBeforeRounding: "Μηνιαίο (Πριν Στρογγ.)",
    monthlyAfterRounding: "Μηνιαίο (Μετά Στρογγ.)",
    totalBeforeRound: "Σύνολο (Πριν Στρογγ.)",
    totalAfterRound: "Σύνολο (Μετά Στρογγ.)",
    diffFlowsToRF: "Μεταφέρεται στο Αποθεματικό ↓",
    adjusted: "Προσαρμοσμένο",
    reserveFundOriginalMonthly: "Αποθεματικό — Μηνιαίο (Αρχικό)",
    reserveFundAdjustedMonthly: "Αποθεματικό — Μηνιαίο (Προσαρμοσμένο)",
    roundingAdjustment: "Προσαρμογή Στρογγυλοποίησης",
    roundingAdjustmentDesc: "Άθροισμα όλων των διαφορών στρογγυλοποίησης ανά έξοδο στο κτίριο.",
    // Phase 147 — Συμφωνία Αποθεματικού με τις στρογγυλοποιημένες τιμές ανά διαμέρισμα.
    monthlyTotalBeforeRounding: "Μηνιαίο Σύνολο (Πριν Στρογγυλοποίηση)",
    sumOfRoundedApartmentAmounts: "Άθροισμα Στρογγυλοποιημένων Διαμερισμάτων",
    roundingAdjustmentFormula: "= Άθροισμα Στρογγυλοποιημένων − Μηνιαίο Σύνολο (Πριν)",
    // Phase 153 — αυτόματη αποθήκευση για τις τιμές κατηγοριών.
    saved: "Αποθηκεύτηκε",
    saving: "Αποθήκευση…",
    unsavedChanges: "Μη αποθηκευμένες αλλαγές",
    saveError: "Αποτυχία αποθήκευσης",
    saveNow: "Αποθήκευση τώρα",
    planYear: "Έτος",
    reserveFundDistributionTitle: "Κατανομή Αποθεματικού",
    annualTotal: "Ετήσιο Σύνολο",
    reserveFundManagedInAnnualExpenses: "Η κατανομή του Αποθεματικού διαχειρίζεται στα Ετήσια Έξοδα.",
    openAnnualExpenses: "Άνοιγμα Ετήσιων Εξόδων",
    noReserveFundPlan: "Δεν υπάρχει ενεργό Ετήσιο Σχέδιο με Αποθεματικό. Ορίστε το Αποθεματικό στα Ετήσια Έξοδα για να δείτε την κατανομή εδώ.",
    paymentSource: "Πηγή Πληρωμής",
    buildingFund: "Ταμείο Κτιρίου",
    buildingFundHint: "Πληρωμή απευθείας από Μετρητά ή Τράπεζα τώρα.",
    distributeToApartments: "Κατανομή στα Διαμερίσματα",
    distributeHint: "Διαμοιρασμός στα διαμερίσματα — δημιουργεί τιμολόγια, δεν πληρώνεται ακόμα.",
    distributionNotPaidYet: "Σημείωση: αυτό δεν έχει πληρωθεί ακόμα — θα χρεωθεί σε κάθε διαμέρισμα βάσει μεριδίου.",
    available: "Διαθέσιμο",
    insufficientFundsWarning: "Ανεπαρκή κεφάλαια: διαθέσιμα μόνο €{available}, απαιτούνται €{needed}.",
    invoicePdf: "PDF Τιμολογίου",
    statementPdf: "PDF Κατάστασης",
    paymentReceiptPdf: "PDF Απόδειξης Πληρωμής",
    // Phase 168 — Συνημμένα επισκευής.
    repairAttachments: "Συνημμένα",
    repairAttachmentsHint: "Σύρετε και αφήστε τιμολόγια, αποδείξεις ή φωτογραφίες εδώ, ή πατήστε Μεταφόρτωση. Μέγιστο 10 MB ανά αρχείο.",
    noAttachments: "Δεν υπάρχουν συνημμένα",
    repairAttachmentTooLarge: "Το αρχείο υπερβαίνει το όριο των 10 MB",
    repairAttachmentUploaded: "Το συνημμένο μεταφορτώθηκε",
    repairAttachmentDeleted: "Το συνημμένο διαγράφηκε",
    // Phase 152 — Πίνακας Προσαρμογής Αποθεματικού (Αρχικό / Προσαρμογή / Προσαρμοσμένο × Μηνιαίο / Ετήσιο).
    reserveFundAdjustmentTitle: "Αποθεματικό — Συμφωνία Στρογγυλοποίησης",
    reserveFundAdjustmentHint: "Προσαρμογή = Άθροισμα Στρογγυλοποιημένων − Μηνιαίο Σύνολο. Θετική αυξάνει το Αποθεματικό· αρνητική το μειώνει.",
    colMonthly: "Μηνιαίο",
    colAnnual: "Ετήσιο (×12)",
    rowOriginal: "Αποθεματικό (Αρχικό)",
    rowAdjustment: "Προσαρμογή Στρογγυλοποίησης (+/−)",
    rowAdjusted: "Αποθεματικό (Προσαρμοσμένο)",
    rfIncreases: "Αύξηση Αποθεματικού",
    rfDecreases: "Μείωση Αποθεματικού",
    rfUnchanged: "Αποθεματικό αμετάβλητο",

    // Phase 148 — Διαχείριση Πλάνων (ονομασμένα πλάνα + Ενεργό/Ανενεργό).
    plan: "Πλάνο",
    plans: "Πλάνα",
    active: "Ενεργό",
    inactive: "Ανενεργό",
    newPlan: "Νέο Πλάνο",
    newPlanDesc: "Δημιουργία κενού πλάνου για το συγκεκριμένο κτίριο και έτος.",
    duplicatePlan: "Αντιγραφή Πλάνου",
    duplicatePlanDesc: "Δημιουργία αντιγράφου του τρέχοντος πλάνου ως νέο σενάριο.",
    renamePlan: "Μετονομασία Πλάνου",
    renamePlanDesc: "Αλλαγή ονόματος αυτού του πλάνου.",
    deletePlan: "Διαγραφή Πλάνου",
    activatePlan: "Ορισμός ως Ενεργό",
    activate: "Ενεργοποίηση",
    planName: "Όνομα Πλάνου",
    planNamePlaceholder: "π.χ. Βασικό Πλάνο, Premium Πλάνο, Σενάριο Α, Προϋπολογισμός 2025",
    planNameRequired: "Το όνομα του πλάνου είναι υποχρεωτικό",
    planCreated: "Το πλάνο δημιουργήθηκε",
    planRenamed: "Το πλάνο μετονομάστηκε",
    planDeleted: "Το πλάνο διαγράφηκε",
    planActivated: "Το πλάνο ενεργοποιήθηκε",
    apartmentsSynced: "διαμερίσματα συγχρονίστηκαν",
    // Phase 169 — Έκδοση Πλάνου με Ημερομηνία Έναρξης / Λήξης
    activatePlanDesc: "Επιλέξτε ημερομηνία έναρξης για αυτό το πλάνο. Το προηγούμενο ενεργό πλάνο θα κλείσει αυτόματα την προηγούμενη ημέρα.",
    previousPlanWillClose: "Το προηγούμενο πλάνο \"{name}\" θα κλείσει στις {date}.",
    startDateRequired: "Η ημερομηνία έναρξης είναι υποχρεωτική",
    editPlanDates: "Επεξεργασία Ημερομηνιών Πλάνου",
    editPlanDatesDesc: "Χειροκίνητη ρύθμιση ημερομηνιών έναρξης / λήξης. Δεν επιτρέπεται επικάλυψη με άλλα πλάνα.",
    planDatesUpdated: "Οι ημερομηνίες του πλάνου ενημερώθηκαν",
    activeFrom: "Ενεργό από",
    leaveEmptyForOngoing: "Αφήστε κενό για να παραμείνει το πλάνο ενεργό χωρίς λήξη.",
    open: "ανοιχτό",
    optional: "προαιρετικό",
    cannotDeleteActivePlan: "Ενεργοποιήστε πρώτα άλλο πλάνο για να διαγράψετε αυτό.",
    cannotDeleteActivePlanHint: "Δεν μπορεί να διαγραφεί το Ενεργό πλάνο. Ενεργοποιήστε πρώτα το \"{name}\".",
    cannotDeleteOnlyPlan: "Δεν μπορεί να διαγραφεί το μοναδικό πλάνο. Δημιουργήστε πρώτα άλλο πλάνο.",
    confirmDeletePlan: "Οριστική διαγραφή πλάνου",
    noPlans: "Δεν υπάρχουν πλάνα",
    sales: "Πωλήσεις",
    salesSubtitle: "Πελάτες, Τιμολόγια, Πληρωμές και Καταστάσεις — συνδεδεμένα με Cleaning Management & Finance.",
    fromFinance: "Από Finance",
    transactionType: "Τύπος",
    allocatedTo: "Κατανομή σε",
    details: "Λεπτομέρειες",
    totalVat: "Σύνολο ΦΠΑ",
    totalAmount: "Συνολικό Ποσό",
    totalPaid: "Σύνολο Πληρωμένα",
    totalUnpaid: "Σύνολο Ανεξόφλητα",
    totalsFor: "Σύνολα για",
    unpaid: "Ανεξόφλητα",
    exportPdf: "Εξαγωγή PDF",
    report: "Αναφορά",
    clientVendorBuilding: "Πελάτης / Προμηθευτής / Πολυκατοικία",
    selectClientOrBuilding: "Επιλέξτε πελάτη ή πολυκατοικία",
    clientsAndVendors: "Πελάτες & Προμηθευτές",
    vatSettlement: "Εκκαθάριση ΦΠΑ",
    vatSettlementHint: "ΦΠΑ Εισόδων − ΦΠΑ Προμηθευτών − ΦΠΑ Εξόδων",
    totalIncomeVat: "Σύνολο ΦΠΑ Εισόδων",
    supplierVat: "ΦΠΑ Προμηθευτών",
    expensesVat: "ΦΠΑ Εξόδων",
    vatToPay: "ΦΠΑ Προς Πληρωμή",
    vatCreditRefund: "Πιστωτικό ΦΠΑ / Επιστροφή",
    fromCustomerInvoices: "από τιμολόγια πελατών",
    fromSupplierInvoices: "από τιμολόγια προμηθευτών",
    fromVendorExpenses: "από Προμηθευτές → Έξοδα",
    payableToAuthority: "πληρωτέο στην εφορία",
    owedByAuthority: "οφειλόμενο από την εφορία",
    snoozed: "Σε αναβολή",
    snoozedUntil: "Σε αναβολή έως",
    snoozeBill: "Αναβολή λογαριασμού",
    changeSnooze: "Αλλαγή αναβολής",
    snoozeBillHelp: "Απόκρυψη του λογαριασμού από τα επείγοντα του dashboard έως την επιλεγμένη ημερομηνία. Παραμένει διαθέσιμος στη λίστα με το φίλτρο «Σε αναβολή».",
    snoozeUntil: "Αναβολή έως",
    reminderDate: "Ημερομηνία υπενθύμισης",
    currentlySnoozedUntil: "Αυτή τη στιγμή σε αναβολή έως",
    clearSnooze: "Διαγραφή αναβολής",
    urgentAndUpcoming: "Επείγοντα & Επερχόμενα",
    snoozeFromOverviewHint: "Αναβολή λογαριασμού για να αφαιρεθεί από τη λίστα έως την ημερομηνία υπενθύμισης.",
    noUrgentBills: "Δεν υπάρχουν επείγοντες λογαριασμοί αυτή τη στιγμή.",
    remindersTitle: "Υπενθυμίσεις",
    remindersHint: "Ενεργές υποχρεώσεις. Αναβληθέντα και πληρωμένα στοιχεία αποκρύπτονται αυτόματα.",
    noActiveObligations: "Δεν υπάρχουν ενεργές υποχρεώσεις αυτή τη στιγμή.",
    openBill: "Άνοιγμα",
    snooze: "Αναβολή",
    billTitle: "Τίτλος",
    autoCreateInvoice: "Αυτόματη Δημιουργία Τιμολογίου",
    intervalMonthly: "Μηνιαία",
    intervalBimonthly: "Κάθε 2 Μήνες",
    intervalQuarterly: "Κάθε 3 Μήνες",
    intervalSemiannual: "Κάθε 6 Μήνες",
    intervalYearly: "Ετήσια",
    intervalCustom: "Προσαρμοσμένο διάστημα",
    everyXMonths: "Κάθε X μήνες",
    createAs: "Αυτόματη δημιουργία ως",
    draft: "Πρόχειρο",
    officialInvoice: "Επίσημο Τιμολόγιο",
    nextGenerationDate: "Ημερομηνία Επόμενης Δημιουργίας",
    billTo: "Χρέωση σε",
    saveRecurrence: "Αποθήκευση επανάληψης",
    recurrenceStatus: "Κατάσταση Επανάληψης",
    lastGenerated: "Τελευταία δημιουργία",
    nextInvoiceDate: "Ημερομηνία επόμενου τιμολογίου",
    nextCycleSkipped: "Ο επόμενος κύκλος θα παραλειφθεί",
    state: "Κατάσταση",
    paused: "Σε παύση",
    active: "Ενεργό",
    pauseRecurrence: "Παύση",
    resumeRecurrence: "Συνέχιση",
    skipNextCycle: "Παράλειψη επόμενου κύκλου",
    clearSkip: "Ακύρωση παράλειψης",
    generateNow: "Δημιουργία Τώρα",
    generationHistory: "Ιστορικό δημιουργίας",
    noHistoryYet: "Δεν έχει δημιουργηθεί κανένα τιμολόγιο ακόμα.",
    generated: "Δημιουργήθηκε",
    skippedStatus: "Παραλήφθηκε",
    triggeredBy: "Έναυσμα από",
    invoice: "Τιμολόγιο",
    invoiceGenerated: "Δημιουργήθηκε τιμολόγιο",
    recurrenceSaved: "Η επανάληψη αποθηκεύτηκε",
    recurrencePaused: "Η επανάληψη τέθηκε σε παύση",
    recurrenceResumed: "Η επανάληψη συνεχίστηκε",
    recurrenceCycleSkipped: "Ο κύκλος παραλήφθηκε",
    skipNextOn: "Ο επόμενος κύκλος θα παραλειφθεί",
    skipNextOff: "Η παράλειψη ακυρώθηκε",
    descriptionPlaceholder: "π.χ. Συντήρηση ανελκυστήρα — ανά 2 μήνες",
    recurrenceSaveFirstHint: "Αποθηκεύστε πρώτα τον λογαριασμό ανανέωσης, μετά ανοίξτε τον ξανά για να ρυθμίσετε αυτόματη δημιουργία τιμολογίων.",
    enabled: "Ενεργοποιημένο",
    activeFilter: "Ενεργά",
    allFilter: "Όλα",
    billsFilter: "Λογαριασμοί",
    renewalsFilter: "Ανανεώσεις",
    snoozedFilter: "Σε αναβολή",
    invoiceNumber: "Αρ. Τιμολογίου",
    outstanding: "Εκκρεμές υπόλοιπο",
    partial: "μερική",
    from: "Από",
    to: "Έως",
    clear: "Καθαρισμός",
    allCategories: "Όλες οι κατηγορίες",
    viewSubcategoryLedger: "Άνοιγμα ιστορικού υποκατηγορίας",
    recurringDate: "Συχνότητα Επανάληψης",
    recurrenceStartDate: "Έναρξη επανάληψης",
    nextRenewalDate: "Επόμενη ανανέωση",
    pickInterval: "Επιλέξτε διάστημα…",
    noneInterval: "— Χωρίς σταθερό διάστημα —",
    viewPDF: "Προβολή PDF",
    exportPDF: "Εξαγωγή PDF",
    identifier: "Αναγνωριστικό",
    identifierPlaceholder: "π.χ. KXH 542 Toyota Yaris · Διαμέρισμα 203 · Μιχάλης",
    billDescription: "Περιγραφή",
    billDescriptionPlaceholder: "π.χ. Toyota Yaris KXH542 · Ηλεκτρικό Γραφείου · Ασφάλεια Μιχάλη · Διαμ. 203 Νερό",
    recurringFrequency: "Συχνότητα Επανάληψης",
    referenceNo: "Αρ. Αναφοράς",
    charge: "Χρέωση",
    allocatePayment: "Κατανομή Πληρωμής",
    allocate: "Κατανομή",
    moveTo: "Μεταφορά σε τιμολόγιο",
    selectInvoice: "Επιλέξτε τιμολόγιο…",
    paymentReallocated: "Η πληρωμή ανακατανεμήθηκε",
    paymentUnallocated: "Η πληρωμή απο-κατανεμήθηκε",
    reallocate: "Ανακατανομή",
    unallocate: "Αφαίρεση κατανομής",
    policyNumber: "Αριθμός Συμβολαίου",
    policyNumbers: "Αριθμοί Συμβολαίων",
    policyNumberPlaceholder: "π.χ. ABC-29384",
    quickViewAllUnpaid: "Όλα Ανεξόφλητα",
    quickViewAllPaid: "Όλα Εξοφλημένα",
    quickViewAllSnoozed: "Όλα Αναβληθέντα",
    viewAllUnpaidBills: "Όλοι οι Ανεξόφλητοι Λογαριασμοί",
    viewAllPaidBills: "Όλοι οι Εξοφλημένοι Λογαριασμοί",
    viewAllSnoozedBills: "Όλοι οι Αναβληθέντες Λογαριασμοί",
    globalView: "Συνολική προβολή",
    inThisContext: "Σε αυτό το περιεχόμενο",
    noAllocationCandidates: "Δεν υπάρχουν άλλα ανεξόφλητα τιμολόγια σε αυτή την υποκατηγορία.",
    unallocatedCredit: "Πίστωση χωρίς κατανομή",
    paymentAmount: "Πληρωμή",
    alreadyAllocated: "Ήδη κατανεμημένο",
    remainingCredit: "Υπόλοιπο πίστωσης",
    payment: "Πληρωμή",
    activeRenewal: "Ενεργή",
    snoozedReappearHint: "Τα αναβληθέντα στοιχεία εξαφανίζονται από την ενεργή λίστα και επιστρέφουν αυτόματα την ημερομηνία υπενθύμισης.",
    alreadyPaid: "Έχει ήδη πληρωθεί",
    markedAsPaid: "Σημειώθηκε ως πληρωμένο",
    dueSoon: "Σύντομα λήγει",
    activeBills: "Ενεργοί λογαριασμοί",
    vendorBill: "Προμηθευτής / Λογαριασμός",
    activeObligations: "Ενεργές υποχρεώσεις",
    vendorClientBuilding: "Προμηθευτής / Πελάτης / Πολυκατοικία",
    type: "Τύπος",
    bill: "Λογαριασμός",
    renewal: "Ανανέωση",
    readOnlyEditInFinance: "Μόνο για ανάγνωση. Επεξεργασία στο Finance.",
    bankTransactionProtected: "Προστατευμένη τραπεζική συναλλαγή — διαχείριση στο Finance",
    // Phase 621 — Accounting-style payment row labels.
    bankPayment: "Τραπεζική Πληρωμή",
    cashPayment: "Μετρητή Πληρωμή",
    financeSync: "Συγχρονισμός Finance",
    syncedFrom: "από",
    viewInvoice: "Προβολή τιμολογίου",
    paymentsReadOnlyHint: "Οι πληρωμές διαχειρίζονται αποκλειστικά από το Finance / Sales. Εμφανίζονται εδώ αυτόματα μόλις καταχωρηθούν.",
    cleanupOrphans: "Καθαρισμός orphan",
    cleanupOrphansHint: "Διαγραφή (soft) πληρωμών / εργασιών / ιστορικού που δεν αντιστοιχούν πλέον σε ενεργό πελάτη ή καθαριστή.",
    cleanupOrphansConfirm: "Αυτή η ενέργεια θα κάνει soft-delete σε όλες τις πληρωμές / εργασίες / ιστορικό που δεν αντιστοιχούν σε ενεργό πελάτη ή καθαριστή. Συνέχεια;",
    cleanupDone: "Ολοκληρώθηκε ο καθαρισμός",
    activePlan: "Ενεργό Πλάνο",
    markActive: "Ενεργοποίηση",
    markAsActivePlan: "Σήμανση ως Ενεργό Πλάνο",
    customers: "Πελάτες",
    invoices: "Τιμολόγια",
    payments: "Πληρωμές",
    statement: "Κατάσταση",
    newInvoice: "Νέο Τιμολόγιο",
    editInvoice: "Επεξεργασία Τιμολογίου",
    newPayment: "Νέα Πληρωμή",
    addPayment: "Νέα Πληρωμή",
    addJob: "Νέα Εργασία",
    splitView: "Διαιρεμένη",
    listView: "Λίστα",
    // Phase 735.43 — Cleaner payment status badges + dropdown filter tabs.
    cleanerStatus_paid: "Πληρωμένο",
    cleanerStatus_partial: "Μερικό",
    cleanerStatus_unpaid: "Απλήρωτο",
    // Phase 735.44 — Cleaner Invoices tab.
    invoices: "Τιμολόγια",
    invoiceNumber: "Αρ. Τιμολογίου",
    invoiceDate: "Ημερομηνία Τιμολογίου",
    createInvoice: "Δημιουργία Τιμολογίου",
    invoiceCreated: "Το τιμολόγιο δημιουργήθηκε",
    invoiceVoided: "Το τιμολόγιο ακυρώθηκε",
    invoiceReactivated: "Το τιμολόγιο επανενεργοποιήθηκε",
    invoiceExists: "Υπάρχει ήδη τιμολόγιο για αυτόν τον μήνα",
    invoiceExistsWarning: "Υπάρχει ήδη ενεργό τιμολόγιο για αυτόν τον μήνα. Ακυρώστε πρώτα το προηγούμενο.",
    confirmVoidInvoice: "Ακύρωση αυτού του τιμολογίου;",
    noInvoicesYet: "Δεν υπάρχουν τιμολόγια ακόμα. Κάντε κλικ στο \"Δημιουργία Τιμολογίου\" για έναν μήνα.",
    showVoided: "Εμφάνιση ακυρωμένων",
    void: "Ακύρωση",
    autoAssigned: "Αυτόματη ανάθεση κατά την αποθήκευση",
    totalInvoiced: "Σύνολο Τιμολογίων",
    outstandingBalance: "Υπόλοιπο Οφειλής",
    noWorkThisMonth: "Δεν βρέθηκαν εργασίες για αυτόν τον μήνα.",
    cleanerInvoiceStatus_paid: "ΠΛΗΡΩΜΕΝΟ",
    cleanerInvoiceStatus_partial: "ΜΕΡΙΚΟ",
    cleanerInvoiceStatus_unpaid: "ΑΠΛΗΡΩΤΟ",
    cleanerInvoiceStatus_voided: "ΑΚΥΡΩΘΗΚΕ",
    cleanerInvoiceStatus_draft: "ΠΡΟΧΕΙΡΟ",
    cleanerInvoiceStatus_finalized: "ΟΡΙΣΤΙΚΟ",
    // Phase 735.45.
    editInvoice: "Επεξεργασία Τιμολογίου",
    invoiceUpdated: "Το τιμολόγιο ενημερώθηκε",
    invoiceFinalized: "Το τιμολόγιο οριστικοποιήθηκε",
    invoiceRebuilt: "Το τιμολόγιο αναδημιουργήθηκε από Εργασίες",
    confirmFinalize: "Οριστικοποίηση αυτού του τιμολογίου; Ο αυτόματος συγχρονισμός με Εργασίες θα απενεργοποιηθεί.",
    lockedByPayments: "ΚΛΕΙΔΩΜΕΝΟ ΑΠΟ ΠΛΗΡΩΜΕΣ",
    editInvoiceLockedWarn: "Αυτό το τιμολόγιο έχει αντιστοιχισμένες πληρωμές. Οι αλλαγές θα καταγραφούν ως override.",
    descriptionPlaceholder: "π.χ. ΜΑΪΟΣ 6+13+20+27",
    addLine: "Προσθήκη Γραμμής",
    finalize: "Οριστικοποίηση",
    rebuildFromJobs: "Αναδημιουργία από Εργασίες",
    rebuildInvoice: "Αναδημιουργία Τιμολογίου από Εργασίες",
    confirmRebuild: "Επιβεβαίωση Αναδημιουργίας",
    rebuilding: "Αναδημιουργία…",
    rebuildWarning: "Αυτό το τιμολόγιο δεν είναι πρόχειρο. Η αναδημιουργία μπορεί να επηρεάσει αντιστοιχίσεις.",
    currentTotal: "Τρέχον Σύνολο",
    proposedTotal: "Προτεινόμενο Σύνολο",
    addedLines: "γραμμές προς προσθήκη",
    removedLines: "γραμμές προς αφαίρεση",
    changedLines: "τροποποιημένες γραμμές",
    manualLinesKept: "χειροκίνητες γραμμές διατηρούνται",
    auditTrail: "Ιστορικό",
    notes: "Σημειώσεις",
    save: "Αποθήκευση",
    quantity: "Ποσότητα",
    rate: "Τιμή",
    amount: "Ποσό",
    saving: "Αποθήκευση…",
    selectAClient: "Επιλέξτε έναν πελάτη από τη λίστα",
    selectAClientHint: "Επιλέξτε πελάτη αριστερά για να δείτε εργασίες, τιμολόγια, πληρωμές και κατάσταση.",
    noJobsYet: "Δεν βρέθηκαν εργασίες",
    noInvoicesYet: "Δεν υπάρχουν τιμολόγια ακόμη",
    noPaymentsRecorded: "Δεν έχουν καταγραφεί πληρωμές",
    noEntriesYet: "Δεν υπάρχουν εγγραφές ακόμη",
    noClientsFound: "Δεν βρέθηκαν πελάτες",
    outstanding: "Υπόλοιπο",
    lastJob: "Τελευταία Εργασία",
    // Phase 472 — Reminders redesign.
    dueToday: "Λήγουν Σήμερα",
    dueThisWeek: "Αυτή την Εβδομάδα",
    next7Days: "Επόμενες 7 Ημέρες",
    upcoming: "Προσεχείς",
    searchBillsPlaceholder: "Αναζήτηση σε περιγραφή, αρ. τιμολογίου, κατηγορία...",
    // Phase 732 — Recurring Bills (Greek)
    recurringBills: "Επαναλαμβανόμενοι Λογαριασμοί",
    addRecurringBill: "Νέος Επαναλαμβανόμενος",
    editRecurringBill: "Επεξεργασία Επαναλαμβανόμενου",
    createRecurringBill: "Δημιουργία Επαναλαμβανόμενου",
    deleteRecurringBill: "Διαγραφή Επαναλαμβανόμενου",
    confirmDeleteRecurring: "Να διαγραφεί αυτό το πρότυπο επαναλαμβανόμενου; Οι ήδη δημιουργημένοι λογαριασμοί παραμένουν.",
    noRecurringBills: "Δεν υπάρχουν επαναλαμβανόμενοι λογαριασμοί ακόμη. Πατήστε \"Νέος Επαναλαμβανόμενος\".",
    recurringUpdated: "Ο επαναλαμβανόμενος ενημερώθηκε",
    recurringCreated: "Ο επαναλαμβανόμενος δημιουργήθηκε",
    recurringHistory: "Ιστορικό Επαναλαμβανόμενου",
    noGeneratedBills: "Δεν έχουν δημιουργηθεί λογαριασμοί από αυτό το πρότυπο ακόμη.",
    generatedBill: "Δημιουργημένος Λογαριασμός",
    generationDate: "Ημερομηνία Δημιουργίας",
    upcomingRecurring: "Προσεχείς Επαναλαμβανόμενοι",
    generateNow: "Δημιουργία Τώρα",
    viewHistory: "Ιστορικό",
    pause: "Παύση",
    resume: "Συνέχιση",
    duplicate: "Αντιγραφή",
    active: "Ενεργός",
    paused: "Σε Παύση",
    expired: "Έληξε",
    daily: "Ημερήσιος",
    weekly: "Εβδομαδιαίος",
    quarterly: "Τριμηνιαίος",
    semiannual: "Ανά 6 Μήνες",
    yearly: "Ετήσιος",
    custom: "Προσαρμοσμένος",
    everyNDays: "Κάθε Ν ημέρες",
    frequency: "Συχνότητα",
    recurrence: "Επανάληψη",
    dates: "Ημερομηνίες",
    options: "Επιλογές",
    optional: "προαιρετικό",
    autoGenerateBills: "Αυτόματη δημιουργία λογαριασμών",
    autoGenerateHint: "Οι λογαριασμοί δημιουργούνται αυτόματα στην προγραμματισμένη ημερομηνία.",
    autoMarkOverdue: "Αυτόματη επισήμανση εκπρόθεσμων",
    autoMarkOverdueHint: "Ληξιπρόθεσμοι απλήρωτοι λογαριασμοί επισημαίνονται ως εκπρόθεσμοι.",
    reminderBeforeDue: "Υπενθύμιση πριν τη λήξη (ημέρες)",
    defaultAmount: "Προεπιλεγμένο Ποσό",
    policyNumber: "Αριθμός Συμβολαίου",
    selectSubcategory: "Επιλογή υποκατηγορίας",
    subcategoryRequired: "Η υποκατηγορία είναι υποχρεωτική",
    startDateRequired: "Η ημερομηνία έναρξης είναι υποχρεωτική",
    done: "Έγινε",
    saveChanges: "Αποθήκευση Αλλαγών",
    upcoming: "Προσεχή",
    thisWeek: "Αυτή την Εβδομάδα",
    searchReminders: "Αναζήτηση υπενθυμίσεων…",
    allCaughtUp: "Είστε ενημερωμένοι.",
    noAlertsForFilter: "Καμία υπενθύμιση δεν ταιριάζει στο φίλτρο.",
    comfortable: "Ευρύχωρο",
    compact: "Συμπαγές",
    sortByDueDate: "Πλησιέστερο σε λήξη",
    sortByAmount: "Μεγαλύτερο Ποσό",
    sortByCategory: "Κατηγορία",
    sortByRecent: "Πρόσφατα",
    expiringSoonShort: "Λήγει",
    dueSoonShort: "Πληρωτέο",
    agoShort: "πριν",
    inShort: "σε",
    showingCount: "Εμφάνιση",
    // Phase 473 — Cleaners split-view.
    selectACleaner: "Επιλέξτε καθαρίστρια από τη λίστα",
    selectACleanerHint: "Επιλέξτε καθαρίστρια αριστερά για να δείτε εργασίες, κτίρια, πληρωμές και κατάσταση.",
    viewStatement: "Προβολή Κατάστασης",
    openStatement: "Άνοιγμα Κατάστασης",
    fullStatement: "Πλήρης Κατάσταση",
    fullStatementHint: "Ανοίγει τον αναλυτικό διάλογο κατάστασης με όλες τις ημερομηνίες, φίλτρα και εξαγωγή PDF.",
    avgHourlyRate: "Μ.Ο. / ώρα",
    pendingPayments: "Εκκρεμή",
    dataMismatchDetected: "Εντοπίστηκε ασυμφωνία δεδομένων",
    expectedCount: "Αναμενόμενα",
    shownCount: "εμφανίζονται",
    refresh: "Ανανέωση",
    noBuildingsCleaning: "Δεν υπάρχουν καθαρισμοί κτιρίων",
    entries: "Εγγραφές",
    // Phase 474 — Sync Audit.
    syncAudit: "Έλεγχος Συγχρονισμού",
    syncAuditHint: "Σύγκριση Finance ↔ Καθαρισμού & Κτιρίων. Εντοπίστε ορφανές εγγραφές, σπασμένους συνδέσμους και εκκρεμείς συγχρονισμούς — επισκευή με ασφάλεια.",
    runRepair: "Εκτέλεση Επισκευής",
    repairing: "Επισκευή...",
    generated: "Δημιουργήθηκε",
    allInSync: "Όλα συγχρονισμένα.",
    issuesFound: "ζητήματα στις ενότητες",
    reconciliationStatus: "Συμφωνία",
    reconciliationTotals: "Συνολική Συμφωνία",
    financeTotal: "Έσοδα Finance (ενεργά)",
    syncedToCleaning: "Συγχρονισμένα ↔ Καθαρισμός",
    syncedToBuilding: "Συγχρονισμένα ↔ Κτίρια",
    manualIncomes: "Χειροκίνητα (χωρίς σύνδεση)",
    financeAnomalies: "Ανωμαλίες Finance",
    orphanCleaningLink: "Finance δείχνει σε ανύπαρκτη πληρωμή καθαρισμού",
    orphanBuildingLink: "Finance δείχνει σε ανύπαρκτη πληρωμή κτιρίου",
    missingBankAccount: "Έσοδο τράπεζας/κάρτας χωρίς λογαριασμό",
    softDeletedStillLinked: "Διαγραμμένη εγγραφή Finance εξακολουθεί να έχει σύνδεση",
    cleaningAnomalies: "Πληρωμές Καθαρισμού",
    synced: "Συγχρονισμένα",
    reverseSyncFromFinance: "Από Finance",
    pendingNoLink: "Εκκρεμή (χωρίς σύνδεση)",
    brokenLinks: "Σπασμένοι σύνδεσμοι",
    cleaningPendingNoLink: "Πληρωμές καθαρισμού μη συγχρονισμένες με Finance",
    cleaningBrokenLink: "Πληρωμή καθαρισμού συνδέεται με διαγραμμένη εγγραφή Finance",
    cleaningMissingClient: "Η πληρωμή καθαρισμού έχει ανύπαρκτο client_id",
    buildingAnomalies: "Πληρωμές Κτιρίων",
    buildingPendingNoLink: "Πληρωμές κτιρίων μη συγχρονισμένες με Finance",
    buildingBrokenLink: "Πληρωμή κτιρίου συνδέεται με διαγραμμένη εγγραφή Finance",
    buildingMissingBuilding: "Η πληρωμή κτιρίου έχει ανύπαρκτο building_id",
    backToFinance: "Πίσω στο Finance",
    rows: "εγγραφές",
    clientOrBuilding: "Πελάτης / Κτίριο",
    hoursShort: "Ώρες",
    category: "Κατηγορία",
    manageCategories: "Διαχείριση",
    // Phase 478 — Full professional invoice editor.
    billTo: "Χρέωση Προς",
    vatNumber: "ΑΦΜ",
    contact: "Επικοινωνία",
    noContactOnFile: "Δεν υπάρχει επικοινωνία",
    invoiceNumber: "Αρ. Τιμολογίου",
    autoGenerated: "Αυτόματη δημιουργία",
    paymentTerms: "Όροι Πληρωμής",
    paymentTermsExample: "π.χ. Net 30",
    items: "Είδη",
    addItem: "Προσθήκη Είδους",
    itemDescription: "Περιγραφή",
    itemExamplePlaceholder: "Καθαρισμός Γραφείου – Μάιος 2026",
    qty: "Ποσ.",
    unitPrice: "Τιμή",
    tax: "ΦΠΑ %",
    customerNotes: "Σημειώσεις Πελάτη",
    visibleOnPdf: "ορατό στο PDF",
    customerNotesPlaceholder: "Σας ευχαριστούμε.",
    internalNotes: "Εσωτερικές Σημειώσεις",
    notOnPdf: "δεν εμφανίζεται στο PDF",
    internalNotesPlaceholder: "Ιδιωτικές σημειώσεις — μόνο για την ομάδα.",
    subtotal: "Υποσύνολο",
    discount: "Έκπτωση",
    adjustment: "Προσαρμογή",
    grandTotal: "Γενικό Σύνολο",
    amountPaid: "Πληρωθέν",
    remainingBalance: "Υπόλοιπο",
    invoiceAtLeastOneItem: "Προσθέστε τουλάχιστον ένα είδος με περιγραφή, ποσότητα και τιμή",
    totalMustBePositive: "Το γενικό σύνολο πρέπει να είναι > 0",
    invoicesReadOnlyHint: "Τα τιμολόγια διαχειρίζονται αποκλειστικά από το Finance. Εμφανίζονται εδώ αυτόματα μόλις εκδοθούν — εμφανίζονται και οι δύο τύποι (Εσωτερικά IC-* και Επίσημα SI-*), ομαδοποιημένα παρακάτω.",
    autoSynced: "Αυτόματος Συγχρ.",
    autoSyncedHint: "Πληρωμή αυτόματα συγχρονισμένη από Finance",
    autoSyncedFromFinanceHint: "Συγχρονισμένο από το Finance — διαχείριση στο /sales",
    openInFinance: "Άνοιγμα στο Finance",
    filtered: "φιλτραρισμένο",
    invoicedMinusCost: "τιμολογημένα − κόστος",
    internalInvoices: "Εσωτερικά Τιμολόγια (IC-*)",
    officialInvoices: "Επίσημα Τιμολόγια (SI-*)",
    // Phase 609 — Cleaner payment allocations.
    paymentAmount: "Πληρωμή",
    allocated: "Κατανεμημένα",
    unallocated: "Ακατανέμητα",
    autoAllocateFifo: "Αυτόματη κατανομή FIFO στις παλαιότερες ανεξόφλητες εργασίες (συνιστάται)",
    unpaidJobs: "Ανεξόφλητες / Μερικώς Πληρωμένες Εργασίες",
    noUnpaidJobs: "Καμία ανεξόφλητη εργασία — η πληρωμή θα καταγραφεί ως πλήρως ακατανέμητο πιστωτικό υπόλοιπο.",
    allocate: "Κατανομή",
    overAllocatedWarn: "Οι κατανομές υπερβαίνουν το ποσό της πληρωμής. Μειώστε ορισμένες γραμμές.",
    unallocatedRemainderWarn: "Μέρος της πληρωμής θα παραμείνει ως ακατανέμητο πιστωτικό υπόλοιπο.",
    cannotOverAllocate: "Το συνολικό ποσό κατανομής δεν μπορεί να υπερβαίνει το ποσό της πληρωμής.",
    runningBalance: "Τρέχον υπόλοιπο",
    debit: "Χρέωση",
    credit: "Πίστωση",
    legacy: "Παλαιό",
    // Phase 611 — Unified allocation modal.
    outstandingDebits: "Ανεξόφλητες Χρεώσεις",
    noOpenDebits: "Καμία ανεξόφλητη χρέωση — η πληρωμή θα καταγραφεί ως πλήρως ακατανέμητο πιστωτικό υπόλοιπο.",
    editAllocation: "Επεξεργασία Κατανομής",
    unallocatedHint: "Δεν έχει συνδεθεί ακόμα με χρέωση",
    jobs: "Εργασίες",
    buildings: "Κτίρια",
    building: "Κτίριο",
    client: "Πελάτης",
    job: "Εργασία",
    clickToAllocateFull: "Κάντε κλικ για να κατανείμετε ολόκληρο το ανεξόφλητο ποσό. Κάντε ξανά κλικ για επαναφορά.",
    noDebitsInRange: "Δεν υπάρχουν ανεξόφλητες χρεώσεις στην επιλεγμένη περίοδο. Προσαρμόστε ή καθαρίστε το φίλτρο.",
    outOfRangeAllocsWarn: "{count} προϋπάρχουσα(ες) κατανομή(ές) συνολικού ποσού €{total} βρίσκονται εκτός της ενεργής περιόδου και αποκρύπτονται αλλά θα αποθηκευτούν. Καθαρίστε το φίλτρο για να τις προβάλετε ή να τις επεξεργαστείτε.",
    mergedDuplicateRowsTip: "Συγχωνευμένες από διπλότυπες εγγραφές cleaning_history για το ίδιο κτίριο και ημερομηνία.",
    statusPaid: "ΠΛΗΡΩΘΗΚΕ",
    statusPartial: "ΜΕΡΙΚΩΣ",
    statusUnpaid: "ΕΚΚΡΕΜΕΙ",
    ledger: "Καθολικό",
    monthlyPayroll: "Μηνιαία Μισθοδοσία",
    monthlyPayrollSummary: "Σύνοψη Μηνιαίας Μισθοδοσίας",
    monthlyPayrollHint: "Οι μήνες βασίζονται στην ημερομηνία εκτέλεσης της εργασίας, όχι στην ημερομηνία πληρωμής. Για χρονοδιάγραμμα ανά ημερομηνία πληρωμής, ανοίξτε την καρτέλα Καθολικό.",
    workDateRange: "Ημερομηνία εργασίας",
    workDateFrom: "Από Ημερομηνία Εργασίας",
    workDateTo: "Έως Ημερομηνία Εργασίας",
    jobsAndBuildings: "Εργασίες & Κτίρια",
    paymentsForMonthWork: "Πληρωμές για Εργασίες {month}",
    noJobsThisMonth: "Δεν υπάρχουν καταχωρημένες εργασίες για αυτόν τον μήνα.",
    noPaymentsThisMonthWork: "Δεν έχουν συνδεθεί ακόμη πληρωμές με τις εργασίες αυτού του μήνα.",
    paymentDate: "Ημ/νία Πληρωμής",
    paymentDateInfoOnly: "Η ημερομηνία πληρωμής είναι μόνο πληροφοριακή — ο μήνας εργασίας καθορίζει την κατηγοριοποίηση της μισθοδοσίας.",
    unallocatedPayments: "Μη Κατανεμημένες Πληρωμές",
    unallocatedPaymentsHint: "(πληρωμές που δεν έχουν συνδεθεί ακόμη με συγκεκριμένη εργασία ή κτίριο)",
    earned: "Έσοδα",
    paid: "Πληρώθηκαν",
    payrollMonth: "Μήνας Μισθοδοσίας",
    payrollMonthHelp: "Δηλώνει σε ποιον μήνα εργασίας ανήκει η πληρωμή. Μια πληρωμή τον Ιούνιο μπορεί να αφορά εργασίες Μαΐου.",
    payrollMonthRequired: "Ο Μήνας Μισθοδοσίας είναι υποχρεωτικός.",
    paymentDateHelp: "Η πραγματική ημερομηνία που πληρώθηκε ο καθαριστής.",
    jumpToMonth: "Μετάβαση σε μήνα",
    selectMonth: "Επιλογή μήνα",
    selectYear: "Επιλογή έτους",
    showAllMonths: "Όλοι οι μήνες",
    totalPaid: "Σύνολο Πληρωμών",
    editPayment: "Επεξεργασία Πληρωμής",
    sendgridApiKey: "Κλειδί API SendGrid",
    brevoApiKey: "Κλειδί API Brevo",
    sendgridHint: "Το SendGrid χρησιμοποιεί Authorization: Bearer <κλειδί>. Βεβαιωθείτε ότι το email αποστολέα είναι επιβεβαιωμένο (Single Sender ή Domain Authentication).",
    brevoHint: "Το Brevo χρησιμοποιεί POST https://api.brevo.com/v3/smtp/email με κεφαλίδα api-key. Βεβαιωθείτε ότι το email αποστολέα είναι επιβεβαιωμένος αποστολέας στον λογαριασμό Brevo.",
    month: "Μήνας",
    year: "Έτος",
    opening: "Άνοιγμα",
    earnings: "έσοδα",
    contactDirectory: "Κατάλογος Επαφών",
    general: "Γενικά",
    contactsHint: "Βρείτε οποιονδήποτε ιδιοκτήτη ή ενοικιαστή σε όλα τα κτίρια με τηλέφωνο, όνομα, διαμέρισμα ή κτίριο.",
    contactsSearchPlaceholder: "Τηλέφωνο, όνομα ιδιοκτήτη / ενοικιαστή, αριθμός διαμερίσματος, ή όνομα κτιρίου…",
    contactsHintMin2: "Πληκτρολογήστε τουλάχιστον 2 χαρακτήρες για αναζήτηση.",
    contactsNoMatch: "Δεν βρέθηκαν επαφές.",
    ownerPhone: "Τηλέφωνο Ιδιοκτήτη",
    tenantPhone: "Τηλέφωνο Ενοικιαστή",
    searching: "Αναζήτηση…",
    result: "αποτέλεσμα",
    results: "αποτελέσματα",
    // Phase 481 — Duplicate clients & merge.
    duplicateClients: "Διπλότυποι πελάτες",
    noDuplicateClients: "Δεν εντοπίστηκαν διπλότυποι πελάτες.",
    duplicateClientsHint: "Ζεύγη ενεργών πελατών που κανονικοποιούνται στο ίδιο όνομα (αγνοεί πεζά/κεφαλαία και προθέσεις όπως LTD / INC). Επιλέξτε επιβιώσαντα και πατήστε Συγχώνευση — η πηγή θα διαγραφεί ήπια και όλες οι εργασίες / τιμολόγια / πληρωμές θα ανακατευθυνθούν.",
    suggestedSurvivor: "Προτεινόμενος επιβιώσας",
    buildingAuto: "Αυτόματο από κτίριο",
    mergeIntoSurvivor: "Συγχώνευση",
    merging: "Συγχώνευση...",
    matchPaymentToInvoice: "Σύνδεση πληρωμής με τιμολόγιο (προαιρετικό)",
    billingAddress: "Διεύθυνση τιμολόγησης",
    amountNet: "Καθαρό Ποσό",
    vatAmount: "Ποσό ΦΠΑ",
    dueDate: "Ημ/νία λήξης",
    bankAccount: "Τραπεζικός λογαριασμός",
    bankTransfer: "Τραπεζική μεταφορά",
    cheque: "Επιταγή",
    selectClient: "Επιλογή Πελάτη",
    selectClientToShowStatement: "Επιλέξτε πελάτη για να δείτε την κατάσταση.",
    totalInvoiced: "Σύνολο τιμολογίων",
    allocated: "Κατανεμημένο",
    optional: "Προαιρετικό",
    none: "— Κανένα —",
    selected: "επιλεγμένα",
    clear: "Καθαρισμός",
    selectAll: "Επιλογή όλων",
    deselectAll: "Αποεπιλογή όλων",
    exportOptions: "Επιλογές Εξαγωγής",
    selectColumnsHint: "Επιλέξτε τις στήλες που θέλετε στο PDF.",
    selectAtLeastOneColumn: "Επιλέξτε τουλάχιστον μία στήλη",
    unallocatedCredit: "Αδιάθετο Υπόλοιπο",
    allocatedStatus: "Κατάσταση Κατανομής",
    fullyAllocated: "Πλήρως Κατανεμημένο",
    unallocated: "Αδιάθετο",
    partial: "Μερικώς",
    remaining: "υπόλοιπο",
    deleteSelected: "Διαγραφή Επιλεγμένων",
    cannotDeleteLinked: "Αδύνατη διαγραφή. Συνδέεται με υπάρχουσες εργασίες/ιστορικό",
    linkedToJobs: "συνδέονται με εργασίες/ιστορικό",
    partiallyDeleted: "Ορισμένες εγγραφές δεν διαγράφηκαν",
    distributionMethod: "Μέθοδος κατανομής",
    byShare: "Με ποσοστό (%)",
    byShareHint: "Κατανομή ανάλογα με το ποσοστό ιδιοκτησίας.",
    equally: "Εξίσου",
    equallyHint: "Ίσος καταμερισμός ανά διαμέρισμα.",
    noPlansAvailable: "Δεν υπάρχουν διαθέσιμα πλάνα",
    noPlansAvailableHint: "Δημιουργήστε το πρώτο σας ετήσιο πλάνο για να ξεκινήσετε.",
    createNewPlan: "Δημιουργία Νέου Πλάνου",
    selectPlan: "Επιλογή Πλάνου",
    duplicateChoice: "Τι θέλετε να διατηρηθεί στο αντίγραφο;",
    duplicateKeepRounded: "Διατήρηση όλων των Στρογγυλοποιημένων (€)",
    duplicateKeepRoundedDesc: "Ιδανικό για μικρές παραλλαγές — τα ακριβή ποσά μεταφέρονται.",
    duplicateResetRounded: "Επαναφορά Στρογγυλοποιημένων — υπολογισμός από προϋπολογισμό",
    duplicateResetRoundedDesc: "Ιδανικό για νέα σενάρια — ξεκινήστε με αυτόματες τιμές.",

    // Phase 150 — Αυτόματος συγχρονισμός μηνιαίας χρέωσης από το Ενεργό Πλάνο.
    repairs: "Επισκευές",
    fromPlan: "Από Πλάνο",
    feeFromActivePlanHint: "Η μηνιαία χρέωση ελέγχεται από το Ενεργό Πλάνο Ετήσιων Εξόδων (Στρογγυλοποιημένη τιμή).",

    // Phase 282 — Ιστορικό Ιδιοκτητών (χρονογραμμή ιδιοκτησίας)
    ownerHistory: "Ιστορικό Ιδιοκτητών",
    ownerHistoryTitle: "Ιστορικό Ιδιοκτητών",
    ownerHistoryDesc: "Χρονογραμμή όλων των αλλαγών ιδιοκτησίας. Τα παλιά τιμολόγια παραμένουν συνδεδεμένα με τον σωστό ιδιοκτήτη.",
    addOwnerHistory: "Προσθήκη Ιδιοκτήτη",
    editOwnerHistory: "Επεξεργασία Ιδιοκτήτη",
    deleteOwnerHistory: "Διαγραφή Ιδιοκτήτη",
    deleteOwnerHistoryConfirm: "Διαγραφή αυτής της εγγραφής ιδιοκτήτη; Η ενέργεια είναι μη αναστρέψιμη.",
    firstName: "Όνομα",
    lastName: "Επώνυμο",
    ownershipPercentage: "Ποσοστό Ιδιοκτησίας %",
    startDate: "Ημ/νία Έναρξης",
    endDate: "Ημ/νία Λήξης",
    statusActive: "Ενεργός",
    statusPrevious: "Προηγούμενος",
    reasonForChange: "Λόγος Αλλαγής",
    reasonSale: "Πώληση",
    reasonDonation: "Δωρεά",
    reasonInheritance: "Κληρονομιά",
    reasonOther: "Άλλο",
    noOwnerHistory: "Δεν υπάρχουν ακόμα εγγραφές ιδιοκτητών. Προσθέστε την πρώτη για να ξεκινήσει η παρακολούθηση.",
    markAsPrevious: "Σήμανση ως Προηγούμενος",
    markAsActive: "Σήμανση ως Ενεργός",
    apartmentLabel: "Διαμέρισμα",
    autoCloseHint: "Η σήμανση ως ενεργός θα κλείσει αυτόματα όλες τις άλλες ενεργές εγγραφές αυτού του διαμερίσματος.",
    cannotDeleteOwnerLinked: "Δεν είναι δυνατή η διαγραφή: συνδέεται με υπάρχοντα τιμολόγια/πληρωμές.",
    buildingOwnerHistoryDesc: "Όλες οι αλλαγές ιδιοκτησίας σε όλα τα διαμερίσματα του κτιρίου.",

    // Phase 336 — Repairs PDF preview & column selector
    repairsReport: "Αναφορά Επισκευών",
    pdfPreview: "Προεπισκόπηση PDF",
    previewAndDownload: "Προεπισκόπηση και λήψη του PDF της κατάστασης επισκευής.",
    closePreview: "Κλείσιμο",
    repairPdfOptions: "Επιλογές PDF Επισκευής",
    repairPdfOptionsHint: "Επιλέξτε τις στήλες που θα συμπεριληφθούν στο PDF. Η επιλογή σας αποθηκεύεται για την επόμενη φορά.",
    generatePreview: "Δημιουργία Προεπισκόπησης",

    // Phase 337 — Email Templates ανά πολυκατοικία
    emailTemplates: "Πρότυπα Email",
    generateEmail: "Δημιουργία Email",
    generateEmailHint: "Επιλέξτε ή επεξεργαστείτε ένα template, συμπληρώστε τιμές, προεπισκοπήστε και στη συνέχεια αντιγράψτε/στείλτε.",
    templates: "Πρότυπα",
    newTemplate: "Νέο",
    noTemplatesYet: "Δεν υπάρχουν πρότυπα ακόμα. Πατήστε «Νέο» για να δημιουργήσετε.",
    templateName: "Όνομα Προτύπου",
    templateNamePh: "π.χ. Μηνιαία Αναφορά",
    templateNameRequired: "Το όνομα του προτύπου είναι υποχρεωτικό",
    setAsDefault: "Ορισμός ως προεπιλογή",
    editor: "Επεξεργαστής",
    body: "Σώμα",
    characters: "χαρ.",
    availablePlaceholders: "Διαθέσιμα Placeholders",
    customFields: "Προσαρμοσμένα Πεδία",
    customFieldNamePh: "π.χ. Υπενθυμίσεις",
    noCustomFields: "Δεν υπάρχουν προσαρμοσμένα πεδία. Προσθέστε για να εμφανιστούν placeholders {{custom:Name}}.",
    previewAndSend: "Προεπισκόπηση & Αποστολή",
    balanceAsOf: "Υπόλοιπο Έως",
    balanceAsOfHint: "Κενό = σήμερα. Επηρεάζει τις τιμές μετρητών & τραπέζης.",
    customFieldValues: "Τιμές Προσαρμοσμένων Πεδίων",
    customFieldValuePh: "Εισάγετε περιεχόμενο…",
    preview: "Προεπισκόπηση",
    copy: "Αντιγραφή",
    copiedToClipboard: "Αντιγράφηκε στο πρόχειρο",
    sendEmail: "Αποστολή Email",
    sendEmailHint: "Το email αποστέλλεται μέσω Brevo με το προεπισκοπημένο περιεχόμενο.",
    to: "Προς",
    commaSeparated: "Διαχωρισμός με κόμμα.",
    atLeastOneRecipient: "Απαιτείται τουλάχιστον ένας παραλήπτης",
    emailSent: "Το email στάλθηκε",
    confirmDeleteTemplate: "Διαγραφή αυτού του προτύπου;",
    managerName: "Όνομα Διαχειριστή",
    managerNamePh: "π.χ. Ιωάννης Παπαδόπουλος",
    committeeName: "Όνομα Επιτροπής",
    committeeNamePh: "π.χ. Επιτροπή Πολυκατοικίας",
    emailContactLabels: "Ετικέτες Επικοινωνίας Email",
    emailContactLabelsHint: "Χρησιμοποιείται από τα πρότυπα Email για αυτόματη συμπλήρωση των {{manager_name}} και {{committee_name}}.",

    // Phase 339 — Email History (audit log)
    compose: "Σύνταξη",
    emailHistory: "Ιστορικό Email",
    searchHistoryPh: "Αναζήτηση σε θέμα, σώμα, παραλήπτη, πρότυπο…",
    allStatuses: "Όλες οι καταστάσεις",
    sent: "Στάλθηκε",
    failed: "Απέτυχε",
    sentAt: "Ημερομηνία",
    recipients: "Παραλήπτες",
    template: "Πρότυπο",
    sentBy: "Από",
    actions: "Ενέργειες",
    resend: "Επαναποστολή",
    noEmailHistory: "Δεν έχουν σταλεί email ακόμα.",
    emailDetails: "Λεπτομέρειες Email",
    error: "Σφάλμα",
    building: "Πολυκατοικία",
    close: "Κλείσιμο",

    // Phase 340 — Expense category auto-fill picker
    expenseCategories: "Κατηγορίες Εξόδων",
    expenseCategoriesHint: "Κάντε κλικ για εισαγωγή της τελευταίας εγγραφής κάθε κατηγορίας. Κατηγορίες χωρίς εγγραφές αποκρύπτονται αυτόματα.",
    insertAll: "Εισαγωγή όλων",
    insertAllCategories: "Εισαγωγή όλων των κατηγοριών",

    // Phase 345 — Απόκρυψη / επαναφορά chips & κουμπιά αποστολής στον editor
    restoreHiddenTags: "Επαναφορά κρυφών",
    confirmRestoreHiddenTags: "Επαναφορά όλων των κρυφών placeholders και κατηγοριών;",
    allPlaceholdersHidden: "Όλα τα placeholders είναι κρυφά.",
    allCategoriesHidden: "Όλες οι κατηγορίες είναι κρυφές.",
    copyResolved: "Αντιγραφή τελικού περιεχομένου",

    // Phase 347 — Συμπαγής επιλογή προτύπου + Αποστολή / Επιβεβαίωση / Συνημμένα
    selectTemplate: "Επιλέξτε πρότυπο…",
    liveBalancesNote: "Τα {{cash_balance}} & {{bank_balance}} εμφανίζουν πάντα τα ΖΩΝΤΑΝΑ ποσά (όπως στο Dashboard).",
    addFiles: "Προσθήκη αρχείων",
    replace: "Αντικατάσταση",
    noAttachmentsHint: "Δεν υπάρχουν συνημμένα. Υποστηρίζονται PDF, Excel, Word, εικόνες και άλλες κοινές μορφές.",
    attachments: "Συνημμένα",
    reviewAndSend: "Έλεγχος & Αποστολή",
    sendEmailHintConfirm: "Προσθέστε παραλήπτες & συνημμένα. Θα εμφανιστεί τελική προεπισκόπηση πριν την αποστολή.",
    confirmSendTitle: "Τελική προεπισκόπηση",
    confirmSendHint: "Αυτό ακριβώς θα λάβουν οι παραλήπτες. Πατήστε «Επιβεβαίωση Αποστολής» για αποστολή.",
    confirmSend: "Επιβεβαίωση Αποστολής",

    // Phase 341 — Πιστοποίηση Πυροσβεστήρων
    fireCertification: "Πιστοποίηση Πυροσβεστήρων",
    fireCertHint: "Καταχωρίστε τα στοιχεία της τελευταίας ετήσιας επιθεώρησης και του συμβολαίου συντήρησης πυροσβεστήρων.",
    latestCertification: "Τελευταία Πιστοποίηση",
    addCertification: "Προσθήκη Πιστοποίησης",
    editCertification: "Επεξεργασία Πιστοποίησης",
    confirmDeleteCertification: "Διαγραφή αυτής της πιστοποίησης;",
    noFireCertYet: "Δεν έχει καταχωρηθεί πιστοποίηση πυροσβεστήρων ακόμα. Πατήστε «Προσθήκη Πιστοποίησης» για να δημιουργήσετε την πρώτη.",
    companyName: "Όνομα Εταιρείας",
    companyNamePh: "Ή πληκτρολογήστε όνομα…",
    companyNameRequired: "Το όνομα εταιρείας είναι υποχρεωτικό",
    selectCompany: "Επιλέξτε εταιρεία…",
    addCompany: "Προσθήκη εταιρείας",
    addCompanyHint: "Καταχωρίστε νέο πάροχο υπηρεσιών πυροσβεστήρων.",
    certificationDate: "Ημερομηνία Πιστοποίησης",
    quantity: "Ποσότητα",
    unitPrice: "Τιμή Μονάδας",
    totalAmount: "Σύνολο",
    totalAutoHint: "Αυτόματο = ποσότητα × τιμή μονάδας. Επεξεργάσιμο.",
    contractNumber: "Αριθμός Συμβολαίου",
    contractStartDate: "Έναρξη Συμβολαίου",
    contractEndDate: "Λήξη Συμβολαίου",
    notesPh: "Σημειώσεις πολλαπλών γραμμών…",
    history: "Ιστορικό",
    phone: "Τηλέφωνο",

    // Phase 342 — Καθολικός κατάλογος Εταιρειών Πυροσβεστήρων
    fireExtinguisherCompanies: "Εταιρείες Πυροσβεστήρων",
    assignedCompany: "Ανατεθειμένη Εταιρεία",
    manageCompanies: "Διαχείριση εταιρειών",
    noFireCompaniesHint: "Δεν υπάρχουν εταιρείες ακόμα. Πατήστε «Διαχείριση εταιρειών» για να προσθέσετε.",
    companyRequired: "Παρακαλώ επιλέξτε εταιρεία",
    storedCompanyName: "Αποθηκευμένο όνομα",
    contactPerson: "Πρόσωπο Επικοινωνίας",

    // Phase 346 — Κέντρο Εταιρειών μέσα στο Manage Buildings → Settings
    companies: "Εταιρείες",
    companiesHint: "Διαχειριστείτε όλους τους καταλόγους παρόχων (ασφάλεια, ανελκυστήρας, πιστοποίηση, πυροσβεστήρες)",
    companiesIntro: "Διαχειριστείτε όλους τους παρόχους υπηρεσιών από ένα σημείο. Κάθε κατηγορία ανοίγει την οθόνη CRUD με αναζήτηση, επεξεργασία και διαγραφή.",
    insuranceCompaniesHint: "Πάροχοι ασφάλειας πολυκατοικιών — στοιχεία επικοινωνίας & συμβόλαια.",
    elevatorCompaniesHint: "Εταιρείες συντήρησης ανελκυστήρων — στοιχεία επικοινωνίας & συμβόλαια.",
    certificationCompaniesHint: "Εταιρείες πιστοποίησης ανελκυστήρων — επιθεωρητές & συμβόλαια.",
    fireExtinguisherCompaniesHint: "Εταιρείες πυροσβεστήρων — ετήσιες πιστοποιήσεις & συμβόλαια.",

    // Phase 348 — Καθολικοί Προμηθευτές / Κατηγορίες Εξόδων / Αιτίες Βλαβών
    vendorsCentralHint: "Κεντρικός κατάλογος προμηθευτών — προσθήκη, επεξεργασία, διαγραφή και αναζήτηση.",
    expenseCategoriesCentralHint: "Κεντρική διαχείριση κατηγοριών εξόδων (μηνιαίες + κεφαλαιουχικές) — ισχύει σε όλες τις πολυκατοικίες.",
    failureReasonsCentralHint: "Κεντρική λίστα αιτιών βλαβών ανελκυστήρα — κοινή για όλες τις πολυκατοικίες.",
    searchCategoryPh: "Αναζήτηση με κωδικό ή όνομα…",

    // Phase 349 — Καθολικά πρότυπα email + tab αποστολής ανά κτίριο
    emailTemplatesCentralHint: "Κεντρική διαχείριση προτύπων email — κοινά για όλες τις πολυκατοικίες.",
    emailTemplatesGlobalHint: "Τα πρότυπα είναι κοινά για όλες τις πολυκατοικίες. Επιλέξτε ποιο θα χρησιμοποιείτε από το tab «Emails» κάθε κτιρίου.",
    emails: "Emails",
    emailCenter: "Κέντρο Email",
    // Phase 810 — Operations Dashboard widgets (Greek)
    electricityWidget: "Ηλεκτρικό",
    nextMeetings: "Επόμενες Συνελεύσεις",
    noElectricityData: "Δεν υπάρχουν πληρωμές ηλεκτρικού",
    managementWidget: "Διαχείριση",
    noManagementData: "Δεν υπάρχουν πληρωμές διαχείρισης",
    noEmails: "Δεν έχουν σταλεί email",
    noNextMeetings: "Δεν υπάρχουν προγραμματισμένες συνελεύσεις",
    emailCenterMailbox: "Θυρίδα",
    emailCenterInbox: "Εισερχόμενα",
    emailCenterSent: "Απεσταλμένα",
    emailCenterDrafts: "Πρόχειρα",
    emailCenterArchive: "Αρχείο",
    emailCenterTrash: "Κάδος",
    emailCenterCompose: "Σύνταξη",
    emailCenterReply: "Απάντηση",
    emailCenterReplyAll: "Απάντηση σε όλους",
    emailCenterForward: "Προώθηση",
    emailCenterSearch: "Αναζήτηση",
    emailCenterCompanyMailbox: "Εταιρική θυρίδα",
    selectPeriodFirst: "Επιλέξτε ημερομηνίες Από και Έως",
    invalidPeriod: "Η ημερομηνία «Από» πρέπει να είναι πριν ή ίδια με την «Έως»",
    setActive: "Ενεργό",
    setActiveTemplateForBuilding: "Καρφίτσωμα ως ενεργό για αυτό το κτίριο",
    templatePreview: "Προεπισκόπηση προτύπου",
    attachElevatorStatement: "Επισύναψη κατάστασης ανελκυστήρα",
    attachElevatorStatementHint: "Το PDF της κατάστασης θα δημιουργηθεί αυτόματα για την επιλεγμένη περίοδο και θα επισυναφθεί.",
    autoGenerated: "αυτόματο",
    noAttachments: "Δεν υπάρχουν συνημμένα.",
    from: "Από",

    // Phase 351 — Ιστορικό Email ανά κτίριο + φίλτρο περιόδου κατάστασης
    template: "Πρότυπο",
    resend: "Επαναποστολή",
    view: "Προβολή",
    emailDetails: "Λεπτομέρειες Email",
    readyToResend: "Αντιγράφηκαν οι παραλήπτες — ελέγξτε & στείλτε όταν είστε έτοιμοι.",
    searchHistoryPh: "Αναζήτηση παραλήπτη / θέματος / προτύπου…",
    noEmailsYet: "Δεν έχουν σταλεί ακόμα emails από αυτή την πολυκατοικία.",
    clear: "Καθαρισμός",

    // Phase 352 — Κέντρο Γενικών Συνελεύσεων (Ημερήσια Διάταξη + Κείμενα)
    generalMeetings: "Γενικές Συνελεύσεις",
    generalMeetingsHint: "Πρότυπα Ημερήσιας Διάταξης + Πρότυπα Κειμένων Συνελεύσεων — κοινά για όλες τις πολυκατοικίες.",
    generalMeetingsIntro: "Κεντρική διαχείριση των προτύπων που χρησιμοποιούνται σε όλες τις γενικές συνελεύσεις των πολυκατοικιών.",
    agendaTemplatesHint: "Κατάλογος προτύπων θεμάτων που χρησιμοποιούνται όταν δημιουργείτε νέα γενική συνέλευση.",
    meetingTextTemplates: "Πρότυπα Κειμένων Συνελεύσεων",
    meetingTextTemplatesHint: "Νομικό κείμενο απαρτίας & κείμενο απόφασης επιτροπής — αυτόματα κείμενα στα πρακτικά.",
    // Phase 733 — Agenda Templates per-topic template text (Greek)
    greekTemplateText: "Ελληνικό Κείμενο Προτύπου",
    greekTemplatePlaceholder: "Κείμενο που εισάγεται αυτόματα στη συνέλευση όταν επιλέγεται αυτό το θέμα.",
    englishTranslation: "Αγγλική Μετάφραση",
    englishTemplatePlaceholder: "Προαιρετική αγγλική έκδοση του κειμένου προτύπου.",
    filled: "Συμπληρώθηκε",

    // Phase 343 — Sub-tabs Fire Cert (Τιμολόγια / Πληρωμές / Κατάσταση)
    certifications: "Πιστοποιήσεις",
    certificationExpiryDate: "Λήξη Πιστοποίησης",
    invoices: "Τιμολόγια",
    payments: "Πληρωμές",
    statement: "Κατάσταση",
    addInvoice: "Προσθήκη τιμολογίου",
    noFireInvoices: "Δεν υπάρχουν συνδεδεμένα τιμολόγια ακόμα.",
    noFirePayments: "Δεν υπάρχουν κατανεμημένες πληρωμές ακόμα.",
    paymentsAutoHint: "Οι πληρωμές κατανέμονται αυτόματα από τα Cash/Bank Receipts όταν ορίσετε την πηγή στο τιμολόγιο.",
    description: "Περιγραφή",
    reference: "Αναφορά",
    source: "Πηγή",
    openingBalance: "Υπόλοιπο Έναρξης",
    invoicesTotal: "Σύνολο Τιμολογίων",
    paymentsTotal: "Σύνολο Πληρωμών",
    remainingBalance: "Υπόλοιπο",

    // Phase 344 — Ledger statement + inline επεξεργασία
    invoiceNumber: "Αρ. Τιμολογίου",
    invoiceAmount: "Ποσό Τιμολογίου",
    receiptNumber: "Αρ. Απόδειξης",
    receiptAmount: "Ποσό Απόδειξης",
    runningBalance: "Τρέχον Υπόλοιπο",
    totals: "Σύνολα",
    noLedgerEntries: "Δεν υπάρχουν εγγραφές ακόμα.",
    editInvoice: "Επεξεργασία Τιμολογίου",
    editInvoiceHint: "Οι αλλαγές ενημερώνουν το συνδεδεμένο έξοδο σε πραγματικό χρόνο.",
    editPayment: "Επεξεργασία Πληρωμής",
    editPaymentHint: "Οι αλλαγές προσαρμόζουν αυτόματα τα υπόλοιπα Cash / Bank.",
    confirmDeleteInvoice: "Διαγραφή αυτού του τιμολογίου;",
    confirmDeletePayment: "Διαγραφή αυτής της πληρωμής;",
    attachedFile: "Συνημμένο Αρχείο",
    attachedFiles: "αρχεία",
    attachments: "Συνημμένα",
    attachmentsHelp: "Ανέβασμα τιμολογίων, αποδείξεων, αποδεικτικών πληρωμής (PDF / εικόνα, έως 15MB).",
    uploadFiles: "Ανέβασμα αρχείων",
    multipleFilesAllowed: "Επιτρέπονται πολλά αρχεία · PDF, PNG, JPG, WEBP",
    uploading: "Ανέβασμα…",
    addAttachment: "Προσθήκη συνημμένου",
    fileName: "Αρχείο",
    size: "Μέγεθος",
    uploadedAt: "Ανέβηκε",
    // Phase 437 — Expense Vendors page + nested customer/supplier detail
    telephone: "Τηλέφωνο",
    expenseVendors: "Πάροχοι Εξόδων",
    expenseVendorsDesc: "Πάροχοι που χρησιμοποιούνται στα Οικονομικά → Έξοδα. Ανεξάρτητοι από Προμηθευτές, Λογαριασμούς και Διαχείριση Κτιρίων.",
    vendorSearchPlaceholder: "Αναζήτηση ή πληκτρολογήστε νέο πάροχο (π.χ. Petrolina, Superhome)",
    createVendor: "Δημιουργία παρόχου",
    startTyping: "Πληκτρολογήστε για αναζήτηση…",
    editVendor: "Επεξεργασία Παρόχου",
    deleteVendor: "Διαγραφή Παρόχου",
    confirmDeleteVendor: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον πάροχο;",
    vendorInUseWarning: "Ο πάροχος συνδέεται με ένα ή περισσότερα έξοδα. Επανατοποθετήστε ή διαγράψτε τα έξοδα πρώτα.",
    noVendors: "Δεν υπάρχουν πάροχοι ακόμη. Οι πάροχοι δημιουργούνται αυτόματα κατά την προσθήκη στη φόρμα Εξόδων, ή χειροκίνητα εδώ.",
    noMatches: "Κανένας πάροχος δεν ταιριάζει στην αναζήτησή σας.",
    totalExpenses: "Σύνολο Εξόδων",
    attachment: "Συνημμένο",
    fileTooLarge: "Το αρχείο είναι μεγαλύτερο από 5 MB",
    remove: "αφαίρεση",
    backToCustomers: "Πίσω στους Πελάτες",
    backToSuppliers: "Πίσω στους Προμηθευτές",
    customerNotFound: "Ο πελάτης δεν βρέθηκε",
    supplierNotFound: "Ο προμηθευτής δεν βρέθηκε",
    billingDetails: "Στοιχεία Χρέωσης",
    recentActivity: "Πρόσφατη Δραστηριότητα",
    noActivity: "Καμία δραστηριότητα ακόμη.",
    noInvoicesYet: "Δεν υπάρχουν τιμολόγια ακόμη.",
    noPaymentsYet: "Δεν υπάρχουν πληρωμές ακόμη.",
    totalInvoices: "Σύνολο Τιμολογίων",
    totalPayments: "Σύνολο Πληρωμών",
    contact: "Επαφή",
    back: "Πίσω",
    summary: "Σύνοψη",
    // Phase 438
    clearAll: "Καθαρισμός",
    minAmount: "Ελάχ. €",
    maxAmount: "Μέγ. €",
    invoicesLabel: "Τιμολόγια",
    paymentsLabel: "Πληρωμές",
    // Phase 439
    billCategoriesNestedDesc: "Δημιουργήστε δέντρο: Κατηγορία → Υποκατηγορία → Υπο-υποκατηγορία. Οι λογαριασμοί συνδέονται μόνο στο τελευταίο επίπεδο.",
    addChild: "Προσθήκη παιδιού",
    addSubcategory: "Προσθήκη υποκατηγορίας",
    editSubcategory: "Επεξεργασία υποκατηγορίας",
    deleteSubcategory: "Διαγραφή υποκατηγορίας",
    under: "Κάτω από",
    noSubcategories: "Δεν υπάρχουν υποκατηγορίες ακόμη — πατήστε + για προσθήκη.",
    noCategoriesYet: "Δεν υπάρχουν κατηγορίες ακόμη. Πατήστε + Προσθήκη κατηγορίας.",
    noLeafSubcategories: "Δεν υπάρχουν τερματικές υποκατηγορίες — προσθέστε μία στις Κατηγορίες",
    deleteWithChildrenHint: "Αυτός ο κόμβος έχει υποκόμβους ή/και λογαριασμούς. Επιλέξτε πώς να προχωρήσετε.",
    deleteCascadeHint: "Αφαίρεση όλων των υποκόμβων και των λογαριασμών τους.",
    confirmDeleteSimple: "Αυτό θα διαγράψει το στοιχείο οριστικά.",
    selectTarget: "Επιλέξτε προορισμό",
    // Phase 440
    editItem: "Επεξεργασία στοιχείου",
    deleteItem: "Διαγραφή στοιχείου",
    confirmDeleteItem: "Αυτό θα διαγράψει ήπια το στοιχείο. Οι λογαριασμοί που είναι συνδεδεμένοι παραμένουν αλλά δεν μπορούν να επεξεργαστούν.",
    identifier: "Αναγνωριστικό",
    itemIdHint: "Πινακίδα, αρ. δωματίου, μοντέλο, κ.λπ.",
    optional: "προαιρετικό",
    uncategorized: "χωρίς κατηγοριοποίηση — αντιστοιχίστε σε τερματική υποκατηγορία",
    // Phase 441
    subSubcategory: "Υπο-υποκατηγορία",
    categoryRequired: "Η κατηγορία είναι υποχρεωτική",
    subcategoryRequired: "Η υποκατηγορία είναι υποχρεωτική",
    pickDeepestSub: "Επιλέξτε την τερματική υποκατηγορία (η τρέχουσα έχει επιπλέον επίπεδα)",
    noSubsInCategory: "Αυτή η κατηγορία δεν έχει υποκατηγορίες. Προσθέστε μία στις Κατηγορίες πρώτα.",
    none: "Κανένα",
    // Phase 442
    billType: "Τύπος λογαριασμού",
    billTypeInvoice: "Τιμολόγιο",
    billTypeInvoiceDesc: "Παρακολουθεί ανεξόφλητο υπόλοιπο & ημερομηνία λήξης πληρωμής.",
    billTypeRenewal: "Ανανέωση / κάλυψη",
    billTypeRenewalDesc: "Τέλη κυκλοφορίας, ασφάλεια, ΚΤΕΟ, άδεια, συνδρομή. Κατάσταση = ενεργό μέχρι λήξη.",
    coverageStartDate: "Έναρξη κάλυψης",
    coverageExpiryDate: "Λήξη κάλυψης",
    renewalInvoicePlaceholder: "Αρ. απόδειξης / επιβεβαίωσης (προαιρετικό)",
    renewalReminderHint: "Υπενθύμιση 15 μέρες πριν τη λήξη. Κατάσταση: Ενεργό → Λήγει σύντομα → Έληξε αυτόματα.",
    expiryRequiredForRenewal: "Η ημερομηνία λήξης είναι υποχρεωτική για ανανεώσιμους λογαριασμούς",
    active: "Ενεργό",
    expiringSoon: "Λήγει σύντομα",
    expired: "Έληξε",
    pending: "Εκκρεμές",
    left: "ακόμη",
    overdue: "καθυστερεί",
    balanceOrDays: "Υπόλοιπο / Ημέρες",
    deleteBill: "Διαγραφή λογαριασμού",
    confirmDeleteBill: "Αυτό θα διαγράψει ήπια τον λογαριασμό και όλες τις πληρωμές. Οι υπενθυμίσεις σταματούν. Συνέχεια;",
    invoiceBills: "Λογαριασμοί Τιμολογίων",
    renewalBills: "Λογαριασμοί Ανανέωσης",
    invoiceBillsDesc: "Τυπικοί λογαριασμοί με αριθμό τιμολογίου, ημερομηνία λήξης, πληρωμένα/απλήρωτα υπόλοιπα και ΦΠΑ.",
    renewalBillsDesc: "Τέλη κυκλοφορίας, ασφάλειες, άδειες, συνδρομές — βασισμένα στην κάλυψη, παρακολουθούν ημερομηνία λήξης αντί χρέους.",
    amountPaid: "Πληρωμένο ποσό",
    amountPaidTotal: "Σύνολο πληρωμένο",
    renewalsCount: "Ανανεώσεις",
    activeRenewals: "Ενεργές",
    coverageOk: "κάλυψη σε ισχύ",
    within15Days: "εντός 15 ημερών",
    expiredOverdue: "Έληξαν / Καθυστερημένες",
    actionRequired: "απαιτείται ενέργεια",
    partiallyPaid: "Μερικώς Πληρωμένο",
    invoiceBill: "Λογαριασμός Τιμολογίου",
    initialPayment: "Αρχική πληρωμή",
    initialPaymentHint: "Καταχωρεί πληρωμή άμεσα. Άδειο = πλήρως απλήρωτο.",
    initialPayExceedsTotal: "Η πληρωμή υπερβαίνει το σύνολο του τιμολογίου.",
    paymentAmount: "Ποσό πληρωμής",
    paymentAmountRequired: "Το ποσό πρέπει να είναι > 0",
    paymentAdded: "Η πληρωμή προστέθηκε",
    paymentUpdated: "Η πληρωμή ενημερώθηκε",
    paymentDeleted: "Η πληρωμή διαγράφηκε",
    addPayment: "Προσθήκη πληρωμής",
    editPayment: "Επεξεργασία πληρωμής",
    deletePayment: "Διαγραφή πληρωμής",
    confirmDeletePayment: "Διαγραφή της πληρωμής; Το υπόλοιπο του λογαριασμού θα υπολογιστεί ξανά.",
    summary: "Σύνοψη",
    invoiceCreated: "Δημιουργία τιμολογίου",
    billTotal: "Σύνολο λογαριασμού",
    alreadyPaid: "Ήδη πληρώθηκαν",
    outstanding: "Εκκρεμές",
    viewDetails: "Προβολή λεπτομερειών",
    close: "Κλείσιμο",
    bank: "Τράπεζα",
    cash: "Μετρητά",
    card: "Κάρτα",
    cheque: "Επιταγή",
    other: "Άλλο",
    openCustomerStatement: "Άνοιγμα κατάστασης πελάτη",
    viewStatement: "Προβολή κατάστασης",
    fullStatement: "Πλήρης Κατάσταση",
    totalInvoiced: "Συνολικά τιμολογημένα",
    totalPaid: "Συνολικά πληρωμένα",
    outstandingBalance: "Εκκρεμές υπόλοιπο",
    settled: "Εξοφλημένο",
    runningBalance: "Τρέχον Υπόλοιπο",
    type: "Τύπος",
    debit: "Χρέωση",
    credit: "Πίστωση",
    noBillsYetForCustomer: "Δεν υπάρχουν λογαριασμοί ακόμη για αυτόν τον πελάτη.",
    invoicesLabel: "Τιμολόγια",
    totalPayments: "Συνολικές πληρωμές",
    noPaymentsThisMonth: "Δεν έχουν καταγραφεί πληρωμές αυτόν τον μήνα.",
    client: "Πελάτης / Προμηθευτής",
    selectBankAccount: "Επιλέξτε τραπεζικό λογαριασμό…",
    searchBankAccount: "Αναζήτηση τραπεζικού λογαριασμού…",
    noBankAccountsCreated: "Δεν έχουν δημιουργηθεί τραπεζικοί λογαριασμοί",
    createBankAccount: "Δημιουργία τραπεζικού λογαριασμού",
    noMatches: "Καμία αντιστοιχία.",
    weOwe: "Οφείλουμε",
    totalInvoiceAmount: "Συνολικό Ποσό Τιμολογίων",
    noEntriesInRange: "Δεν υπάρχουν εγγραφές στο επιλεγμένο διάστημα.",
    totals: "Σύνολα",
    openInvoices: "ανοιχτά",
    allocated: "Κατανεμημένο",
    unallocated: "Μη κατανεμημένο",
    allocate: "Κατανομή",
    full: "Πλήρες",
    noOpenInvoices: "Δεν υπάρχουν ανοιχτά τιμολόγια για κατανομή.",
    allocateFull: "Κατανομή πλήρους υπολοίπου",
    // Phase 960 — Λογαριασμοί → Προμηθευτές → Καρτέλα Προμηθευτή
    vendors: "Προμηθευτές",
    vendor: "Προμηθευτής",
    allInvoices: "Όλα τα Τιμολόγια",
    vendorsCount: "Προμηθευτές",
    outstandingBalance: "Υπόλοιπο",
    invoicedTotal: "Τιμολογήθηκαν",
    paidTotal: "Πληρώθηκαν",
    creditedTotal: "Πιστωτικά",
    creditNotes: "Πιστωτικά τιμολόγια",
    withBalance: "με υπόλοιπο",
    fullyPaid: "εξοφλημένα",
    invoices: "Τιμολόγια",
    withOutstanding: "Με Υπόλοιπο",
    searchVendorsPlaceholder: "Αναζήτηση προμηθευτή…",
    searchInvoicesPlaceholder: "Αναζήτηση αρ. τιμολογίου, σημείωσης, περιγραφής…",
    breakdown: "Κατάσταση",
    lastActivity: "Τελευταία κίνηση",
    unpaidShort: "απλήρωτα",
    partialShort: "μερικώς",
    paidShort: "εξοφλημένα",
    noVendors: "Δεν υπάρχουν προμηθευτές",
    noVendorsHint: "Προσθέστε λογαριασμό για να εμφανιστεί ο προμηθευτής εδώ.",
    backToVendors: "Πίσω",
    invoiceDate: "Ημερομηνία Τιμολογίου",
    invoicesLabel: "Τιμολόγια",
    paymentsLabel: "Πληρωμές",
    statement: "Καρτέλα",
    noInvoicesForVendor: "Κανένα τιμολόγιο δεν ταιριάζει με τα φίλτρα.",
    noPaymentsYet: "Δεν έχουν καταχωρηθεί πληρωμές ακόμη.",
    noEntries: "Καμία κίνηση σε αυτή την περίοδο.",
    runningBalance: "Υπόλοιπο",
    invoice: "Τιμολόγιο",
    payment: "Πληρωμή",
    creditNote: "Πιστωτικό",
    type: "Τύπος",
    renewals: "ανανεώσεις",
    // Phase 961 — Επεκτεινόμενη γραμμή + Απλήρωτα + Ασφαλής διαγραφή κατηγορίας
    paymentHistory: "Ιστορικό Πληρωμών",
    unpaidView: "Απλήρωτα",
    totalOutstanding: "Συνολικό Υπόλοιπο",
    allOpen: "Όλα τα Ανοικτά",
    searchUnpaidPlaceholder: "Αναζήτηση προμηθευτή, αρ. τιμολογίου, σημείωσης…",
    remaining: "Υπόλοιπο",
    overdue: "Ληξιπρόθεσμο",
    openVendorStatement: "Άνοιγμα καρτέλας προμηθευτή",
    allPaidUp: "Δεν εκκρεμούν πληρωμές",
    allPaidUpHint: "Δεν υπάρχουν απλήρωτα ή μερικώς πληρωμένα τιμολόγια στα φίλτρα.",
    deleteCategoryOnly: "Διαγραφή μόνο της κατηγορίας",
    deleteDetachHint: "Οι προμηθευτές, οι λογαριασμοί και οι πληρωμές διατηρούνται. Θα εμφανίζονται ως χωρίς κατηγορία.",
    moveToAnother: "Μεταφορά προμηθευτών σε άλλη κατηγορία",
    moveHint: "Όλα τα περιεχόμενα μεταφέρονται στην κατηγορία που θα επιλέξετε και μετά η τρέχουσα διαγράφεται.",
    deleteCategoryDataSafeHint: "Αυτή η κατηγορία περιέχει",
    vendorsAssociated: "προμηθευτή(ές). Τα τιμολόγια και οι πληρωμές σας ΔΕΝ θα διαγραφούν — απλώς οι προμηθευτές θα χάσουν την ετικέτα κατηγορίας.",
    deleteCategoryEmptyHint: "Η κατηγορία δεν έχει προμηθευτές και μπορεί να διαγραφεί με ασφάλεια.",
    deleteSubcategoryHint: "Η υποκατηγορία έχει εμφωλευμένα στοιχεία. Επιλέξτε πώς θα προχωρήσετε.",
    // Phase 962 — Πλοήγηση με βάση κατηγορίες
    categoriesListHint: "Ανοίξτε μια κατηγορία για να δείτε τους προμηθευτές που περιέχει.",
    searchCategoryPlaceholder: "Αναζήτηση κατηγορίας…",
    noCategoriesHint: "Πατήστε «Προσθήκη κατηγορίας» για να δημιουργήσετε την πρώτη.",
    noVendorsInCategory: "Δεν υπάρχουν προμηθευτές ακόμη",
    uncategorized: "Χωρίς κατηγορία",
    renameCategory: "Μετονομασία κατηγορίας",
    categoryNamePlaceholder: "π.χ. Οικιακά",
    // Phase 963 — Επεξεργασία / Διαγραφή Προμηθευτή & Πληρωμής
    renameVendor: "Μετονομασία προμηθευτή",
    vendorName: "Όνομα προμηθευτή",
    vendorNamePlaceholder: "π.χ. CYTA",
    vendorRenameHint: "Η μετονομασία ενημερώνει όλες τις καρτέλες και τα τιμολόγια αυτού του προμηθευτή. Το οικονομικό ιστορικό διατηρείται.",
    deleteVendor: "Διαγραφή προμηθευτή",
    deleteVendorHint: "Ο προμηθευτής αφαιρείται από τη λίστα, αλλά",
    deleteVendorHintSuffix: "τιμολόγιο(α) και το ιστορικό πληρωμών διατηρούνται. Θα εμφανίζονται ως «Χωρίς κατηγορία» ή «Μη καθορισμένο» μέχρι να τα επανα-αντιστοιχίσετε.",
    deleteVendorEmpty: "Ο προμηθευτής δεν έχει τιμολόγια και μπορεί να διαγραφεί με ασφάλεια.",
    deletePayment: "Διαγραφή πληρωμής",
    deletePaymentHint: "Αφαιρεί την πληρωμή από την καρτέλα τιμολογίου. Η κατάσταση και το υπόλοιπο του τιμολογίου υπολογίζονται αυτόματα εκ νέου. Συνέχεια;",
    // Phase 965 — Αναλυτικές γραμμές τιμολογίου
    lineItems: "Αναλυτικές Γραμμές",
    lineItemsHint: "Προαιρετικό. Όταν προσθέσετε γραμμές, το Σύνολο υπολογίζεται αυτόματα.",
    addLine: "Προσθήκη γραμμής",
    noLineItemsYet: "Καμία γραμμή — πατήστε «Προσθήκη γραμμής» για ανάλυση.",
    lineDescPlaceholder: "π.χ. Είδη καθαρισμού",
    quantity: "Ποσ.",
    unitPrice: "Τιμή Μονάδας",
    lineItemsTotal: "Σύνολο γραμμών",
    item: "στοιχείο",
    items: "στοιχεία",
    remove: "Αφαίρεση",
    noPaymentsForInvoice: "Δεν έχουν καταχωρηθεί πληρωμές για αυτό το τιμολόγιο.",
    // Phase 967 — Επαγγελματικά columns Statement
    invoiceAmount: "Ποσό Τιμολογίου",
    paymentAmount: "Ποσό Πληρωμής",
    totalInvoiced: "Σύνολο Τιμολογημένων",
    totalPaid: "Σύνολο Πληρωμένων",
    totalPayments: "Σύνολο Πληρωμών",
    // Phase 1004g/1005 — Management Company Advance History dialog
    viewMcaHistory: "Ιστορικό",
    mcaViewPdf: "PDF Προκαταβολών",
    mcaHistoryTitle: "Ιστορικό Προκαταβολών Εταιρείας Διαχείρισης",
    mcaTotalAdvances: "Σύνολο Προκαταβολών",
    mcaTotalRepayments: "Σύνολο Επιστροφών",
    mcaOutstanding: "Υπόλοιπο",
    advance: "Προκαταβολή",
    repayment: "Επιστροφή",
    outstanding: "Υπόλοιπο",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
